//React
import React, { Component } from 'react';
import { withRouter } from "react-router-dom";

//Proptype
import PropTypes from 'prop-types';

// Cookies
import Cookies from 'js-cookie';

//UI
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes,faEdit } from '@fortawesome/free-solid-svg-icons';
import { Container, ListGroup, ListGroupItem, Row, Col, Form, FormInput,
        FormCheckbox, FormSelect, DatePicker, FormTextarea, FormRadio } from "shards-react";
import {Tabs, Tab} from 'react-bootstrap'

import { Card, CardHeader, CardImg, CardBody, Button, InputGroup, InputGroupAddon, InputGroupText} from "shards-react";

import DateFnsUtils from "@date-io/date-fns";
import { es } from "date-fns/locale";

import { Table } from 'reactstrap';
import {  Dialog, DialogContent, DialogActions, DialogTitle, DialogContentText } from '@material-ui/core';

//Redux
import {connect} from 'react-redux';

import { agregarContract } from '../../actions/contractActions';
import { validarFormulario } from '../../actions/errorActions';
import { tokenTemplate, mostrarTemplateAll, mostrarTemplate } from '../../actions/templateActions';
import {username_new} from '../../actions/userActions'
import {getFileDB, putFileDB} from '../../actions/mongoDBActions'
import {profileUser} from '../../actions/gaiaActions'

//UUID
import uuid from 'uuid';

//Axios
import axios from 'axios';

//Email
import emailjs from 'emailjs-com'

//Timer
import TimerMixin from 'react-timer-mixin'

//Currency
import currency from '../../utils/currency';
import currencyCrypto from '../../utils/currency-crypto';

//PACT
//import sendPactCommand from '../../utils/send-pact-command';

// blockstack
import { hexStringToECPair } from 'blockstack';
//import { writeFile, readFile } from "blockstack-large-storage";
import { UserSession } from '@stacks/auth';
import { Storage } from '@stacks/storage'

//Sagas
import { saveNewPactLogisticConfig, saveNewPactLogisticRules, removePactLogisticConfig,
         saveNewPactMaintenanceConfig, saveNewPactMaintenanceRules,
         saveNewPactProformaConfig, saveNewPactProformaRules } from '../../actions/pactActions';

//Components
import ContractIoTDevice from '../contractiotdevice/ContractIoTDevice';
import ContractAttachFile from '../contractattachfile/ContractAttachFile';
import ContractDeliverable from '../contractdeliverable/ContractDeliverable';
import FormsDeliverable from '../contractdeliverable/FormsDeliverable';
import MasterFileDeliverable from '../contractdeliverable/MasterFileDeliverable';
import ReporteTurnoDeliverable from '../contractdeliverable/ReporteTurnoDeliverable';
import InformeDeliverable from '../contractdeliverable/InformeDeliverable';
import AuthorizersDeliverable from '../contractdeliverable/AuthorizersDeliverable';
import ContractDashboard from '../dashboard/ContractDashboard';
import ContractChat from '../chat/ContractChat';
import ContractTag from '../contracttag/ContractTag';
import ContractSign from '../sign/ContractSign';
import ContractRegister from '../register/ContractRegister';
import ContractUserGroup from '../usergroup/ContractUserGroup';
import ContractPaymentForm from '../paymentform/ContractPaymentForm';
import ContractPay from '../pay/ContractPay';
import DatosCryptoCurrency from "../cryptocurrency/DatosCryptoCurrency";
import TituloPagina3 from "../common/TituloPagina3";
import ContractAssociated from "../associatedto/ContractAssociated";
import ContractRules from "../rules/ContractRules";
import ContenedorSimulador from "../../views/ContenedorSimulador";
import ContractDelete from "./ContractDelete";
import ContractLoader from "./ContractLoader";
import ContractTab from "./ContractTab";
import ContractUpload from "./ContractUpload";
import Spreadsheet from "./ContractSpreadsheet";
import ActiveParticipants from "../paycertify/ActiveParticipants";
import TemporaryDrawer from "./ContractDrawer";
import TemporaryDrawerLeft from "./ContractDrawerLeft";
import ViewerPdf from "../pdf/ViewerPdf";

//Configuración
import { MAINNET_STACKS_API_URL,
         TESTNET_STACKS_API_URL } from '../../config.js'

//translate
import { FormattedMessage } from 'react-intl';

//Configuracion
import {token} from '../../config.js'

//viewer
import MyViewerPdf from '../contractattachfile/MyViewerPdf';

//base64
import { Base64 } from 'js-base64';

//Signature
import SignaturePad from 'react-signature-canvas'

//chat
//import {Launcher} from 'react-chat-window'

//Editor Wysiwyg
import { EditorState, convertFromRaw } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html';
import {stateToHTML} from 'draft-js-export-html'
import '../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

import forge from 'node-forge'

const content = {"entityMap":{},"blocks":[{"key":"637gr","text":"Initialized from content state.","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}]};

function uploadImageCallBack(file) {
  return new Promise(
    (resolve, reject) => {
      const xhr = new XMLHttpRequest(); // eslint-disable-line no-undef
      xhr.open('POST', 'https://api.imgur.com/3/image');
      xhr.setRequestHeader('Authorization', 'Client-ID 8d26ccd12712fca');
      const data = new FormData(); // eslint-disable-line no-undef
      data.append('image', file);
      xhr.send(data);
      xhr.addEventListener('load', () => {
        const response = JSON.parse(xhr.responseText);
        resolve(response);
      });
      xhr.addEventListener('error', () => {
        const error = JSON.parse(xhr.responseText);
        reject(error);
      });
    },
  );
}

//
function Confirmacion(props) {
    return (
        <Dialog
            open={props.dialogOpen}
            onClose={() => props.handleDialog('cancel')}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">{props.dialogTitle}</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {props.dialogMessage}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => props.handleDialog(props.dialogTitle, 'cancel')} theme="warning" autoFocus>
                    <FormattedMessage id="alert.cancel" />
                </Button>
                <Button onClick={() => props.handleDialog(props.dialogTitle, 'confirm')} theme="danger">
                    <FormattedMessage id="alert.confirm" />
                </Button>
            </DialogActions>
        </Dialog>
    );
}

function ConfirmacionWriteBlockchain(props) {
    return (
        <Dialog
            open={props.dialogOpen}
            onClose={() => props.handleDialog('cancel')}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">{props.dialogTitle}</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {props.dialogMessage}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => props.handleDialog(props.dialogTitle, 'cancel')} theme="warning" autoFocus>
                    <FormattedMessage id="alert.cancel" />
                </Button>
                <Button onClick={() => props.handleDialog(props.dialogTitle, 'confirm')} theme="danger">
                    <FormattedMessage id="alert.confirm" />
                </Button>
            </DialogActions>
        </Dialog>
    );
}

function ConfirmacionSign(props) {
    return (
        <Dialog
            open={props.dialogOpen}
            onClose={() => props.handleDialog('cancel')}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">{props.dialogTitle}</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {props.dialogMessage}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => props.handleDialog(props.dialogTitle, 'cancel')} theme="warning" autoFocus>
                     <FormattedMessage id="alert.cancel" />
                </Button>
                <Button onClick={() => props.handleDialog(props.dialogTitle, 'confirm')} theme="danger">
                     <FormattedMessage id="alert.confirm" />
                </Button>
            </DialogActions>
        </Dialog>
    );
}

function ConfirmacionUnSign(props) {
    return (
        <Dialog
            open={props.dialogOpen}
            onClose={() => props.handleDialog('cancel')}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">{props.dialogTitle}</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {props.dialogMessage}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => props.handleDialog(props.dialogTitle, 'cancel')} theme="warning" autoFocus>
                    <FormattedMessage id="alert.cancel" />
                </Button>
                <Button onClick={() => props.handleDialog(props.dialogTitle, 'confirm')} theme="danger">
                    <FormattedMessage id="alert.confirm" />
                </Button>
            </DialogActions>
        </Dialog>
    );
}

function ConfirmacionWalletSinSaldo(props) {
    return (
        <Dialog
            open={props.dialogOpen}
            onClose={() => props.handleDialog('cancel')}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">{props.dialogTitle}</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {props.dialogMessage}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => props.handleDialog(props.dialogTitle, 'cancel')} theme="warning" autoFocus>
                    <FormattedMessage id="alert.cancel" />
                </Button>
            </DialogActions>
        </Dialog>
    );
}

function ConfirmacionContractExist(props) {
    return (
        <Dialog
            open={props.dialogOpen}
            onClose={() => props.handleDialog('cancel')}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">{props.dialogTitle}</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {props.dialogMessage}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => props.handleDialog(props.dialogTitle, 'cancel')} theme="warning" autoFocus>
                    <FormattedMessage id="alert.cancel" />
                </Button>
            </DialogActions>
        </Dialog>
    );
}

function ConfirmacionDeactivate(props) {
    return (
        <Dialog
            open={props.dialogOpen}
            onClose={() => props.handleDialog('cancel')}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">{props.dialogTitle}</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {props.dialogMessage}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => props.handleDialog(props.dialogTitle, 'cancel')} theme="warning" autoFocus>
                    <FormattedMessage id="alert.cancel" />
                </Button>
                <Button onClick={() => props.handleDialog(props.dialogTitle, 'confirm')} theme="danger">
                    <FormattedMessage id="alert.confirm" />
                </Button>
            </DialogActions>
        </Dialog>
    );
}

function ConfirmacionSaveDraft(props) {
    return (
        <Dialog
            open={props.dialogOpen}
            onClose={() => props.handleDialog('cancel')}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">{props.dialogTitle}</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {props.dialogMessage}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => props.handleDialog(props.dialogTitle, 'cancel')} theme="warning" autoFocus>
                    <FormattedMessage id="alert.cancel" />
                </Button>
            </DialogActions>
        </Dialog>
    );
}

function ConfirmacionSaveDraftAgree(props) {
    return (
        <Dialog
            open={props.dialogOpen}
            onClose={() => props.handleDialog('cancel')}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">{props.dialogTitle}</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {props.dialogMessage}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => props.handleDialog(props.dialogTitle, 'cancel')} theme="warning" autoFocus>
                    <FormattedMessage id="alert.cancel" />
                </Button>
            </DialogActions>
        </Dialog>
    );
}

function ConfirmacionPaymentForm(props) {
    return (
        <Dialog
            open={props.dialogOpen}
            onClose={() => props.handleDialog('cancel')}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">{props.dialogTitle}</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {props.dialogMessage}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => props.handleDialog(props.dialogTitle, 'cancel')} theme="danger" autoFocus>
                    <FormattedMessage id="alert.cancel" />
                </Button>
            </DialogActions>
        </Dialog>
    );
}

class Contract extends Component {

      constructor(props) {
        super(props);

        const contentState = convertFromRaw(content);
        this.state = {contentState, }
        const editorState = EditorState.createWithContent(contentState);
        this.state = { editorState, }

        //----------------------------------------
        //Funcionalidades para los Contratos
        //----------------------------------------
        this.handleChange = this.handleChange.bind(this);
        this.handleChangeNumber = this.handleChangeNumber.bind(this);
        this.handleBlurNumber = this.handleBlurNumber.bind(this);
        this.handleInputNumber = this.handleInputNumber.bind(this);
        this.handleDate = this.handleDate.bind(this);
        this.handleDialog = this.handleDialog.bind(this);
        this.nuevoContract = this.nuevoContract.bind(this);
        this.backConfigurationContract = this.backConfigurationContract.bind(this);
        this.backTypeContract = this.backTypeContract.bind(this);
        this.mostrarBotonesAbajo = this.mostrarBotonesAbajo.bind(this);
        this.messageErrorWrite = this.messageErrorWrite.bind(this);
        this.searchContracts = this.searchContracts.bind(this);
        this.verifyContract = this.verifyContract.bind(this);
        this.listContract = this.listContract.bind(this);
        this.listContract2 = this.listContract2.bind(this);
        this.listContractPrevious = this.listContractPrevious.bind(this);
        this.listContractPreviousPrevious = this.listContractPreviousPrevious.bind(this);
        this.displayListContract = this.displayListContract.bind(this);
        this.displayListContractArchive = this.displayListContractArchive.bind(this);
        this.displayListContractEditorStart = this.displayListContractEditorStart.bind(this);
        this.displayListContractEditorNew = this.displayListContractEditorNew.bind(this);
        this.displayListContractEditorNew2 = this.displayListContractEditorNew2.bind(this);
        this.displayListContractEditorOpen = this.displayListContractEditorOpen.bind(this);
        this.llenaDatosLocalStorage = this.llenaDatosLocalStorage.bind(this);
        this.llenaDatosRules = this.llenaDatosRules.bind(this);
        this.goContractIoTDevice = this.goContractIoTDevice.bind(this);
        this.goContractUserGroup = this.goContractUserGroup.bind(this);
        this.goContractUserGroup3 = this.goContractUserGroup3.bind(this);
        this.goContractUserGroupPrevious = this.goContractUserGroupPrevious.bind(this);
        this.goContractUserGroupRemoto = this.goContractUserGroupRemoto.bind(this);
        this.goContractRules = this.goContractRules.bind(this);
        this.goContract = this.goContract.bind(this);
        this.goMostrarAllTemplates = this.goMostrarAllTemplates.bind(this);
        this.goSignList = this.goSignList.bind(this);
        this.goSignListRemoto = this.goSignListRemoto.bind(this);
        this.goSignListRemotoSignature = this.goSignListRemotoSignature.bind(this);
        this.goRoleList = this.goRoleList.bind(this);
        this.goAttachFile = this.goAttachFile.bind(this);
        this.goDeliverableFile = this.goDeliverableFile.bind(this);
        this.goAttachFileCreator = this.goAttachFileCreator.bind(this);
        this.goDeliverableFileCreator = this.goDeliverableFileCreator.bind(this);
        this.goUserGroup = this.goUserGroup.bind(this);
        this.goUserGroupAttachFileCreator = this.goUserGroupAttachFileCreator.bind(this);
        this.goUserGroupOrigin = this.goUserGroupOrigin.bind(this);
        this.createListContract = this.createListContract.bind(this);
        this.createUserGroup = this.createUserGroup.bind(this);
        this.deleteListContract = this.deleteListContract.bind(this);
        this.displayTemplates = this.displayTemplates.bind(this);
        this.signContract = this.signContract.bind(this);
        this.signContract2 = this.signContract2.bind(this);
        this.unsignContract = this.unsignContract.bind(this);
        this.blockchainContract = this.blockchainContract.bind(this);
        this.walletSinSaldoContract = this.walletSinSaldoContract.bind(this);
        this.deactivateConfirm = this.deactivateConfirm.bind(this);
        this.activateConfirm = this.activateConfirm.bind(this);
        this.saveDraftConfirm = this.saveDraftConfirm.bind(this);
        this.saveDraftAgreeConfirm = this.saveDraftAgreeConfirm.bind(this);
        this.editProformaDetailConfirm = this.editProformaDetailConfirm.bind(this);
        this.deleteProformaDetailConfirm = this.deleteProformaDetailConfirm.bind(this);
        this.sendConfirm = this.sendConfirm.bind(this);
        this.signConfirm = this.signConfirm.bind(this);
        this.unsignConfirm = this.unsignConfirm.bind(this);
        this.errorNumberContract = this.errorNumberContract.bind(this);
        this.existContract = this.existContract.bind(this);
        this.signUserGroup = this.signUserGroup.bind(this);
        this.signUserGroupWrite = this.signUserGroupWrite.bind(this);
        this.displayPaginacion = this.displayPaginacion.bind(this);
        this.displayNewContract = this.displayNewContract.bind(this);
        this.displayConfigContract = this.displayConfigContract.bind(this);
        this.displayConfigContractArchive = this.displayConfigContractArchive.bind(this);
        this.displayArrowCollapsed = this.displayArrowCollapsed.bind(this);
        this.returnProps = this.returnProps.bind(this);
        this.newDetail = this.newDetail.bind(this);
        this.modifyDetail = this.modifyDetail.bind(this);
        this.newContractBlank = this.newContractBlank.bind(this);
        this.newContractUploaded = this.newContractUploaded.bind(this);
        this.newContractSpreadsheet = this.newContractSpreadsheet.bind(this);
        this.clickRemoveProformaDetail = this.clickRemoveProformaDetail.bind(this);
        this.clickEditProformaDetail = this.clickEditProformaDetail.bind(this);
        this.llenaTablaEnrollment = this.llenaTablaEnrollment.bind(this);
        this.llenaTablaEnrollment2 = this.llenaTablaEnrollment2.bind(this);
        this.verifySign = this.verifySign.bind(this);
        this.sendContract = this.sendContract.bind(this);
        this.pageContracts = this.pageContracts.bind(this);
        this.userRemoteContracts = this.userRemoteContracts.bind(this);
        this.tagListContracts = this.tagListContracts.bind(this);
        this.carpetListContracts = this.carpetListContracts.bind(this);
        this.getUploadParams = this.getUploadParams.bind(this);
        this.handleChangeStatus = this.handleChangeStatus.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
        this.attachFile = this.attachFile.bind(this);
        this.pushUserListRemote = this.pushUserListRemote.bind(this);
        this.pushGetUserListRemote = this.pushGetUserListRemote.bind(this);
        this.pushPutUserListRemote = this.pushPutUserListRemote.bind(this);
        this.printContract = this.printContract.bind(this);
        this.editContract = this.editContract.bind(this);
        this.deleteContract = this.deleteContract.bind(this);
        this.generatePdf = this.generatePdf.bind(this);
        this.savetodiscContract = this.savetodiscContract.bind(this);
        this.saveContractDoc = this.saveContractDoc.bind(this);
        this.readContractDoc = this.readContractDoc.bind(this);
        this.sendMailSigned = this.sendMailSigned.bind(this);
        this.sendMailUnSigned = this.sendMailUnSigned.bind(this);
        this.getProformaDetail = this.getProformaDetail.bind(this);
        this.getUploadedDetail = this.getUploadedDetail.bind(this);
        this.getSpreadsheetDetail = this.getSpreadsheetDetail.bind(this);
        this.getBlankDetail = this.getBlankDetail.bind(this);
        this.getBlankDetailLoremIpsum = this.getBlankDetailLoremIpsum.bind(this);
        this.displayButtonsTab = this.displayButtonsTab.bind(this);
        this.displayButtonsTabRed = this.displayButtonsTabRed.bind(this);
        this.displayButtons = this.displayButtons.bind(this);
        this.displayButtonsRed = this.displayButtonsRed.bind(this);
        this.alertSupport = this.alertSupport.bind(this);
        this.simulation = this.simulation.bind(this);
        this.buttonArrow1 = this.buttonArrow1.bind(this);
        this.buttonArrow2 = this.buttonArrow2.bind(this);
        this.buttonArrow3 = this.buttonArrow3.bind(this);
        this.button0 = this.button0.bind(this);
        this.button1 = this.button1.bind(this);
        this.button2 = this.button2.bind(this);
        this.button3 = this.button3.bind(this);
        this.button4 = this.button4.bind(this);
        this.button5 = this.button5.bind(this);
        this.button6 = this.button6.bind(this);
        this.button7 = this.button7.bind(this);
        this.button8 = this.button8.bind(this);
        this.button9 = this.button9.bind(this);
        this.button10 = this.button10.bind(this);
        this.button11 = this.button11.bind(this);
        this.button12 = this.button12.bind(this);
        this.button13 = this.button13.bind(this);
        this.button14 = this.button14.bind(this);
        this.button15 = this.button15.bind(this);
        this.button16 = this.button16.bind(this);
        this.button17 = this.button17.bind(this);
        this.button18 = this.button18.bind(this);
        this.button19 = this.button19.bind(this);
        this.button20 = this.button20.bind(this);
        this.button21 = this.button21.bind(this);
        this.button22 = this.button22.bind(this);
        this.button23 = this.button23.bind(this);
        this.button24 = this.button24.bind(this);
        this.button25 = this.button25.bind(this);
        this.button26 = this.button26.bind(this);
        this.button27 = this.button27.bind(this);
        this.button28 = this.button28.bind(this);
        this.button29 = this.button29.bind(this);
        this.button30 = this.button30.bind(this);
        this.tagList = this.tagList.bind(this);
        this.returnUploadContract = this.returnUploadContract.bind(this);
        this.getContractTag = this.getContractTag.bind(this);
        this.handleChangeProformaSender = this.handleChangeProformaSender.bind(this);
        this.handleChangeProformaReceiver = this.handleChangeProformaReceiver.bind(this);
        this.getDisplayCompanyData = this.getDisplayCompanyData.bind(this);
        this.getDisplayCompanyLogo = this.getDisplayCompanyLogo.bind(this);
        this.storeListContract = this.storeListContract.bind(this);
        this.getCircleGreen = this.getCircleGreen.bind(this);
        this.putCircleGreen = this.putCircleGreen.bind(this);
        this.publicKeySTXAddress = this.publicKeySTXAddress.bind(this);
        this.publicKeyGet = this.publicKeyGet.bind(this);
        this.stxAddressGet = this.stxAddressGet.bind(this);
        this.validatePaymentForm1 = this.validatePaymentForm1.bind(this);
        this.validatePaymentForm2 = this.validatePaymentForm2.bind(this);
        this.printContract = this.printContract.bind(this);
        this.activeInactiveAllContracts = this.activeInactiveAllContracts.bind(this);
        //----------------------------------------
        this.state = {
          userSession: new UserSession(),
          username: '',
          usernameY: '',
          user: '',
          pathname: '',
          messageList: [],
          dynamicFormXML: '[]',
          mensajeErrorTemplates: '',
          errorMensajeTemplates: false,
          displayTemplate: false,
          tokenTemplate: '',
          displayTemplateDetail: false,
          JSONTemplateDetail: '',
          JSONTemplateDetail2: '',
          JSONTemplateDetailString: '',
          JSONTemplateName: '',
          sinTemplateDetail: true,
          searchContract2: false,
          displayBlockchain: false,
          displayCryptoCurrency: false,
          displayPaymentForm: false,
          displayPay: false,
          displayDocument: false,
          displayUser: false,
          displaySign: false,
          displayRegister: false,
          displayLink: false,
          displayAttach: false,
          displayDashboard: false,
          displayReport: false,
          displayChat: false,
          displayRules: false,
          displayAssociated: false,
          displayShare: false,
          displayActiveParticipants: false,
          displayReporteTurnoDeliverable: false,
          displayInformeDeliverable: false,
          iContractTable: null,
          typeContractTable: '',
          numberContractTable: '',
          subjectContractTable: '',
          jsonLinkZ50:[],
          jsonAttachZ50:[],
          jsonBlockchainZ50:[],
          jsonLinkZ50Remote:[],
          jsonBlockchainZ50Remote:[],
          jsonBlockchainRemoteZ50:[],
          jsonStatusBlockchain: '',
          jsonStatusLifeCycle: '',
          jsonStatusIdPact: '',
          jsonProformaDetail: [],
          jsonContractTag: [],
          jsonCircleGreen: [],
          dialogOpen: false,
          dialogOpenWriteBlockchain: false,
          dialogOpenWalletSinSaldo: false,
          dialogOpenContractExist: false,
          dialogOpenPaymentForm: false,
          dialogOpenSign: false,
          dialogOpenUnSign: false,
          dialogOpenDeactivate: false,
          dialogOpenSaveDraft: false,
          dialogOpenSaveDraftAgree: false,
          dialogMessage: '',
          dialogTitle: '',
          displayTemplateDetailTypeContract: false,
          signTrue: true,
          person: '',
          exist: true,
          pubKey: '',
          publicKey: '',
          identityAddress: undefined,
          decentralizedID: undefined,
          nameBlockstack: undefined,
          scrollInitial: 1,
          scrollPrevious: 0,
          scrollNext: 0,
          scrollEnd: 100,
          scrollLength: 0,
          arrowsort: false,
          arrowsort1: false,
          arrowsort2: false,
          arrowsort3: false,
          arrowsort4: false,
          arrowsort5: false,
          arrowsortChange: [],
          jsonEnrollment: [],
          jsonEnrollmentChange: [],
          enrollmentContractTable: '',
          displayRulesEnrollment: '',
          displayRulesDisable: true,
          typeContractSign: '',
          configurationContractNumberSign: '',
          existContractRules: false,
          clickRules: false,
          jsonUserGroupPact: [],
          jsonBlockstackSetting: '',
          jsonPaymentForm: [],
          userlistRemote: [],
          tagList: [],
          pageContracts: 100,
          userRemoteX: '',
          jsonAttachFile: [],
          jsonAttachFile1: [],
          jsonAttachFile2: [],
          isErrorWriteConfigurationContractNumber: false,
          isErrorWriteIdBillOfLading: false,
          isErrorWriteIdTypeBillOfLading: false,
          isErrorWriteDateContract: false,
          activeContract: true,
          languaje: 'English',
          mycontact: 'My Contacts',
          mytag: 'My Tags',
          tagListX: '',
          carpetListX: 'inbox',
          activeInactiveAllX: 'Active',
          newcontract : '',
          bringContractTemplateFrom: '',
          modeDisplay: '',
          templatesAllLocal: [],
          attachFile30X: true,
          rules30X: true,
          associatedTo30X: true,
          tax30X: 0,
          title30X: '',
          subtotalProformaDetail: 0,
          subtotalProformaDetailPrev: 0,
          nameContractEditor: '',
          icondisplayReportX: '',
          icondisplayDeliverableX: '',
          icondisplayFormsDeliverableX: '',
          icondisplayAuthorizersDeliverableX: '',
          icondisplayRolDeliverableX: '',
          icondisplayTagDeliverableX: '',
          icondisplayReporteTurnoDeliverableX: '',
          icondisplayUserX: '',
          icondisplaySignatureX: '',
          icondisplayRegisterX: '',
          icondisplayLinkX: '',
          icondisplayEyeX: '',
          icondisplayChatX: '',
          icondisplayTagX: '',
          icontypeContract: '',
          iconconfigurationContractNumber: '',
          icondisplayRoleX: '',
          icondisplayOriginX: '',
          icondisplaySubjectX: '',
          icondisplayCryptoCurrencyX: '',
          icondisplayBlockchainX: '',
          icondisplayAssociatedX: '',
          icondisplayRulesX: '',
          icondisplayDocumentX: '',
          icondisplayShareX: '',
          icondisplayActiveParticipantsX: '',
          displayIconsRed: '',
          modeContract: '',
          deleteListContract: false,
          editListContract: false,
          modeMenuContract: 'Tab',
          DisplayCompanyLogoData: 'Yes',
          seeAttachX: false,
          newUploadedX: false,
          filedecodeAttachX: {},
          fileAttachX: {},
          typeAttachX: '',
          nameAttachX: '',
          typeAttachText: false,
          typeAttachImage: false,
          typeAttachPdf: true,
          typeAttachAudio: false,
          typeAttachVideo: false,
          selectedOption: null,
          modifyItemProformaDetail: false,
          logoCompany: '',
          isocode: 'en',
          dateFormatX: 'dd/MM/yyyy',
          jsonAssociatedToMaintenance: [],
          codeAssociatedToMaintenance: '',
          selectedTypeMaintenance: '',
          jsonArchive: [],
          countMessages: 0,
          activeUserGroupX: false,
          confirmSignX: false,
          confirmRegisterX: false,
          activeDeliverableX: false,
          activeDataDashboardX: false,
          networkUrlX: '',
          clientWorkOrder: [],
                    //----------------------------------------
          //Perfil Blockstack
          //----------------------------------------
          url: 'https://gaia.blockstack.org/hub/',
          url2: 'https://core.blockstack.org/v1/users/',
          url3: 'https://core.blockstack.org/v1/names/',
          //----------------------------------------
          //Datos Fijos para checkbox de Sensores
          //----------------------------------------
          c01SensorContract:true,
          c02SensorContract:true,
          c03SensorContract:true,
          c04SensorContract:false,
          c05SensorContract:false,
          c06SensorContract:false,
          c07SensorContract:false,
          c08SensorContract:true,
          c09SensorContract:true,
          c10SensorContract:true,
          c11SensorContract:true,
          c12SensorContract:true,
          c13SensorContract:true,
          //---------------------------------------
          //Datos Fijos para Area de Configuracion
          //---------------------------------------
          c03ConfigurationContract: true,
          c04ConfigurationContract: true,
          c05ConfigurationContract: true,
          //----------------------------------------
          //Datos Fijos para Area Reglas de Sensores
          //----------------------------------------
          sensorTemperatureActiveRule: false,
          sensorHumidityActiveRule: false,
          sensorGasControlActiveRule: false,
          sensorGPSActiveRule: false,

          sTemperatureLowerThreshold: '',
          sTemperatureUpperThreshold: '',
          sTemperatureFrecuency: '',
          sTemperatureUnitFrecuency: '',
          sTemperatureUnitMeasurement: '',
          sTemperatureErrorTime: '',
          sTemperatureErrorTimeUnit: '',
          sTemperatureErrorAction: '',
          sTemperatureActiveRule: '',

          sHumidityLowerThreshold: '',
          sHumidityUpperThreshold: '',
          sHumidityFrecuency: '',
          sHumidityUnitFrecuency: '',
          sHumidityUnitMeasurement: '',
          sHumidityErrorTime: '',
          sHumidityErrorTimeUnit: '',
          sHumidityErrorAction: '',
          sHumidityActiveRule: '',

          sGPSFrecuency: '',
          sGPSUnitFrecuency: '',
          sGPSUnitMeasurement: '',
          sGPSErrorTime: '',
          sGPSErrorTimeUnit: '',
          sGPSErrorAction: '',
          sGPSActiveRule: '',

          sFireErrorAction: '',
          sFireActiveRule: '',

          sFloodErrorAction: '',
          sFloodActiveRule: '',

          sMotionErrorAction: '',
          sMotionActiveRule: '',

          sSealIntegrityAction: '',
          sSealIntegrityActiveRule: '',

          sSmokeAction: '',
          sSmokeActiveRule: '',

          sTemperature:false,
          sHumidity:false,
          sGascontrol:false,
          sImpact:false,
          sVibration:false,
          sProximity:false,
          sSealIntegrity:false,
          sFire:false,
          sFlood:false,
          sMotion:false,
          sSmoke:false,
          //----------------------------------------

          startDate2: new Date(),
          nowDate2: new Date(),
          startDate: new Date(),
          endDate: new Date(),
          nowDate: new Date(),
          existContract: false,
          existContract2: false,
          cContractPolicy: false,
          jsonConfiguration: '',
          statusActive2: true,
          isErrorWrite: false,
          statusDelete: false,
          errorNumber: false,
          disableSensor: false,
          sIdLogisticContract:false,
          sIdContainer:false,
          sIdBillOfLading:false,
          sIdTypeBillOfLading:false,
          sDateContract:false,
          sExistContract:false,
          isLoading: false,
          existListContract: false,
          existListContractX: false,
          jsonBlockstackZ: '',
          jsonBlockstackZ50: '',
          jsonBlockstackZ50Remote: '',
          existNewContract: false,
          showLoader:true,
          indiceRules: 0,
          jsonUserGroup: [],
          algunosSign: false,
          ningunoSign: true,
          todosSign: false,
          algunosDevice: false,
          ningunoDevice: false,
          todosDevice: false,
          whatUserRole: '',
          whatUserOrigin: '',
          viewSimulate: 'Yes',
          fromSearch: false,
          fromSearchList: false,
          fromSearchListSearch: '',
          neverVisibility: true,
          displayWriteUp: true,
          displaySimulator: false,
          activeTab: props.activeTab || 1,
          activeItem: "1",
          displayStringTagX: '',
          displayColourTagX: '',
          displayColourLetterTagX: '',
          active_after_publishedX: 'true',
          displayCircleGreenX: '',
          categorySearch: null,
          displayProformaSearchSender: false,
          displayProformaSearchReceiver: false,
          displayCertificatePaymentsMade: false,
          displayCertificateContract: false,
          jsonProformaSender: [],
          jsonProformaReceiver: [],
          dataCompany: '',
          dataCompany2: '',
          trimmedDataURL: null,
          displayTitleEdit: '',
          displayTitleArchive: '',
          displayTitleDelete: '',
          FIACurrency: 'USD - US Dollar',
          cryptoCurrencyOrigin: 'BTC - Bitcoin',
          cryptoCurrencyPayment: 'STX - Stacks',
          cryptoPactClarityEthereum: 'Blockstack Clarity (STX)',
          encryptDecryptFile: 'Yes',
          displayChatDocument: 'Yes',
          encryptDecryptFileContract: false,
          myUserConfig: [],
          documentSidebarStartsOpen: 'Yes',
          jsonPaymentForm: [],
          displayLifeCycleX: '',
          generatePdfX: false,
          contentStateRaw: '',
          subject: '',
          nameX: '',
          avatarX: '',
          setItemDocument: null,
          selectedSignaturePayment: 'SignatureAndPayment',
          editorChange: false,
          currencyType: 'FIAT Money',
          amountPayment: 0,
          workordercliente: '',
          workordercampaña: '',
          workordersondaje: '',
          workordertipoperforacion: '',
          workorderfase: '',
          workordernumerocontrato: '',
          workorderdeclinacion: '',
          workorderrecomendado: '',
          workorderfecharealinicio: new Date(),
          workorderfechainiciopozo: new Date(),
          workorderfechaterminoperforacion: new Date(),
          workorderfechaterminosondaje: new Date(),
          workordermeta: '',
          workordermetaturnodia: '',
          workordermetaturnonoche: '',
          deliverableFormsX: false,
        }
      }

      cContractByPage = React.createRef();
      cUserRemote = React.createRef();
      cTagList = React.createRef();
      cCarpetList = React.createRef();
      cActiveInactiveAll = React.createRef();

      //---------------------------------------
      //Datos Fijos para Area de Configuracion
      //---------------------------------------
      c01ConfigurationContract = React.createRef();
      c02ConfigurationContract = React.createRef();
      c06ConfigurationContract = React.createRef();
      c07ConfigurationContract = React.createRef();
      c08ConfigurationContract = React.createRef();
      c09ConfigurationContract = React.createRef();
      c10ConfigurationContract = React.createRef();

      //---------------------------------------------------
      //IMPORTANTE: Variables para Area campos de Contratos
      //---------------------------------------------------
      c01FieldContract = React.createRef();
      c02FieldContract = React.createRef();
      c03FieldContract = React.createRef();
      c04FieldContract = React.createRef();
      c05FieldContract = React.createRef();
      c06FieldContract = React.createRef();
      c07FieldContract = React.createRef();
      c08FieldContract = React.createRef();
      c09FieldContract = React.createRef();
      c10FieldContract = React.createRef();
      c11FieldContract = React.createRef();
      c12FieldContract = React.createRef();
      c13FieldContract = React.createRef();
      c14FieldContract = React.createRef();
      c15FieldContract = React.createRef();
      c16FieldContract = React.createRef();
      c17FieldContract = React.createRef();
      c18FieldContract = React.createRef();
      c19FieldContract = React.createRef();
      c20FieldContract = React.createRef();
      c21FieldContract = React.createRef();
      c22FieldContract = React.createRef();
      c23FieldContract = React.createRef();
      c24FieldContract = React.createRef();
      c25FieldContract = React.createRef();
      c26FieldContract = React.createRef();
      c27FieldContract = React.createRef();
      c28FieldContract = React.createRef();
      c29FieldContract = React.createRef();
      c30FieldContract = React.createRef();
      c31FieldContract = React.createRef();
      c32FieldContract = React.createRef();
      c33FieldContract = React.createRef();
      c34FieldContract = React.createRef();
      c35FieldContract = React.createRef();
      c36FieldContract = React.createRef();
      c37FieldContract = React.createRef();
      c38FieldContract = React.createRef();
      c39FieldContract = React.createRef();
      c40FieldContract = React.createRef();
      c41FieldContract = React.createRef();
      c42FieldContract = React.createRef();
      c43FieldContract = React.createRef();
      c44FieldContract = React.createRef();
      c45FieldContract = React.createRef();
      c46FieldContract = React.createRef();
      c47FieldContract = React.createRef();
      c48FieldContract = React.createRef();
      c49FieldContract = React.createRef();
      c50FieldContract = React.createRef();
      c51FieldContract = React.createRef();
      c52FieldContract = React.createRef();
      c53FieldContract = React.createRef();
      c54FieldContract = React.createRef();
      c55FieldContract = React.createRef();
      c56FieldContract = React.createRef();
      c57FieldContract = React.createRef();
      c58FieldContract = React.createRef();
      c59FieldContract = React.createRef();
      c60FieldContract = React.createRef();

      c06FieldContractSearch = React.createRef();
      c13FieldContractSearch = React.createRef();

      static async getInitialProps({ query }) {
        const { id } = query;
        const { _id } = await Contract.findByUrlParam(id);
        return {
          logisticcontractId: _id,
        };
      }

      _onMessageWasSent(message) {
          this.setState({
            messageList: [...this.state.messageList, message]
          })
      }

      _sendMessage(text) {
          if (text.length > 0) {
            this.setState({
              messageList: [...this.state.messageList, {
                author: 'them',
                type: 'text',
                data: { text }
              }]
            })
          }
      }

      onContentStateChange: Function = (contentState) => {
        this.setState({contentState,});
        if (contentState === '' || contentState === null){
          this.setState({displayWriteUp: true})
        }else{
          this.setState({displayWriteUp: false})
        }
      };

      onEditorStateChange: Function = (editorState) => {
          this.setState({editorState,});
      };

      handleDate(val, chk){
        if (chk==='startDateX'){
          this.setState({startDate: new Date(val)})
        }else{
          if (chk==='endDateX'){
            this.setState({endDate: new Date(val)})
          }else{
           if (chk==='nowDate2X'){
             this.setState({nowDate2: new Date(val)})
           }else{
             if (chk==='workorderfecharealinicio'){
               if (!isNaN(Date.parse(this.state.workorderfechaterminosondaje))){
                 let fechaHoyX = this.state.workorderfechaterminosondaje
                 let diaX = fechaHoyX.getDate()
                 let mesX = fechaHoyX.getMonth()+1
                 let anioX = fechaHoyX.getFullYear()
                 let dia2X = 0
                 let mes2X = 0
                 if (diaX<10){dia2X = '0'+ diaX.toString()}else{ dia2X = diaX.toString()}
                 if (mesX<10){mes2X = '0'+ mesX.toString()}else{ mes2X = mesX.toString()}
                 const fechaterminosondaje2X = anioX.toString()+mes2X+dia2X

                 fechaHoyX = new Date(val)
                 diaX = fechaHoyX.getDate()
                 mesX = fechaHoyX.getMonth()+1
                 anioX = fechaHoyX.getFullYear()
                 dia2X = 0
                 mes2X = 0
                 if (diaX<10){dia2X = '0'+ diaX.toString()}else{ dia2X = diaX.toString()}
                 if (mesX<10){mes2X = '0'+ mesX.toString()}else{ mes2X = mesX.toString()}
                 const fecharealinicio2X = anioX.toString()+mes2X+dia2X

                 if (parseInt(fecharealinicio2X) <= parseInt(fechaterminosondaje2X)){
                    this.setState({workorderfecharealinicio: new Date(val)})
                 }
               }else{
                 this.setState({workorderfecharealinicio: new Date(val)})
               }
             }else{
               if (chk==='workorderfechainiciopozo'){

                 if (!isNaN(Date.parse(this.state.workorderfechaterminosondaje))){
                   let fechaHoyX = this.state.workorderfechaterminosondaje
                   let diaX = fechaHoyX.getDate()
                   let mesX = fechaHoyX.getMonth()+1
                   let anioX = fechaHoyX.getFullYear()
                   let dia2X = 0
                   let mes2X = 0
                   if (diaX<10){dia2X = '0'+ diaX.toString()}else{ dia2X = diaX.toString()}
                   if (mesX<10){mes2X = '0'+ mesX.toString()}else{ mes2X = mesX.toString()}
                   const fechaterminosondaje2X = anioX.toString()+mes2X+dia2X

                   fechaHoyX = new Date(val)
                   diaX = fechaHoyX.getDate()
                   mesX = fechaHoyX.getMonth()+1
                   anioX = fechaHoyX.getFullYear()
                   dia2X = 0
                   mes2X = 0
                   if (diaX<10){dia2X = '0'+ diaX.toString()}else{ dia2X = diaX.toString()}
                   if (mesX<10){mes2X = '0'+ mesX.toString()}else{ mes2X = mesX.toString()}
                   const fechainiciopozo2X = anioX.toString()+mes2X+dia2X

                   if (parseInt(fechainiciopozo2X) <= parseInt(fechaterminosondaje2X)){
                      this.setState({workorderfechainiciopozo: new Date(val)})
                   }
                 }else{
                   this.setState({workorderfechainiciopozo: new Date(val)})
                 }
               }else{
                 if (chk==='workorderfechaterminoperforacion'){

                   let cambia1X = false
                   if (!isNaN(Date.parse(this.state.workorderfechainiciopozo))){
                     let fechaHoyX = this.state.workorderfechainiciopozo
                     let diaX = fechaHoyX.getDate()
                     let mesX = fechaHoyX.getMonth()+1
                     let anioX = fechaHoyX.getFullYear()
                     let dia2X = 0
                     let mes2X = 0
                     if (diaX<10){dia2X = '0'+ diaX.toString()}else{ dia2X = diaX.toString()}
                     if (mesX<10){mes2X = '0'+ mesX.toString()}else{ mes2X = mesX.toString()}
                     const fechainiciopozo2X = anioX.toString()+mes2X+dia2X

                     fechaHoyX = new Date(val)
                     diaX = fechaHoyX.getDate()
                     mesX = fechaHoyX.getMonth()+1
                     anioX = fechaHoyX.getFullYear()
                     dia2X = 0
                     mes2X = 0
                     if (diaX<10){dia2X = '0'+ diaX.toString()}else{ dia2X = diaX.toString()}
                     if (mesX<10){mes2X = '0'+ mesX.toString()}else{ mes2X = mesX.toString()}
                     const fechaterminoperforacion2X = anioX.toString()+mes2X+dia2X

                     if (parseInt(fechaterminoperforacion2X) >= parseInt(fechainiciopozo2X)){
                        cambia1X = true
                     }
                   }else{
                     cambia1X = true
                   }

                   let cambia2X = false
                   if (!isNaN(Date.parse(this.state.workorderfechaterminosondaje))){
                     let fechaHoyX = this.state.workorderfechaterminosondaje
                     let diaX = fechaHoyX.getDate()
                     let mesX = fechaHoyX.getMonth()+1
                     let anioX = fechaHoyX.getFullYear()
                     let dia2X = 0
                     let mes2X = 0
                     if (diaX<10){dia2X = '0'+ diaX.toString()}else{ dia2X = diaX.toString()}
                     if (mesX<10){mes2X = '0'+ mesX.toString()}else{ mes2X = mesX.toString()}
                     const fechafechaterminosondaje2X = anioX.toString()+mes2X+dia2X

                     fechaHoyX = new Date(val)
                     diaX = fechaHoyX.getDate()
                     mesX = fechaHoyX.getMonth()+1
                     anioX = fechaHoyX.getFullYear()
                     dia2X = 0
                     mes2X = 0
                     if (diaX<10){dia2X = '0'+ diaX.toString()}else{ dia2X = diaX.toString()}
                     if (mesX<10){mes2X = '0'+ mesX.toString()}else{ mes2X = mesX.toString()}
                     const fechaterminoperforacion2X = anioX.toString()+mes2X+dia2X

                     if (parseInt(fechaterminoperforacion2X) <= parseInt(fechafechaterminosondaje2X)){
                        cambia2X = true
                     }
                   }else{
                     cambia2X = true
                   }

                   if (cambia1X && cambia2X){
                      this.setState({workorderfechaterminoperforacion: new Date(val)})
                   }

                 }else{
                   if (chk==='workorderfechaterminosondaje'){

                     let cambia1X = false
                     if (!isNaN(Date.parse(this.state.workorderfechainiciopozo))){
                       let fechaHoyX = this.state.workorderfechainiciopozo
                       let diaX = fechaHoyX.getDate()
                       let mesX = fechaHoyX.getMonth()+1
                       let anioX = fechaHoyX.getFullYear()
                       let dia2X = 0
                       let mes2X = 0
                       if (diaX<10){dia2X = '0'+ diaX.toString()}else{ dia2X = diaX.toString()}
                       if (mesX<10){mes2X = '0'+ mesX.toString()}else{ mes2X = mesX.toString()}
                       const fechainiciopozo2X = anioX.toString()+mes2X+dia2X

                       fechaHoyX = new Date(val)
                       diaX = fechaHoyX.getDate()
                       mesX = fechaHoyX.getMonth()+1
                       anioX = fechaHoyX.getFullYear()
                       dia2X = 0
                       mes2X = 0
                       if (diaX<10){dia2X = '0'+ diaX.toString()}else{ dia2X = diaX.toString()}
                       if (mesX<10){mes2X = '0'+ mesX.toString()}else{ mes2X = mesX.toString()}
                       const fechaterminosondaje2X = anioX.toString()+mes2X+dia2X

                       if (parseInt(fechaterminosondaje2X) >= parseInt(fechainiciopozo2X)){
                          cambia1X = true
                       }
                     }else{
                       cambia1X = true
                     }

                     let cambia2X = false
                     if (!isNaN(Date.parse(this.state.workorderfechaterminoperforacion))){
                       let fechaHoyX = this.state.workorderfechaterminoperforacion
                       let diaX = fechaHoyX.getDate()
                       let mesX = fechaHoyX.getMonth()+1
                       let anioX = fechaHoyX.getFullYear()
                       let dia2X = 0
                       let mes2X = 0
                       if (diaX<10){dia2X = '0'+ diaX.toString()}else{ dia2X = diaX.toString()}
                       if (mesX<10){mes2X = '0'+ mesX.toString()}else{ mes2X = mesX.toString()}
                       const fechafechaterminoperforacion2X = anioX.toString()+mes2X+dia2X

                       fechaHoyX = new Date(val)
                       diaX = fechaHoyX.getDate()
                       mesX = fechaHoyX.getMonth()+1
                       anioX = fechaHoyX.getFullYear()
                       dia2X = 0
                       mes2X = 0
                       if (diaX<10){dia2X = '0'+ diaX.toString()}else{ dia2X = diaX.toString()}
                       if (mesX<10){mes2X = '0'+ mesX.toString()}else{ mes2X = mesX.toString()}
                       const fechaterminosondaje2X = anioX.toString()+mes2X+dia2X

                       if (parseInt(fechaterminosondaje2X) >= parseInt(fechafechaterminoperforacion2X)){
                          cambia2X = true
                       }
                     }else{
                       cambia2X = true
                     }

                     if (cambia1X && cambia2X){
                        this.setState({workorderfechaterminosondaje: new Date(val)})
                     }

                   }
                 }
               }
             }
           }
         }
        }
      }

      handleContractNumber = (e) => {
        let contractNumberX = this.c02ConfigurationContract.current.value
        if (contractNumberX.includes('!') || contractNumberX.includes('"') || contractNumberX.includes('#') || contractNumberX.includes('$') || contractNumberX.includes('%') ||
            contractNumberX.includes('&') || contractNumberX.includes('/') || contractNumberX.includes('(') || contractNumberX.includes(')') || contractNumberX.includes('=') ||
            contractNumberX.includes('?') || contractNumberX.includes('¡') || contractNumberX.includes('¿') || contractNumberX.includes('*') || contractNumberX.includes('{') ||
            contractNumberX.includes('}') || contractNumberX.includes('[') || contractNumberX.includes(']') || contractNumberX.includes(',') || contractNumberX.includes('.') ||
            contractNumberX.includes(' ') || contractNumberX.includes('\\') || contractNumberX.includes('|') || contractNumberX.includes("'") || contractNumberX.includes(';') ||
            contractNumberX.includes(':') || contractNumberX.includes('+') || contractNumberX.includes('<') || contractNumberX.includes('>') || contractNumberX.includes('@')) {

            this.c02ConfigurationContract.current.value = contractNumberX.substring(0,contractNumberX.length-1)

        }
      }

      handleChange(e,chk) {
        const newState = {};
        newState[chk] = !this.state[chk];
        this.setState({...this.state, ...newState, isErrorWrite: false});

        if (chk==='arrowsort' && this.state.arrowsort===true){
          this.setState({arrowsort:false, arrowsortChange: this.state.jsonBlockstackZ50.reverse()})
        }else{
          if (chk==='arrowsort' && this.state.arrowsort===false){
            this.setState({arrowsort:true, arrowsortChange: this.state.jsonBlockstackZ50.reverse()})
          }
        }

        if (chk==='arrowsort1' && this.state.arrowsort1===true){
          this.setState({arrowsort1:false, jsonBlockstackZ50: this.state.jsonBlockstackZ50.sort(function(a, b){
              // Use toUpperCase() to ignore character casing
              let nZeroes = '00000000000000000000'
              let nLengthA = a.configurationContractNumber.length
              let nLengthB = b.configurationContractNumber.length
              let nContractA = nZeroes.substring(0,20-nLengthA)+a.configurationContractNumber
              let nContractB = nZeroes.substring(0,20-nLengthB)+b.configurationContractNumber
              const bandA = a.typeContract.toUpperCase()+nContractA.toUpperCase();
              const bandB = b.typeContract.toUpperCase()+nContractB.toUpperCase();
              let comparison = 0;
              if (bandA > bandB) {
                comparison = 1;
              } else if (bandA < bandB) {
                comparison = -1;
              }
              return comparison})})
        }else{
          if (chk==='arrowsort1' && this.state.arrowsort1===false){
            this.setState({arrowsort1:true, jsonBlockstackZ50: this.state.jsonBlockstackZ50.sort(function(a, b){
                // Use toUpperCase() to ignore character casing
                let nZeroes = '00000000000000000000'
                let nLengthA = a.configurationContractNumber.length
                let nLengthB = b.configurationContractNumber.length
                let nContractA = nZeroes.substring(0,20-nLengthA)+a.configurationContractNumber
                let nContractB = nZeroes.substring(0,20-nLengthB)+b.configurationContractNumber
                const bandA = a.typeContract.toUpperCase()+nContractA.toUpperCase();
                const bandB = b.typeContract.toUpperCase()+nContractB.toUpperCase();
                let comparison = 0;
                if (bandB > bandA) {
                  comparison = 1;
                } else if (bandB < bandA) {
                  comparison = -1;
                }
                return comparison})})
          }
        }
        if (chk==='arrowsort2' && this.state.arrowsort2===true){
          this.setState({arrowsort2:false, jsonBlockstackZ50: this.state.jsonBlockstackZ50.sort(function(a, b){
              // Use toUpperCase() to ignore character casing
              const bandA = a.origin.toUpperCase();
              const bandB = b.origin.toUpperCase();
              let comparison = 0;
              if (bandA > bandB) {
                comparison = 1;
              } else if (bandA < bandB) {
                comparison = -1;
              }
              return comparison})})
        }else{
          if (chk==='arrowsort2' && this.state.arrowsort2===false){
            this.setState({arrowsort2:true, jsonBlockstackZ50: this.state.jsonBlockstackZ50.sort(function(a, b){
                // Use toUpperCase() to ignore character casing
                const bandA = a.origin.toUpperCase();
                const bandB = b.origin.toUpperCase();
                let comparison = 0;
                if (bandB > bandA) {
                  comparison = 1;
                } else if (bandB < bandA) {
                  comparison = -1;
                }
                return comparison})})
          }
        }
        if (chk==='arrowsort3' && this.state.arrowsort3===true){
          this.setState({arrowsort3:false, jsonBlockstackZ50: this.state.jsonBlockstackZ50.sort(function(a, b){
              // Use toUpperCase() to ignore character casing
              const bandA = a.subject.toUpperCase();
              const bandB = b.subject.toUpperCase();
              let comparison = 0;
              if (bandA > bandB) {
                comparison = 1;
              } else if (bandA < bandB) {
                comparison = -1;
              }
              return comparison})})
        }else{
          if (chk==='arrowsort3' && this.state.arrowsort3===false){
            this.setState({arrowsort3:true, jsonBlockstackZ50: this.state.jsonBlockstackZ50.sort(function(a, b){
                // Use toUpperCase() to ignore character casing
                const bandA = a.subject.toUpperCase();
                const bandB = b.subject.toUpperCase();
                let comparison = 0;
                if (bandB > bandA) {
                  comparison = 1;
                } else if (bandB < bandA) {
                  comparison = -1;
                }
                return comparison})})
          }
        }

        if (chk==='arrowsort4' && this.state.arrowsort4===true){
          this.setState({arrowsort4:false, jsonBlockstackZ50: this.state.jsonBlockstackZ50.sort(function(a, b){
              // Use toUpperCase() to ignore character casing
              const bandA = a.typeContract.toUpperCase();
              const bandB = b.typeContract.toUpperCase();
              let comparison = 0;
              if (bandA > bandB) {
                comparison = 1;
              } else if (bandA < bandB) {
                comparison = -1;
              }
              return comparison})})
        }else{
          if (chk==='arrowsort4' && this.state.arrowsort4===false){
            this.setState({arrowsort4:true, jsonBlockstackZ50: this.state.jsonBlockstackZ50.sort(function(a, b){
                // Use toUpperCase() to ignore character casing
                const bandA = a.typeContract.toUpperCase();
                const bandB = b.typeContract.toUpperCase();
                let comparison = 0;
                if (bandB > bandA) {
                  comparison = 1;
                } else if (bandB < bandA) {
                  comparison = -1;
                }
                return comparison})})
          }
        }

        if (chk==='arrowsort5' && this.state.arrowsort5===true){
          this.setState({arrowsort5:false, jsonBlockstackZ50: this.state.jsonBlockstackZ50.sort(function(a, b){
              // Use toUpperCase() to ignore character casing
              let mesA = a.dateLogisticContract.substring(4,7).toUpperCase()
              if (mesA === 'JAN'){mesA='01'}
              if (mesA === 'FEB'){mesA='02'}
              if (mesA === 'MAR'){mesA='03'}
              if (mesA === 'APR'){mesA='04'}
              if (mesA === 'MAY'){mesA='05'}
              if (mesA === 'JUN'){mesA='06'}
              if (mesA === 'JUL'){mesA='07'}
              if (mesA === 'AUG'){mesA='08'}
              if (mesA === 'SEP'){mesA='09'}
              if (mesA === 'OCT'){mesA='10'}
              if (mesA === 'NOV'){mesA='11'}
              if (mesA === 'DEC'){mesA='12'}
              let mesB = b.dateLogisticContract.substring(4,7).toUpperCase()
              if (mesB === 'JAN'){mesB='01'}
              if (mesB === 'FEB'){mesB='02'}
              if (mesB === 'MAR'){mesB='03'}
              if (mesB === 'APR'){mesB='04'}
              if (mesB === 'MAY'){mesB='05'}
              if (mesB === 'JUN'){mesB='06'}
              if (mesB === 'JUL'){mesB='07'}
              if (mesB === 'AUG'){mesB='08'}
              if (mesB === 'SEP'){mesB='09'}
              if (mesB === 'OCT'){mesB='10'}
              if (mesB === 'NOV'){mesB='11'}
              if (mesB === 'DEC'){mesB='12'}

              let nZeroes = '00000000000000000000'
              let nLengthA = a.configurationContractNumber.length
              let nLengthB = b.configurationContractNumber.length
              let nContractA = nZeroes.substring(0,20-nLengthA)+a.configurationContractNumber
              let nContractB = nZeroes.substring(0,20-nLengthB)+b.configurationContractNumber

              const bandA = a.dateLogisticContract.substring(11,15).toUpperCase()+mesA+a.dateLogisticContract.substring(8,10).toUpperCase()+nContractA.toUpperCase();
              const bandB = b.dateLogisticContract.substring(11,15).toUpperCase()+mesB+b.dateLogisticContract.substring(8,10).toUpperCase()+nContractB.toUpperCase();
              let comparison = 0;
              if (bandA > bandB) {
                comparison = 1;
              } else if (bandA < bandB) {
                comparison = -1;
              }
              return comparison})})
        }else{
          if (chk==='arrowsort5' && this.state.arrowsort5===false){
            this.setState({arrowsort5:true, jsonBlockstackZ50: this.state.jsonBlockstackZ50.sort(function(a, b){
              // Use toUpperCase() to ignore character casing
              let mesA = a.dateLogisticContract.substring(4,7).toUpperCase()
              if (mesA === 'JAN'){mesA='01'}
              if (mesA === 'FEB'){mesA='02'}
              if (mesA === 'MAR'){mesA='03'}
              if (mesA === 'APR'){mesA='04'}
              if (mesA === 'MAY'){mesA='05'}
              if (mesA === 'JUN'){mesA='06'}
              if (mesA === 'JUL'){mesA='07'}
              if (mesA === 'AUG'){mesA='08'}
              if (mesA === 'SEP'){mesA='09'}
              if (mesA === 'OCT'){mesA='10'}
              if (mesA === 'NOV'){mesA='11'}
              if (mesA === 'DEC'){mesA='12'}
              let mesB = b.dateLogisticContract.substring(4,7).toUpperCase()
              if (mesB === 'JAN'){mesB='01'}
              if (mesB === 'FEB'){mesB='02'}
              if (mesB === 'MAR'){mesB='03'}
              if (mesB === 'APR'){mesB='04'}
              if (mesB === 'MAY'){mesB='05'}
              if (mesB === 'JUN'){mesB='06'}
              if (mesB === 'JUL'){mesB='07'}
              if (mesB === 'AUG'){mesB='08'}
              if (mesB === 'SEP'){mesB='09'}
              if (mesB === 'OCT'){mesB='10'}
              if (mesB === 'NOV'){mesB='11'}
              if (mesB === 'DEC'){mesB='12'}

              let nZeroes = '00000000000000000000'
              let nLengthA = a.configurationContractNumber.length
              let nLengthB = b.configurationContractNumber.length
              let nContractA = nZeroes.substring(0,20-nLengthA)+a.configurationContractNumber
              let nContractB = nZeroes.substring(0,20-nLengthB)+b.configurationContractNumber

              const bandA = a.dateLogisticContract.substring(11,15).toUpperCase()+mesA+a.dateLogisticContract.substring(8,10).toUpperCase()+nContractA.toUpperCase();
              const bandB = b.dateLogisticContract.substring(11,15).toUpperCase()+mesB+b.dateLogisticContract.substring(8,10).toUpperCase()+nContractB.toUpperCase();
                let comparison = 0;
                if (bandB > bandA) {
                  comparison = 1;
                } else if (bandB < bandA) {
                  comparison = -1;
                }
                return comparison})})
          }
        }

        if (this.state.JSONTemplateName === 'delivery' || this.state.JSONTemplateName === 'simulate'){
            if (chk==='c03ConfigurationContract' && this.state.c03ConfigurationContract===true){
              this.setState({c08SensorContract:false})
            }else{
              if (chk==='c03ConfigurationContract' && this.state.c03ConfigurationContract===false){
                this.setState({c08SensorContract:true})
              }
            }
            if (chk==='c04ConfigurationContract' && this.state.c04ConfigurationContract===true){
              this.setState({disableSensor:true, c01SensorContract:false, c02SensorContract:false, c03SensorContract:false})
            }else{
              if (chk==='c04ConfigurationContract' && this.state.c04ConfigurationContract===false){
                this.setState({disableSensor:false, c01SensorContract:true, c02SensorContract:true, c03SensorContract:true})
              }
            }
        }else{
          if (this.state.JSONTemplateName === 'maintenance'){
          }else{
            if (this.state.JSONTemplateName === 'maintenance'){
            }else{
              if (this.state.JSONTemplateName === 'proforma'){
                if (chk==='Quantity'){
                  if (isNaN(this.c27FieldContract.current.value)){
                    this.c27FieldContract.current.value = 0
                  }
                }
                if (chk==='UnitPrice'){
                  if (isNaN(this.c28FieldContract.current.value)){
                    this.c28FieldContract.current.value = 0
                  }
                }
                if (chk==='Discount' || chk==='Shipping'){
                    if (this.c29FieldContract.current.value === undefined || this.c29FieldContract.current.value === null || this.c29FieldContract.current.value === ''){this.c29FieldContract.current.value = 0}
                    if (this.c30FieldContract.current.value === undefined || this.c30FieldContract.current.value === null || this.c30FieldContract.current.value === ''){this.c30FieldContract.current.value = 0}
                    if (this.c31FieldContract.current.value === undefined || this.c31FieldContract.current.value === null || this.c31FieldContract.current.value === ''){this.c31FieldContract.current.value = 0}
                    if (this.c32FieldContract.current.value === undefined || this.c32FieldContract.current.value === null || this.c32FieldContract.current.value === ''){this.c32FieldContract.current.value = 0}
                    if (this.c33FieldContract.current.value === undefined || this.c33FieldContract.current.value === null || this.c33FieldContract.current.value === ''){this.c33FieldContract.current.value = 0}
                    if (this.c34FieldContract.current.value === undefined || this.c34FieldContract.current.value === null || this.c34FieldContract.current.value === ''){this.c34FieldContract.current.value = 0}
                    if (isNaN(this.c30FieldContract.current.value)){
                      this.c30FieldContract.current.value = 0
                    }
                    if (isNaN(this.c33FieldContract.current.value)){
                      this.c33FieldContract.current.value = 0
                    }
                    if (parseFloat(this.c29FieldContract.current.value) >= parseFloat(this.c30FieldContract.current.value)){
                      this.c31FieldContract.current.valulistContract3Namese = parseFloat(this.state.tax30X)
                      const c32 = (parseFloat(this.state.tax30X) * ((parseFloat(this.c29FieldContract.current.value) - parseFloat(this.c30FieldContract.current.value)))) / 100
                      this.c32FieldContract.current.value = c32.toFixed(2)
                      const c34 = parseFloat(this.c29FieldContract.current.value) - parseFloat(this.c30FieldContract.current.value) + parseFloat(this.c32FieldContract.current.value) + parseFloat(this.c33FieldContract.current.value)
                      this.c34FieldContract.current.value = c34.toFixed(2)
                    }else{
                      this.c30FieldContract.current.value = 0
                    }
                  }
              }
            }
          }
        }
      }

      sortList = (jsonBlockstackSort) => {
        return new Promise ((resolve2, reject2) =>{
          this.setState({arrowsort5:true, jsonBlockstackZ50: jsonBlockstackSort.sort(function(a, b){
              let mesA = a.dateLogisticContract.substring(4,7).toUpperCase()
              if (mesA === 'JAN'){mesA='01'}
              if (mesA === 'FEB'){mesA='02'}
              if (mesA === 'MAR'){mesA='03'}
              if (mesA === 'APR'){mesA='04'}
              if (mesA === 'MAY'){mesA='05'}
              if (mesA === 'JUN'){mesA='06'}
              if (mesA === 'JUL'){mesA='07'}
              if (mesA === 'AUG'){mesA='08'}
              if (mesA === 'SEP'){mesA='09'}
              if (mesA === 'OCT'){mesA='10'}
              if (mesA === 'NOV'){mesA='11'}
              if (mesA === 'DEC'){mesA='12'}
              let mesB = b.dateLogisticContract.substring(4,7).toUpperCase()
              if (mesB === 'JAN'){mesB='01'}
              if (mesB === 'FEB'){mesB='02'}
              if (mesB === 'MAR'){mesB='03'}
              if (mesB === 'APR'){mesB='04'}
              if (mesB === 'MAY'){mesB='05'}
              if (mesB === 'JUN'){mesB='06'}
              if (mesB === 'JUL'){mesB='07'}
              if (mesB === 'AUG'){mesB='08'}
              if (mesB === 'SEP'){mesB='09'}
              if (mesB === 'OCT'){mesB='10'}
              if (mesB === 'NOV'){mesB='11'}
              if (mesB === 'DEC'){mesB='12'}

              const bandA = a.dateLogisticContract.substring(11,15).toUpperCase()+mesA+a.dateLogisticContract.substring(8,10).toUpperCase();
              const bandB = b.dateLogisticContract.substring(11,15).toUpperCase()+mesB+b.dateLogisticContract.substring(8,10).toUpperCase();
                let comparison = 0;
                if (bandB > bandA) {
                  comparison = 1;
                } else if (bandB < bandA) {
                  comparison = -1;
                }
                return comparison})})
            resolve2()
        })
      }


      handleChangeOption = (optSearch,disabledX) => {
        if (disabledX === false){
          this.setState({selectedTypeMaintenance: optSearch, selectedSignaturePayment: optSearch});
          /*
          if (optSearch === 'SignatureOnly'){
            this.c16FieldContract.current.value = ''
            this.c60FieldContract.current.value = 'FIAT Money'
            this.c20FieldContract.current.value = ''
          }else{
            this.c16FieldContract.current.value = this.state.FIACurrency
            this.c60FieldContract.current.value = 'FIAT Money'
            this.c20FieldContract.current.value = ''
          }
          this.setState({currencyType: 'FIAT Money'});
          */
        }
      }

      handleChangeEditor = () => {
        this.setState({editorChange: true});
      }

      handleChangeCriptoFIAT = (e) => {
        this.setState({currencyType: this.c60FieldContract.current.value});
      }

      handleDialog = (type, action) => {
          if (type === 'Confirm: 3001') {
              if (action === 'confirm') {
                  const optx = this.state.iContractTable
                  const typeContract = this.state.typeContractSign
                  const configurationContractNumber = this.state.configurationContractNumberSign
                  this.setState({ dialogOpen: false, deleteListContract: true });
              }
              else if (action === 'cancel') {
                this.setState({ dialogOpen: false, deleteListContract: false });
              }
          }else{
            if (type === 'Confirm: 3002') {
                if (action === 'confirm') {
                    this.setState({ dialogOpenWriteBlockchain: false });
                    if (this.state.cContractPolicy){
                        if (this.state.typeContractSign==='simulate' && this.state.configurationContractNumberSign==='sim00001'){
                          let e = ''
                          this.saveBlockchainPact(e)
                          this.nuevoContract(e,'modify','blockchain')
                        }else{
                          this.setState({ dialogOpenWalletSinSaldo: true });
                          this.walletSinSaldoContract()
                        }
                    }else{
                      this.saveDraftAgreeConfirm()
                    }
                }
                else if (action === 'cancel') {
                  this.setState({ dialogOpenWriteBlockchain: false, dialogOpenWalletSinSaldo: false });
                }
            }else{
              if (type === 'Error: 1001') {
                  if (action === 'cancel') {
                    this.setState({ dialogOpenWriteBlockchain: false, dialogOpenWalletSinSaldo: false });
                  }
              }else{
                if (type === 'Confirm: 3003') {
                   if (action === 'confirm') {
                        this.setState({ dialogOpenSign: false });
                        this.signContract()
                   }else{
                     if (action === 'cancel') {
                      this.setState({ dialogOpenSign: false });
                     }
                   }
                }else{
                  if (type === 'Confirm: 3004') {
                     if (action === 'confirm') {
                          this.setState({ dialogOpenUnSign: false });
                          this.unsignContract()
                     }else{
                       if (action === 'cancel') {
                        this.setState({ dialogOpenUnSign: false });
                       }
                     }
                  }else{
                     if (type === 'Error: 1002') {
                        if (action === 'cancel') {
                          this.setState({ dialogOpenContractExist: false });
                        }
                      }else{
                        if (type === 'Confirm: 3005') {
                            if (action === 'confirm') {
                                this.setState({ dialogOpenDeactivate: false });
                                let e = ''
                                this.nuevoContract(e, "delete", "cloud")
                            }
                            else if (action === 'cancel') {
                              this.setState({ dialogOpenDeactivate: false });
                            }
                        }else{
                          if (type === 'Confirm: 3006') {
                              if (action === 'confirm') {
                                  this.setState({ dialogOpenDeactivate: false });
                                  let e = ''
                                  this.nuevoContract(e, "modify", "cloud")
                              }
                              else if (action === 'cancel') {
                                this.setState({ dialogOpenDeactivate: false });
                              }
                          }else{
                            if (type === 'Confirm: 3015') {
                                if (action === 'confirm') {
                                    this.setState({ dialogOpenDeactivate: false });
                                    let e = ''
                                    this.nuevoContract(e, "inactive_after_published", "blockchain")
                                }
                                else if (action === 'cancel') {
                                  this.setState({ dialogOpenDeactivate: false });
                                }
                            }else{
                              if (type === 'Confirm: 3016') {
                                  if (action === 'confirm') {
                                      this.setState({ dialogOpenDeactivate: false });
                                      let e = ''
                                      this.nuevoContract(e, "active_after_published", "blockchain")
                                  }
                                  else if (action === 'cancel') {
                                    this.setState({ dialogOpenDeactivate: false });
                                  }
                              }else{
                                if (type === 'Error: 1003') {
                                  if (action === 'cancel') {
                                    this.setState({ dialogOpenSaveDraft: false });
                                  }
                                }else{
                                  if (type === 'Error: 1004') {
                                    if (action === 'cancel') {
                                      this.setState({ dialogOpenSaveDraftAgree: false });
                                    }
                                  }else{
                                      if (type === 'Warning: 2001') {
                                      }else{
                                         if (type === 'Error: 1005') {
                                            if (action === 'cancel') {
                                              this.setState({ dialogOpenSaveDraft: false });
                                            }
                                         }else{
                                            if (type === 'Confirm: 3007') {
                                               if (action === 'confirm') {
                                                    this.setState({ dialogOpen: false });
                                                    this.sendContract()
                                               }else{
                                                 if (action === 'cancel') {
                                                  this.setState({ dialogOpen: false });
                                                 }
                                               }
                                            }else{
                                               if (type === 'Confirm: 3008') {
                                                  if (action === 'confirm') {
                                                       this.setState({ dialogOpen: false });
                                                       let e = ''
                                                       if (localStorage["correlativoAttach"]) {
                                                          const i = localStorage.getItem('correlativoAttach')
                                                         this.clickRemoveAttach(e, i)
                                                       }
                                                  }else{
                                                    if (action === 'cancel') {
                                                     this.setState({ dialogOpen: false });
                                                    }
                                                  }
                                                }else{
                                                   if (type === 'Confirm: 3009') {
                                                      if (action === 'confirm') {
                                                           this.setState({ dialogOpen: false });
                                                           let e = ''
                                                           if (localStorage["correlativoProformaDetail"]) {
                                                              const i = localStorage.getItem('correlativoProformaDetail')
                                                             this.clickRemoveProformaDetail(e, i)
                                                           }
                                                      }else{
                                                        if (action === 'cancel') {
                                                         this.setState({ dialogOpen: false });
                                                        }
                                                      }
                                                    }else{
                                                       if (type === 'Confirm: 3010') {
                                                          if (action === 'confirm') {
                                                               this.setState({ dialogOpen: false });
                                                               let e = ''
                                                               if (localStorage["correlativoProformaDetail"]) {
                                                                  const i = localStorage.getItem('correlativoProformaDetail')
                                                                 this.clickEditProformaDetail(e, i)
                                                               }
                                                          }else{
                                                            if (action === 'cancel') {
                                                             this.setState({ dialogOpen: false });
                                                            }
                                                          }
                                                       }else{
                                                           if (type === 'Error: 1006') {
                                                              if (action === 'cancel') {
                                                                  this.setState({ dialogOpenSaveDraft: false });
                                                              }
                                                           }else{
                                                             if (type === 'Warning: 2002') {
                                                                 if (action === 'cancel') {
                                                                   this.setState({ dialogOpenWalletSinSaldo: false });
                                                                 }
                                                             }else{
                                                               if (type === 'Confirm: 3011') {
                                                                   if (action === 'confirm') {
                                                                       let archiveContractX = JSON.parse(localStorage.getItem('archiveContract'))
                                                                       const optx = archiveContractX.iContractTable
                                                                       const typeContract = archiveContractX.typeContractSign
                                                                       const configurationContractNumber = archiveContractX.configurationContractNumberSign
                                                                       this.setState({ dialogOpen: false });
                                                                       this.storeListContract(optx,typeContract,configurationContractNumber)
                                                                   }
                                                                   else if (action === 'cancel') {
                                                                     this.setState({ dialogOpen: false });
                                                                   }
                                                                }else{
                                                                  if (type === 'Confirm: 3012') {
                                                                      if (action === 'confirm') {
                                                                          let archiveContractX = JSON.parse(localStorage.getItem('archiveContract'))
                                                                          const optx = archiveContractX.iContractTable
                                                                          const typeContract = archiveContractX.typeContractSign
                                                                          const configurationContractNumber = archiveContractX.configurationContractNumberSign
                                                                          this.setState({ dialogOpen: false });
                                                                          this.unarchiveListContract(optx,typeContract,configurationContractNumber)
                                                                      }
                                                                      else if (action === 'cancel') {
                                                                        this.setState({ dialogOpen: false });
                                                                      }
                                                                   }else{
                                                                     if (type === 'Error: 1007') {
                                                                        if (action === 'cancel') {
                                                                           this.setState({ dialogOpenPaymentForm: false });
                                                                        }
                                                                     }else{
                                                                       if (type === 'Error: 1008') {
                                                                          if (action === 'cancel') {
                                                                             this.setState({ dialogOpenPaymentForm: false });
                                                                          }
                                                                       }
                                                                     }
                                                                   }
                                                                }
                                                             }
                                                          }
                                                       }
                                                    }
                                                 }
                                              }
                                           }
                                        }
                                     }
                                  }
                               }
                            }
                          }
                        }
                     }
                  }
                }
              }
            }
          }
      }

      handleCaracteresEspeciales = (e) => {
        let palabra = e.target.value
        let ArrayIdValue = palabra.split(`"`)
        e.target.value = ArrayIdValue[0]
        palabra = e.target.value
        ArrayIdValue = palabra.split("'")
        e.target.value = ArrayIdValue[0]
      }

      handleSelect(selectedTab) {
         this.setState({activeTab: selectedTab});
      }

      toggle = tab => e => {
        if (this.state.activeItem !== tab) {
          this.setState({activeItem: tab});
        }
      };

      handleChangeNumber(e,chk) {
      }

      handleBlurNumber(e,chk) {
      }

      handleInputNumber(e,chk) {
          if (chk==='temperatureLowerThreshold'){
            if (this.sensorTemperatureLowerThreshold.current.value.length===0){
               this.sensorTemperatureLowerThreshold.current.value = ''
            }
          }else{
            if (chk==='temperatureUpperThreshold'){
              if (this.sensorTemperatureUpperThreshold.current.value.length===0){
                 this.sensorTemperatureUpperThreshold.current.value = ''
              }
            }
          }
          if (chk==='humidityLowerThreshold'){
            if (this.sensorHumidityLowerThreshold.current.value.length===0){
               this.sensorHumidityLowerThreshold.current.value = ''
            }
          }else{
            if (chk==='humidityUpperThreshold'){
              if (this.sensorHumidityUpperThreshold.current.value.length===0){
                 this.sensorHumidityUpperThreshold.current.value = ''
              }
            }
          }
          if (chk==='gascontrolLowerThreshold'){
            if (this.sensorGasControlLowerThreshold.current.value.length===0){
               this.sensorGasControlLowerThreshold.current.value = ''
            }
          }else{
            if (chk==='gascontrolUpperThreshold'){
              if (this.sensorGasControlUpperThreshold.current.value.length===0){
                 this.sensorGasControlUpperThreshold.current.value = ''
              }
            }
          }
          if (chk==='Amount'){
            if (this.c20FieldContract.current.value.length===0){
               this.c20FieldContract.current.value = ''
            }
          }
          if (chk==='MetaDia'){
            if (this.c48FieldContract.current.value.length===0){
               this.c48FieldContract.current.value = ''
            }
          }
          if (chk==='MetaNoche'){
            if (this.c49FieldContract.current.value.length===0){
               this.c49FieldContract.current.value = ''
            }
          }
      }

      getUploadParams = () => {
          return { url: 'https://httpbin.org/post' }
      }

      handleChangeStatus = ({ meta }, status) => {
          //console.log(status, meta)
      }

      handleSubmit  = (files, allFiles) => {
          const {userSession} = this.state
          const storage = new Storage({ userSession });
          const options = {contentType: 'application/json', encrypt: false, dangerouslyIgnoreEtag: true }
          let jsonAttachFile = this.state.jsonAttachFile
          let jsonBlockstack3 = JSON.stringify(jsonAttachFile)
          if (jsonBlockstack3.substring(0,1)==='"') {
             jsonBlockstack3 = jsonBlockstack3.substring(1,jsonBlockstack3.length - 1);
          }
          if (jsonBlockstack3.substring(0,1)==='[') {
             jsonBlockstack3 = jsonBlockstack3.substring(1,jsonBlockstack3.length - 1);
          }
          jsonAttachFile = jsonBlockstack3
          let jsonBlockstackAttach = {}
          let jsonBlockstackAttach2 = {}
          let status = 'Uploaded'
          files.map((todo,i)=>{
            jsonBlockstackAttach = files[i].meta
            jsonBlockstackAttach2 = files[i].xhr.response
            jsonBlockstackAttach2 = JSON.parse(jsonBlockstackAttach2)
            const {file} = jsonBlockstackAttach2.files
            const {id,lastModifiedDate,name,type,uploadedDate } = jsonBlockstackAttach
            if (jsonAttachFile.length === 0){
              jsonAttachFile =`{"id":"${id}","name":"${name}","type":"${type}","status":"${status}","lastModifiedDate":"${lastModifiedDate}","uploadedDate":"${uploadedDate}","userName":"${this.state.username}","deleteAttach":${true},"file":"${file}"}`
            }else{
              jsonAttachFile =`${jsonAttachFile},{"id":"${id}","name":"${name}","type":"${type}","status":"${status}","lastModifiedDate":"${lastModifiedDate}","uploadedDate":"${uploadedDate}","userName":"${this.state.username}","deleteAttach":${true},"file":"${file}"}`
            }
          })
          jsonAttachFile =`[${jsonAttachFile}]`
          jsonAttachFile = JSON.parse(jsonAttachFile)
          this.setState({jsonAttachFile:jsonAttachFile})
          putFileDB(this.state.username,`${this.state.typeContractSign}_${this.state.configurationContractNumberSign}_attachlist.json`, 'Crosscheck_Contract', JSON.stringify(jsonAttachFile), JSON.stringify(options))
            .then(keyUrl => {})
          allFiles.forEach(f => f.remove())
      }

      UNSAFE_componentWillMount() {
        this.setState({showLoader:true});
        if (localStorage["searchContract"]) {
            const categorySearch = localStorage.getItem('category')
            this.setState({ categorySearch: categorySearch })
            const jsonSearchTypeContract = localStorage.getItem('searchTypeContract')
            const jsonSearchContract = localStorage.getItem('searchContract')
            this.setState({ fromSearchList: true,
                            fromSearchListSearch: jsonSearchContract,
                            JSONTemplateName: jsonSearchTypeContract,
                            displayTemplateDetailTypeContract: true,
                            sinTemplateDetail: false})
            //------------------------------------------------------
        }else{
          this.setState({ searchContract2: false, fromSearch: false })
        }

        const { userSession } = this.state
        let stacksNetX = ''
        let serverStacksX = ''
        let networkUrlX = ''
        if (userSession.isUserSignedIn()) {
          const user = userSession.loadUserData()
          this.setState({ user })
          if (!localStorage["serverStacks"]) {
            serverStacksX = 'MainNet'
          }else{
            serverStacksX = localStorage.getItem('serverStacks')
          }
          if (serverStacksX === 'MainNet'){
             stacksNetX =  user.profile.stxAddress.mainnet
             networkUrlX = MAINNET_STACKS_API_URL
          }
          if (serverStacksX === 'TestNet'){
             stacksNetX =  user.profile.stxAddress.testnet
             networkUrlX = TESTNET_STACKS_API_URL
          }
        }
        const {identityAddress} = userSession.loadUserData();
        const {decentralizedID} = userSession.loadUserData();
        const {name} = userSession.loadUserData().profile;
        this.setState({ identityAddress,decentralizedID,nameBlockstack: name, networkUrlX })

        const languageX = localStorage.getItem('language')
        if (languageX === undefined || languageX === ''){
          this.setState({ language: 'English',mycontact: 'My Business Peers ',mytag: 'My Tags',newcontract: 'Select here for new contract' })
        }else{
          this.setState({ language: languageX })
        }
        if (languageX === 'English'){this.setState({ mycontact: 'My Business Peers ',mytag: 'My Tags',newcontract: 'Select here for new contract', displayTitleEdit: 'Edit this document', displayTitleArchive: 'Archive this document', displayTitleDelete: 'Delete this document' })}
        if (languageX === 'French'){this.setState({ mycontact: 'Mes Contacts',mytag: 'Mes Tags',newcontract: 'Sélectionnez ici pour le nouveau contrat', displayTitleEdit: 'Modifier ce document', displayTitleArchive: 'Archiver ce document', displayTitleDelete: 'Supprimer ce document' })}
        if (languageX === 'Spanish'){this.setState({ mycontact: 'Originador',mytag: 'Mis Etiquetas',newcontract: 'Seleccione aquí para un nuevo contrato', displayTitleEdit: 'Editar este documento', displayTitleArchive: 'Archivar este documento', displayTitleDelete: 'Eliminar este documento' })}
        if (languageX === 'Portuguese'){this.setState({ mycontact: 'Meus Contatos',mytag: 'Minhas Etiquetas',newcontract: 'Selecione aqui para novo contrato', displayTitleEdit: 'Edite este documento', displayTitleArchive: 'Arquivar este documento', displayTitleDelete: 'Excluir este documento' })}
        if (languageX === 'Swedish'){this.setState({ mycontact: 'Mina Kontakter',mytag: 'Mina Taggar',newcontract: 'Välj här för nytt kontrakt', displayTitleEdit: 'Redigera detta dokument', displayTitleArchive: 'Arkivera detta dokument', displayTitleDelete: 'Ta bort detta dokument' })}
        if (languageX === 'Netherlands'){this.setState({ mycontact: 'Mijn Contacten',mytag: 'Mijn Tags',newcontract: 'Selecteer hier voor nieuw contract', displayTitleEdit: 'Bewerk dit document', displayTitleArchive: 'Archiveer dit document', displayTitleDelete: 'Verwijder dit document' })}
        if (languageX === 'Russian'){this.setState({ mycontact: 'Мои контакты',mytag: 'Мои Теги',newcontract: 'Выберите здесь для нового контракта', displayTitleEdit: 'Изменить этот документ', displayTitleArchive: 'Архивировать этот документ', displayTitleDelete: 'Удалить этот документ' })}
        if (languageX === 'Japanese'){this.setState({ mycontact: '私の連絡先',mytag: '私のタグ',newcontract: '新しい契約についてはこちらを選択してください', displayTitleEdit: 'このドキュメントを編集', displayTitleArchive: 'この文書をアーカイブする', displayTitleDelete: 'この文書を削除' })}
        if (languageX === 'Chinese'){this.setState({ mycontact: '我的联络人',mytag: '我的标签',newcontract: '在这里选择新合同', displayTitleEdit: '编辑这份文件', displayTitleArchive: '存档此文件', displayTitleDelete: '删除此文件' })}
        if (languageX === 'German'){this.setState({ mycontact: 'Meine Kontakte',mytag: 'Meine Tags',newcontract: 'Wählen Sie hier für einen neuen Vertrag', displayTitleEdit: 'Bearbeiten Sie dieses Dokument', displayTitleArchive: 'Archivieren Sie dieses Dokument', displayTitleDelete: 'Löschen Sie dieses Dokument' })}
        if (languageX === 'Italian'){this.setState({ mycontact: 'I miei contatti',mytag: 'I miei tag',newcontract: 'Seleziona qui per il nuovo contratto', displayTitleEdit: 'Modifica questo documento', displayTitleArchive: 'Archivia questo documento', displayTitleDelete: 'Elimina questo documento' })}

        if (languageX === 'English'){this.setState({ isocode: "en", dateFormatX:"MM/dd/yyyy"})}
        if (languageX === 'French'){this.setState({ isocode:  "fr", dateFormatX:"MM/dd/yyyy"})}
        if (languageX === 'Spanish'){this.setState({ isocode:  "es", dateFormatX:"dd/MM/yyyy"})}
        if (languageX === 'Portuguese'){this.setState({ isocode:  "pt", dateFormatX:"dd/MM/yyyy"})}
        if (languageX === 'Swedish'){this.setState({ isocode:  "sv", dateFormatX:"MM/dd/yyyy"})}
        if (languageX === 'Netherlands'){this.setState({ isocode:  "nl", dateFormatX:"MM/dd/yyyy"})}
        if (languageX === 'Russian'){this.setState({ isocode:  "ru", dateFormatX:"MM/dd/yyyy"})}
        if (languageX === 'Japanese'){this.setState({ isocode:  "ja_JP", dateFormatX:"MM/dd/yyyy"})}
        if (languageX === 'Chinese'){this.setState({ isocode: "zh", dateFormatX:"MM/dd/yyyy"})}
        if (languageX === 'German'){this.setState({ isocode:  "de", dateFormatX:"MM/dd/yyyy"})}
        if (languageX === 'Italian'){this.setState({ isocode:  "it", dateFormatX:"MM/dd/yyyy"})}
        const {username} = userSession.loadUserData();
        if (username === '' || username === undefined || username === null){
          username_new(stacksNetX).then(val => {
            this.setState({username: val})
            Promise.all(
               [this.pushUserListRemote(val),
               this.goMostrarAllTemplates()
               ]
            ).then(
              (resolve) =>{
                this.listContract(val);
                this.setState({showLoader:false});},
              (reject) =>{
                this.listContract(val);
                this.setState({showLoader:false});}
            )
          })
        }else{
          this.setState({ username })
          Promise.all(
             [this.pushUserListRemote(username),
             this.goMostrarAllTemplates()
             ]
          ).then(
            (resolve) =>{
              this.listContract(username);
              this.setState({showLoader:false});},
            (reject) =>{
              this.listContract(username);
              this.setState({showLoader:false});}
          )
        }
      }

      componentDidMount() {
        this.publicKeySTXAddress()
        if (this.state.searchContract2===true){
            this.llenaDatosLocalStorage('')
        }
      }

      publicKeySTXAddress(){
        Promise.all(
           [this.publicKeyGet(),
            this.stxAddressGet()
           ]
        ).then(
          (resolve) =>{},
          (reject) =>{}
        )
      }

      publicKeyGet(){
        const {userSession} = this.state
        const storage = new Storage({ userSession });
        const options = {contentType: 'application/json', encrypt: false, dangerouslyIgnoreEtag: true }
        const privateKey = userSession.loadUserData().appPrivateKey;
        const publicKey2 = hexStringToECPair(privateKey).publicKey.toString('hex')
        const publicKeyPath = "publickey2.json"
        const publicKeyData = { publicKey2 }
        this.setState({ publicKey: publicKey2 })
        return new Promise ((resolve, reject) => {
          putFileDB(this.state.username,`${publicKeyPath}`, 'Crosscheck_Contract', JSON.stringify(publicKeyData), JSON.stringify(options))
          .then(() => {
            resolve()
          })
          .catch(error => {
            reject()
          });

        })
      }

      stxAddressGet(){
        const {userSession} = this.state
        const storage = new Storage({ userSession });
        const options = {contentType: 'application/json', encrypt: false, dangerouslyIgnoreEtag: true }
        const user = userSession.loadUserData()
        this.setState({ user })

        const addressMainNetX =  user.profile.stxAddress.mainnet
        const addressTestNetX =  user.profile.stxAddress.testnet

        const stxAddressKeyPath = "stxaddress3.json"
        const stxAddressKeyData = { addressMainNetX, addressTestNetX  }
        return new Promise ((resolve, reject) => {
          putFileDB(this.state.username,`${stxAddressKeyPath}`, 'Crosscheck_Contract', JSON.stringify(stxAddressKeyData), JSON.stringify(options))
          .then(() => {
            resolve()
          })
          .catch(error => {
            reject()
          });
        })
      }

      pushUserListRemote(userX){
        let existCookies = Cookies.get("userName");
        if(existCookies){
          let userlist = JSON.parse(Cookies.get("userName"));
            //----------------------------------------------------------
            Promise.all(
               [this.pushGetUserListRemote(userlist,userX)]
            ).then(
              (resolve) =>{
                 Cookies.remove('userName');
              },
              (reject) =>{
              }
            )
            //----------------------------------------------------------
        }
      }

      pushGetUserListRemote(userlist,userX){
        const {userSession} = this.state
        const storage = new Storage({ userSession });
        const options = { decrypt: false, verify: false }
        let jsonBlockstack6 = []
        let jsonBlockstack7 = []
        return new Promise ((resolve, reject) =>{
          getFileDB(userX, `userlist_remote.json`)
             .then((fileContents) => {
               if(fileContents) {
                 const jsonBlockstack1 = JSON.parse(fileContents)
                 const jsonBlockstack2 = jsonBlockstack1.data
                 let jsonBlockstack5 = '[]'
                 if (jsonBlockstack2 !== null){
                    const jsonBlockstack3 = jsonBlockstack2.dataobject
                    const jsonBlockstack4 = jsonBlockstack3.replace(/\\/g,"");
                    if (jsonBlockstack4.substring(0,1) === '"') {
                       jsonBlockstack5 = jsonBlockstack4.substring(1,jsonBlockstack4.length - 1)
                    } else {
                       jsonBlockstack5 = jsonBlockstack4
                    }
                 }
                 let jsonBlockstack6 = JSON.parse(jsonBlockstack5)

                 let existUserPut = false
                 userlist.map((oneUser,key12)=>{
                   let existUser = false
                   jsonBlockstack6.map((todo11,key11) =>{
                      if (todo11.remoteuser === oneUser){
                         existUser = true
                      }
                   })
                   if (!existUser){
                      existUserPut = true
                      jsonBlockstack7 = {"remoteuser":oneUser,"active":true}
                      jsonBlockstack6 = [...jsonBlockstack6, jsonBlockstack7]
                   }
                 })
                 let jsonBlockstack8 = []
                 let jsonBlockstack9 = []
                 let existUserPut2 = false
                 jsonBlockstack6.map((todo11,key11) =>{
                    if (todo11.remoteuser === '' || todo11.remoteuser === null || todo11.active === false || todo11.active === undefined){
                         existUserPut2 = true
                    }else{
                        jsonBlockstack8 = jsonBlockstack6[key11]
                        jsonBlockstack9 = [...jsonBlockstack9, jsonBlockstack8]
                    }
                 })
                 if (existUserPut2){
                    jsonBlockstack6 = jsonBlockstack9
                 }
                 if (existUserPut || existUserPut2){
                     Promise.all([this.pushPutUserListRemote(jsonBlockstack6,userX)]).then((resolve) =>{resolve()},(reject) =>{resolve()})
                 }else{
                    resolve()
                 }
               } else {
                 userlist.map((oneUser,key12)=>{
                      jsonBlockstack7 = {"remoteuser":oneUser,"active":true}
                      jsonBlockstack6 = [...jsonBlockstack6, jsonBlockstack7]
                 })
                 Promise.all([this.pushPutUserListRemote(jsonBlockstack6,userX)]).then((resolve) =>{resolve()},(reject) =>{resolve()})
               }
             })
              .catch(error => {
                 reject()
             });
        })
      }

      pushPutUserListRemote(jsonBlockstack4,userX){
        const {userSession} = this.state
        const storage = new Storage({ userSession });
        const options = {contentType: 'application/json', encrypt: false, dangerouslyIgnoreEtag: true }
        return new Promise ((resolve4c3, reject4c3) =>{
          const jsonBlockstack1 = JSON.stringify(jsonBlockstack4)
          putFileDB(userX,`userlist_remote.json`, 'Crosscheck_Contract', jsonBlockstack1, JSON.stringify(options))
            .then(() => {resolve4c3()})
            .catch(error => {resolve4c3()})
        })
      }

      goMostrarAllTemplates() {
        this.setState({showLoader:true});
        const { userSession } = this.state
        return new Promise ((resolve4c2, reject4c2) =>{
          let stacksNetX = ''
          let serverStacksX = ''
          if (userSession.isUserSignedIn()) {
            const user = userSession.loadUserData()
            this.setState({ user })
            if (!localStorage["serverStacks"]) {
              serverStacksX = 'MainNet'
            }else{
              serverStacksX = localStorage.getItem('serverStacks')
            }
            if (serverStacksX === 'MainNet'){
               stacksNetX =  user.profile.stxAddress.mainnet
            }
            if (serverStacksX === 'TestNet'){
               stacksNetX =  user.profile.stxAddress.testnet
            }
          }
          const {username} = userSession.loadUserData();
          if (username === '' || username === undefined || username === null){
            username_new(stacksNetX).then(val => this.setState({username: val, usernameY: val})) ;
          }
          this.setState({ username,usernameY: username },() =>{resolve4c2()})
        })
      }

      llenaDatosLocalStorage(displayOriginX) {
            if (localStorage["idsmartcontract"]) {
               this.c06ConfigurationContract.current.value = localStorage.getItem('idsmartcontract')
               localStorage.removeItem('idsmartcontract')
            }

            const {location} = this.props
            const {pathname} = location
            if (pathname === '/new') {
               this.button0()
            }
            if (pathname === '/start' || pathname === '/open') {
              if (localStorage["jsonBlockstack2"]) {
                const jsonBlockstack2 = localStorage.getItem('jsonBlockstack2')
                let jsonBlockstack6 = ''
                if (jsonBlockstack2.substring(0,1) === '{'){
                   jsonBlockstack6 = JSON.parse(jsonBlockstack2)
                }else {
                  const jsonBlockstack3 = "'" + jsonBlockstack2.substring(1);
                  const jsonBlockstack4 = jsonBlockstack3.substring(0,jsonBlockstack3.length - 1) + "'";
                  const jsonBlockstack5 = jsonBlockstack4.replace(/\\/g,"");
                  jsonBlockstack6 = JSON.parse(jsonBlockstack5.substring(1,jsonBlockstack5.length - 1))
                }
                const {typeContract,configurationContractNumber,startDate,endDate,transportOriginDestination,
                       conditionsIntegrityMaterials,useAssets,statusActive,subject,idSmartContract,
                       statusLifeCycle,statusBlockchain,usernameInsert, signatureAndPayment } = jsonBlockstack6

                this.setState({JSONTemplateName: typeContract,
                               startDate: new Date(startDate),
                               endDate: new Date(endDate),
                               subject: subject})
                this.c02ConfigurationContract.current.value = configurationContractNumber
                if (idSmartContract !== undefined){
                  this.c06ConfigurationContract.current.value = idSmartContract
                } else{
                  this.c06ConfigurationContract.current.value = ''
                }
                if (statusLifeCycle === 'Published'){
                  this.c08ConfigurationContract.current.value = 'Sign and Published in the Blockchain'
                }else{
                  this.c08ConfigurationContract.current.value = statusLifeCycle
                }
                this.c07ConfigurationContract.current.value = statusBlockchain
                this.c09ConfigurationContract.current.value = subject
                this.c10ConfigurationContract.current.value = typeContract
                if (transportOriginDestination==="false"){this.setState({c03ConfigurationContract: false})}else{this.setState({c03ConfigurationContract: true})}
                if (conditionsIntegrityMaterials==="false"){this.setState({c04ConfigurationContract: false})}else{this.setState({c04ConfigurationContract: true})}
                if (conditionsIntegrityMaterials==="false"){this.setState({disableSensor: true})}else{this.setState({disableSensor: false})}
                if (useAssets==="false"){this.setState({c04ConfigurationContract: false})}else{this.setState({c05ConfigurationContract: true})}
                if (statusActive==="false"){this.setState({statusActive2: false})}else{this.setState({statusActive2: true})}

                if (signatureAndPayment===undefined){this.setState({selectedSignaturePayment: 'SignatureAndPayment'})}else{this.setState({selectedSignaturePayment: signatureAndPayment})}

                this.setState({existContract: true,
                               existContract2: true,
                               existContract2: true,
                               jsonStatusBlockchain: statusBlockchain,
                               jsonStatusLifeCycle: statusLifeCycle,
                               jsonStatusIdPact: "IdPact"})

                if (typeContract === 'delivery' || typeContract === 'simulate'){
                    const {idBillOfLading,idTypeBillOfLading,dateContract,
                           shipper,consignee,notifyParty,carrier,placeOfAceptance,portOfLading,vessel,portOfDischarge,placeOfDelivery,
                           finalDestination,amount,currency,currencyType} = jsonBlockstack6

                    this.c02FieldContract.current.value = ""
                    this.c03FieldContract.current.value = idBillOfLading
                    this.c04FieldContract.current.value = idTypeBillOfLading
                    this.setState({startDate: new Date(dateContract)})
                    this.c06FieldContract.current.value = shipper
                    this.c07FieldContract.current.value = consignee
                    this.c08FieldContract.current.value = notifyParty
                    this.c09FieldContract.current.value = carrier
                    this.c10FieldContract.current.value = placeOfAceptance
                    this.c11FieldContract.current.value = portOfLading
                    this.c12FieldContract.current.value = vessel
                    this.c13FieldContract.current.value = portOfDischarge
                    this.c14FieldContract.current.value = placeOfDelivery
                    this.c15FieldContract.current.value = finalDestination
                    this.c16FieldContract.current.value = currency
                    this.c20FieldContract.current.value = amount
                    this.setState({startDate: new Date(dateContract), CurrencyType: currencyType, amountPayment: amount })
                    if (currencyType === 'FIAT Money'){
                      this.setState({FIACurrency: currency})
                    }
                    if (currencyType === 'CryptoCurrency'){
                      this.setState({cryptoCurrencyOrigin: currency})
                    }

                }else{
                  if (typeContract === 'maintenance'){
                      const {idBillOfLading,idTypeBillOfLading,dateContract,
                             yournamecompany,youraddress,clientnamecompany,clientaddress,
                             amount,currency,observations,responsible,frecuency,project,
                             typemaintenance,idTypeBillOfLadingDescription,currencyType} = jsonBlockstack6

                      this.c02FieldContract.current.value = ""
                      this.c03FieldContract.current.value = idBillOfLading
                      this.setState({startDate: new Date(dateContract)})
                      this.setState({codeAssociatedToMaintenance: idTypeBillOfLading})
                      this.c06FieldContract.current.value = yournamecompany
                      this.c07FieldContract.current.value = youraddress
                      this.c10FieldContract.current.value = clientnamecompany
                      this.c11FieldContract.current.value = clientaddress
                      this.c16FieldContract.current.value = currency
                      this.c20FieldContract.current.value = amount
                      this.c30FieldContract.current.value = observations
                      this.c31FieldContract.current.value = responsible
                      this.c32FieldContract.current.value = frecuency
                      this.c33FieldContract.current.value = project
                      this.setState({selectedTypeMaintenance: typemaintenance})
                      if (usernameInsert === this.state.username){
                         this.c04FieldContract.current.value = idTypeBillOfLading
                         this.setState({codeAssociatedToMaintenance:idTypeBillOfLading})
                      }else{
                        this.c04FieldContract.current.value = idTypeBillOfLadingDescription
                      }
                      this.setState({CurrencyType: currencyType, amountPayment: amount })
                      if (currencyType === 'FIAT Money'){
                        this.setState({FIACurrency: currency})
                      }
                      if (currencyType === 'CryptoCurrency'){
                        this.setState({cryptoCurrencyOrigin: currency})
                      }

                  }else{
                    if (typeContract === 'proforma'){
                        const {idBillOfLading,idTypeBillOfLading,dateContract,currency,
                               shippername,shippercompanyname,shippercontactperson,shipperstreetaddress,shippercitystzipcode,shipperphone,shipperemail,
                               receivername,receivercompanyname,receivercontactperson,receiverstreetaddress,receivercitystzipcode,receiverphone,receiveremail,
                               reference,modeoftransport,totalnumberpackages,totalgrossweight,
                               proformasubtotal,proformadiscount,proformataxrate,proformasalesrate,proformashipping,proformatotal,
                               countryoforigin,portofembarcation,reasonforexport,portofdischarge,termsaleothercomments,currencyType} = jsonBlockstack6

                        this.c02FieldContract.current.value = ""
                        this.c03FieldContract.current.value = idBillOfLading
                        this.c04FieldContract.current.value = idTypeBillOfLading
                        this.setState({startDate: new Date(dateContract)})
                        this.c06FieldContract.current.value = shippername
                        this.c07FieldContract.current.value = shippercompanyname
                        this.c08FieldContract.current.value = shippercontactperson
                        this.c09FieldContract.current.value = shipperstreetaddress
                        this.c10FieldContract.current.value = shippercitystzipcode
                        this.c11FieldContract.current.value = shipperphone
                        this.c12FieldContract.current.value = shipperemail
                        this.c13FieldContract.current.value = receivername
                        this.c14FieldContract.current.value = receivercompanyname
                        this.c15FieldContract.current.value = receivercontactperson
                        this.c16FieldContract.current.value = currency
                        this.c17FieldContract.current.value = receiverstreetaddress
                        this.c18FieldContract.current.value = receivercitystzipcode
                        this.c19FieldContract.current.value = receiverphone
                        this.c20FieldContract.current.value = receiveremail
                        this.c21FieldContract.current.value = reference
                        this.c22FieldContract.current.value = modeoftransport
                        this.c23FieldContract.current.value = totalnumberpackages
                        this.c24FieldContract.current.value = totalgrossweight
                        this.c29FieldContract.current.value = proformasubtotal
                        this.c30FieldContract.current.value = proformadiscount
                        this.c31FieldContract.current.value = proformataxrate
                        this.c32FieldContract.current.value = proformasalesrate
                        this.c33FieldContract.current.value = proformashipping
                        this.c34FieldContract.current.value = proformatotal
                        this.c35FieldContract.current.value = countryoforigin
                        this.c36FieldContract.current.value = portofembarcation
                        this.c37FieldContract.current.value = reasonforexport
                        this.c38FieldContract.current.value = portofdischarge
                        this.c39FieldContract.current.value = termsaleothercomments
                        this.setState({CurrencyType: currencyType, amountPayment: proformatotal })
                        if (currencyType === 'FIAT Money'){
                          this.setState({FIACurrency: currency})
                        }
                        if (currencyType === 'CryptoCurrency'){
                          this.setState({cryptoCurrencyOrigin: currency})
                        }

                      }else{
                        if (typeContract === 'blank' || typeContract === 'uploaded' || typeContract === 'spreadsheet'){
                            const {idBillOfLading,idTypeBillOfLading,dateContract,amount,currency,currencyType} = jsonBlockstack6

                            this.c02FieldContract.current.value = ""
                            this.c03FieldContract.current.value = idBillOfLading
                            this.c04FieldContract.current.value = idTypeBillOfLading
                            this.c16FieldContract.current.value = currency
                            this.c20FieldContract.current.value = amount
                            this.c60FieldContract.current.value = currencyType
                            this.setState({startDate: new Date(dateContract), CurrencyType: currencyType, amountPayment: amount })
                            if (currencyType === 'FIAT Money'){
                              this.setState({FIACurrency: currency})
                            }
                            if (currencyType === 'CryptoCurrency'){
                              this.setState({cryptoCurrencyOrigin: currency})
                            }
                        }else{
                          if (typeContract === 'workorder'){
                              const {idWorkOrder,idTypeWorkOrder,dateContract,startDate,endDate,
                                      workordercampaña,workordersondaje,workorderrecomendado,workordertipoperforacion,
                                      workorderfase,workordernumerocontrato,workorderprimerobjetivo,workordersegundoobjetivo,
                                      workordereste,workordernorte,workordercotainicio,workordercotfinal,workordercliente,
                                      workorderlargo,workorderantepozo,workorderfechainiciopozo,workorderfechaterminoperforacion,
                                      workorderfechaterminosondaje,workorderdesde,workorderhasta,workorderazimut,
                                      workorderdeclinacion,workordersobrecargadesde1,workordersobrecargahasta1,
                                      workorderantepozodesde1,workorderantepozohasta1,workorderpolvodesde1,
                                      workorderpolvohasta1,workorderdiamantinodesde1,workorderdiamantinohasta1,
                                      workordersobrecargadesde2,workordersobrecargahasta2,workorderantepozodesde2,
                                      workorderantepozohasta2,workorderpolvodesde2,workorderpolvohasta2,
                                      workorderdiamantinodesde2,workorderdiamantinohasta2,workorderobservacion,
                                      workorderfecharealinicio,workordermetaturnodia,workordermetaturnonoche} = jsonBlockstack6

                              this.c02FieldContract.current.value = ""
                              this.c03FieldContract.current.value = idWorkOrder
                              this.setState({startDate: new Date(startDate)})
                              this.setState({endDate: new Date(endDate)})
                              this.c06FieldContract.current.value = workordercliente
                              this.c07FieldContract.current.value = workordercampaña
                              this.c08FieldContract.current.value = workordersondaje
                              this.c09FieldContract.current.value = workorderrecomendado
                              this.c10FieldContract.current.value = workordertipoperforacion
                              this.c11FieldContract.current.value = workorderfase
                              this.c12FieldContract.current.value = workordernumerocontrato
                              this.c13FieldContract.current.value = workorderprimerobjetivo
                              this.c14FieldContract.current.value = workordersegundoobjetivo
                              this.c15FieldContract.current.value = workordereste
                              this.c17FieldContract.current.value = workordernorte
                              this.c18FieldContract.current.value = workordercotainicio
                              this.c19FieldContract.current.value = workordercotfinal
                              this.c21FieldContract.current.value = workorderlargo
                              this.c22FieldContract.current.value = workorderantepozo
                              this.c27FieldContract.current.value = workorderdesde
                              this.c28FieldContract.current.value = workorderhasta
                              this.c29FieldContract.current.value = workorderazimut
                              this.c30FieldContract.current.value = workorderdeclinacion
                              this.c31FieldContract.current.value = workordersobrecargadesde1
                              this.c32FieldContract.current.value = workordersobrecargahasta1
                              this.c33FieldContract.current.value = workorderantepozodesde1
                              this.c34FieldContract.current.value = workorderantepozohasta1
                              this.c35FieldContract.current.value = workorderpolvodesde1
                              this.c36FieldContract.current.value = workorderpolvohasta1
                              this.c37FieldContract.current.value = workorderdiamantinodesde1
                              this.c38FieldContract.current.value = workorderdiamantinohasta1
                              this.c39FieldContract.current.value = workordersobrecargadesde2
                              this.c40FieldContract.current.value = workordersobrecargahasta2
                              this.c41FieldContract.current.value = workorderantepozodesde2
                              this.c42FieldContract.current.value = workorderantepozohasta2
                              this.c43FieldContract.current.value = workorderpolvodesde2
                              this.c44FieldContract.current.value = workorderpolvohasta2
                              this.c45FieldContract.current.value = workorderdiamantinodesde2
                              this.c46FieldContract.current.value = workorderdiamantinohasta2
                              this.c47FieldContract.current.value = workorderobservacion
                              this.c48FieldContract.current.value = workordermetaturnodia
                              this.c49FieldContract.current.value = workordermetaturnonoche

                              if (isNaN(Date.parse(workorderfechainiciopozo))){
                                 this.setState({workorderfechainiciopozo: new Date()})
                              }else{
                                this.setState({workorderfechainiciopozo: new Date(workorderfechainiciopozo)})
                              }
                              if (isNaN(Date.parse(workorderfechaterminoperforacion))){
                                 this.setState({workorderfechaterminoperforacion: new Date()})
                              }else{
                                this.setState({workorderfechaterminoperforacion: new Date(workorderfechaterminoperforacion)})
                              }
                              if (isNaN(Date.parse(workorderfechaterminosondaje))){
                                 this.setState({workorderfechaterminosondaje: new Date()})
                              }else{
                                this.setState({workorderfechaterminosondaje: new Date(workorderfechaterminosondaje)})
                              }

                              if (isNaN(Date.parse(workorderfecharealinicio))){
                                 this.setState({workorderfecharealinicio: new Date()})
                              }else{
                                this.setState({workorderfecharealinicio: new Date(workorderfecharealinicio)})
                              }
                              this.setState({workordermetaturnodia})
                              this.setState({workordermetaturnonoche})

                              Promise.all([this.readWorkOrderDatoExtra()]).then((resolve) =>{},(reject) =>{})

                              this.setState({workordercliente,workordercampaña,workordersondaje,workordertipoperforacion,workorderfase,workordernumerocontrato,workorderdeclinacion,workorderrecomendado})
                              this.setState({clientWorkOrder:[{"code":workordercliente,"description":workordercliente}]})

                              this.setState({selectedTypeWorkOrder: idTypeWorkOrder})
                              if (usernameInsert === this.state.username){
                                 this.c04FieldContract.current.value = idTypeWorkOrder
                              }
                           }
                        }
                     }
                  }
                }

                let userX = ''
                if (this.state.fromSearch === true){
                   if (usernameInsert === this.state.username){
                     this.setState({whatUserRole:"Observer",
                                    whatUserOrigin:this.state.username})
                   }
                   this.setState({fromSearch: false})
                   userX = this.state.whatUserOrigin
                }else{
                   if (usernameInsert !== this.state.username){
                      userX = displayOriginX
                   }
                }
                localStorage.removeItem('jsonBlockstack2')
                localStorage.removeItem('searchContract')
                localStorage.removeItem('searchTypeContract')
                if (typeContract === 'proforma'){
                     Promise.all([this.getProformaDetail(typeContract,configurationContractNumber,userX)]).then((resolve) =>{},(reject) =>{})
                }
                if (typeContract === 'blank'){
                     Promise.all([this.getBlankDetail(typeContract,configurationContractNumber,userX)]).then((resolve) =>{},(reject) =>{})
                }
                if (typeContract === 'uploaded'){
                     Promise.all([this.getUploadedDetail(typeContract,configurationContractNumber,userX)]).then((resolve) =>{},(reject) =>{})
                }
                if (typeContract === 'spreadsheet'){
                     Promise.all([this.getSpreadsheetDetail(typeContract,configurationContractNumber,userX)]).then((resolve) =>{},(reject) =>{})
                }
                Promise.all([this.llenaDatosRules(typeContract,configurationContractNumber,userX),this.attachFile(typeContract,configurationContractNumber,userX)]).then((resolve) =>{},(reject) =>{})
              }
            }
      }

      getUploadedDetail(typeContract,configurationContractNumber,userX){
        const {userSession} = this.state
        const storage = new Storage({ userSession });
        let options = ''
        if (userX !== ''){options = { username: userX, decrypt: false, verify: false }}else{options = { decrypt: false, verify: false }}
        let user2X = userX
        if (userX === ''){user2X = this.state.username}
        getFileDB(user2X, `${typeContract}_${configurationContractNumber}_uploadeddetail.json`)
           .then((fileContents) => {
             if(fileContents) {
               const jsonBlockstack1 = JSON.parse(fileContents)
               const jsonBlockstack2 = jsonBlockstack1.data
               let jsonBlockstack5 = '[]'
               if (jsonBlockstack2 !== null){
                  const jsonBlockstack3 = jsonBlockstack2.dataobject
                  const jsonBlockstack4 = jsonBlockstack3.replace(/\\/g,"");
                  if (jsonBlockstack4.substring(0,1) === '"') {
                     jsonBlockstack5 = jsonBlockstack4.substring(1,jsonBlockstack4.length - 1)
                  } else {
                     jsonBlockstack5 = jsonBlockstack4
                  }
               }
               let jsonBlockstack6 = JSON.parse(jsonBlockstack5)
               const file64 = jsonBlockstack6.file
               const file = Base64.decode(file64);
               this.setState({filedecodeAttachX: file,
                              fileAttachX: file64,
                              typeAttachX: '',
                              nameAttachX: '',
                              newUploadedX: false,
                              seeAttachX: true,
                              typeAttachText: false,
                              typeAttachImage: false,
                              typeAttachPdf: true,
                              typeAttachAudio: false,
                              typeAttachVideo: false })
             } else {}
           })
            .catch(error => {
            });
      }

      getSpreadsheetDetail(typeContract,configurationContractNumber,userX){
        const {userSession} = this.state
        const storage = new Storage({ userSession });
        let options = ''
        if (userX !== ''){options = { username: userX, decrypt: false, verify: false }}else{options = { decrypt: false, verify: false }}
        let user2X = userX
        if (userX === ''){user2X = this.state.username}
        getFileDB(user2X,`${typeContract}_${configurationContractNumber}_spreadsheetdetail.json`)
           .then((fileContents) => {
             if(fileContents) {
             } else {}
           })
            .catch(error => {
            });
      }

      getBlankDetail(typeContract,configurationContractNumber,userX){
        const {userSession} = this.state
        const storage = new Storage({ userSession });
        let options = ''
        if (userX !== ''){options = { username: userX, decrypt: false, verify: false }}else{options = { decrypt: false, verify: false }}
        let user2X = userX
        if (userX === ''){user2X = this.state.username}
        getFileDB(user2X, `${typeContract}_${configurationContractNumber}_blankdetail.json`)
           .then((fileContents) => {
             if(fileContents) {
               const jsonBlockstack1 = JSON.parse(fileContents)
               const jsonBlockstack2 = jsonBlockstack1.data
               let jsonBlockstack5 = '[]'
               if (jsonBlockstack2 !== null){
                  const jsonBlockstack3 = jsonBlockstack2.dataobject
                  const jsonBlockstack4b = jsonBlockstack3.replace(/\\n/g,"");
                  const jsonBlockstack4 = jsonBlockstack4b.replace(/\\/g,"");
                  if (jsonBlockstack4.substring(0,1) === '"') {
                     jsonBlockstack5 = jsonBlockstack4.substring(1,jsonBlockstack4.length - 1)
                  } else {
                     jsonBlockstack5 = jsonBlockstack4
                  }
               }
               let jsonBlockstack6 = JSON.parse(jsonBlockstack5)
               const contentState = convertFromRaw(JSON.parse(jsonBlockstack5))
               this.setState({contentState, contentStateRaw:jsonBlockstack5, })
               const editorState = EditorState.createWithContent(contentState);
               this.setState({editorState, })
             } else {}
           })
            .catch(error => {
               console.log(error)
           });
      }

      getBlankDetailLoremIpsum(){
        const {userSession} = this.state
        const storage = new Storage({ userSession });
        const options = { decrypt: false, verify: false }
        getFileDB(`blankdetail.json`, options)
           .then((fileContents) => {
             if(fileContents) {
               const jsonBlockstack1 = JSON.parse(fileContents)
               const jsonBlockstack2 = jsonBlockstack1.data
               let jsonBlockstack5 = '[]'
               if (jsonBlockstack2 !== null){
                  const jsonBlockstack3 = jsonBlockstack2.dataobject
                  const jsonBlockstack4b = jsonBlockstack3.replace(/\\n/g,"");
                  const jsonBlockstack4 = jsonBlockstack4b.replace(/\\/g,"");
                  if (jsonBlockstack4.substring(0,1) === '"') {
                     jsonBlockstack5 = jsonBlockstack4.substring(1,jsonBlockstack4.length - 1)
                  } else {
                     jsonBlockstack5 = jsonBlockstack4
                  }
               }
               let jsonBlockstack6 = JSON.parse(jsonBlockstack5)
               const contentState = convertFromRaw(JSON.parse(jsonBlockstack5))
               this.setState({contentState, contentStateRaw:jsonBlockstack5, })
               const editorState = EditorState.createWithContent(contentState);
               this.setState({editorState, })
             } else {}
           })
          .catch(error => {});
      }

      getProformaDetail(typeContract,configurationContractNumber,userX){
        const {userSession} = this.state
        const storage = new Storage({ userSession });
        let options = ''
        if (userX !== ''){options = { username: userX, decrypt: false, verify: false }}else{options = { decrypt: false, verify: false }}
        let user2X = userX
        if (userX === ''){user2X = this.state.username}
        getFileDB(user2X,`${typeContract}_${configurationContractNumber}_proformadetail.json`)
           .then((fileContents) => {
             if(fileContents) {
               const jsonBlockstack1 = JSON.parse(fileContents)
               const jsonBlockstack2 = jsonBlockstack1.data
               let jsonBlockstack5 = '[]'
               if (jsonBlockstack2 !== null){
                  const jsonBlockstack3 = jsonBlockstack2.dataobject
                  const jsonBlockstack4 = jsonBlockstack3.replace(/\\/g,"");
                  if (jsonBlockstack4.substring(0,1) === '"') {
                     jsonBlockstack5 = jsonBlockstack4.substring(1,jsonBlockstack4.length - 1)
                  } else {
                     jsonBlockstack5 = jsonBlockstack4
                  }
               }
               let jsonBlockstack6 = JSON.parse(jsonBlockstack5)

               let totalProformaDetail1 = 0
               let totalProformaDetail2 = 0
               jsonBlockstack6.map((todo, i) => {
                 totalProformaDetail1 = parseFloat(todo.quantity) * parseFloat(todo.unitprice)
                 totalProformaDetail1 = totalProformaDetail1.toFixed(2)
                 totalProformaDetail2 = parseFloat(totalProformaDetail2) + parseFloat(totalProformaDetail1)
               })
               if (this.c29FieldContract.current.value === undefined || this.c29FieldContract.current.value === null || this.c29FieldContract.current.value === ''){this.c29FieldContract.current.value = 0}
               if (this.c30FieldContract.current.value === undefined || this.c30FieldContract.current.value === null || this.c30FieldContract.current.value === ''){this.c30FieldContract.current.value = 0}
               if (this.c31FieldContract.current.value === undefined || this.c31FieldContract.current.value === null || this.c31FieldContract.current.value === ''){this.c31FieldContract.current.value = 0}
               if (this.c32FieldContract.current.value === undefined || this.c32FieldContract.current.value === null || this.c32FieldContract.current.value === ''){this.c32FieldContract.current.value = 0}
               if (this.c33FieldContract.current.value === undefined || this.c33FieldContract.current.value === null || this.c33FieldContract.current.value === ''){this.c33FieldContract.current.value = 0}
               if (this.c34FieldContract.current.value === undefined || this.c34FieldContract.current.value === null || this.c34FieldContract.current.value === ''){this.c34FieldContract.current.value = 0}
               this.setState({subtotalProformaDetail: parseFloat(totalProformaDetail2)})
               const c29 = parseFloat(totalProformaDetail2)
               this.c29FieldContract.current.value = c29.toFixed(2)
               this.c31FieldContract.current.value = parseFloat(this.state.tax30X)
               const c32 = (parseFloat(this.state.tax30X) * ((parseFloat(totalProformaDetail2) - parseFloat(this.c30FieldContract.current.value)))) / 100
               this.c32FieldContract.current.value = c32.toFixed(2)
               const c34 = parseFloat(this.c29FieldContract.current.value) - parseFloat(this.c30FieldContract.current.value) + parseFloat(this.c32FieldContract.current.value) + parseFloat(this.c33FieldContract.current.value)
               this.c34FieldContract.current.value = c34.toFixed(2)
               this.setState({jsonProformaDetail: jsonBlockstack6})
             } else {}
           })
            .catch(error => {
            });
      }

      llenaDatosRules(typeContract,configurationContractNumber,userX) {
          const {userSession} = this.state
          const storage = new Storage({ userSession });
          let options = ''
          if (userX !== ''){options = { username: userX, decrypt: false, verify: false }}else{options = { decrypt: false, verify: false }}
          let user2X = userX
          if (userX === ''){user2X = this.state.username}
          this.setState({jsonEnrollment: []})
          getFileDB(user2X,`${typeContract}_${configurationContractNumber}_rules.json`)
             .then((fileContents) => {
               if(fileContents) {
                 const jsonBlockstack1 = JSON.parse(fileContents)
                 const jsonBlockstack2 = jsonBlockstack1.data
                 let jsonBlockstack5 = '[]'
                 if (jsonBlockstack2 !== null){
                    const jsonBlockstack3 = jsonBlockstack2.dataobject
                    const jsonBlockstack4 = jsonBlockstack3.replace(/\\/g,"");
                    if (jsonBlockstack4.substring(0,1) === '"') {
                       jsonBlockstack5 = jsonBlockstack4.substring(1,jsonBlockstack4.length - 1)
                    } else {
                       jsonBlockstack5 = jsonBlockstack4
                    }
                 }
                 let jsonBlockstack6 = JSON.parse(jsonBlockstack5)
                 this.setState({jsonEnrollment: jsonBlockstack6})
               } else {}
             })
              .catch(error => {
              });
      }

      componentWillUnmount() {
        localStorage.removeItem('idsmartcontract')
        localStorage.removeItem('searchContract')
      }

      verifyContract = async (e, optx, statblock, typecontract, contractnumber) => {
        if (this.state.cContractPolicy){
          const {userSession} = this.state
          const storage = new Storage({ userSession });
          const options = { decrypt: false, verify: false }
          let jsonBlockstack4 = []
          var existNewContract3 = false
          this.setState({generatePdfX: false})
          await getFileDB(this.state.username, `contractlist.json`)
             .then((fileContents) => {
               if(fileContents) {
                 this.setState({existListContract: true})
                 const jsonBlockstack1 = JSON.parse(fileContents)
                 const jsonBlockstack2 = jsonBlockstack1.data
                 let jsonBlockstack5 = '[]'
                 if (jsonBlockstack2 !== null){
                    const jsonBlockstack3 = jsonBlockstack2.dataobject
                    const jsonBlockstack4 = jsonBlockstack3.replace(/\\/g,"");
                    if (jsonBlockstack4.substring(0,1) === '"') {
                       jsonBlockstack5 = jsonBlockstack4.substring(1,jsonBlockstack4.length - 1)
                    } else {
                       jsonBlockstack5 = jsonBlockstack4
                    }
                 }
                 let jsonBlockstack6 = JSON.parse(jsonBlockstack5)
                 localStorage.setItem('jsonBlockstack40',jsonBlockstack5)
                 this.setState({jsonBlockstackZ: jsonBlockstack6,existNewContract: false})
                 jsonBlockstack6.map((todo, i) => {
                    if (todo.typeContract === typecontract && todo.configurationContractNumber === contractnumber) {
                      if (optx === "insert") {
                           existNewContract3 = true
                           this.setState({existNewContract: true})
                           this.existContract()
                           return true
                      }else{
                         if (todo.statusBlockchain==="Blockchain"){
                           existNewContract3 = true
                           this.setState({existNewContract: true})
                           return true
                         }
                      }
                      return false
                    }
                 })
                 if (existNewContract3===true  ){
                    return
                 }
                 Promise.all([this.nuevoContract(e, optx, statblock)]).then((resolve) =>{},(reject) =>{})
               } else {
                 this.setState({existListContract: false})
                 Promise.all([this.nuevoContract(e, optx, statblock)]).then((resolve) =>{},(reject) =>{})
               }
             })
              .catch(error => {
                console.log(error)
                this.setState({existListContract: false})
                Promise.all([this.nuevoContract(e, optx, statblock)]).then((resolve) =>{},(reject) =>{})
              });
        }else{
            Promise.all([this.saveDraftAgreeConfirm()]).then((resolve) =>{},(reject) =>{})
        }
      }

      verifySign(typeContract,configurationContractNumber) {
          const {userSession} = this.state
          const storage = new Storage({ userSession });
          const options = { decrypt: false, verify: false }
           let algunosSign = false
           let ningunoSign = false
           let todosSign = false
           let jsonBlockstack4 = []
           getFileDB(this.state.username, `${typeContract}_${configurationContractNumber}_usergroup.json`)
             .then((fileContents) => {
               if(fileContents) {
                  const jsonBlockstack1 = JSON.parse(fileContents)
                  const jsonBlockstack2 = jsonBlockstack1.data
                  let jsonBlockstack5 = '[]'
                  if (jsonBlockstack2 !== null){
                     const jsonBlockstack3 = jsonBlockstack2.dataobject
                     const jsonBlockstack4 = jsonBlockstack3.replace(/\\/g,"");
                     if (jsonBlockstack4.substring(0,1) === '"') {
                        jsonBlockstack5 = jsonBlockstack4.substring(1,jsonBlockstack4.length - 1)
                     } else {
                        jsonBlockstack5 = jsonBlockstack4
                     }
                  }
                  let jsonBlockstack6 = JSON.parse(jsonBlockstack5)

                  let noSign = false
                  let yesSign = false
                  jsonBlockstack6.map((todo,i) =>{
                     if ((todo.role === 'Authorizer' || todo.role === 'Authorizer-Inviter' || todo.role === 'Creator') && (todo.signature === '' || todo.signature === undefined)){
                        noSign = true
                     }
                     if ((todo.role === 'Authorizer' || todo.role === 'Authorizer-Inviter' || todo.role === 'Creator') && (todo.signature !== '' && todo.signature !== undefined)){
                        yesSign = true
                     }
                     if (todo.id === this.state.username && (todo.signature !== '' && todo.signature !== undefined)){
                        this.c26FieldContract.current.value = todo.signature
                        this.setState({signTrue: false})
                     }
                     if (todo.id === this.state.username && (todo.signature === '' || todo.signature === undefined)){
                        this.c26FieldContract.current.value = todo.signature
                        this.setState({signTrue: true})
                     }
                  })
                  if (yesSign && noSign){
                     algunosSign = true
                  }
                  if (!yesSign && noSign){
                     ningunoSign = true
                  }
                  if (yesSign && !noSign){
                     todosSign = true
                  }
                  this.setState({algunosSign,ningunoSign,todosSign})
               } else {}
             })
            .catch(error => {});
      }

      listContractPreviousPrevious(){
        this.setState({fromSearchList: false,userRemoteX:'',tagListX:'',carpetListX:'inbox'})
        this.setState({showLoader:true})
        Promise.all([this.listContractPrevious()]).then((resolve) =>{},(reject) =>{})
      }

      listContractPrevious(){
        this.setState({fromSearchList: false,displayTemplateDetail: false,searchContract2: false,displayBlockchain: false,displayCryptoCurrency: false,displayDocument: false, displayRules: false,displayAssociated: false,displayShare: false,displayActiveParticipants: false,displayUser: false,displaySign: false,displayLink: false,displayAttach: false,displayDashboard: false,displayDeliverable: false,displayReport: false,signTrue: true,dialogOpenContractExist: false,modeDisplayCollapsed: false,deleteListContract: false,editListContract: false})
        localStorage.removeItem('jsonBlockstack2')
        localStorage.removeItem('idsmartcontract')
        localStorage.removeItem('searchContract')
        Promise.all([this.listContract(this.state.username)]).then((resolve) =>{},(reject) =>{})
      }

      listContract(usernameX){
        const {userSession} = this.state
        const storage = new Storage({ userSession });
        const options = { decrypt: false, verify: false }
        this.setState({existListContractX: false,
                       displayTemplateDetail: false,
                       displayBlockchain: false,
                       displayCryptoCurrency: false,
                       displayDocument: false,
                       displayRules: false,
                       displayAssociated: false,
                       displayShare: false,
                       displayActiveParticipants: false,
                       displayUser: false,
                       displaySign: false,
                       displayRegister: false,
                       displayLink: false,
                       displayAttach: false,
                       displayDashboard: false,
                       displayDeliverable: false,
                       displayReport: false,
                       displayChat: false,
                       displayTag: false,
                       displayPaymentForm: false,
                       displayPay: false,
                       sinTemplateDetail: true,
                       displayRulesDisable: true,
                       viewSimulate: 'Yes',
                       arrowsort: false,
                       arrowsort1: false,
                       arrowsort2: false,
                       arrowsort3: false,
                       arrowsort4: false,
                       arrowsort5: false,
                       modeDisplayCollapsed: false,
                       deleteListContract: false,
                       editListContract: false,
                       seeAttachX: false,
                       newUploadedX: false,
                       displayProformaSearchSender: false,
                       displayProformaSearchReceiver: false,
                       generatePdfX: false,
                       jsonBlockchain: '',
                       displayLifeCycleX: '',
                       algunosSign: false,
                       ningunoSign: true,
                       todosSign: false,
                       active_after_publishedX: "true",
                       displayInformeDeliverable: false,
                     })

        let settingViewDataSimulator = 'Yes',
            settingBringContractTemplateFrom = 'Local',
            settingModeDisplay = 'Editor',
            settingModeMenuContract = 'Tab',
            settingDisplayCompanyLogoData = 'Yes',
            settingFIACurrency = 'USD - US Dollar',
            settingCryptoCurrencyOrigin = 'BTC - Bitcoin',
            settingPactClarityEthereum = 'Blockstack Clarity (STX)',
            settingDocumentSidebarStartsOpen = 'Yes',
            settingEncryptDecryptFile = 'Yes',
            settingDisplayChat = 'Yes',
            settingCryptoCurrencyPayment = 'STX - Stacks',
            jsonBlockchain = [],
            jsonUser = [],
            jsonGarbage = []
        this.setState({jsonUserZ50: [],
                       jsonGarbageZ50: [],
                       jsonBlockstackZ50: [],
                       jsonBlockstackZ50a: [],
                       jsonBlockstackZ50b: [],
                       jsonBlockstackZ50c: [],
                       jsonBlockchainZ50: [],
                       displaySimulator: false})

        let language3 = 'en'
        if (this.state.language === 'English'){language3 = 'en'}
        if (this.state.language === 'French'){language3 = 'fr'}
        if (this.state.language === 'Spanish'){language3 = 'es'}
        if (this.state.language === 'Portuguese'){language3 = 'pt'}
        if (this.state.language === 'Swedish'){language3 = 'sv'}
        if (this.state.language === 'Netherlands'){language3 = 'nl'}
        if (this.state.language === 'Russian'){language3 = 'ru'}
        if (this.state.language === 'Japanese'){language3 = 'jp'}
        if (this.state.language === 'Chinese'){language3 = 'cn'}
        if (this.state.language === 'German'){language3 = 'de'}
        if (this.state.language === 'Italian'){language3 = 'it'}

        getFileDB(usernameX, `settings3.json`)
             .then((fileContents) => {

                if(fileContents) {
                   const jsonBlockstack1 = JSON.parse(fileContents)
                   const jsonBlockstack2 = jsonBlockstack1.data
                   let jsonBlockstack5 = '[]'
                   let jsonBlockstack8 = '[]'
                   let jsonBlockstack10 = '[]'
                   if (jsonBlockstack2 !== null){
                       const jsonBlockstack3 = jsonBlockstack2.dataobject
                       const jsonBlockstack4 = jsonBlockstack3.replace(/\\/g,"");
                       if (jsonBlockstack4.substring(0,1) === '"') {
                          jsonBlockstack5 = jsonBlockstack4.substring(1,jsonBlockstack4.length - 1)
                       } else {
                          jsonBlockstack5 = jsonBlockstack4
                       }

                       const jsonBlockstack6 = jsonBlockstack2.options
                       const jsonBlockstack7 = jsonBlockstack6.replace(/\\/g,"");
                       if (jsonBlockstack7.substring(0,1) === '"') {
                          jsonBlockstack8 = jsonBlockstack7.substring(1,jsonBlockstack7.length - 1)
                       } else {
                          jsonBlockstack8 = jsonBlockstack7
                       }
                       let jsonBlockstack9 = JSON.parse(jsonBlockstack8)

                       if (jsonBlockstack9.encrypt === true) {
                         Promise.all([profileUser(usernameX)])
                          .then(
                            (publicKey) =>{
                              const vi = jsonBlockstack5
                              const data = jsonBlockstack5,
                                    iv = '1111111111111111',
                                    password = publicKey
                              const key = forge.md.sha256.create().update(password).digest().getBytes();
                              const encryptedBytes = forge.util.decode64(data);
                              const decipher = forge.cipher.createDecipher('AES-CTR', key)
                              decipher.start({ iv });
                              decipher.update(forge.util.createBuffer(encryptedBytes));
                              decipher.finish();
                              const decryptedBytes = decipher.output.getBytes();
                              const decryptedString = forge.util.encodeUtf8(decryptedBytes);
                              let jsonBlockstack4 = decryptedString.replace(/\\/g,"");
                              if (jsonBlockstack4.substring(0,1) === '"') {
                                 jsonBlockstack5 = jsonBlockstack4.substring(1,jsonBlockstack4.length - 1)
                              } else {
                                 jsonBlockstack5 = jsonBlockstack4
                              }
                              jsonBlockstack10 = JSON.parse(jsonBlockstack5)
                              const largo = jsonBlockstack10.length
                              jsonBlockstack10.map((todo,i)=>{
                                if(todo.code==='ViewDataSimulator'){
                                  settingViewDataSimulator = todo.description
                                }
                                if(todo.code==='BringContractTemplateFrom'){
                                  settingBringContractTemplateFrom = todo.description
                                }
                                if(todo.code==='DisplayCompanyLogoData'){
                                  settingDisplayCompanyLogoData = todo.description
                                }
                                if(todo.code==='FIACurrency'){
                                  settingFIACurrency = todo.description
                                }
                                if(todo.code==='CryptoCurrencyOrigin'){
                                  settingCryptoCurrencyOrigin = todo.description
                                }
                                if(todo.code==='CryptoCurrency'){
                                  settingCryptoCurrencyPayment = todo.description
                                }
                                if(todo.code==='PactClarityEthereum'){
                                  settingPactClarityEthereum = todo.description
                                }
                                if(todo.code==='DocumentSidebarStartsOpen'){
                                  settingDocumentSidebarStartsOpen = todo.description
                                }
                                if(todo.code==='EncryptDecryptFile'){
                                  settingEncryptDecryptFile = todo.description
                                }
                                if(todo.code==='DisplayChat'){
                                  settingDisplayChat = todo.description
                                }
                                if (i === (largo - 1)){
                                }
                              })
                              this.setState({viewSimulate: settingViewDataSimulator,
                                             bringContractTemplateFrom: settingBringContractTemplateFrom,
                                             modeDisplay: settingModeDisplay,
                                             modeMenuContract: settingModeMenuContract,
                                             DisplayCompanyLogoData: settingDisplayCompanyLogoData,
                                             FIACurrency: settingFIACurrency,
                                             documentSidebarStartsOpen: settingDocumentSidebarStartsOpen,
                                             cryptoPactClarityEthereum: settingPactClarityEthereum,
                                             encryptDecryptFile: settingEncryptDecryptFile,
                                             cryptoCurrencyOrigin: settingCryptoCurrencyOrigin,
                                             cryptoCurrencyPayment: settingCryptoCurrencyPayment,
                                             displayChatDocument: settingDisplayChat})

                              if (settingBringContractTemplateFrom === 'Server'){
                                Promise.all([this.props.mostrarTemplateAll('')]).then(
                                  (resolve) =>{Promise.all([this.saveContractDoc(this.props.templatesAll[0])]).then((resolve) =>{},(reject) =>{})},
                                  (reject)  =>{Promise.all([this.readContractDoc(usernameX)]).then((resolve) =>{},(reject) =>{})}
                                 )
                              }else{
                                Promise.all([this.readContractDoc(usernameX)]).then((resolve) =>{},(reject) =>{})
                              }
                              //----------------------------------------------------------------------------------------------------------------------
                              Promise.all(
                                [ this.getSignature(usernameX),
                                  this.tagList(usernameX),
                                  this.myUserConfig(usernameX),
                                  this.getCircleGreen(usernameX),
                                  this.getContractTag(usernameX),
                                  this.goRoleList(null,null,usernameX),
                                  this.listContract2(settingViewDataSimulator,settingModeDisplay,jsonBlockchain,jsonUser,jsonGarbage,'','','','',[],usernameX)]
                              ).then(
                                (resolve) =>{this.listUserRemote(settingViewDataSimulator,settingModeDisplay,jsonBlockchain,jsonUser,jsonGarbage,usernameX)},
                                (reject) =>{this.listUserRemote(settingViewDataSimulator,settingModeDisplay,jsonBlockchain,jsonUser,jsonGarbage,usernameX)})
                              //----------------------------------------------------------------------------------------------------------------------


                            },
                            (reject) =>{}
                          )
                       }else{
                         jsonBlockstack10 = JSON.parse(jsonBlockstack5)
                         const largo = jsonBlockstack10.length
                         jsonBlockstack10.map((todo,i)=>{
                           if(todo.code==='ViewDataSimulator'){
                             settingViewDataSimulator = todo.description
                           }
                           if(todo.code==='BringContractTemplateFrom'){
                             settingBringContractTemplateFrom = todo.description
                           }
                           if(todo.code==='DisplayCompanyLogoData'){
                             settingDisplayCompanyLogoData = todo.description
                           }
                           if(todo.code==='FIACurrency'){
                             settingFIACurrency = todo.description
                           }
                           if(todo.code==='CryptoCurrencyOrigin'){
                             settingCryptoCurrencyOrigin = todo.description
                           }
                           if(todo.code==='CryptoCurrency'){
                             settingCryptoCurrencyPayment = todo.description
                           }
                           if(todo.code==='PactClarityEthereum'){
                             settingPactClarityEthereum = todo.description
                           }
                           if(todo.code==='DocumentSidebarStartsOpen'){
                             settingDocumentSidebarStartsOpen = todo.description
                           }
                           if(todo.code==='EncryptDecryptFile'){
                             settingEncryptDecryptFile = todo.description
                           }
                           if(todo.code==='DisplayChat'){
                             settingDisplayChat = todo.description
                           }
                           if (i === (largo - 1)){
                           }
                         })
                         this.setState({viewSimulate: settingViewDataSimulator,
                                        bringContractTemplateFrom: settingBringContractTemplateFrom,
                                        modeDisplay: settingModeDisplay,
                                        modeMenuContract: settingModeMenuContract,
                                        DisplayCompanyLogoData: settingDisplayCompanyLogoData,
                                        FIACurrency: settingFIACurrency,
                                        documentSidebarStartsOpen: settingDocumentSidebarStartsOpen,
                                        cryptoPactClarityEthereum: settingPactClarityEthereum,
                                        encryptDecryptFile: settingEncryptDecryptFile,
                                        cryptoCurrencyOrigin: settingCryptoCurrencyOrigin,
                                        cryptoCurrencyPayment: settingCryptoCurrencyPayment,
                                        displayChatDocument: settingDisplayChat})

                         if (settingBringContractTemplateFrom === 'Server'){
                           Promise.all([this.props.mostrarTemplateAll('')]).then(
                             (resolve) =>{Promise.all([this.saveContractDoc(this.props.templatesAll[0])]).then((resolve) =>{},(reject) =>{})},
                             (reject)  =>{Promise.all([this.readContractDoc(usernameX)]).then((resolve) =>{},(reject) =>{})}
                            )
                         }else{
                           Promise.all([this.readContractDoc(usernameX)]).then((resolve) =>{},(reject) =>{})
                         }
                         //----------------------------------------------------------------------------------------------------------------------
                         Promise.all(
                           [ this.getSignature(usernameX),
                             this.tagList(usernameX),
                             this.myUserConfig(usernameX),
                             this.getCircleGreen(usernameX),
                             this.getContractTag(usernameX),
                             this.goRoleList(null,null,usernameX),
                             this.listContract2(settingViewDataSimulator,settingModeDisplay,jsonBlockchain,jsonUser,jsonGarbage,'','','','',[],usernameX)]
                         ).then(
                           (resolve) =>{this.listUserRemote(settingViewDataSimulator,settingModeDisplay,jsonBlockchain,jsonUser,jsonGarbage,usernameX)},
                           (reject) =>{this.listUserRemote(settingViewDataSimulator,settingModeDisplay,jsonBlockchain,jsonUser,jsonGarbage,usernameX)})
                         //----------------------------------------------------------------------------------------------------------------------
                       }
                   }else{
                     //-----------------------------------------------------------------------------------------------------------------------
                     Promise.all([this.simulation(language3)]).then((resolve) =>{},(reject) =>{})
                     //-----------------------------------------------------------------------------------------------------------------------
                   }
                  //----------------------------------------------------------------------------------------------------------------------
                }else{
                  //-----------------------------------------------------------------------------------------------------------------------
                  Promise.all([this.simulation(language3)]).then((resolve) =>{},(reject) =>{})
                  //-----------------------------------------------------------------------------------------------------------------------
                }
             })
              .catch(error => {
                //-----------------------------------------------------------------------------------------------------------------------
                Promise.all([this.simulation(language3)]).then((resolve) =>{},(reject) =>{})
                //-----------------------------------------------------------------------------------------------------------------------
             });
      }

      simulation  = async (language3) => {
          const {userSession} = this.state
          const storage = new Storage({ userSession });
          this.setState({displaySimulator: true})
          await storage.listFiles((fileContents) => {
                 if (fileContents === 'settings3.json') {
                   this.setState({displaySimulator: false})
                   return false
                 }
                 return true
          })
      }

      saveContractDoc(arrayTemplateDBX){
          const {userSession} = this.state
          const storage = new Storage({ userSession });
          const options = {contentType: 'application/json', encrypt: false, dangerouslyIgnoreEtag: true }
          const jsonBlockstack1 = JSON.stringify(arrayTemplateDBX)
          return new Promise((resolve1, reject1) => {
            putFileDB(this.state.username,`contractdoc.json`, 'Crosscheck_Contract', jsonBlockstack1, JSON.stringify(options))
                .then(() => {resolve1()})
          });
      }

      readContractDoc(usernameX){
        const {userSession} = this.state
        const storage = new Storage({ userSession });
        const options = { decrypt: false, verify: false }
        return new Promise((resolve1, reject1) => {
          if (this.state.templatesAllLocal.length === 0){
            getFileDB(usernameX,`contractdoc.json`)
               .then((fileContents) => {
                 if(fileContents) {
                   const jsonBlockstack1 = JSON.parse(fileContents)
                   const jsonBlockstack2 = jsonBlockstack1.data
                   let jsonBlockstack5 = '[]'
                   if (jsonBlockstack2 !== null){
                      const jsonBlockstack3 = jsonBlockstack2.dataobject
                      const jsonBlockstack4 = jsonBlockstack3.replace(/\\/g,"");
                      if (jsonBlockstack4.substring(0,1) === '"') {
                         jsonBlockstack5 = jsonBlockstack4.substring(1,jsonBlockstack4.length - 1)
                      } else {
                         jsonBlockstack5 = jsonBlockstack4
                      }
                   }
                   let jsonBlockstack6 = JSON.parse(jsonBlockstack5)
                   this.setState({templatesAllLocal: jsonBlockstack6},() =>{resolve1();});
                 }else{
                   resolve1()
                 }
               })
                .catch(error => {
                  resolve1()
              });
          }else{
            resolve1()
          }
        });
      }

      getSignature = (usernameX) => {
        const {userSession} = this.state
        const storage = new Storage({ userSession });
        const options = { decrypt: false, verify: false }
        this.setState({trimmedDataURL: null})
        return new Promise((resolve1, reject1) => {
            getFileDB(usernameX, `signature.json`)
               .then((fileContents) => {
                 if(fileContents) {
                   const jsonBlockstack1 = JSON.parse(fileContents)
                   const jsonBlockstack2 = jsonBlockstack1.data
                   let jsonBlockstack5 = '[]'
                   if (jsonBlockstack2 !== null){
                      const jsonBlockstack3 = jsonBlockstack2.dataobject
                      const jsonBlockstack4 = jsonBlockstack3.replace(/\\/g,"");
                      if (jsonBlockstack4.substring(0,1) === '"') {
                         jsonBlockstack5 = jsonBlockstack4.substring(1,jsonBlockstack4.length - 1)
                      } else {
                         jsonBlockstack5 = jsonBlockstack4
                      }
                   }
                   let jsonBlockstack6 = JSON.parse(jsonBlockstack5)

                   if (jsonBlockstack6.signature === 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVQImWNgYGBgAAAABQABh6FO1AAAAABJRU5ErkJggg==' ||
                       jsonBlockstack6.signature === null) {
                       this.setState({trimmedDataURL: null})
                   }else{
                       this.setState({trimmedDataURL: jsonBlockstack6.signature})
                   }

                   resolve1()
                 } else {
                   resolve1()
                 }
               })
                .catch(error => {
                  resolve1()
                });
        });
      }

      getCircleGreen(usernameX) {
        const {userSession} = this.state
        const storage = new Storage({ userSession });
        const options = { decrypt: false, verify: false }
        this.setState({jsonCircleGreen: []})
        let jsonBlockstack6 = []
        return new Promise ((resolve1, reject1) =>{
          getFileDB(usernameX, `circlegreen.json`)
            .then((fileContents) => {
               if(fileContents) {
                 const jsonBlockstack1 = JSON.parse(fileContents)
                 const jsonBlockstack2 = jsonBlockstack1.data
                 let jsonBlockstack5 = '[]'
                 if (jsonBlockstack2 !== null){
                    const jsonBlockstack3 = jsonBlockstack2.dataobject
                    const jsonBlockstack4 = jsonBlockstack3.replace(/\\/g,"");
                    if (jsonBlockstack4.substring(0,1) === '"') {
                       jsonBlockstack5 = jsonBlockstack4.substring(1,jsonBlockstack4.length - 1)
                    } else {
                       jsonBlockstack5 = jsonBlockstack4
                    }
                 }
                 let jsonBlockstack6 = JSON.parse(jsonBlockstack5)
                 this.setState({jsonCircleGreen: jsonBlockstack6})
               }
               resolve1()
             })
            .catch(error => {
                resolve1()
             });
        })
      }

      tagList(usernameX) {
        const {userSession} = this.state
        const storage = new Storage({ userSession });
        const options = { decrypt: false, verify: false }
        this.setState({tagList: []})
        let jsonBlockstack6 = []
        return new Promise ((resolve1, reject1) =>{
          getFileDB(usernameX, `tag.json`)
            .then((fileContents) => {
               if(fileContents) {
                 const jsonBlockstack1 = JSON.parse(fileContents)
                 const jsonBlockstack2 = jsonBlockstack1.data
                 let jsonBlockstack5 = '[]'
                 if (jsonBlockstack2 !== null){
                    const jsonBlockstack3 = jsonBlockstack2.dataobject
                    const jsonBlockstack4 = jsonBlockstack3.replace(/\\/g,"");
                    if (jsonBlockstack4.substring(0,1) === '"') {
                       jsonBlockstack5 = jsonBlockstack4.substring(1,jsonBlockstack4.length - 1)
                    } else {
                       jsonBlockstack5 = jsonBlockstack4
                    }
                 }
                 let jsonBlockstack6 = JSON.parse(jsonBlockstack5)
                 this.setState({tagList: jsonBlockstack6})
               }
               resolve1()
             })
            .catch(error => {
                resolve1()
             });
        })
      }

      myUserConfig(usernameX) {
        const {userSession} = this.state
        const storage = new Storage({ userSession });
        const options = { decrypt: false, verify: false }
        this.setState({myUserConfig: []})
        let jsonBlockstack6 = []
        return new Promise ((resolve1, reject1) =>{
          getFileDB(usernameX, `myUserConfig.json`)
            .then((fileContents) => {
               if(fileContents) {
                 const jsonBlockstack1 = JSON.parse(fileContents)
                 const jsonBlockstack2 = jsonBlockstack1.data
                 let jsonBlockstack5 = '[]'
                 if (jsonBlockstack2 !== null){
                    const jsonBlockstack3 = jsonBlockstack2.dataobject
                    const jsonBlockstack4 = jsonBlockstack3.replace(/\\/g,"");
                    if (jsonBlockstack4.substring(0,1) === '"') {
                       jsonBlockstack5 = jsonBlockstack4.substring(1,jsonBlockstack4.length - 1)
                    } else {
                       jsonBlockstack5 = jsonBlockstack4
                    }
                 }
                 let jsonBlockstack6 = JSON.parse(jsonBlockstack5)
                 this.setState({myUserConfig: jsonBlockstack6})
               }
               resolve1()
             })
            .catch(error => {
                resolve1()
             });
        })
      }

      getContractTag(usernameX) {
        const {userSession} = this.state
        const storage = new Storage({ userSession });
        const options = { decrypt: false, verify: false }
        this.setState({jsonContractTag: []})
        let jsonBlockstack6 = []
        return new Promise ((resolve1, reject1) =>{
          getFileDB(usernameX, `contracttag.json`)
            .then((fileContents) => {
               if(fileContents) {
                 const jsonBlockstack1 = JSON.parse(fileContents)
                 const jsonBlockstack2 = jsonBlockstack1.data
                 let jsonBlockstack5 = '[]'
                 if (jsonBlockstack2 !== null){
                    const jsonBlockstack3 = jsonBlockstack2.dataobject
                    const jsonBlockstack4 = jsonBlockstack3.replace(/\\/g,"");
                    if (jsonBlockstack4.substring(0,1) === '"') {
                       jsonBlockstack5 = jsonBlockstack4.substring(1,jsonBlockstack4.length - 1)
                    } else {
                       jsonBlockstack5 = jsonBlockstack4
                    }
                 }
                 let jsonBlockstack6 = JSON.parse(jsonBlockstack5)
                 this.setState({jsonContractTag: jsonBlockstack6})
               }
               resolve1()
             })
            .catch(error => {
                resolve1()
             });
        })
      }

      listUserRemote = async (settingViewDataSimulator,settingModeDisplay,jsonBlockchain,jsonUser,jsonGarbage,usernameX) => {
        const {userSession} = this.state
        const storage = new Storage({ userSession });
        const options = { decrypt: false, verify: false }
        this.setState({showLoader:true});
        this.setState({userlistRemote: []})
        let jsonBlockstack6 = []
        let jsonBlockstack5X = []
        return new Promise ((resolve8, reject8) =>{
          getFileDB(usernameX, `userlist_remote.json`)
             .then((fileContents) => {
               if(fileContents) {
                 const jsonBlockstack1 = JSON.parse(fileContents)
                 const jsonBlockstack2 = jsonBlockstack1.data
                 let jsonBlockstack5 = '[]'
                 if (jsonBlockstack2 !== null){
                    const jsonBlockstack3 = jsonBlockstack2.dataobject
                    const jsonBlockstack4 = jsonBlockstack3.replace(/\\/g,"");
                    if (jsonBlockstack4.substring(0,1) === '"') {
                       jsonBlockstack5 = jsonBlockstack4.substring(1,jsonBlockstack4.length - 1)
                    } else {
                       jsonBlockstack5 = jsonBlockstack4
                    }
                 }
                 let jsonBlockstack6 = JSON.parse(jsonBlockstack5)

                 this.setState({userlistRemote: jsonBlockstack6})
                 if (this.state.userRemoteX !== ''){
                     let jsonBlockstack7 = []
                     let jsonBlockstack8 = ''
                     let largoX = jsonBlockstack6.length
                     jsonBlockstack6.map((todo11,key11) =>{
                       if (todo11.remoteuser === this.state.userRemoteX){
                          jsonBlockstack8 = jsonBlockstack6[key11]
                          jsonBlockstack7 = [...jsonBlockstack7, jsonBlockstack8]
                       }
                       if (key11 === largoX - 1){
                         jsonBlockstack6 = jsonBlockstack7
                         //----------------------------------------------------------------------------------------------------------------------------------
                         Promise.all([this.listContract3(jsonBlockstack6,settingViewDataSimulator,settingModeDisplay,jsonBlockchain,jsonUser,jsonGarbage,jsonBlockstack5X,usernameX)])
                           .then((resolve) =>{resolve8()},(reject) =>{resolve8()})
                         //----------------------------------------------------------------------------------------------------------------------------------
                       }
                     })
                 }else{
                   //----------------------------------------------------------------------------------------------------------------------------------
                   Promise.all([this.listContract3(jsonBlockstack6,settingViewDataSimulator,settingModeDisplay,jsonBlockchain,jsonUser,jsonGarbage,jsonBlockstack5X,usernameX)])
                     .then((resolve) =>{resolve8()},(reject) =>{resolve8()})
                   //----------------------------------------------------------------------------------------------------------------------------------
                 }
               } else {
                 //----------------------------------------------------------------------------------------------------------------------------------
                 Promise.all([this.listContract3(jsonBlockstack6,settingViewDataSimulator,settingModeDisplay,jsonBlockchain,jsonUser,jsonGarbage,jsonBlockstack5X,usernameX)])
                   .then((resolve) =>{resolve8()},(reject) =>{resolve8()})
                 //----------------------------------------------------------------------------------------------------------------------------------
               }
             })
              .catch(error => {
                 //----------------------------------------------------------------------------------------------------------------------------------
                 Promise.all([this.listContract3(jsonBlockstack6,settingViewDataSimulator,settingModeDisplay,jsonBlockchain,jsonUser,jsonGarbage,jsonBlockstack5X,usernameX)])
                   .then((resolve) =>{resolve8()},(reject) =>{resolve8()})
                 //----------------------------------------------------------------------------------------------------------------------------------
             });
        })
      }

      listContract2(settingViewDataSimulator,settingModeDisplay,jsonBlockchain,jsonUser,jsonGarbage,userX,typeContract,configurationContractNumber,rolex,jsonBlockstack5X,usernameX){
          const {userSession} = this.state
          const storage = new Storage({ userSession });
          let options = ''
          if (userX !== ''){options = { username: userX, decrypt: false, verify: false }}else{options = { decrypt: false, verify: false }}
          let user2X = userX
          if (userX === '') { user2X = usernameX}
          let jsonBlockstack6 = []
          let largo = 0
          let scrollAuxiliar = this.state.scrollInitial
          return new Promise ((resolve1, reject1) =>{
              getFileDB(user2X, `contractlist.json`)
               .then((fileContents) => {
                 if(fileContents) {
                     const jsonBlockstack1 = JSON.parse(fileContents)
                     const jsonBlockstack2 = jsonBlockstack1.data
                     let jsonBlockstack5 = '[]'
                     if (jsonBlockstack2 !== null){
                        const jsonBlockstack3 = jsonBlockstack2.dataobject
                        const jsonBlockstack4 = jsonBlockstack3.replace(/\\/g,"");
                        if (jsonBlockstack4.substring(0,1) === '"') {
                           jsonBlockstack5 = jsonBlockstack4.substring(1,jsonBlockstack4.length - 1)
                        } else {
                           jsonBlockstack5 = jsonBlockstack4
                        }
                     }
                     let jsonBlockstack6 = JSON.parse(jsonBlockstack5)
                     let jsonBlockstack7 = []
                     if (userX === ''){
                         let userRemoteX = this.state.userRemoteX
                         if (userRemoteX === undefined){userRemoteX=''}
                         localStorage.setItem('jsonBlockstack50L',jsonBlockstack5)
                         let jsonBlockstack8 = ''
                         let jsonBlockstack4b = []
                         this.setState({jsonBlockstackZ50c: jsonBlockstack6})
                         largo = jsonBlockstack6.length
                         let hastaX = 0
                         jsonBlockstack6.map((todo11,key11) =>{
                            if (userRemoteX === '' && (todo11.typeContract !== 'simulate' || (todo11.typeContract === 'simulate' && this.state.viewSimulate === 'Yes' ))) {
                               if (todo11.origin === undefined || todo11.origin === null) {todo11.origin = ''}
                               if (todo11.subject === undefined || todo11.subject === null) {todo11.subject = ''}
                               if (todo11.role === undefined || todo11.role === null) {todo11.role = ''}
                               jsonBlockstack8 = jsonBlockstack6[key11]
                               jsonBlockstack7 = [...jsonBlockstack7, jsonBlockstack8]
                               this.setState({jsonBlockstackZ50a: jsonBlockstack7})
                               jsonBlockstack4b = jsonBlockstack7.concat(this.state.jsonBlockstackZ50b)
                               this.setState({jsonBlockstackZ50: jsonBlockstack4b,existListContractX: true})

                               if (this.state.activeInactiveAllX === 'Active'){
                                  if (todo11.active==="true" && (todo11.active_after_published==="true" || todo11.active_after_published===undefined)){
                                     hastaX = hastaX + 1
                                  }
                               }
                               if (this.state.activeInactiveAllX === 'Inactive'){
                                  if (todo11.active==="false" || (todo11.active==="true" && todo11.active_after_published==="false")){
                                     hastaX = hastaX + 1
                                  }
                               }
                               if (this.state.activeInactiveAllX === 'All'){
                                  hastaX = hastaX + 1
                               }

                               Promise.all([this.sortList(jsonBlockstack4b)]).then((resolve2)=>{},(reject2)=>{})
                            }
                            if (key11 === (largo -1)){
                              this.setState({scrollLength: hastaX, existListContractX: true})
                              //this.setState({scrollLength: jsonBlockstack4b.length, existListContractX: true})
                            }

                         })
                     }else{
                         let jsonBlockstack6b = {}
                         let jsonBlockstack4b = []
                         let userRemoteX = this.state.userRemoteX
                         if (userRemoteX === undefined){userRemoteX=''}
                         largo = jsonBlockstack6.length
                         let hastaX = 0
                         jsonBlockstack6.map((todo11,key11) =>{
                           if (userRemoteX === '' || (userRemoteX !== '' && userRemoteX === userX)){
                             if (todo11.typeContract === typeContract && todo11.configurationContractNumber  === configurationContractNumber){
                               if (todo11.origin === undefined || todo11.origin === null) {todo11.origin = ''}
                               if (todo11.subject === undefined || todo11.subject === null) {todo11.subject = ''}
                               if (todo11.role === undefined || todo11.role === null) {todo11.role = ''}
                               jsonBlockstack6b = jsonBlockstack6[key11]
                               //jsonBlockstack5X = [...jsonBlockstack5X, jsonBlockstack6b]
                               jsonBlockstack5X = [...this.state.jsonBlockstackZ50b, jsonBlockstack6b]
                               this.setState({jsonBlockstackZ50b: jsonBlockstack5X})
                               jsonBlockstack4b = this.state.jsonBlockstackZ50a.concat(jsonBlockstack5X)
                               this.setState({jsonBlockstackZ50: jsonBlockstack4b,existListContractX: true,scrollLength: jsonBlockstack4b.length})

                               if (this.state.activeInactiveAllX === 'Active'){
                                  if (todo11.active==="true" && (todo11.active_after_published==="true" || todo11.active_after_published===undefined)){
                                     hastaX = hastaX + 1
                                  }
                               }
                               if (this.state.activeInactiveAllX === 'Inactive'){
                                  if (todo11.active==="false" || (todo11.active==="true" && todo11.active_after_published==="false")){
                                     hastaX = hastaX + 1
                                  }
                               }
                               if (this.state.activeInactiveAllX === 'All'){
                                  hastaX = hastaX + 1
                               }

                               Promise.all([this.sortList(jsonBlockstack4b)]).then((resolve2)=>{},(reject2)=>{})
                             }
                           }
                           if (key11 === (largo -1)){
                             if (hastaX === 0 ){
                             //if (jsonBlockstack4b.length === 0 ){
                               this.setState({scrollInitial:scrollAuxiliar})
                             }else{
                               this.setState({scrollLength: hastaX})
                               //this.setState({scrollLength: jsonBlockstack4b.length})
                             }
                           }
                         })
                    }
                   //----------------------------------------------------------------------------------------------------------------------------------------------------------------------------
                   Promise.all([this.goContract('existe',jsonBlockstack6,settingViewDataSimulator,settingModeDisplay,jsonBlockchain,jsonUser,jsonGarbage,userX,typeContract,configurationContractNumber,rolex,usernameX)])
                     .then((resolve) =>{resolve1()},(reject) =>{resolve1()})
                   //----------------------------------------------------------------------------------------------------------------------------------------------------------------------------
                 } else {
                   //----------------------------------------------------------------------------------------------------------------------------------------------------------------------------
                   Promise.all([this.goContract('existe',jsonBlockstack6,settingViewDataSimulator,settingModeDisplay,jsonBlockchain,jsonUser,jsonGarbage,userX,typeContract,configurationContractNumber,rolex,usernameX)])
                     .then((resolve) =>{resolve1()},(reject) =>{resolve1()})
                   //----------------------------------------------------------------------------------------------------------------------------------------------------------------------------
                 }
               })
                .catch(error => {
                  resolve1()
               })
          })
      }

      listContract3(jsonRemote4,settingViewDataSimulator,settingModeDisplay,jsonBlockchain,jsonUser,jsonGarbage,jsonBlockstack5X,usernameX) {
        const {userSession} = this.state
        const storage = new Storage({ userSession });
        let options = {}
        return new Promise ((resolve9, reject9) =>{
            const largo = jsonRemote4.length
            jsonRemote4.map((todo9, key9) => {
                if (todo9.active === true){
                    options = { username: todo9.remoteuser, decrypt: false, verify: false }
                    getFileDB(todo9.remoteuser, `${usernameX}_remote.json`)
                       .then((fileContents) => {
                         if(fileContents) {
                             const jsonBlockstack1 = JSON.parse(fileContents)
                             const jsonBlockstack2 = jsonBlockstack1.data
                             let jsonBlockstack5 = '[]'
                             if (jsonBlockstack2 !== null){
                                const jsonBlockstack3 = jsonBlockstack2.dataobject
                                const jsonBlockstack4 = jsonBlockstack3.replace(/\\/g,"");
                                if (jsonBlockstack4.substring(0,1) === '"') {
                                   jsonBlockstack5 = jsonBlockstack4.substring(1,jsonBlockstack4.length - 1)
                                } else {
                                   jsonBlockstack5 = jsonBlockstack4
                                }
                                let jsonBlockstack6 = JSON.parse(jsonBlockstack5)
                                const jsonBlockstack40 = JSON.parse(jsonBlockstack5)
                                jsonBlockstack40.map((todo10,i) =>{
                                  if (todo10 !== null){
                                    //------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
                                    Promise.all([this.listContract2(settingViewDataSimulator,settingModeDisplay,jsonBlockchain,jsonUser,jsonGarbage,todo9.remoteuser,todo10.typeContract,todo10.configurationContractNumber,todo10.role,jsonBlockstack5X,usernameX)])
                                      .then((resolve) =>{},(reject) =>{})
                                    //------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
                                  }
                                })
                            } else {}
                         } else {}
                       })
                      .catch(error => {
                       });
                }
                if (key9 === largo -1){
                   resolve9()
                }
            })
        })
      }

      goContract(sExiste,jsonBlockstack4b,settingViewDataSimulator,settingModeDisplay,jsonBlockchain,jsonUser,jsonGarbage,userX,typeContract,configurationContractNumber,rolex,usernameX) {
        return new Promise ((resolve2, reject2) =>{
            if (sExiste === 'existe') {
                const largo =  jsonBlockstack4b.length
                jsonBlockstack4b.map((todo, key) => {
                  if (userX !== ''){
                    if (todo.typeContract === typeContract && todo.configurationContractNumber === configurationContractNumber){
                      if (todo.active === "true"){
                         todo.role = rolex
                         //------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
                         Promise.all([this.goContract2(todo.typeContract,todo.configurationContractNumber,todo.subject,todo.statusBlockchain,settingViewDataSimulator,settingModeDisplay,jsonBlockchain,jsonUser,jsonGarbage,userX,rolex,todo.statusActiveAfterPublished,usernameX)])
                           .then((resolve) =>{},(reject) =>{})
                         //------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
                      }else{
                         const jsonBlockchain0 = {"typecontract": `${todo.typeContract}`,"contractnumber": `${todo.configurationContractNumber}`,"subject": "","blockchain":"","lifeCycle":"Closed","origin":"","delete":"Yes","signature":"","role":"","ningunoSign":"","algunosSign":"","todosSign":"","ningunoDevice":"","algunosDevice":"","todosDevice":"","pause":""}
                         jsonBlockchain = [...this.state.jsonBlockchainZ50,jsonBlockchain0]
                         this.setState({jsonBlockchainZ50: jsonBlockchain})
                      }
                    }
                  }else{
                    if (todo.active === "true"){
                      //------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
                      Promise.all([this.goContract2(todo.typeContract,todo.configurationContractNumber,todo.subject,todo.statusBlockchain,settingViewDataSimulator,settingModeDisplay,jsonBlockchain,jsonUser,jsonGarbage,userX,rolex,todo.statusActiveAfterPublished,usernameX)])
                        .then((resolve) =>{},(reject) =>{})
                      //------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
                    }else{
                      const jsonBlockchain0 = {"typecontract": `${todo.typeContract}`,"contractnumber": `${todo.configurationContractNumber}`,"subject": "","blockchain":"","lifeCycle":"Closed","origin":"","delete":"Yes","signature":"","role":"","ningunoSign":"","algunosSign":"","todosSign":"","ningunoDevice":"","algunosDevice":"","todosDevice":"","pause":"yes"}
                      jsonBlockchain = [...this.state.jsonBlockchainZ50,jsonBlockchain0]
                      this.setState({jsonBlockchainZ50: jsonBlockchain})
                    }
                  }
                  if (key === largo - 1){
                    resolve2()
                  }
                })
            }else{
                reject2()
            }
        })
      }

      goContract2(typeContract,configurationContractNumber,subject,statusBlockchain,settingViewDataSimulator,settingModeDisplay,jsonBlockchain,jsonUser,jsonGarbage,userX,rolex,statusActiveAfterPublished,usernameX){
        const {userSession} = this.state
        const storage = new Storage({ userSession });
         let options = ''
         if (userX !== ''){options = { username: userX, decrypt: false, verify: false }}else{options = { decrypt: false, verify: false }}
         let user2X = userX
         if (userX === '') { user2X = usernameX}
         return new Promise ((resolve3, reject3) =>{
           getFileDB(user2X, `${typeContract}_${configurationContractNumber}.json`)
             .then((fileContents) => {
               if(fileContents) {
                 const jsonBlockstack1 = JSON.parse(fileContents)
                 const jsonBlockstack2 = jsonBlockstack1.data
                 let jsonBlockstack5 = '[]'
                 if (jsonBlockstack2 !== null){
                    const jsonBlockstack3 = jsonBlockstack2.dataobject
                    const jsonBlockstack4 = jsonBlockstack3.replace(/\\/g,"");
                    if (jsonBlockstack4.substring(0,1) === '"') {
                       jsonBlockstack5 = jsonBlockstack4.substring(1,jsonBlockstack4.length - 1)
                    } else {
                       jsonBlockstack5 = jsonBlockstack4
                    }
                    let jsonBlockstack6 = JSON.parse(jsonBlockstack5)
                     const jsonBlockstack40 = JSON.parse(jsonBlockstack5)
                     let signature = ''
                     if (jsonBlockstack40.signature !==''){
                        signature = "images/signGreen.png"
                     }else{
                       signature = "images/signRed.png"
                     }
                     if (jsonBlockstack40.statusBlockchain==='Cloud'){
                       const jsonBlockchain0 = {"typecontract": `${typeContract}`,"contractnumber": `${configurationContractNumber}`,"subject": `${subject}`,"blockchain":"images/ blockchainRed.png","lifeCycle":jsonBlockstack40.statusLifeCycle,"origin":jsonBlockstack40.usernameInsert,"delete":"Yes","signature":`${signature}`,"role":"","ningunoSign":"","algunosSign":"","todosSign":"","ningunoDevice":"","algunosDevice":"","todosDevice":"","pause":"","statusActiveAfterPublished":`${statusActiveAfterPublished}`}
                       jsonBlockchain = [...this.state.jsonBlockchainZ50,jsonBlockchain0]
                       this.setState({jsonBlockchainZ50: jsonBlockchain,jsonStatusBlockchain: jsonBlockstack40.statusBlockchain})
                     }else{
                        if (jsonBlockstack40.statusBlockchain==='Blockchain'){
                          const jsonBlockchain0 = {"typecontract": `${typeContract}`,"contractnumber": `${configurationContractNumber}`,"subject": `${subject}`,"blockchain":"images/ blockchainGreen.png","lifeCycle":jsonBlockstack40.statusLifeCycle,"origin":jsonBlockstack40.usernameInsert,"delete":"No","signature":`${signature}`,"role":"","ningunoSign":"","algunosSign":"","todosSign":"","ningunoDevice":"","algunosDevice":"","todosDevice":"","pause":"","statusActiveAfterPublished":`${statusActiveAfterPublished}`}
                          jsonBlockchain = [...this.state.jsonBlockchainZ50,jsonBlockchain0]
                          this.setState({jsonBlockchainZ50: jsonBlockchain,jsonStatusBlockchain: jsonBlockstack40.statusBlockchain})
                        }
                     }
                     //--------------------------------------------------------------------------------------------------------------------------------------------------------------------------
                     Promise.all([this.goContractAttachFile(typeContract,configurationContractNumber,statusBlockchain,settingViewDataSimulator,settingModeDisplay,jsonBlockchain,jsonUser,jsonGarbage,userX,rolex,usernameX)])
                       .then((resolve) =>{resolve3()},(reject) =>{resolve3()})
                     //--------------------------------------------------------------------------------------------------------------------------------------------------------------------------
                  } else {
                     const jsonBlockchain0 = {"typecontract": `${typeContract}`,"contractnumber": `${configurationContractNumber}`,"subject": "","blockchain":"","lifeCycle":"Error","origin":"","delete":"Yes","signature":"","role":"","ningunoSign":"","algunosSign":"","todosSign":"","ningunoDevice":"","algunosDevice":"","todosDevice":"","pause":"","statusActiveAfterPublished":`${statusActiveAfterPublished}`}
                     jsonBlockchain = [...this.state.jsonBlockchainZ50,jsonBlockchain0]
                     this.setState({jsonBlockchainZ50: jsonBlockchain})
                     resolve3()
                  }
               } else {
                  const jsonBlockchain0 = {"typecontract": `${typeContract}`,"contractnumber": `${configurationContractNumber}`,"subject": "","blockchain":"","lifeCycle":"Error","origin":"","delete":"Yes","signature":"","role":"","ningunoSign":"","algunosSign":"","todosSign":"","ningunoDevice":"","algunosDevice":"","todosDevice":"","pause":"","statusActiveAfterPublished":`${statusActiveAfterPublished}`}
                  jsonBlockchain = [...this.state.jsonBlockchainZ50,jsonBlockchain0]
                  this.setState({jsonBlockchainZ50: jsonBlockchain})
                  resolve3()
               }
             })
            .catch(error => {
                  resolve3()
             });
        })
      }

      goContractAttachFile(typeContract,configurationContractNumber,statusBlockchain,settingViewDataSimulator,settingModeDisplay,jsonBlockchain,jsonUser,jsonGarbage,userX,rolex,usernameX){
        const {userSession} = this.state
        const storage = new Storage({ userSession });
        let options = ''
        if (userX !== ''){options = { username: userX, decrypt: false, verify: false }}else{options = { decrypt: false, verify: false }}
        let user2X = userX
        if (userX === '') { user2X = usernameX}
        let jsonAttach = []
        this.setState({jsonAttach: []})
        return new Promise ((resolve4, reject4) =>{
            getFileDB(user2X, `${typeContract}_${configurationContractNumber}_attachlist.json`)
             .then((fileContents) => {
               if(fileContents) {
                  const jsonBlockstack1 = JSON.parse(fileContents)
                  const jsonBlockstack2 = jsonBlockstack1.data
                  if (jsonBlockstack2 === null){
                    jsonAttach = [...this.state.jsonAttachZ50, {"typecontract": `${typeContract}`,"contractnumber": `${configurationContractNumber}`,"attach":"images/attachRed.png"}]
                    this.setState({jsonAttachZ50: jsonAttach})
                    //-------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
                    Promise.all([this.goContractUserGroupPrevious(typeContract,configurationContractNumber,statusBlockchain,settingViewDataSimulator,settingModeDisplay,jsonBlockchain,jsonUser,jsonGarbage,user2X,rolex,usernameX)])
                      .then((resolve) =>{resolve4()},(reject) =>{resolve4()})
                    //-------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
                  }else{
                    const jsonBlockstack3 = jsonBlockstack2.dataobject
                    const jsonBlockstack4 = jsonBlockstack3.replace(/\\/g,"");
                    let jsonBlockstack5 = '[]'
                    if (jsonBlockstack4.substring(0,1) === '"') {
                       jsonBlockstack5 = jsonBlockstack4.substring(1,jsonBlockstack4.length - 1)
                    } else {
                       jsonBlockstack5 = jsonBlockstack4
                    }
                    let jsonBlockstack6 = JSON.parse(jsonBlockstack5)
                    jsonAttach = [...this.state.jsonAttachZ50, {"typecontract": `${typeContract}`,"contractnumber": `${configurationContractNumber}`,"attach":"images/attachGreen.png"}]
                    this.setState({jsonAttachZ50: jsonAttach})
                    //--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
                    Promise.all([this.goContractUserGroupPrevious(typeContract,configurationContractNumber,statusBlockchain,settingViewDataSimulator,settingModeDisplay,jsonBlockchain,jsonUser,jsonGarbage,user2X,rolex,usernameX)])
                      .then((resolve) =>{resolve4()},(reject) =>{resolve4()})
                    //--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
                  }
               } else {
                  jsonAttach = [...this.state.jsonAttachZ50, {"typecontract": `${typeContract}`,"contractnumber": `${configurationContractNumber}`,"attach":"images/attachRed.png"}]
                  this.setState({jsonAttachZ50: jsonAttach})
                  //----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
                  Promise.all([this.goContractUserGroupPrevious(typeContract,configurationContractNumber,statusBlockchain,settingViewDataSimulator,settingModeDisplay,jsonBlockchain,jsonUser,jsonGarbage,user2X,rolex,usernameX)])
                    .then((resolve) =>{resolve4()},(reject) =>{resolve4()})
                  //----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
               }
             })
            .catch(error => {
                  jsonAttach = [...this.state.jsonAttachZ50, {"typecontract": `${typeContract}`,"contractnumber": `${configurationContractNumber}`,"attach":"images/attachRed.png"}]
                  this.setState({jsonAttachZ50: jsonAttach})
                  //----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
                  Promise.all([this.goContractUserGroupPrevious(typeContract,configurationContractNumber,statusBlockchain,settingViewDataSimulator,settingModeDisplay,jsonBlockchain,jsonUser,jsonGarbage,user2X,rolex,usernameX)])
                    .then((resolve) =>{resolve4()},(reject) =>{resolve4()})
                  //----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
             });
        })
      }

      goContractUserGroupPrevious(typeContract,configurationContractNumber,statusBlockchain,settingViewDataSimulator,settingModeDisplay,jsonBlockchain,jsonUser,jsonGarbage,userX,rolex,usernameX){
        const {userSession} = this.state
        const storage = new Storage({ userSession });
        const options = { decrypt: false, verify: false }
        let user2X = userX
        if (userX === '') { user2X = usernameX}
        let jsonBlockstack4c = []
        this.setState({jsonUserGroupPact: []})
        return new Promise ((resolve4b, reject4b) =>{
            getFileDB(user2X, `${typeContract}_${configurationContractNumber}_usergroup.json`)
             .then((fileContents) => {
               if(fileContents) {
                  const jsonBlockstack1 = JSON.parse(fileContents)
                  const jsonBlockstack2 = jsonBlockstack1.data
                  let jsonBlockstack5 = '[]'
                  if (jsonBlockstack2 === null){
                     //----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
                     Promise.all([this.goContractUserGroupRemoto(typeContract,configurationContractNumber,statusBlockchain,settingViewDataSimulator,settingModeDisplay,jsonBlockchain,jsonUser,jsonGarbage,jsonBlockstack4c,userX,rolex,usernameX)])
                       .then((resolve) =>{resolve4b()},(reject) =>{resolve4b()})
                     //----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
                  } else {
                    const jsonBlockstack3 = jsonBlockstack2.dataobject
                    const jsonBlockstack4 = jsonBlockstack3.replace(/\\/g,"");
                    if (jsonBlockstack4.substring(0,1) === '"') {
                       jsonBlockstack5 = jsonBlockstack4.substring(1,jsonBlockstack4.length - 1)
                    } else {
                       jsonBlockstack5 = jsonBlockstack4
                    }
                    let jsonBlockstack6 = JSON.parse(jsonBlockstack5)
                    jsonBlockstack4c = JSON.parse(jsonBlockstack5)
                    this.setState({jsonUserGroupPact: jsonBlockstack5})
                    //-----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
                    Promise.all([this.goContractUserGroupRemoto(typeContract,configurationContractNumber,statusBlockchain,settingViewDataSimulator,settingModeDisplay,jsonBlockchain,jsonUser,jsonGarbage,jsonBlockstack4c,userX,rolex,usernameX)])
                      .then((resolve) =>{resolve4b()},(reject) =>{resolve4b()})
                    //-----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
                  }
               } else {
                  //-----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
                  Promise.all([this.goContractUserGroupRemoto(typeContract,configurationContractNumber,statusBlockchain,settingViewDataSimulator,settingModeDisplay,jsonBlockchain,jsonUser,jsonGarbage,jsonBlockstack4c,userX,rolex,usernameX)])
                    .then((resolve) =>{resolve4b()},(reject) =>{resolve4b()})
                  //-----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
               }
             })
            .catch(error => {
                  jsonUser = [...this.state.jsonUserZ50,{"typecontract": `${typeContract}`,"contractnumber": `${configurationContractNumber}`,"user":"","role":"","nome":"","linkSupport":""}]
                  jsonGarbage = [...this.state.jsonGarbageZ50, {"typecontract": `${typeContract}`,"contractnumber": `${configurationContractNumber}`,"deleteContract":true,"sign":"images/signRed.png","register":"images/registerRed.png","todosSign":false,"statusBlockchain": `${statusBlockchain}`,"role":"","nome":"","algunosSign":false,"ningunoSign":false}]
                  this.setState({jsonUserZ50: jsonUser,jsonGarbageZ50: jsonGarbage})
                  //-----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
                  Promise.all([this.goContractUserGroupRemoto(typeContract,configurationContractNumber,statusBlockchain,settingViewDataSimulator,settingModeDisplay,jsonBlockchain,jsonUser,jsonGarbage,jsonBlockstack4c,userX,rolex,usernameX)])
                    .then((resolve) =>{resolve4b()},(reject) =>{resolve4b()})
                  //-----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
             });
        })
      }

      goContractUserGroupRemoto(typeContract,configurationContractNumber,statusBlockchain,settingViewDataSimulator,settingModeDisplay,jsonBlockchain,jsonUser,jsonGarbage,jsonBlockstack4c,userX,rolex,usernameX){
        const {userSession} = this.state
        const storage = new Storage({ userSession });
        const largo = jsonBlockstack4c.length
        this.setState({showLoader:false})
        let salirX = false
        return new Promise ((resolve4c, reject4c) =>{
          if (jsonBlockstack4c.length > 0){
            jsonBlockstack4c.map((todoUserRemote,keyUserRemote)=>{
              let options = ''
              if (todoUserRemote.role === 'Authorizer' || todoUserRemote.role === 'Authorizer-Inviter'){
                options = { username: todoUserRemote.id, decrypt: false, verify: false }
                let jsonBlockstack4d = []
                this.setState({jsonUserGroupPactRemoto: []})
                new Promise ((resolve4d, reject4d) =>{
                    getFileDB(todoUserRemote.id, `${typeContract}_${configurationContractNumber}_usergroup.json`)
                     .then((fileContents) => {
                       if(fileContents) {
                            const jsonBlockstack1 = JSON.parse(fileContents)
                            const jsonBlockstack2 = jsonBlockstack1.data
                            let jsonBlockstack5 = '[]'
                            if (jsonBlockstack2 !== null){
                               const jsonBlockstack3 = jsonBlockstack2.dataobject
                               const jsonBlockstack4 = jsonBlockstack3.replace(/\\/g,"");
                               if (jsonBlockstack4.substring(0,1) === '"') {
                                  jsonBlockstack5 = jsonBlockstack4.substring(1,jsonBlockstack4.length - 1)
                               } else {
                                  jsonBlockstack5 = jsonBlockstack4
                               }
                               let jsonBlockstack6 = JSON.parse(jsonBlockstack5)
                               jsonBlockstack4d = JSON.parse(jsonBlockstack5)
                               const signature = jsonBlockstack4d[0].signature
                               todoUserRemote.signature = signature
                               if (keyUserRemote === largo - 1){
                                 //----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
                                 Promise.all([this.goContractUserGroup3(typeContract,configurationContractNumber,statusBlockchain,settingViewDataSimulator,settingModeDisplay,jsonBlockchain,jsonUser,jsonGarbage,jsonBlockstack4c,userX,rolex,usernameX)])
                                   .then((resolve) =>{resolve4d();salirX = true;},(reject) =>{resolve4d();salirX = true;})
                                 //----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
                               } else {
                                 resolve4d()
                               }
                            } else {
                              if (keyUserRemote === largo - 1){
                                //----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
                                Promise.all([this.goContractUserGroup3(typeContract,configurationContractNumber,statusBlockchain,settingViewDataSimulator,settingModeDisplay,jsonBlockchain,jsonUser,jsonGarbage,jsonBlockstack4c,userX,rolex,usernameX)])
                                  .then((resolve) =>{resolve4d();salirX = true;},(reject) =>{resolve4d();salirX = true;})
                                //----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
                              } else {
                                resolve4d()
                              }
                            }
                       } else {
                         if (keyUserRemote === largo - 1){
                           //----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
                           Promise.all([this.goContractUserGroup3(typeContract,configurationContractNumber,statusBlockchain,settingViewDataSimulator,settingModeDisplay,jsonBlockchain,jsonUser,jsonGarbage,jsonBlockstack4c,userX,rolex,usernameX)])
                             .then((resolve) =>{resolve4d();salirX = true;},(reject) =>{resolve4d();salirX = true;})
                           //----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
                         } else {
                           resolve4d()
                         }
                       }
                     })
                     .catch(error => {
                       if (keyUserRemote === largo - 1){
                         //----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
                         Promise.all([this.goContractUserGroup3(typeContract,configurationContractNumber,statusBlockchain,settingViewDataSimulator,settingModeDisplay,jsonBlockchain,jsonUser,jsonGarbage,jsonBlockstack4c,userX,rolex,usernameX)])
                           .then((resolve) =>{resolve4d();salirX = true;},(reject) =>{resolve4d();salirX = true;})
                         //----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
                       } else {
                         resolve4d()
                       }
                     });
                })
              }else{
                if (keyUserRemote === largo - 1){
                  //----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
                  Promise.all([this.goContractUserGroup3(typeContract,configurationContractNumber,statusBlockchain,settingViewDataSimulator,settingModeDisplay,jsonBlockchain,jsonUser,jsonGarbage,jsonBlockstack4c,userX,rolex,usernameX)])
                    .then((resolve) =>{resolve4c();salirX = true;},(reject) =>{resolve4c();salirX = true;})
                  //----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
                }
              }
              if (salirX){
                resolve4c()
              }
            })
          }else{
            let options = { username: userX, decrypt: false, verify: false }
            let jsonBlockstack4d = []
            this.setState({jsonUserGroupPactRemoto: []})
            new Promise ((resolve4e, reject4e) =>{
                getFileDB(userX, `${typeContract}_${configurationContractNumber}_usergroup.json`)
                 .then((fileContents) => {
                   if(fileContents) {
                        const jsonBlockstack1 = JSON.parse(fileContents)
                        const jsonBlockstack2 = jsonBlockstack1.data
                        let jsonBlockstack5 = '[]'
                        if (jsonBlockstack2 !== null){
                           const jsonBlockstack3 = jsonBlockstack2.dataobject
                           const jsonBlockstack4 = jsonBlockstack3.replace(/\\/g,"");
                           if (jsonBlockstack4.substring(0,1) === '"') {
                              jsonBlockstack5 = jsonBlockstack4.substring(1,jsonBlockstack4.length - 1)
                           } else {
                              jsonBlockstack5 = jsonBlockstack4
                           }
                           let jsonBlockstack6 = JSON.parse(jsonBlockstack5)
                           jsonBlockstack4d = JSON.parse(jsonBlockstack5)
                           //-----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
                           Promise.all([this.goContractUserGroup3(typeContract,configurationContractNumber,statusBlockchain,settingViewDataSimulator,settingModeDisplay,jsonBlockchain,jsonUser,jsonGarbage,jsonBlockstack4d,userX,rolex,usernameX)])
                             .then((resolve) =>{resolve4e()},(reject) =>{resolve4e()})
                           //-----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
                        } else {
                          jsonUser = [...this.state.jsonUserZ50, {"typecontract": `${typeContract}`,"contractnumber": `${configurationContractNumber}`,"user":"images/userRed.png","role":"","nome":"","linkSupport":""}]
                          jsonGarbage = [...this.state.jsonGarbageZ50, {"typecontract": `${typeContract}`,"contractnumber": `${configurationContractNumber}`,"deleteContract":true,"sign":"images/signRed.png","register":"images/registerRed.png","todosSign":false,"statusBlockchain": `${statusBlockchain}`,"role":"","nome":"","algunosSign":false,"ningunoSign":false}]
                          this.setState({jsonUserZ50: jsonUser,jsonGarbageZ50: jsonGarbage})
                          resolve4e()
                        }
                   } else {
                      jsonUser = [...this.state.jsonUserZ50, {"typecontract": `${typeContract}`,"contractnumber": `${configurationContractNumber}`,"user":"images/userRed.png","role":"","nome":"","linkSupport":""}]
                      jsonGarbage = [...this.state.jsonGarbageZ50, {"typecontract": `${typeContract}`,"contractnumber": `${configurationContractNumber}`,"deleteContract":true,"sign":"images/signRed.png","register":"images/registerRed.png","todosSign":false,"statusBlockchain": `${statusBlockchain}`,"role":"","nome":"","algunosSign":false,"ningunoSign":false}]
                      this.setState({jsonUserZ50: jsonUser,jsonGarbageZ50: jsonGarbage})
                      resolve4e()
                   }
                 })
                 .catch(error => {
                    resolve4e()
                 });
            })
          }
        })
      }

      goContractUserGroup3(typeContract,configurationContractNumber,statusBlockchain,settingViewDataSimulator,settingModeDisplay,jsonBlockchain,jsonUser,jsonGarbage,jsonBlockstack4c,userX,roleX2,usernameX){
          let noSign = false,yesSign = false,deleteContract = false,signContractY = '',registerContractY = '',algunosSign = false,ningunoSign = false,todosSign = false,rolex='',nomex='',linkSupport = false
          jsonBlockstack4c.map((todo2,key2)=>{
              if (todo2.id===usernameX){
                 rolex = todo2.role
                 nomex = todo2.id
              }
              if ((todo2.role === 'Authorizer' || todo2.role === 'Authorizer-Inviter' || todo2.role === 'Creator') && (todo2.signature === '' || todo2.signature === undefined)){
                  noSign = true
              }
              if ((todo2.role === 'Authorizer' || todo2.role === 'Authorizer-Inviter' || todo2.role === 'Creator') && (todo2.signature !== '' && todo2.signature !== undefined)){
                  yesSign = true
              }
              if (todo2.role === 'Support'){
                  linkSupport = true
              }
          })
          if (yesSign && noSign){
             algunosSign = true
             signContractY = 'images/signGreen.png'
             registerContractY = 'images/registerGreen.png'
          }
          if (!yesSign && noSign){
             ningunoSign = true
             signContractY = 'images/signRed.png'
             registerContractY = 'images/registerRed.png'
          }
          if (yesSign && !noSign){
             todosSign = true
             signContractY = 'images/signGreen.png'
             registerContractY = 'images/registerGreen.png'
          }
          if (ningunoSign){
              deleteContract = true
          }
          //----------------------------------------
          if (roleX2 !== '' && roleX2 !== undefined){
             if (roleX2 !== 'Creator') {rolex = roleX2}
          }
          //----------------------------------------
          jsonGarbage = [...this.state.jsonGarbageZ50, {"typecontract": `${typeContract}`,"contractnumber": `${configurationContractNumber}`,"deleteContract":deleteContract,"sign":signContractY,"register":registerContractY,"todosSign":todosSign,"statusBlockchain": `${statusBlockchain}`,"role": `${rolex}`,"nome":`${nomex}`,"algunosSign":algunosSign,"ningunoSign":ningunoSign}]
          if (jsonBlockstack4c.length === 2){
             jsonUser = [...this.state.jsonUserZ50, {"typecontract": `${typeContract}`,"contractnumber": `${configurationContractNumber}`,"user":"images/user2Green.png","role":`${rolex}`,"nome":`${nomex}`,"linkSupport":linkSupport}]
          }else{
            if (jsonBlockstack4c.length === 1){
               jsonUser = [...this.state.jsonUserZ50, {"typecontract": `${typeContract}`,"contractnumber": `${configurationContractNumber}`,"user":"images/user1Green.png","role":`${rolex}`,"nome":`${nomex}`,"linkSupport":linkSupport}]
            }else{
               jsonUser = [...this.state.jsonUserZ50, {"typecontract": `${typeContract}`,"contractnumber": `${configurationContractNumber}`,"user":"images/userGreen.png","role":`${rolex}`,"nome":`${nomex}`,"linkSupport":linkSupport}]
            }
          }
          this.setState({jsonUserZ50: jsonUser,jsonGarbageZ50: jsonGarbage})
          //----------------------------------------------------------------------------------------------------------------------
          if (rolex === 'Support' || rolex === 'Observer'){
            Promise.all([this.goContractRules(typeContract,configurationContractNumber,rolex,settingViewDataSimulator,settingModeDisplay,userX,usernameX)])
              .then((resolve) =>{},(reject) =>{})
          }
          //----------------------------------------------------------------------------------------------------------------------
      }

      goContractUserGroup(typeContract,configurationContractNumber,statusBlockchain,settingViewDataSimulator,settingModeDisplay,jsonBlockchain,jsonUser,jsonGarbage,userX,usernameX){
        const {userSession} = this.state
        const storage = new Storage({ userSession });
        const options = { decrypt: false, verify: false }
        let jsonBlockstack4c = []
        this.setState({jsonUserGroupPact: []})
        return new Promise ((resolve4d, reject4d) =>{
            getFileDB(usernameX, `${typeContract}_${configurationContractNumber}_usergroup.json`)
             .then((fileContents) => {
               if(fileContents) {
                  const jsonBlockstack1 = JSON.parse(fileContents)
                  const jsonBlockstack2 = jsonBlockstack1.data
                  if (jsonBlockstack2 === null){
                    jsonUser = [...this.state.jsonUserZ50, {"typecontract": `${typeContract}`,"contractnumber": `${configurationContractNumber}`,"user":"images/userRed.png","role": ``,"nome":``}]
                    jsonGarbage = [...this.state.jsonGarbageZ50, {"typecontract": `${typeContract}`,"contractnumber": `${configurationContractNumber}`,"deleteContract":true,"sign":"images/signRed.png","register":"images/registerRed.png","todosSign":false,"statusBlockchain": `${statusBlockchain}`,"role": ``,"nome":``,"algunosSign":false,"ningunoSign":false}]
                    this.setState({jsonUserZ50: jsonUser,jsonGarbageZ50: jsonGarbage})
                    resolve4d()
                  } else {
                     const jsonBlockstack3 = jsonBlockstack2.dataobject
                     const jsonBlockstack4 = jsonBlockstack3.replace(/\\/g,"");
                     let jsonBlockstack5 = jsonBlockstack3.replace(/\\/g,"");
                     if (jsonBlockstack4.substring(0,1) === '"') {
                        jsonBlockstack5 = jsonBlockstack4.substring(1,jsonBlockstack4.length - 1)
                     } else {
                        jsonBlockstack5 = jsonBlockstack4
                     }
                     let jsonBlockstack6 = JSON.parse(jsonBlockstack5)
                     jsonBlockstack4c = JSON.parse(jsonBlockstack5)
                     this.setState({jsonUserGroupPact: jsonBlockstack5})
                     let noSign = false,yesSign = false,deleteContract = false,signContractY = '',registerContractY = '',algunosSign = false,ningunoSign = false,todosSign = false,rolex='',nomex=''
                     jsonBlockstack4c.map((todo2,key2)=>{
                       if (todo2.id===usernameX){
                          rolex = todo2.role
                          nomex = todo2.id
                       }
                       if ((todo2.role === 'Authorizer' || todo2.role === 'Authorizer-Inviter' || todo2.role === 'Creator') && (todo2.signature === '' || todo2.signature === undefined)){
                           noSign = true
                       }
                       if ((todo2.role === 'Authorizer' || todo2.role === 'Authorizer-Inviter' || todo2.role === 'Creator') && (todo2.signature !== '' && todo2.signature !== undefined)){
                           yesSign = true
                       }
                     })
                     if (yesSign && noSign){
                        algunosSign = true
                        signContractY = 'images/signGreen.png'
                        registerContractY = 'images/registerGreen.png'
                     }
                     if (!yesSign && noSign){
                        ningunoSign = true
                        signContractY = 'images/signRed.png'
                        registerContractY = 'images/registerRed.png'
                     }
                     if (yesSign && !noSign){
                        todosSign = true
                        signContractY = 'images/signGreen.png'
                        registerContractY = 'images/registerGreen.png'
                     }
                     if (ningunoSign){
                         deleteContract = true
                     }
                     jsonGarbage = [...this.state.jsonGarbageZ50, {"typecontract": `${typeContract}`,"contractnumber": `${configurationContractNumber}`,"deleteContract":deleteContract,"sign":signContractY,"register":registerContractY,"todosSign":todosSign,"statusBlockchain": `${statusBlockchain}`,"role": `${rolex}`,"nome":`${nomex}`,"algunosSign":algunosSign,"ningunoSign":ningunoSign}]
                     if (jsonBlockstack4c.length === 2){
                        jsonUser = [...this.state.jsonUserZ50, {"typecontract": `${typeContract}`,"contractnumber": `${configurationContractNumber}`,"user":"images/user2Green.png","role":`${rolex}`,"nome":`${nomex}`}]
                     }else{
                       if (jsonBlockstack4c.length === 1){
                          jsonUser = [...this.state.jsonUserZ50, {"typecontract": `${typeContract}`,"contractnumber": `${configurationContractNumber}`,"user":"images/user1Green.png","role":`${rolex}`,"nome":`${nomex}`}]
                       }else{
                          jsonUser = [...this.state.jsonUserZ50, {"typecontract": `${typeContract}`,"contractnumber": `${configurationContractNumber}`,"user":"images/userGreen.png","role":`${rolex}`,"nome":`${nomex}`}]
                       }
                     }
                     this.setState({jsonUserZ50: jsonUser,jsonGarbageZ50: jsonGarbage})
                     //----------------------------------------------------------------------------------------------------------------------
                     if (rolex === 'Support' || rolex === 'Observer'){
                       Promise.all([this.goContractRules(typeContract,configurationContractNumber,rolex,settingViewDataSimulator,settingModeDisplay,userX)])
                         .then((resolve) =>{resolve4d()},(reject) =>{resolve4d()})
                     }else{
                       resolve4d()
                     }
                     //----------------------------------------------------------------------------------------------------------------------
                  }
               } else {
                  jsonUser = [...this.state.jsonUserZ50, {"typecontract": `${typeContract}`,"contractnumber": `${configurationContractNumber}`,"user":"images/userRed.png","role":"","nome":""}]
                  jsonGarbage = [...this.state.jsonGarbageZ50, {"typecontract": `${typeContract}`,"contractnumber": `${configurationContractNumber}`,"deleteContract":true,"sign":"images/signRed.png","register":"images/registerRed.png","todosSign":false,"statusBlockchain": `${statusBlockchain}`,"role":"","nome":"","algunosSign":false,"ningunoSign":false}]
                  this.setState({jsonUserZ50: jsonUser,jsonGarbageZ50: jsonGarbage})
                  resolve4d()
               }
             })
            .catch(error => {
                  jsonUser = [...this.state.jsonUserZ50,{"typecontract": `${typeContract}`,"contractnumber": `${configurationContractNumber}`,"user":"","role":"","nome":""}]
                  jsonGarbage = [...this.state.jsonGarbageZ50, {"typecontract": `${typeContract}`,"contractnumber": `${configurationContractNumber}`,"deleteContract":true,"sign":"images/signRed.png","register":"images/registerRed.png","todosSign":false,"statusBlockchain": `${statusBlockchain}`,"role":"","nome":"","algunosSign":false,"ningunoSign":false}]
                  this.setState({jsonUserZ50: jsonUser,jsonGarbageZ50: jsonGarbage})
                  resolve4d()
             });
        })
      }

      goContractRules(typeContract,configurationContractNumber,rolex,settingViewDataSimulator,settingModeDisplay,userX,usernameX){
         const {userSession} = this.state
         const storage = new Storage({ userSession });
         let options = ''
         if (userX !== ''){options = { username: userX, decrypt: false, verify: false }}else{options = { decrypt: false, verify: false }}
         let user2X = userX
         if (userX === '') { user2X = usernameX}
         let jsonBlockstack4c = []
         let jsonLink = []
         return new Promise ((resolve5, reject5) =>{
            getFileDB(user2X, `${typeContract}_${configurationContractNumber}_rules.json`)
               .then((fileContents) => {
                 if(fileContents) {
                      const jsonBlockstack1 = JSON.parse(fileContents)
                      const jsonBlockstack2 = jsonBlockstack1.data
                      let jsonBlockstack5 = '[]'
                      if (jsonBlockstack2 !== null){
                         const jsonBlockstack3 = jsonBlockstack2.dataobject
                         const jsonBlockstack4 = jsonBlockstack3.replace(/\\/g,"");
                         if (jsonBlockstack4.substring(0,1) === '"') {
                            jsonBlockstack5 = jsonBlockstack4.substring(1,jsonBlockstack4.length - 1)
                         } else {
                            jsonBlockstack5 = jsonBlockstack4
                         }
                         let jsonBlockstack6 = JSON.parse(jsonBlockstack5)
                         jsonBlockstack4c = JSON.parse(jsonBlockstack5)
                         //------------------------------------------------------------------------------------------------
                         Promise.all([this.goContractIoTDevice(jsonBlockstack4c,rolex,settingViewDataSimulator,settingModeDisplay,userX,usernameX)])
                           .then((resolve) =>{resolve5()},(reject) =>{resolve5()})
                         //------------------------------------------------------------------------------------------------
                       } else {
                          let lifeCycle = ''
                          if (rolex==="Observer"){
                            lifeCycle = 'Active'
                          }else{
                            if (rolex==="Support"){
                              lifeCycle = 'Disconnect'
                            }
                          }
                          jsonLink = {"typecontract": `${typeContract}`,"contractnumber": `${configurationContractNumber}`,"link":"images/linkbrokenRed.png","lifeCycle":`${lifeCycle}`,"algunosDevice":false,"ningunoDevice":false,"todosDevice":false}
                          const jsonLink2 = [...this.state.jsonLinkZ50, jsonLink]
                          this.setState({jsonLinkZ50: jsonLink2})
                          resolve5()
                       }
                 } else {
                    let lifeCycle = ''
                    if (rolex==="Observer"){
                      lifeCycle = 'Active'
                    }else{
                      if (rolex==="Support"){
                        lifeCycle = 'Disconnect'
                      }
                    }
                    jsonLink = {"typecontract": `${typeContract}`,"contractnumber": `${configurationContractNumber}`,"link":"images/linkbrokenRed.png","lifeCycle":`${lifeCycle}`,"algunosDevice":false,"ningunoDevice":false,"todosDevice":false}
                    const jsonLink2 = [...this.state.jsonLinkZ50, jsonLink]
                    this.setState({jsonLinkZ50: jsonLink2})
                    resolve5()
                 }
               })
              .catch(error => {
                    resolve5()
               });
         })
      }

      goContractIoTDevice(jsonBlockstack4,rolex,settingViewDataSimulator,settingModeDisplay,userX,usernameX){
         let jsonLink = []
         return new Promise ((resolve6, reject6) =>{
             const largo = jsonBlockstack4.length
             jsonBlockstack4.map ((todo3, key3) => {
                 Promise.all([this.goContractIoTDevice2(todo3.typeContract,todo3.configurationContractNumber,todo3.enrollment,rolex,settingViewDataSimulator,settingModeDisplay,jsonLink,userX,usernameX)])
                   .then((resolve) =>{},(reject) =>{})
                 if (key3 === largo -1){
                   resolve6()
                 }
             })
         })
      }

      goContractIoTDevice2(typeContract,configurationContractNumber,enrollment,rolex,settingViewDataSimulator,settingModeDisplay,jsonLink,userX,usernameX){
         const {userSession} = this.state
         const storage = new Storage({ userSession });
         let options = ''
         if (userX !== ''){options = { username: userX, decrypt: false, verify: false }}else{options = { decrypt: false, verify: false }}
         let user2X = userX
         if (userX === '') { user2X = usernameX}
         let jsonBlockstack4c = []
         return new Promise ((resolve7, reject7) =>{
             getFileDB(user2X, `${typeContract}_${configurationContractNumber}_${enrollment}_device.json`)
              .then((fileContents) => {
                if(fileContents) {
                  const jsonBlockstack1 = JSON.parse(fileContents)
                  const jsonBlockstack2 = jsonBlockstack1.data
                  let jsonBlockstack5 = '[]'
                  if (jsonBlockstack2 === null){
                    jsonLink = {"typecontract": `${typeContract}`,"contractnumber": `${configurationContractNumber}`,"link":"images/linkbrokenRed.png","lifeCycle":"Disconnect","algunosDevice":false,"ningunoDevice":false,"todosDevice":false}
                    const jsonLink2 = [...this.state.jsonLinkZ50, jsonLink]
                    this.setState({jsonLinkZ50: jsonLink2})
                    resolve7()
                  }else{
                     const jsonBlockstack3 = jsonBlockstack2.dataobject
                     const jsonBlockstack4 = jsonBlockstack3.replace(/\\/g,"");
                     if (jsonBlockstack4.substring(0,1) === '"') {
                        jsonBlockstack5 = jsonBlockstack4.substring(1,jsonBlockstack4.length - 1)
                     } else {
                        jsonBlockstack5 = jsonBlockstack4
                     }
                     let jsonBlockstack6 = JSON.parse(jsonBlockstack5)
                     jsonBlockstack4c = JSON.parse(jsonBlockstack5)
                     let noDevice= false,yesDevice = false,algunosDevice = false,ningunoDevice = false,todosDevice = false,lifeCycle = ''
                     jsonBlockstack4c.map((todo2,key2)=>{
                       if (todo2.activate === false){
                           noDevice = true
                        }
                        if (todo2.activate === true){
                           yesDevice = true
                        }
                     })
                     if (rolex==="Support"){
                       if (yesDevice && noDevice){
                          algunosDevice = true
                          lifeCycle = 'Disconnect'
                       }
                       if (!yesDevice && noDevice){
                          ningunoDevice = true
                          lifeCycle = 'Connected'
                       }
                       if (yesDevice && !noDevice){
                          todosDevice = true
                          lifeCycle = 'Transmitting'
                       }
                     }else{
                       if (rolex==="Observer"){
                         if (yesDevice && noDevice){
                            algunosDevice = true
                            lifeCycle = 'Active'
                         }
                         if (!yesDevice && noDevice){
                            ningunoDevice = true
                            lifeCycle = 'Active'
                         }
                         if (yesDevice && !noDevice){
                            todosDevice = true
                            lifeCycle = 'Active'
                         }
                       }
                     }
                     jsonLink = {"typecontract": `${typeContract}`,"contractnumber": `${configurationContractNumber}`,"link":"images/linkGreen.png","lifeCycle":`${lifeCycle}`,"algunosDevice":algunosDevice,"ningunoDevice":ningunoDevice,"todosDevice":todosDevice}
                     const jsonLink2 = [...this.state.jsonLinkZ50, jsonLink]
                     this.setState({jsonLinkZ50: jsonLink2})
                     resolve7()
                  }
                } else {
                   let lifeCycle = ''
                   if (rolex==="Observer"){
                     lifeCycle = 'Active'
                   }else{
                     if (rolex==="Support"){
                       lifeCycle = 'Disconnect'
                     }
                   }
                   jsonLink = {"typecontract": `${typeContract}`,"contractnumber": `${configurationContractNumber}`,"link":"images/linkbrokenRed.png","lifeCycle":`${lifeCycle}`,"algunosDevice":false,"ningunoDevice":false,"todosDevice":false}
                   const jsonLink2 = [...this.state.jsonLinkZ50, jsonLink]
                   this.setState({jsonLinkZ50: jsonLink2})
                   resolve7()
                }
              })
             .catch(error => {
                   resolve7()
              });
        })
      }

      attachFile(typeContract,configurationContractNumber,userX) {
           const {userSession} = this.state
           const storage = new Storage({ userSession });
           let options = ''
           if (userX !== ''){options = { username: userX, decrypt: false, verify: false }}else{options = { decrypt: false, verify: false }}
           let user2X = userX
           if (userX === '') { user2X = this.state.username}
           let jsonBlockstack4 = []
           getFileDB(user2X,`${typeContract}_${configurationContractNumber}_attachlist.json`)
             .then((fileContents) => {
               if(fileContents) {
                 const jsonBlockstack1 = JSON.parse(fileContents)
                 const jsonBlockstack2 = jsonBlockstack1.data
                 let jsonBlockstack5 = '[]'
                 if (jsonBlockstack2 !== null){
                    const jsonBlockstack3 = jsonBlockstack2.dataobject
                    const jsonBlockstack4 = jsonBlockstack3.replace(/\\/g,"");
                    if (jsonBlockstack4.substring(0,1) === '"') {
                       jsonBlockstack5 = jsonBlockstack4.substring(1,jsonBlockstack4.length - 1)
                    } else {
                       jsonBlockstack5 = jsonBlockstack4
                    }
                 }
                 let jsonBlockstack6 = JSON.parse(jsonBlockstack5)
                  this.setState({jsonAttachFile:jsonBlockstack6})
               } else {}
             })
            .catch(error => {
            });
      }

      getDisplayCompanyLogo(userX,typeContract){
        if (typeContract === 'simulate'){typeContract='delivery'}
        return new Promise ((resolve, reject) =>{
            this.setState({logoCompany: '',dataCompany: '' })
            if (userX === this.state.username){
                const templatesAllLocalX = this.state.templatesAllLocal
                templatesAllLocalX.map((todoTemplate,t) => {
                   if (todoTemplate.secondaryName === typeContract){
                      this.setState({logoCompany: todoTemplate.file,dataCompany: todoTemplate.title })
                   }
                })
                resolve()
            }else{
              const {userSession} = this.state
              const storage = new Storage({ userSession });
              const options = { username: userX, decrypt: false, verify: false }
              getFileDB(userX, `contractdoc.json`)
                   .then((fileContents) => {
                     if(fileContents) {
                       const jsonBlockstack1 = JSON.parse(fileContents)
                       const jsonBlockstack2 = jsonBlockstack1.data
                       let jsonBlockstack5 = '[]'
                       if (jsonBlockstack2 !== null){
                          const jsonBlockstack3 = jsonBlockstack2.dataobject
                          const jsonBlockstack4 = jsonBlockstack3.replace(/\\/g,"");
                          if (jsonBlockstack4.substring(0,1) === '"') {
                             jsonBlockstack5 = jsonBlockstack4.substring(1,jsonBlockstack4.length - 1)
                          } else {
                             jsonBlockstack5 = jsonBlockstack4
                          }
                       }
                       let jsonBlockstack6 = JSON.parse(jsonBlockstack5)
                       const largo = jsonBlockstack6.length
                       jsonBlockstack6.map((todoTemplate,t)=>{
                         if (todoTemplate.secondaryName === typeContract){
                            this.setState({logoCompany: todoTemplate.file,dataCompany: todoTemplate.title })
                         }
                       })
                       resolve()
                     }else{
                       resolve()
                     }
                   })
                  .catch(error => {
                     resolve()
                   });
            }
        })
      }

      getDisplayCompanyData(userX,typeContract){
        if (typeContract === 'simulate'){typeContract='delivery'}
        const {userSession} = this.state
        const storage = new Storage({ userSession });
        let options = ''
        if (userX !== this.state.username){options = { username: userX, decrypt: false, verify: false }}else{options = { decrypt: false, verify: false }}
        let user2X = userX
        if (userX === '') { user2X = this.state.username}
        this.setState({dataCompany2: ''})
        return new Promise ((resolve, reject) =>{
          getFileDB(user2X, `${typeContract}_settings_companydata.json`)
             .then((fileContents) => {
               if(fileContents) {
                 const jsonBlockstack1 = JSON.parse(fileContents)
                 const jsonBlockstack2 = jsonBlockstack1.data
                 let jsonBlockstack5 = '[]'
                 if (jsonBlockstack2 !== null){
                    const jsonBlockstack3 = jsonBlockstack2.dataobject
                    const jsonBlockstack4 = jsonBlockstack3.replace(/\\/g,"");
                    if (jsonBlockstack4.substring(0,1) === '"') {
                       jsonBlockstack5 = jsonBlockstack4.substring(1,jsonBlockstack4.length - 1)
                    } else {
                       jsonBlockstack5 = jsonBlockstack4
                    }
                 }
                 let jsonBlockstack6 = JSON.parse(jsonBlockstack5)
                 const dataCompany2 = stateToHTML(convertFromRaw(JSON.parse(jsonBlockstack5)))
                 this.setState({dataCompany2, })
               }
               resolve()
             })
            .catch(error => {
               resolve()
             })
        })
      }

      associatedToMaintenance = () =>{
        const {userSession} = this.state
        const storage = new Storage({ userSession });
        const options = { decrypt: false, verify: false }
        this.setState({jsonAssociatedToMaintenance:[] })
        return new Promise ((resolve, reject) =>{
            getFileDB(this.state.username, `maintenance_associatedof.json`)
              .then((fileContents) => {
                 if(fileContents) {
                   const jsonBlockstack1 = JSON.parse(fileContents)
                   const jsonBlockstack2 = jsonBlockstack1.data
                   let jsonBlockstack5 = '[]'
                   if (jsonBlockstack2 !== null){
                      const jsonBlockstack3 = jsonBlockstack2.dataobject
                      const jsonBlockstack4 = jsonBlockstack3.replace(/\\/g,"");
                      if (jsonBlockstack4.substring(0,1) === '"') {
                         jsonBlockstack5 = jsonBlockstack4.substring(1,jsonBlockstack4.length - 1)
                      } else {
                         jsonBlockstack5 = jsonBlockstack4
                      }
                   }
                   let jsonBlockstack6 = JSON.parse(jsonBlockstack5)
                   this.setState({jsonAssociatedToMaintenance:jsonBlockstack6 })
                 }
                 resolve()
               })
              .catch(error => {
                  resolve()
               })
          })
      }

      displayListContractEditorStart(pathname) {
      }

      displayListContractEditorNew(pathname) {
        return (
          <div>
            <Table style={{"color": 'black'}} size="sm" borderless responsive className="text-center">
              <tbody>
                  <tr>
                    <td><h4><FormattedMessage id="contract.new" /></h4></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td><strong style={{cursor: 'pointer'}}  onClick={e=>this.searchContracts(e,8)}><img src="images/workorder.png" weight="150" height="150" alt=""/></strong></td>
                    <td><strong style={{cursor: 'pointer'}}  onClick={e=>this.searchContracts(e,2)}><img src="images/blankcontract.png" weight="150" height="150" alt=""/></strong></td>
                    <td><strong style={{cursor: 'pointer'}}  onClick={e=>this.searchContracts(e,2)}><img src="images/blankspreadsheet.png" weight="150" height="150" alt=""/></strong></td>
                    <td><strong style={{cursor: 'pointer'}}  onClick={e=>this.searchContracts(e,4)}><img src="images/proformainvoice.png" weight="150" height="150" alt=""/></strong></td>
                    <td><strong style={{cursor: 'pointer'}}  onClick={e=>this.searchContracts(e,5)}><img src="images/maintenance.png" weight="150" height="150" alt=""/></strong></td>
                    <td><strong style={{cursor: 'pointer'}}  onClick={e=>this.searchContracts(e,3)}><img src="images/billoflading.png" weight="150" height="150" alt=""/></strong></td>
                  </tr>
                  <tr>
                    <td><FormattedMessage id="contract.workorder" /></td>
                    <td><FormattedMessage id="contract.blankcontract" /></td>
                    <td><FormattedMessage id="contract.blankspreadsheet" /></td>
                    <td><FormattedMessage id="contract.proforma" /></td>
                    <td><FormattedMessage id="contract.industrailmaintenance" /></td>
                    <td><FormattedMessage id="contract.billoflading" /></td>
                  </tr>
                  <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td><h4><FormattedMessage id="contract.loadnew" /></h4></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td><strong style={{cursor: 'pointer'}}  onClick={e=>this.searchContracts(e,77)}><img src="images/uploadPdf.png" weight="150" height="150" alt=""/></strong></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td><FormattedMessage id="contract.uploadcontract" /></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                </tbody>
            </Table>
          </div>
        )
      }

      displayListContractEditorNew2(pathname) {
        const templatesAllLocalX = this.state.templatesAllLocal
        let templateNameDeliveryX = false
        let templateNameMaintenanceX = false
        let templateNameProformaX = false
        let templateNameWorkOrderX = false
        let templateNameBlankX = false
        let templateNameUploadedX = false
        let templateNameSpreadsheetX = false
        templatesAllLocalX.map((templateName,t) => {
          if (templateName.secondaryName === 'delivery' || templateName.secondaryName === 'simulate'){
              templateNameDeliveryX = templateName.isActive
          }else{
            if (templateName.secondaryName === 'maintenance'){
               templateNameMaintenanceX = templateName.isActive
            }else{
              if (templateName.secondaryName === 'proforma'){
                 templateNameProformaX = templateName.isActive
              }else{
                 if (templateName.secondaryName === 'blank'){
                    templateNameBlankX = templateName.isActive
                  }else{
                     if (templateName.secondaryName === 'uploaded'){
                        templateNameUploadedX = templateName.isActive
                     }else{
                       if (templateName.secondaryName === 'spreadsheet'){
                          templateNameSpreadsheetX = templateName.isActive
                       }else{
                         if (templateName.secondaryName === 'workorder'){
                            templateNameWorkOrderX = templateName.isActive
                         }
                       }
                     }
                  }
              }
            }
          }
        })

        return (
          <div>
            <Table style={{"color": 'black'}} size="sm" borderless responsive className="text-center" style={{ width: "100%" }} >
              <tbody>
                  <tr>
                    <td style={{width: "14%"}}>{templateNameWorkOrderX ? <><span className="page-subtitle" style={{color:'red'}}><FormattedMessage id="contract.newdoc" /></span></> : null}</td>
                    <td style={{width: "14%"}}>{templateNameBlankX ? <><span className="page-subtitle" style={{color:'red'}}><FormattedMessage id="contract.newdoc" /></span></> : null}</td>
                    <td style={{width: "14%"}}>{templateNameUploadedX ? <><span className="page-subtitle" style={{color:'red'}}><FormattedMessage id="contract.newdoc" /></span></> : null}</td>
                    <td style={{width: "14%"}}>{templateNameSpreadsheetX ? <><span className="page-subtitle" style={{color:'red'}}><FormattedMessage id="contract.newdoc" /></span></> : null}</td>
                    <td style={{width: "14%"}}>{templateNameProformaX ? <><span className="page-subtitle" style={{color:'red'}}><FormattedMessage id="contract.newdoc" /></span></> : null}</td>
                    <td style={{width: "14%"}}>{templateNameMaintenanceX ? <><span className="page-subtitle" style={{color:'red'}}><FormattedMessage id="contract.newdoc" /></span></> : null}</td>
                    <td style={{width: "14%"}}>{templateNameDeliveryX ? <><span className="page-subtitle" style={{color:'red'}}><FormattedMessage id="contract.newdoc" /></span></> : null}</td>
                  </tr>
                  <tr>
                    <td style={{width: "14%"}}>{templateNameWorkOrderX ? <><strong style={{cursor: 'pointer'}}  onClick={e=>this.searchContracts(e,8)}><img src="images/workorder.png" weight="100" height="100" alt=""/></strong></> : null}</td>
                    <td style={{width: "14%"}}>{templateNameBlankX ? <><strong style={{cursor: 'pointer'}}  onClick={e=>this.searchContracts(e,2)}><img src="images/blankcontract.png" weight="100" height="100" alt=""/></strong></> : null}</td>
                    <td style={{width: "14%"}}>{templateNameUploadedX ? <><strong style={{cursor: 'pointer'}}  onClick={e=>this.searchContracts(e,77)}><img src="images/uploadPdf.png" weight="100" height="100" alt=""/></strong></> : null}</td>
                    <td style={{width: "14%"}}>{templateNameSpreadsheetX ? <><strong style={{cursor: 'pointer'}}  onClick={e=>this.searchContracts(e,6)}><img src="images/blankspreadsheet.png" weight="100" height="100" alt=""/></strong></> : null}</td>
                    <td style={{width: "14%"}}>{templateNameProformaX ? <><strong style={{cursor: 'pointer'}}  onClick={e=>this.searchContracts(e,4)}><img src="images/proformainvoice.png" weight="100" height="100" alt=""/></strong></> : null}</td>
                    <td style={{width: "14%"}}>{templateNameMaintenanceX ? <><strong style={{cursor: 'pointer'}}  onClick={e=>this.searchContracts(e,5)}><img src="images/maintenance.png" weight="100" height="100" alt=""/></strong></> : null}</td>
                    <td style={{width: "14%"}}>{templateNameDeliveryX ? <><strong style={{cursor: 'pointer'}}  onClick={e=>this.searchContracts(e,3)}><img src="images/billoflading.png" weight="100" height="100" alt=""/></strong></> : null}</td>
                  </tr>
                  <tr>
                    <td style={{width: "14%"}}>{templateNameWorkOrderX ? <><FormattedMessage id="contract.workorder" /></> : null}</td>
                    <td style={{width: "14%"}}>{templateNameBlankX ? <><FormattedMessage id="contract.blankcontract" /></> : null}</td>
                    <td style={{width: "14%"}}>{templateNameUploadedX ? <><FormattedMessage id="contract.uploadcontract" /></> : null}</td>
                    <td style={{width: "14%"}}>{templateNameSpreadsheetX ? <><FormattedMessage id="contract.blankspreadsheet" /></> : null}</td>
                    <td style={{width: "14%"}}>{templateNameProformaX ? <><FormattedMessage id="contract.proforma" /></> : null}</td>
                    <td style={{width: "14%"}}>{templateNameMaintenanceX ? <><FormattedMessage id="contract.industrailmaintenance" /></> : null}</td>
                    <td style={{width: "14%"}}>{templateNameDeliveryX ? <><FormattedMessage id="contract.billoflading" /></> : null}</td>
                  </tr>
              </tbody>
            </Table>
          </div>
        )
      }

      displayListContractEditorOpen(pathname) {
      }

      onMouseEnterHandler = (i) =>{
        this.setState({setItemDocument: i})
      }

      onMouseLeaveHandler = (i) => {
      }

      displayListContract(pathname,modeDisplay) {
          let modeDisplayMailX = false
          let modeDisplayEditorX = false
          let displayNoEdit = false
          let modeDisplayTag = true
          if (modeDisplay === 'Mail'){
             modeDisplayMailX = true
          }else{
            if (modeDisplay === 'Editor'){
               modeDisplayEditorX = true
            }
          }
          let displayTitleEdit = this.state.displayTitleEdit
          let displayTitleDelete = this.state.displayTitleDelete
          let displayTitleArchive = this.state.displayTitleArchive
          let arrowX="images/arrowdown.png"
          let arrowX1="images/arrowdown.png"
          let arrowX2="images/arrowdown.png"
          let arrowX3="images/arrowdown.png"
          let arrowX4="images/arrowdown.png"
          let arrowX5="images/arrowdown.png"
          if (this.state.arrowsort===true){arrowX="images/arrowuporange.png"}else{arrowX="images/arrowdown.png"}
          if (this.state.arrowsort1===true){arrowX1="images/arrowuporange.png"}else{arrowX1="images/arrowdown.png"}
          if (this.state.arrowsort2===true){arrowX2="images/arrowuporange.png"}else{arrowX2="images/arrowdown.png"}
          if (this.state.arrowsort3===true){arrowX3="images/arrowuporange.png"}else{arrowX3="images/arrowdown.png"}
          if (this.state.arrowsort4===true){arrowX4="images/arrowuporange.png"}else{arrowX4="images/arrowdown.png"}
          if (this.state.arrowsort5===true){arrowX5="images/arrowuporange.png"}else{arrowX5="images/arrowdown.png"}
          if (this.props.templatesAll.length > 0) {
            //arrayTemplateDBX = this.props.templatesAll[0]
            //displayTemplateX = true
          }else{
            //arrayTemplateDBX = this.state.templatesAllLocal
            //displayTemplateX = true
          }
          if (this.state.existListContractX===true) {
              let item=0
              let statuscontract = ''
              let jsondisplayLink = this.state.jsonLinkZ50
              let jsondisplayAttach = this.state.jsonAttachZ50
              let jsondisplayUser = this.state.jsonUserZ50
              let jsondisplayGarbage = this.state.jsonGarbageZ50
              let jsondisplayBlockchain = this.state.jsonBlockchainZ50
              let jsondisplayListContract = this.state.jsonBlockstackZ50
              let jsondisplayListContractLength = jsondisplayListContract.length
              let jsonContractTag = this.state.jsonContractTag
              let jsonCircleGreen = this.state.jsonCircleGreen
              let tagList = this.state.tagList

              if (this.state.arrowsort===true){
                 item = 0
              }else{
                 item = jsondisplayListContractLength
              }
              if (this.state.fromSearchList === true) {
                 if (this.state.categorySearch === '5' ) {
                    let palabra = this.state.fromSearchListSearch.toLowerCase()
                    let subject = ''
                    let jsonBlockstack4 = []
                    jsondisplayListContract.map((todo, i) => {
                        if (jsondisplayBlockchain !== undefined) {
                           jsondisplayBlockchain.map((todoblockchain, z) => {
                              if (todoblockchain.typecontract === todo.typeContract && todoblockchain.contractnumber === todo.configurationContractNumber) {
                                 subject = todoblockchain.subject.toLowerCase()
                                 if (subject.indexOf(palabra) !== -1){
                                    jsonBlockstack4 = [...jsonBlockstack4, jsondisplayListContract[i]]
                                 }
                              }
                           })
                        }
                    })
                    jsondisplayListContract = jsonBlockstack4
                 }
                 if (this.state.categorySearch === '2' ) {
                   const palabra = this.state.fromSearchListSearch
                   const ArrayIdValue = palabra.split('_')
                   const jsonSearchTypeContractX = ArrayIdValue[0]
                   const jsonSearchNumberContractX = ArrayIdValue[1].substring(0,ArrayIdValue[1].length-5)
                   let jsonBlockstack4 = []
                   jsondisplayListContract.map((todo, i) => {
                     if (jsonSearchTypeContractX === todo.typeContract && jsonSearchNumberContractX === todo.configurationContractNumber){
                       jsonBlockstack4 = [...jsonBlockstack4, jsondisplayListContract[i]]
                     }
                   })
                   jsondisplayListContract = jsonBlockstack4
                 }
                 if (this.state.categorySearch === '2ReturnProps' ) {
                   const palabra = this.state.fromSearchListSearch
                   const ArrayIdValue = palabra.split('_')
                   const jsonSearchTypeContractX = ArrayIdValue[0]
                   const jsonSearchNumberContractX = ArrayIdValue[1].substring(0,ArrayIdValue[1].length-5)
                   let jsonBlockstack4 = []
                   jsondisplayListContract.map((todo, i) => {
                     if (jsonSearchTypeContractX === todo.typeContract && jsonSearchNumberContractX === todo.configurationContractNumber){
                       jsonBlockstack4 = [...jsonBlockstack4, jsondisplayListContract[i]]
                     }
                   })
                   jsondisplayListContract = jsonBlockstack4
                 }

              }

              if (jsonContractTag !== undefined) {
                if (this.state.tagListX !== ''){
                  let jsonBlockstack4 = []
                  jsondisplayListContract.map((todo, i) => {
                    jsondisplayBlockchain.map((todoblockchain, z) => {
                       if (todoblockchain.typecontract === todo.typeContract && todoblockchain.contractnumber === todo.configurationContractNumber) {
                          jsonContractTag.map((todotag, t) => {
                              if (todotag.typeContract === todo.typeContract && todotag.configurationContractNumber === todo.configurationContractNumber && todotag.origin === todoblockchain.origin) {
                                 if (this.state.tagListX === todotag.tag){
                                    jsonBlockstack4 = [...jsonBlockstack4, jsondisplayListContract[i]]
                                 }
                              }
                          })
                       }
                    })
                  })
                  jsondisplayListContract = jsonBlockstack4
                }
              }
              return (
                <div>
                  <Table size="sm" style={ this.props.colorDark ? { backgroundColor:'#0b151d'} : {}} className="text-center" responsive hover striped>
                    <thead>
                        <tr style={{fontSize:13}}>
                          <th style={{ width: "30px" }}><strong style={{cursor: 'pointer'}} onClick={e => this.handleChange(e,"arrowsort4")}><img src={arrowX4} weight="15" height="15" alt=""/></strong> </th>
                          <th></th>
                          <th ><FormattedMessage id="contract.listcol1" />/<FormattedMessage id="contract.listcol2" />&nbsp;<span style={{ width: "30px" }}><strong style={{cursor: 'pointer'}} onClick={e => this.handleChange(e,"arrowsort1")}><img src={arrowX1} weight="15" height="15" alt=""/></strong> </span></th>
                          <th ><FormattedMessage id="configuration.tag1" /></th>
                          <th ><FormattedMessage id="contract.listcol3" /></th>
                          <th ><FormattedMessage id="contract.listcol4" />&nbsp;<span style={{ width: "30px" }}><strong style={{cursor: 'pointer'}} onClick={e => this.handleChange(e,"arrowsort2")}><img src={arrowX2} weight="15" height="15" alt=""/></strong> </span></th>
                          <th ><FormattedMessage id="contract.listcol5" />&nbsp;<span style={{ width: "30px" }}><strong style={{cursor: 'pointer'}} onClick={e => this.handleChange(e,"arrowsort3")}><img src={arrowX3} weight="15" height="15" alt=""/></strong> </span></th>
                          <th ><FormattedMessage id="contract.listcol6" />&nbsp;<span style={{ width: "30px" }}><strong style={{cursor: 'pointer'}} onClick={e => this.handleChange(e,"arrowsort5")}><img src={arrowX5} weight="15" height="15" alt=""/></strong> </span></th>
                          <th ><FormattedMessage id="contract.listcol7" /></th>
                          <th ><FormattedMessage id="contract.listcol8" /></th>
                          <th ><FormattedMessage id="configuration.edit" /></th>
                          <th ><FormattedMessage id="configuration.delete" /></th>
                          <th ><FormattedMessage id="configuration.store" /></th>
                        </tr>
                    </thead>

                    <tbody>
                       {jsondisplayListContract.map((todo, i) => {
                          if ((todo.typeContract === 'simulate' && this.state.viewSimulate === 'Yes' && this.state.userRemoteX === '') || todo.typeContract !== 'simulate'){
                            if (this.state.arrowsort===true){
                               item++
                            }else{
                               item = jsondisplayListContractLength - i
                            }
                            if (i >= (this.state.scrollInitial - 1) && i <= (this.state.scrollEnd - 1)) {
                              if (todo.active==="true"){
                                 statuscontract = 'Active'
                                 if (todo.active_after_published === "true" || todo.active_after_published === undefined){
                                   statuscontract = 'Active'
                                 }else{
                                   statuscontract = 'Inactive'
                                 }
                              }else{
                                 statuscontract = 'Inactive'
                              }
                              let displayUserX = ""
                              let displaySignatureX = ""
                              let displayRegisterX = ""
                              let displayLinkX = ""
                              let displayEyeX = ""
                              let displayBlockchainX = ""
                              let displayAssociatedX = ""
                              let displayRulesX = ""
                              let displayStoreX = ""
                              let displayCircleGreenX = ""
                              let displaySignatureAndPaymentX = ''
                              if (todo.signatureAndPayment===undefined){displaySignatureAndPaymentX='SignatureAndPayment'}else{displaySignatureAndPaymentX=todo.signatureAndPayment}
                              if (todo.typeContract === 'proforma' || todo.typeContract === 'blank' || todo.typeContract === 'uploaded' || todo.typeContract === 'spreadsheet'){
                                  displayAssociatedX = "images/associated2Grey25p.png"
                                  displayRulesX = "images/rulesGrey25p.png"
                              }else{
                                  displayAssociatedX = "images/associated2Grey.png"
                                  displayRulesX = "images/rulesGrey.png"
                              }
                              let displayDocumentX = "images/documentGreen.png"
                              let displayShareX = "images/shareGrey.png"
                              let displayActiveParticipantsX = "images/activateparticipantsGrey.png"
                              let displayCryptoCurrencyX = ""
                              let displayReportX = ""
                              let displayDeliverableX = "images/deliverableGrey.png"
                              let displayFormsDeliverableX = "images/formsGrey.png"
                              let displayAuthorizersDeliverableX = "images/userGrey.png"
                              let displayRolDeliverableX = "images/rolGrey.png"
                              let displayTagDeliverableX = "images/etiqueta2Grey.png"
                              let displayReporteTurnoDeliverableX = "images/reporteTurnoGreen.png"
                              let displayChatX = ""
                              let displayTagX = ""
                              let displayLifeCycleX = ""
                              let displayOriginX = ""
                              let displayRoleX = ""
                              let displayDeleteX = ""
                              let displayEditX2 = ""
                              let displayEditX3 = "images/edit25p.png"
                              let displayDeleteX2 = ""
                              let displaySubjectX = ""
                              let displaySendReceiveX = ""
                              let displayActiveUserGroupX = false
                              let displayConfirmSignX = false
                              let displayConfirmRegisterX = false
                              let displayActiveDeliverableX = false
                              let displayActiveDataDashboardX = false

                              if (jsondisplayUser !== undefined) {
                                {jsondisplayUser.map((todouser, x) => {
                                  if ((todouser.typecontract === todo.typeContract && todouser.contractnumber === todo.configurationContractNumber && todouser.typecontract !== 'simulate' && (todo.role === todouser.role || todo.role === undefined || todo.role === null || todo.role === '')) ||
                                      (todouser.typecontract === todo.typeContract && todouser.contractnumber === todo.configurationContractNumber && todouser.typecontract === 'simulate')){
                                     if (todouser.nome===this.state.username){
                                        displayUserX = ''
                                        if (todouser.role==="Creator"){
                                            displayRoleX = todouser.role
                                            todo.role = todouser.role
                                            displayUserX = todouser.user
                                            if (displayUserX==="images/userRed.png"){
                                              displaySendReceiveX = "images/receivenotarrow.svg"
                                              displayChatX = "images/chatRed.png"
                                            }else{
                                               displaySendReceiveX = "images/receivenotarrow.svg"
                                               if (displayUserX==="images/userGreen.png" || displayUserX==="images/user1Green.png" || displayUserX==="images/user2Green.png"){
                                                 if (displayUserX==="images/userGreen.png" || displayUserX==="images/user2Green.png"){
                                                    displaySendReceiveX = "images/send.svg"
                                                 }
                                                 displayChatX = "images/chatGreen.png"
                                               }
                                            }
                                            if (todouser.linkSupport){
                                              displayLinkX = "images/linkGrey25pSupport.png"
                                              displayEyeX = "images/eyeGrey.png"
                                            }else{
                                              if (todo.typeContract === 'proforma' || todo.typeContract === 'blank' || todo.typeContract === 'uploaded' || todo.typeContract === 'spreadsheet'){
                                                displayLinkX = "images/linkGrey25p.png"
                                                displayEyeX = "images/eyeGrey25p.png"
                                              }else{
                                                displayLinkX = "images/linkGrey.png"
                                                displayEyeX = "images/eyeGrey.png"
                                              }
                                            }
                                            displayReportX = "images/attachGreen.png"
                                            displayDeliverableX = "images/deliverableGreen.png"
                                            displayFormsDeliverableX = "images/formsGrey.png"
                                            displayAuthorizersDeliverableX = "images/userGrey.png"
                                            displayRolDeliverableX = "images/rolGrey.png"
                                            displayTagDeliverableX = "images/etiqueta2Grey.png"
                                            displayReporteTurnoDeliverableX = "images/reporteTurnoGreen.png"
                                        }else{
                                          if (todouser.role==="Authorizer"){
                                                displayRoleX = todouser.role
                                                todo.role = todouser.role
                                                displayUserX = todouser.user
                                                displaySendReceiveX = "images/receive.svg"
                                                displayChatX = "images/chatGreen.png"
                                                displayLinkX = ""
                                                displayEyeX = "images/eyeGrey.png"
                                                displayReportX = ""
                                                displayDeliverableX = "images/deliverableGrey.png"
                                                displayFormsDeliverableX = "images/formsGrey.png"
                                                displayAuthorizersDeliverableX = "images/userGrey.png"
                                                displayRolDeliverableX = "images/rolGrey.png"
                                                displayTagDeliverableX = "images/etiqueta2Grey.png"
                                                displayReporteTurnoDeliverableX = "images/reporteTurnoGreen.png"
                                                displayShareX = "images/shareGrey25p.png"
                                          }else{
                                            if (todouser.role==="Authorizer-Inviter"){
                                                  displayRoleX = todouser.role
                                                  todo.role = todouser.role
                                                  displayUserX = todouser.user
                                                  displaySendReceiveX = "images/receive.svg"
                                                  displayChatX = "images/chatGreen.png"
                                                  displayLinkX = ""
                                                  displayEyeX = "images/eyeGrey.png"
                                                  displayReportX = ""
                                                  displayDeliverableX = "images/deliverableGrey.png"
                                                  displayFormsDeliverableX = "images/formsGrey.png"
                                                  displayAuthorizersDeliverableX = "images/userGrey.png"
                                                  displayRolDeliverableX = "images/rolGrey.png"
                                                  displayTagDeliverableX = "images/etiqueta2Grey.png"
                                                  displayReporteTurnoDeliverableX = "images/reporteTurnoGreen.png"
                                                  displayShareX = "images/shareGrey25p.png"
                                            }else{
                                              if (todouser.role==="Observer" || todouser.role === 'Payer' || todouser.role === 'PayTo'){
                                                    displayRoleX = todouser.role
                                                    todo.role = todouser.role
                                                    displayUserX = todouser.user
                                                    displaySendReceiveX = "images/receive.svg"
                                                    displayChatX = "images/chatGreen.png"
                                                    displayLinkX = ""
                                                    displayEyeX = "images/eyeGrey.png"
                                                    displayReportX = ""
                                                    displayDeliverableX = "images/deliverableGrey.png"
                                                    displayFormsDeliverableX = "images/formsGrey.png"
                                                    displayAuthorizersDeliverableX = "images/userGrey.png"
                                                    displayRolDeliverableX = "images/rolGrey.png"
                                                    displayTagDeliverableX = "images/etiqueta2Grey.png"
                                                    displayReporteTurnoDeliverableX = "images/reporteTurnoGreen.png"
                                                    displayShareX = "images/shareGrey25p.png"
                                              }else{
                                                if (todouser.role==="Support"){
                                                      displayRoleX = todouser.role
                                                      todo.role = todouser.role
                                                      displayUserX = ''
                                                      displaySendReceiveX = "images/receive.svg"
                                                      displayChatX = "images/chatGreen.png"
                                                      displayLinkX = "images/linkGrey.png"
                                                      displayEyeX = ""
                                                      displayReportX = ""
                                                      displayDeliverableX = "images/deliverableGrey25p.png"
                                                      displayFormsDeliverableX = "images/formsGrey.png"
                                                      displayAuthorizersDeliverableX = "images/userGrey.png"
                                                      displayRolDeliverableX = "images/rolGrey.png"
                                                      displayTagDeliverableX = "images/etiqueta2Grey.png"
                                                      displayReporteTurnoDeliverableX = "images/reporteTurnoGreen.png"
                                                      displayAssociatedX = "images/associated2Grey25p.png"
                                                      displayRulesX = "images/rulesGrey25p.png"
                                                      displayDocumentX = "images/documentGrey25p.png"
                                                      displayShareX = "images/shareGrey25p.png"
                                                }else{
                                                      displayRoleX = todouser.role
                                                      todo.role = todouser.role
                                                      displayUserX = todouser.user
                                                      displaySendReceiveX = "images/receive.svg"
                                                      displayChatX = "images/chatGreen.png"
                                                      displayLinkX = ""
                                                      displayEyeX = "images/eyeGrey.png"
                                                      displayReportX = ""
                                                      displayDeliverableX = "images/deliverableGrey.png"
                                                      displayFormsDeliverableX = "images/formsGrey.png"
                                                      displayAuthorizersDeliverableX = "images/userGrey.png"
                                                      displayRolDeliverableX = "images/rolGrey.png"
                                                      displayTagDeliverableX = "images/etiqueta2Grey.png"
                                                      displayReporteTurnoDeliverableX = "images/reporteTurnoGreen.png"
                                                      displayShareX = "images/shareGrey25p.png"
                                                }
                                              }
                                            }
                                          }
                                        }
                                     }
                                  }
                                })}
                              }

                              if (jsondisplayLink !== undefined) {
                                  {jsondisplayLink.map((todolink, y) => {
                                    if (todolink.typecontract === todo.typeContract && todolink.contractnumber === todo.configurationContractNumber) {
                                        if (displayRoleX === 'Support' || displayRoleX === 'Observer' ) {
                                            displayLifeCycleX = todolink.lifeCycle
                                        }
                                        todo.algunosDevice = todolink.algunosDevice
                                        todo.ningunoDevice = todolink.ningunoDevice
                                        todo.todosDevice = todolink.todosDevice
                                    }
                                  })}
                              }

                              if (jsondisplayAttach !== undefined) {
                                {jsondisplayAttach.map((todoattach, y) => {
                                  if (todoattach.typecontract === todo.typeContract && todoattach.contractnumber === todo.configurationContractNumber) {
                                      if (displayRoleX === 'Creator' || displayRoleX === 'Authorizer' || displayRoleX === 'Authorizer-Inviter' || displayRoleX === 'Observer' ||
                                          displayRoleX === 'Payer' || displayRoleX === 'PayTo') {
                                          displayReportX = todoattach.attach
                                      }else{
                                          displayReportX = "images/attachGrey25p.png"
                                      }
                                  }
                                })}
                              }

                              if (jsondisplayBlockchain !== undefined) {
                                {jsondisplayBlockchain.map((todoblockchain, z) => {
                                 if (todoblockchain.typecontract === todo.typeContract && todoblockchain.contractnumber === todo.configurationContractNumber) {
                                    if (displayRoleX === 'Creator') {
                                        displayBlockchainX = todoblockchain.blockchain
                                        displayLifeCycleX = todoblockchain.lifeCycle
                                        displayOriginX = todoblockchain.origin
                                        todo.origin = todoblockchain.origin
                                        displayDeleteX = todoblockchain.delete
                                        if (todoblockchain.subject==="undefined"){
                                           displaySubjectX = ""
                                        }else{
                                           displaySubjectX = todoblockchain.subject
                                        }
                                        if (displayBlockchainX==="images/blockchainRed.png"){
                                           displayCryptoCurrencyX = "images/cryptocurrencyRed.png"
                                        }else{
                                           if (displayBlockchainX==="images/blockchainGreen.png"){
                                              displayCryptoCurrencyX = "images/cryptocurrencyGreen.png"
                                           }
                                        }
                                        if (displayDeleteX==='Yes') {
                                            displayDeleteX2 = "images/deleteRed.png"
                                        }else{
                                            if (this.props.colorDark) {displayDeleteX2 = "images/delete.png"}else{displayDeleteX2 = "images/delete25p.png"}
                                        }
                                    }else{
                                       if (displayRoleX === 'Authorizer') {
                                          displayLifeCycleX = todoblockchain.lifeCycle
                                          displayOriginX = todoblockchain.origin
                                          todo.origin = todoblockchain.origin
                                          displayDeleteX = ''
                                          if (this.props.colorDark) {displayDeleteX2 = "images/delete.png"}else{displayDeleteX2 = "images/delete25p.png"}
                                          if (todoblockchain.subject==="undefined"){
                                             displaySubjectX = ""
                                          }else{
                                             displaySubjectX = todoblockchain.subject
                                          }
                                          displayCryptoCurrencyX = "images/cryptocurrencyGrey25p.png"
                                          //displayUserX = "images/userGreen.png"
                                          displayLinkX = "images/linkGrey25p.png"
                                          displayBlockchainX = "images/blockchainGrey25p.png"
                                       }else{
                                         if (displayRoleX === 'Authorizer-Inviter') {
                                            displayLifeCycleX = todoblockchain.lifeCycle
                                            displayOriginX = todoblockchain.origin
                                            todo.origin = todoblockchain.origin
                                            displayDeleteX = ''
                                            if (this.props.colorDark) {displayDeleteX2 = "images/delete.png"}else{displayDeleteX2 = "images/delete25p.png"}
                                            if (todoblockchain.subject==="undefined"){
                                               displaySubjectX = ""
                                            }else{
                                               displaySubjectX = todoblockchain.subject
                                            }
                                            displayCryptoCurrencyX = "images/cryptocurrencyGrey25p.png"
                                            //displayUserX = "images/userGreen.png"
                                            displayLinkX = "images/linkGrey25p.png"
                                            displayBlockchainX = "images/blockchainGrey25p.png"
                                         }else{
                                           if (displayRoleX === 'Observer') {
                                               //if (todoblockchain.lifeCycle==="Published"){
                                                   displayLifeCycleX = todoblockchain.lifeCycle
                                               //}
                                               displayOriginX = todoblockchain.origin
                                               todo.origin = todoblockchain.origin
                                               displayDeleteX = ''
                                               if (this.props.colorDark) {displayDeleteX2 = "images/delete.png"}else{displayDeleteX2 = "images/delete25p.png"}
                                               if (todoblockchain.subject==="undefined"){
                                                  displaySubjectX = ""
                                               }else{
                                                  displaySubjectX = todoblockchain.subject
                                               }
                                               displayCryptoCurrencyX = "images/cryptocurrencyGrey25p.png"
                                               //displayUserX = "images/userGreen.png"
                                               displaySignatureX = "images/signGrey25p.png"
                                               displayRegisterX = "images/register.png"
                                               displayLinkX = "images/linkGrey25p.png"
                                               displayBlockchainX = "images/blockchainGrey25p.png"
                                           }else{
                                               if (displayRoleX === 'Support' || displayRoleX === 'Payer' || displayRoleX === 'PayTo') {
                                                   //if (todoblockchain.lifeCycle==="Published"){
                                                       displayLifeCycleX = todoblockchain.lifeCycle
                                                   //}
                                                   displayOriginX = todoblockchain.origin
                                                   todo.origin = todoblockchain.origin
                                                   displayDeleteX = ''
                                                   if (this.props.colorDark) {displayDeleteX2 = "images/delete.png"}else{displayDeleteX2 = "images/delete25p.png"}
                                                   if (todoblockchain.subject==="undefined"){
                                                      displaySubjectX = ""
                                                   }else{
                                                      displaySubjectX = todoblockchain.subject
                                                   }
                                                   displayCryptoCurrencyX = "images/cryptocurrencyGrey25p.png"
                                                   displayUserX = "images/userGrey25p.png"
                                                   displaySignatureX = "images/signGrey25p.png"
                                                   displayRegisterX = "images/register.png"
                                                   displayLinkX = "images/linkGrey.png"
                                                   displayBlockchainX = "images/blockchainGrey25p.png"
                                                   displayReportX = "images/attachGrey25p.png"
                                                   displayDeliverableX = "images/deliverableGrey25p.png"
                                                   displayFormsDeliverableX = "images/formsGrey.png"
                                                   displayAuthorizersDeliverableX = "images/userGrey.png"
                                                   displayRolDeliverableX = "images/rolGrey.png"
                                                   displayTagDeliverableX = "images/etiqueta2Grey.png"
                                                   displayReporteTurnoDeliverableX = "images/reporteTurnoGreen.png"
                                                   displayEyeX = "images/eyeGrey25p.png"
                                                }else{
                                                    //if (todoblockchain.lifeCycle==="Published"){
                                                        displayLifeCycleX = todoblockchain.lifeCycle
                                                    //}
                                                    displayOriginX = todoblockchain.origin
                                                    todo.origin = todoblockchain.origin
                                                    displayDeleteX = ''
                                                    if (this.props.colorDark) {displayDeleteX2 = "images/delete.png"}else{displayDeleteX2 = "images/delete25p.png"}
                                                    if (todoblockchain.subject==="undefined"){
                                                       displaySubjectX = ""
                                                    }else{
                                                       displaySubjectX = todoblockchain.subject
                                                    }
                                                    displayCryptoCurrencyX = "images/cryptocurrencyGrey25p.png"
                                                    displayUserX = "images/userGrey25p.png"
                                                    displaySignatureX = "images/signGrey25p.png"
                                                    displayRegisterX = "images/register.png"
                                                    displayLinkX = "images/linkGrey.png"
                                                    displayBlockchainX = "images/blockchainGrey25p.png"
                                                    displayReportX = "images/attachGrey25p.png"
                                                    displayDeliverableX = "images/deliverableGrey25p.png"
                                                    displayFormsDeliverableX = "images/formsGrey.png"
                                                    displayAuthorizersDeliverableX = "images/userGrey.png"
                                                    displayRolDeliverableX = "images/rolGrey.png"
                                                    displayTagDeliverableX = "images/etiqueta2Grey.png"
                                                    displayReporteTurnoDeliverableX = "images/reporteTurnoGreen.png"
                                                    displayEyeX = "images/eyeGrey25p.png"
                                                }
                                           }
                                         }
                                       }
                                     }
                                   }
                                })}
                              }
                              if (jsondisplayGarbage !== undefined) {
                                {jsondisplayGarbage.map((todogarbage, u) => {
                                  if (todogarbage.typecontract === todo.typeContract && todogarbage.contractnumber === todo.configurationContractNumber) {
                                     if (todogarbage.role==="Creator"){
                                         if (todogarbage.deleteContract) {
                                            displayDeleteX2 = "images/deleteRed.png"
                                         }else{
                                           if (this.props.colorDark) {displayDeleteX2 = "images/delete.png"}else{displayDeleteX2 = "images/delete25p.png"}
                                         }
                                         displaySignatureX = todogarbage.sign
                                         displayRegisterX = todogarbage.register
                                         if (todogarbage.statusBlockchain==="Cloud" && displayLifeCycleX !== 'Published'){
                                           if (todogarbage.todosSign){
                                              displayLifeCycleX = "Signed"
                                           }
                                           if (todogarbage.algunosSign){
                                              displayLifeCycleX = "Signing"
                                           }
                                         }
                                     }else{
                                        if (todogarbage.role==="Authorizer"){
                                          if (this.props.colorDark) {displayDeleteX2 = "images/delete.png"}else{displayDeleteX2 = "images/delete25p.png"}
                                           displaySignatureX = todogarbage.sign
                                           displayRegisterX = todogarbage.register
                                           if (todogarbage.statusBlockchain==="Cloud" && displayLifeCycleX !== 'Published'){
                                             if (todogarbage.todosSign){
                                                displayLifeCycleX = "Signed"
                                             }else{
                                               if (todogarbage.algunosSign){
                                                  displayLifeCycleX = "Signing"
                                               }else{
                                                  displayLifeCycleX = "Unsigned"
                                               }
                                             }
                                           }
                                        }else{
                                          if (todogarbage.role==="Authorizer-Inviter"){
                                            if (this.props.colorDark) {displayDeleteX2 = "images/delete.png"}else{displayDeleteX2 = "images/delete25p.png"}
                                             displaySignatureX = todogarbage.sign
                                             displayRegisterX = todogarbage.register
                                             if (todogarbage.statusBlockchain==="Cloud" && displayLifeCycleX !== 'Published'){
                                               if (todogarbage.todosSign){
                                                  displayLifeCycleX = "Signed"
                                               }else{
                                                 if (todogarbage.algunosSign){
                                                    displayLifeCycleX = "Signing"
                                                 }else{
                                                    displayLifeCycleX = "Unsigned"
                                                 }
                                               }
                                             }
                                          }else{
                                            if (todogarbage.role==="Observer"){
                                              if (this.props.colorDark) {displayDeleteX2 = "images/delete.png"}else{displayDeleteX2 = "images/delete25p.png"}
                                            }else{
                                              if (todogarbage.role==="Support" || todogarbage.role === 'Payer' || todogarbage.role === 'PayTo'){
                                                if (this.props.colorDark) {displayDeleteX2 = "images/delete.png"}else{displayDeleteX2 = "images/delete25p.png"}
                                              }else{
                                                if (this.props.colorDark) {displayDeleteX2 = "images/delete.png"}else{displayDeleteX2 = "images/delete25p.png"}
                                              }
                                            }
                                          }
                                        }
                                     }
                                     todo.algunosSign = todogarbage.algunosSign
                                     todo.ningunoSign = todogarbage.ningunoSign
                                     todo.todosSign = todogarbage.todosSign
                                  }
                                })}
                              }

                              todo.tag = ''
                              todo.colortag = ''
                              todo.colorlettertag = ''
                              let displayStringTagX = ''
                              let displayColourTagX = ''
                              let displayColourLetterTagX = ''
                              modeDisplayTag = true
                              if (jsonContractTag !== undefined) {
                                if (this.state.tagListX !== ''){
                                  modeDisplayTag = false
                                  jsonContractTag.map((todotag, t) => {
                                    if (todotag.typeContract === todo.typeContract && todotag.configurationContractNumber === todo.configurationContractNumber && todotag.origin === todo.origin) {
                                       if (this.state.tagListX === todotag.tag){
                                          modeDisplayTag = true
                                          todo.tag = todotag.tag
                                          displayStringTagX = todotag.tag
                                          tagList.map((todotaglist, s) => {
                                              if (todotaglist.code === todotag.tag){
                                                todo.colortag = todotaglist.hex
                                                todo.colorlettertag = todotaglist.colorletter
                                                displayColourTagX = todotag.hex
                                                displayColourLetterTagX = todotag.colorLetter
                                              }
                                          })
                                      }
                                    }
                                  })
                                }else{
                                  modeDisplayTag = true
                                  jsonContractTag.map((todotag, t) => {
                                    if (todotag.typeContract === todo.typeContract && todotag.configurationContractNumber === todo.configurationContractNumber && todotag.origin === todo.origin) {
                                      todo.tag = todotag.tag
                                      displayStringTagX = todotag.tag
                                      tagList.map((todotaglist, s) => {
                                          if (todotaglist.code === todotag.tag){
                                            todo.colortag = todotaglist.hex
                                            todo.colorlettertag = todotaglist.colorletter
                                            displayColourTagX = todotag.hex
                                            displayColourLetterTagX = todotag.colorLetter
                                          }
                                      })
                                    }
                                  })
                                }
                              }

                              let displaySupport = false
                              if (displayRoleX === "Support"){
                                 displaySupport = true
                              }

                              if (displayRoleX==='' || displayRoleX===undefined  || displayRoleX.role===null) {
                                  if (this.props.colorDark) {displayDeleteX2 = "images/delete.png"}else{displayDeleteX2 = "images/delete25p.png"}
                                  displayEditX3 = "images/edit25p.png"
                                  displayLifeCycleX = 'Synchronizing'
                                  displayOriginX=todo.origin
                                  displaySubjectX=todo.subject
                                  if (displayOriginX === '' || displayOriginX === undefined || displayOriginX === null){displayDeleteX2 = "images/deleteRed.png"}
                                  if (displayOriginX === this.state.username){displayRoleX = 'Creator'}
                                  //if (displayOriginX === this.state.username){displayRoleX = 'Creator';displayDeleteX2 = "images/deleteRed.png"}
                                  if (displayOriginX.includes('...')){displayRoleX = 'Creator';displayDeleteX2 = "images/deleteRed.png"}
                                  if (todo.typeContract === 'simulate'){displayDeleteX2 = "images/deleteRed.png"}
                              }else{
                                displayEditX2 = "images/editGreen.png"
                              }

                              if (statuscontract === 'Inactive'){
                                if (displayLifeCycleX !== 'Published'){
                                   displayLifeCycleX = 'Paused'
                                }else{
                                   if (this.props.colorDark) {displayDeleteX2 = "images/delete.png"}else{displayDeleteX2 = "images/delete25p.png"}
                                   displayEditX2 = "images/editGreen.png"
                                }
                              }

                              displayDeliverableX = "images/deliverableGrey.png"
                              displayFormsDeliverableX = "images/formsGrey.png"
                              displayAuthorizersDeliverableX = "images/userGrey.png"
                              displayRolDeliverableX = "images/rolGrey.png"
                              displayTagDeliverableX = "images/etiqueta2Grey.png"
                              displayReporteTurnoDeliverableX = "images/reporteTurnoGreen.png"
                              displayTagX = "images/tagGrey.png"

                              let displayDeleteListContract = false
                              if (this.state.deleteListContract){
                                if (i === this.state.iContractTable && todo.typeContract === this.state.typeContractSign && todo.configurationContractNumber === this.state.configurationContractNumberSign){
                                   displayDeleteListContract = true
                                }
                              }
                              let displayEditListContract = false
                              if (this.state.editListContract){
                                if (i === this.state.iContractTable){
                                  displayEditListContract = true
                                }
                              }

                              if (todo.typeContract === 'simulate' || displayRoleX !== 'Creator'){
                                 if (this.props.colorDark) {displayStoreX = "images/store.png"}else{displayStoreX = "images/storeGrey25p.png"}
                              }else{
                                 displayStoreX = "images/storeGrey.png"
                              }

                              displayCircleGreenX = ""
                              let existCircle = false
                              if (displayRoleX !== 'Creator' && displayRoleX !== undefined && displayRoleX !== null) {
                                if (jsonCircleGreen !== undefined) {
                                  {jsonCircleGreen.map((todocircle, y) => {
                                    if (todocircle.typecontract === todo.typeContract && todocircle.contractnumber === todo.configurationContractNumber && todo.origin === todocircle.origin) {
                                        existCircle = true
                                    }
                                  })}
                                }
                                if (existCircle === false) {
                                   displayCircleGreenX = "images/circleGreen.png"
                                }
                              }

                              if (todo.typeContract === 'simulate'){
                                displayActiveUserGroupX = true
                                displayConfirmSignX = true
                                displayConfirmRegisterX = true
                                displayActiveDeliverableX = true
                                displayActiveDataDashboardX = true
                              }else{
                                if (todo.activeUserGroup === undefined){displayActiveUserGroupX=false}else{displayActiveUserGroupX=todo.activeUserGroup}
                                if (todo.confirmSign === undefined){displayConfirmSignX=false}else{displayConfirmSignX=todo.confirmSign}
                                if (todo.confirmSign === undefined){displayConfirmRegisterX=false}else{displayConfirmRegisterX=todo.confirmSign}
                                if (todo.activeDeliverable  === undefined){displayActiveDeliverableX=false}else{displayActiveDeliverableX=todo.activeDeliverable }
                                if (todo.activeDataDashboard === undefined){displayActiveDataDashboardX=false}else{displayActiveDataDashboardX=todo.activeDataDashboard}
                              }

                              let encryptDecryptFileX = todo.encryptDecryptFile
                              if (todo.encryptDecryptFile === undefined || todo.encryptDecryptFile === null){
                                 encryptDecryptFileX = false
                              }

                              let setOpcionDocument= false
                              if (this.state.setItemDocument === i) {
                                setOpcionDocument = true
                              }

                              if (statuscontract === 'Inactive'){
                                displayCircleGreenX = "images/circleRed.png"
                              }

                              if ( modeDisplayTag === true){
                                 let blankX = false
                                 let deliveryX = false
                                 let proformaX = false
                                 let maintenanceX = false
                                 let simulateX = false
                                 let uploadedX = false
                                 let spreadsheetX = false
                                 let workorderX = false
                                 let nameContractEditor =  ''
                                 if (todo.typeContract === 'blank'){ blankX = true; nameContractEditor = 'Blank Contract' }
                                 if (todo.typeContract === 'delivery'){ deliveryX = true; nameContractEditor = 'Logistic, Transport & Delivery Contract' }
                                 if (todo.typeContract === 'proforma'){ proformaX = true; nameContractEditor = 'Proforma ' }
                                 if (todo.typeContract === 'maintenance'){ maintenanceX = true; nameContractEditor = 'Industrial Maintenance Contract' }
                                 if (todo.typeContract === 'simulate'){ simulateX = true; nameContractEditor = 'Simulate Contract' }
                                 if (todo.typeContract === 'uploaded'){ uploadedX = true; nameContractEditor = 'Uploaded Contract' }
                                 if (todo.typeContract === 'spreadsheet'){ spreadsheetX = true; nameContractEditor = 'Spreadsheet' }
                                 if (todo.typeContract === 'workorder'){ workorderX = true; nameContractEditor = 'Work Order' }
                                 let entraX = false
                                 if (this.state.activeInactiveAllX === 'Active') {
                                    if (statuscontract === 'Active') {
                                      entraX = true
                                    }
                                 }
                                 if (this.state.activeInactiveAllX === 'Inactive') {
                                    if (statuscontract === 'Inactive') {
                                      entraX = true
                                    }
                                 }
                                 if (this.state.activeInactiveAllX === 'All') {
                                    entraX = true
                                 }
                                 if (entraX) {
                                   return (
                                     <tr key={i}
                                         onMouseEnter={()=>this.onMouseEnterHandler(i)}
                                         onMouseLeave={()=>this.onMouseLeaveHandler(i)}
                                         style={this.props.colorDark ? {color: 'white'} : {color: 'black'}}
                                       >
                                       {blankX ?
                                          <td><img src="images/blankcontract.png" weight="40" height="40" alt=""/></td>
                                       : null }
                                       {deliveryX ?
                                          <td><img src="images/billoflading.png" weight="40" height="40" alt=""/></td>
                                       : null }
                                       {proformaX ?
                                          <td><img src="images/proformainvoice.png" weight="40" height="40" alt=""/></td>
                                       : null }
                                       {maintenanceX ?
                                          <td><img src="images/maintenance.png" weight="40" height="40" alt=""/></td>
                                       : null }
                                       {simulateX ?
                                          <td><img src="images/simulate.png" weight="40" height="40" alt=""/></td>
                                       : null }
                                       {uploadedX ?
                                          <td><img src="images/uploadPdf.png" weight="40" height="40" alt=""/></td>
                                       : null }
                                       {spreadsheetX ?
                                          <td><img src="images/blankspreadsheet.png" weight="40" height="40" alt=""/></td>
                                       : null }
                                       {workorderX ?
                                          <td><img src="images/workorder.png" weight="40" height="40" alt=""/></td>
                                       : null }
                                       <td><img src={displayCircleGreenX} weight="10" height="10" alt=""/></td>
                                       <td>{todo.typeContract}
                                           <br></br>
                                           {displaySupport ?
                                             <strong style={ this.props.colorDark ? {cursor: 'pointer', color: 'grey'} : {cursor: 'pointer', color: 'grey'}}>{todo.configurationContractNumber}</strong>
                                           :
                                             <strong style={ this.props.colorDark ? {cursor: 'pointer', color: 'orange'} : {cursor: 'pointer', color: 'blue'}} onClick={()=>{
                                                       let e = ''
                                                       if (this.state.DisplayCompanyLogoData === 'Yes' &&
                                                       (todo.typeContract === 'proforma' || todo.typeContract === 'simulate' || todo.typeContract === 'delivery' || todo.typeContract === 'maintenance'  || todo.typeContract === 'workorder')){
                                                           Promise.all(
                                                              [this.getDisplayCompanyLogo(displayOriginX,todo.typeContract),
                                                               this.getDisplayCompanyData(displayOriginX,todo.typeContract)
                                                              ]
                                                           ).then(
                                                             (resolve) =>{
                                                               this.editListContractDialog(e, i, displayOriginX, displayRoleX, todo.typeContract, todo.configurationContractNumber, todo.ningunoSign, todo.algunosSign, todo.todosSign, todo.ningunoDevice, todo.algunosDevice, todo.todosDevice, todo.role, todo.origin, todo.active, nameContractEditor, displayReportX, displayUserX, displaySignatureX, displayLinkX, displayEyeX, displayChatX, displayTagX, displaySubjectX, displayCryptoCurrencyX, displayBlockchainX, displayAssociatedX, displayRulesX, displayDocumentX, displayShareX, displayActiveParticipantsX, displayDeliverableX, displayFormsDeliverableX, displayAuthorizersDeliverableX, displayRolDeliverableX, displayTagDeliverableX, displayReporteTurnoDeliverableX, displayStringTagX, displayColourTagX, displayCircleGreenX, displayActiveUserGroupX, displayConfirmSignX, displayActiveDeliverableX, displayActiveDataDashboardX, encryptDecryptFileX, displayLifeCycleX, displayRegisterX, displayConfirmRegisterX, displaySignatureAndPaymentX,displayColourLetterTagX,todo.active_after_published)
                                                             },
                                                             (reject) =>{
                                                               this.editListContractDialog(e, i, displayOriginX, displayRoleX, todo.typeContract, todo.configurationContractNumber, todo.ningunoSign, todo.algunosSign, todo.todosSign, todo.ningunoDevice, todo.algunosDevice, todo.todosDevice, todo.role, todo.origin, todo.active, nameContractEditor, displayReportX, displayUserX, displaySignatureX, displayLinkX, displayEyeX, displayChatX, displayTagX, displaySubjectX, displayCryptoCurrencyX, displayBlockchainX, displayAssociatedX, displayRulesX, displayDocumentX, displayShareX, displayActiveParticipantsX, displayDeliverableX, displayFormsDeliverableX, displayAuthorizersDeliverableX, displayRolDeliverableX, displayTagDeliverableX, displayReporteTurnoDeliverableX, displayStringTagX, displayColourTagX, displayCircleGreenX, displayActiveUserGroupX, displayConfirmSignX, displayActiveDeliverableX, displayActiveDataDashboardX, encryptDecryptFileX, displayLifeCycleX, displayRegisterX, displayConfirmRegisterX, displaySignatureAndPaymentX,displayColourLetterTagX,todo.active_after_published)
                                                             }
                                                           )
                                                       }else{
                                                         this.editListContractDialog(e, i, displayOriginX, displayRoleX, todo.typeContract, todo.configurationContractNumber, todo.ningunoSign, todo.algunosSign, todo.todosSign, todo.ningunoDevice, todo.algunosDevice, todo.todosDevice, todo.role, todo.origin, todo.active, nameContractEditor, displayReportX, displayUserX, displaySignatureX, displayLinkX, displayEyeX, displayChatX, displayTagX, displaySubjectX, displayCryptoCurrencyX, displayBlockchainX, displayAssociatedX, displayRulesX, displayDocumentX, displayShareX, displayActiveParticipantsX, displayDeliverableX, displayFormsDeliverableX, displayAuthorizersDeliverableX, displayRolDeliverableX, displayTagDeliverableX, displayReporteTurnoDeliverableX, displayStringTagX, displayColourTagX, displayCircleGreenX, displayActiveUserGroupX, displayConfirmSignX, displayActiveDeliverableX, displayActiveDataDashboardX, encryptDecryptFileX, displayLifeCycleX, displayRegisterX, displayConfirmRegisterX, displaySignatureAndPaymentX,displayColourLetterTagX,todo.active_after_published)
                                                       }
                                                     }
                                                  }
                                             >
                                               {todo.configurationContractNumber}
                                             </strong>
                                           }
                                       </td>
                                       <td style={this.props.colorDark ? {color: 'black'} : {}}>
                                           <Card style={{ backgroundColor: todo.colortag, color: todo.colorlettertag }}>{displayStringTagX}</Card>
                                       </td>
                                       <td>{displayRoleX}</td>
                                       <td>{displayOriginX}</td>
                                       <td>{displaySubjectX}</td>
                                       <td>{todo.dateLogisticContract.substring(4,15)}</td>
                                       <td>{statuscontract}</td>
                                       <td style={this.props.colorDark ? {color: 'orange'} : {color: 'darkred'}}>{displayLifeCycleX}</td>
                                       {displayNoEdit ?
                                          <td>
                                            <strong style={{cursor: 'pointer'}} onClick={e=>this.alerteditListContractDialog(e,displayRoleX,displayLifeCycleX)}>
                                               <>
                                               {setOpcionDocument ?
                                                  <img title={displayTitleEdit} src={displayEditX3} weight="33" height="33" alt=""/>
                                               :
                                                  <img title={displayTitleEdit} src={displayEditX3} weight="22" height="22" alt=""/>
                                               }
                                               </>
                                            </strong>
                                          </td>
                                       :
                                          <React.Fragment>
                                            {displayEditListContract ?
                                              <td>
                                                <ContractLoader colorDark={this.props.colorDark}/>
                                              </td>
                                            :
                                              <td>
                                                <strong style={{cursor: 'pointer'}} onClick={()=>{
                                                    let e = ''
                                                    if (this.state.DisplayCompanyLogoData === 'Yes' &&

                                                       (todo.typeContract === 'proforma' || todo.typeContract === 'simulate' || todo.typeContract === 'delivery' || todo.typeContract === 'maintenance' || todo.typeContract === 'workorder')){
                                                        Promise.all(
                                                           [this.getDisplayCompanyLogo(displayOriginX,todo.typeContract),
                                                            this.getDisplayCompanyData(displayOriginX,todo.typeContract),
                                                            this.getDeliverableForms(todo.typeContract,todo.configurationContractNumber,displayOriginX)
                                                           ]
                                                        ).then(
                                                          (resolve) =>{
                                                            this.editListContractDialog(e, i, displayOriginX, displayRoleX, todo.typeContract, todo.configurationContractNumber, todo.ningunoSign, todo.algunosSign, todo.todosSign, todo.ningunoDevice, todo.algunosDevice, todo.todosDevice, todo.role, todo.origin, todo.active, nameContractEditor, displayReportX, displayUserX, displaySignatureX, displayLinkX, displayEyeX, displayChatX, displayTagX, displaySubjectX, displayCryptoCurrencyX, displayBlockchainX, displayAssociatedX, displayRulesX, displayDocumentX, displayShareX, displayActiveParticipantsX, displayDeliverableX, displayFormsDeliverableX, displayAuthorizersDeliverableX, displayRolDeliverableX, displayTagDeliverableX, displayReporteTurnoDeliverableX, displayStringTagX, displayColourTagX, displayCircleGreenX, displayActiveUserGroupX, displayConfirmSignX, displayActiveDeliverableX, displayActiveDataDashboardX, encryptDecryptFileX, displayLifeCycleX, displayRegisterX, displayConfirmRegisterX,displaySignatureAndPaymentX,displayColourLetterTagX,todo.active_after_published)
                                                          },
                                                          (reject) =>{
                                                            this.editListContractDialog(e, i, displayOriginX, displayRoleX, todo.typeContract, todo.configurationContractNumber, todo.ningunoSign, todo.algunosSign, todo.todosSign, todo.ningunoDevice, todo.algunosDevice, todo.todosDevice, todo.role, todo.origin, todo.active, nameContractEditor, displayReportX, displayUserX, displaySignatureX, displayLinkX, displayEyeX, displayChatX, displayTagX, displaySubjectX, displayCryptoCurrencyX, displayBlockchainX, displayAssociatedX, displayRulesX, displayDocumentX, displayShareX, displayActiveParticipantsX, displayDeliverableX, displayFormsDeliverableX, displayAuthorizersDeliverableX, displayRolDeliverableX, displayTagDeliverableX, displayReporteTurnoDeliverableX, displayStringTagX, displayColourTagX, displayCircleGreenX, displayActiveUserGroupX, displayConfirmSignX, displayActiveDeliverableX, displayActiveDataDashboardX, encryptDecryptFileX, displayLifeCycleX, displayRegisterX, displayConfirmRegisterX,displaySignatureAndPaymentX,displayColourLetterTagX,todo.active_after_published)
                                                          }
                                                        )
                                                    }else{
                                                      if (todo.typeContract === 'workorder'){
                                                       Promise.all(
                                                          [this.getDeliverableForms(todo.typeContract,todo.configurationContractNumber,displayOriginX)]
                                                         ).then(
                                                           (resolve) =>{
                                                             this.editListContractDialog(e, i, displayOriginX, displayRoleX, todo.typeContract, todo.configurationContractNumber, todo.ningunoSign, todo.algunosSign, todo.todosSign, todo.ningunoDevice, todo.algunosDevice, todo.todosDevice, todo.role, todo.origin, todo.active, nameContractEditor, displayReportX, displayUserX, displaySignatureX, displayLinkX, displayEyeX, displayChatX, displayTagX, displaySubjectX, displayCryptoCurrencyX, displayBlockchainX, displayAssociatedX, displayRulesX, displayDocumentX, displayShareX, displayActiveParticipantsX, displayDeliverableX, displayFormsDeliverableX, displayAuthorizersDeliverableX, displayRolDeliverableX, displayTagDeliverableX, displayReporteTurnoDeliverableX, displayStringTagX, displayColourTagX, displayCircleGreenX, displayActiveUserGroupX, displayConfirmSignX, displayActiveDeliverableX, displayActiveDataDashboardX, encryptDecryptFileX, displayLifeCycleX, displayRegisterX, displayConfirmRegisterX,displaySignatureAndPaymentX,displayColourLetterTagX,todo.active_after_published)
                                                           },
                                                           (reject) =>{
                                                             this.editListContractDialog(e, i, displayOriginX, displayRoleX, todo.typeContract, todo.configurationContractNumber, todo.ningunoSign, todo.algunosSign, todo.todosSign, todo.ningunoDevice, todo.algunosDevice, todo.todosDevice, todo.role, todo.origin, todo.active, nameContractEditor, displayReportX, displayUserX, displaySignatureX, displayLinkX, displayEyeX, displayChatX, displayTagX, displaySubjectX, displayCryptoCurrencyX, displayBlockchainX, displayAssociatedX, displayRulesX, displayDocumentX, displayShareX, displayActiveParticipantsX, displayDeliverableX, displayFormsDeliverableX, displayAuthorizersDeliverableX, displayRolDeliverableX, displayTagDeliverableX, displayReporteTurnoDeliverableX, displayStringTagX, displayColourTagX, displayCircleGreenX, displayActiveUserGroupX, displayConfirmSignX, displayActiveDeliverableX, displayActiveDataDashboardX, encryptDecryptFileX, displayLifeCycleX, displayRegisterX, displayConfirmRegisterX,displaySignatureAndPaymentX,displayColourLetterTagX,todo.active_after_published)
                                                           }
                                                         )
                                                      }else{
                                                         this.editListContractDialog(e, i, displayOriginX, displayRoleX, todo.typeContract, todo.configurationContractNumber, todo.ningunoSign, todo.algunosSign, todo.todosSign, todo.ningunoDevice, todo.algunosDevice, todo.todosDevice, todo.role, todo.origin, todo.active, nameContractEditor, displayReportX, displayUserX, displaySignatureX, displayLinkX, displayEyeX, displayChatX, displayTagX, displaySubjectX, displayCryptoCurrencyX, displayBlockchainX, displayAssociatedX, displayRulesX, displayDocumentX, displayShareX, displayActiveParticipantsX, displayDeliverableX, displayFormsDeliverableX, displayAuthorizersDeliverableX, displayRolDeliverableX, displayTagDeliverableX, displayReporteTurnoDeliverableX, displayStringTagX, displayColourTagX, displayCircleGreenX, displayActiveUserGroupX, displayConfirmSignX, displayActiveDeliverableX, displayActiveDataDashboardX, encryptDecryptFileX, displayLifeCycleX, displayRegisterX, displayConfirmRegisterX,displaySignatureAndPaymentX,displayColourLetterTagX,todo.active_after_published)
                                                      }
                                                    }
                                                  }
                                                }
                                              >
                                              <>
                                              {setOpcionDocument ?
                                                  <img title={displayTitleEdit} src={displayEditX2} weight="33" height="33" alt=""/>
                                              :
                                                  <img title={displayTitleEdit} src={displayEditX2} weight="22" height="22" alt=""/>
                                              }
                                              </>
                                              </strong>
                                            </td>
                                            }
                                          </React.Fragment>
                                       }
                                       {displayDeleteListContract ?
                                          <td>
                                             <ContractDelete optx={i} typeContract={todo.typeContract} numberContract={todo.configurationContractNumber} returnProps={this.returnProps} deleteListContract={this.deleteListContract} username={this.state.username} />
                                          </td>
                                       :
                                          <td>
                                            <strong style={{cursor: 'pointer'}} onClick={e=>this.deleteListContractDialog(e, i, displayDeleteX, displayDeleteX2, todo.typeContract, todo.configurationContractNumber, displayRoleX, displayLifeCycleX)}>
                                              <>
                                              {setOpcionDocument ?
                                                 <img title={displayTitleDelete} src={displayDeleteX2} weight="30" height="30" alt=""/>
                                              :
                                                 <img title={displayTitleDelete} src={displayDeleteX2} weight="20" height="20" alt=""/>
                                              }
                                              </>
                                            </strong>
                                          </td>
                                       }
                                       <td>
                                         <strong style={{cursor: 'pointer'}} onClick={e=>this.storeListContractDialog(e, i, displayStoreX, todo.typeContract, todo.configurationContractNumber, displayRoleX)}>
                                           <>
                                           {setOpcionDocument ?
                                             <img title={displayTitleArchive} src={displayStoreX} weight="30" height="30" alt=""/>
                                           :
                                             <img title={displayTitleArchive} src={displayStoreX} weight="20" height="20" alt=""/>
                                           }
                                           </>
                                         </strong>
                                       </td>
                                       <td style = {{display:"none"}}>{todo.ningunoSign}</td>
                                       <td style = {{display:"none"}}>{todo.algunosSign}</td>
                                       <td style = {{display:"none"}}>{todo.todosSign}</td>
                                       <td style = {{display:"none"}}>{todo.ningunoDevice}</td>
                                       <td style = {{display:"none"}}>{todo.algunosDevice}</td>
                                       <td style = {{display:"none"}}>{todo.todosDevice}</td>
                                       <td style = {{display:"none"}}>{todo.active_after_published}</td>
                                       <td style = {{display:"none"}}>{encryptDecryptFileX}</td>
                                       <td style = {{display:"none"}}>{displayAssociatedX}</td>
                                       <td style = {{display:"none"}}>{displayRulesX}</td>
                                       <td style = {{display:"none"}}>{displayReportX}</td>
                                       <td style = {{display:"none"}}>{displayUserX}</td>
                                       <td style = {{display:"none"}}>{displaySignatureX}</td>
                                       <td style = {{display:"none"}}>{displayRegisterX}</td>
                                       <td style = {{display:"none"}}>{displayLinkX}</td>
                                       <td style = {{display:"none"}}>{displayEyeX}</td>
                                       <td style = {{display:"none"}}>{displayDeliverableX}</td>
                                       <td style = {{display:"none"}}>{displayFormsDeliverableX}</td>
                                       <td style = {{display:"none"}}>{displayAuthorizersDeliverableX}</td>
                                       <td style = {{display:"none"}}>{displayRolDeliverableX}</td>
                                       <td style = {{display:"none"}}>{displayTagDeliverableX}</td>
                                       <td style = {{display:"none"}}>{displayReporteTurnoDeliverableX}</td>
                                       <td style = {{display:"none"}}>{displayChatX}</td>
                                       <td style = {{display:"none"}}>{displayTagX}</td>
                                       <td style = {{display:"none"}}>{displayShareX}</td>
                                       <td style = {{display:"none"}}>{displayActiveParticipantsX}</td>
                                       <td style = {{display:"none"}}>{displaySignatureAndPaymentX}</td>
                                     </tr>
                                   )
                                 }
                               }
                            }
                         }
                      })}
                    </tbody>
                  </Table>
                </div>
              )
          }
      }

      displayListContractArchive(pathname,modeDisplay) {
            let item=0
            let statuscontract = ''
            let jsondisplayListContract = this.state.jsonArchive
            let jsondisplayListContractLength = jsondisplayListContract.length

            return (
              <div>
                <Table size="sm" style={this.props.colorDark ? {color: 'orange'} : {color: 'darkred'}} className="text-center" responsive hover striped>
                  <thead>
                      <tr style={{fontSize:13}}>
                        <th style={{ width: "30px" }}></th>
                        <th ><FormattedMessage id="contract.listcol1" /></th>
                        <th ><FormattedMessage id="contract.listcol2" /></th>
                        <th ><FormattedMessage id="contract.listcol3" /></th>
                        <th ><FormattedMessage id="contract.listcol4" /></th>
                        <th ><FormattedMessage id="contract.listcol5" /></th>
                        <th ><FormattedMessage id="contract.listcol6" /></th>
                        <th ><FormattedMessage id="configuration.delete" /></th>
                        <th ><FormattedMessage id="contract.unarchive" /></th>
                      </tr>
                  </thead>

                  <tbody>
                     {jsondisplayListContract.map((todo, i) => {
                         let displayRoleX = todo.role
                         let displayOriginX = todo.origin
                         let displaySubjectX = todo.subject
                         let displayUnarchiveX = 'images/unarchiveGrey.png'
                         let displayDeleteX = 'images/delete25p.png'
                         if (this.props.colorDark) {displayDeleteX = "images/delete.png"}else{displayDeleteX = "images/delete25p.png"}
                         let blankX = false
                         let deliveryX = false
                         let proformaX = false
                         let maintenanceX = false
                         let simulateX = false
                         let uploadedX = false
                         let spreadsheetX = false
                         let workorderX = false
                         let nameContractEditor =  ''
                         if (todo.typeContract === 'blank'){ blankX = true; nameContractEditor = 'Blank Contract' }
                         if (todo.typeContract === 'delivery'){ deliveryX = true; nameContractEditor = 'Logistic, Transport & Delivery Contract' }
                         if (todo.typeContract === 'proforma'){ proformaX = true; nameContractEditor = 'Proforma ' }
                         if (todo.typeContract === 'maintenance'){ maintenanceX = true; nameContractEditor = 'Industrial Maintenance Contract' }
                         if (todo.typeContract === 'simulate'){ simulateX = true; nameContractEditor = 'Simulate Contract' }
                         if (todo.typeContract === 'uploaded'){ uploadedX = true; nameContractEditor = 'Uploaded Contract' }
                         if (todo.typeContract === 'spreadsheet'){ spreadsheetX = true; nameContractEditor = 'Spreadsheet' }
                         if (todo.typeContract === 'workorder'){ workorderX = true; nameContractEditor = 'Work Order' }
                         return (
                           <tr key={i} style={this.props.colorDark ? {color: 'white'} : {color: 'darkblue'}}>
                             {blankX ?
                                <td><img src="images/blankcontract.png" weight="40" height="40" alt=""/></td>
                             : null }
                             {deliveryX ?
                                <td><img src="images/billoflading.png" weight="40" height="40" alt=""/></td>
                             : null }
                             {proformaX ?
                                <td><img src="images/proformainvoice.png" weight="40" height="40" alt=""/></td>
                             : null }
                             {maintenanceX ?
                                <td><img src="images/maintenance.png" weight="40" height="40" alt=""/></td>
                             : null }
                             {simulateX ?
                                <td><img src="images/simulate.png" weight="40" height="40" alt=""/></td>
                             : null }
                             {uploadedX ?
                                <td><img src="images/uploadPdf.png" weight="40" height="40" alt=""/></td>
                             : null }
                             {spreadsheetX ?
                                <td><img src="images/blankspreadsheet.png" weight="40" height="40" alt=""/></td>
                             : null }
                             {workorderX ?
                                <td><img src="images/workorder.png" weight="40" height="40" alt=""/></td>
                             : null }
                             <td>{todo.typeContract}</td>
                             <td>{todo.configurationContractNumber}</td>
                             <td>{displayRoleX}</td>
                             <td>{displayOriginX}</td>
                             <td>{displaySubjectX}</td>
                             <td>{todo.dateLogisticContract.substring(4,15)}</td>
                             <td><strong style={{cursor: 'pointer'}} onClick={e=>this.deleteListContractArchiveDialog(e, i, todo.typeContract, todo.configurationContractNumber, displayRoleX, )}><img src={displayDeleteX} weight="20" height="20" alt=""/></strong></td>
                             <td><strong style={{cursor: 'pointer'}} onClick={e=>this.unarchiveListContractArchiveDialog(e, i, todo.typeContract, todo.configurationContractNumber, displayRoleX)}><img src={displayUnarchiveX} weight="20" height="20" alt=""/></strong></td>
                           </tr>
                         )
                    })}
                  </tbody>
                </Table>
              </div>
            )
      }

      stateContract = (typeContract,configurationContractNumber,displaySubjectX,role,origin) => {
        this.setState({ modeContract: 'button',
                        searchContract2: false,
                        displayLink: false,
                        displayAttach: false,
                        displayBlockchain: false,
                        displayCryptoCurrency: false,
                        displayDocument: false,
                        displayRules: false,
                        displayAssociated: false,
                        displayShare: false,
                        displayActiveParticipants: false,
                        displayUser: false,
                        displaySign: false,
                        displayRegister: false,
                        displayDashboard: false,
                        displayDeliverable: false,
                        displayReport: false,
                        displayChat: false,
                        displayTag: false,
                        typeContractTable: typeContract,
                        numberContractTable: configurationContractNumber,
                        subjectContractTable: displaySubjectX,
                        whatUserRole: role,
                        whatUserOrigin: origin,
                        seeAttachX: false,
                        newUploadedX: false,
                        showLoader: false})
      }

      alerteditListContractDialog = (e,displayRoleX,displayLifeCycleX) => {
        this.editContract(displayRoleX, displayLifeCycleX)
      }

      editListContractDialog = (
        e,
        i,
        displayOriginX,
        displayRoleX,
        typeContract,
        configurationContractNumber,
        ningunoSign,
        algunosSign,
        todosSign,
        ningunoDevice,
        algunosDevice,
        todosDevice,
        role,
        origin,
        active,
        nameContractEditor,
        displayReportX,
        displayUserX,
        displaySignatureX,
        displayLinkX,
        displayEyeX,
        displayChatX,
        displayTagX,
        displaySubjectX,
        displayCryptoCurrencyX,
        displayBlockchainX,
        displayAssociatedX,
        displayRulesX,
        displayDocumentX,
        displayShareX,
        displayActiveParticipantsX,
        displayDeliverableX,
        displayFormsDeliverableX,
        displayAuthorizersDeliverableX,
        displayRolDeliverableX,
        displayTagDeliverableX,
        displayReporteTurnoDeliverableX,
        displayStringTagX,
        displayColourTagX,
        displayCircleGreenX,
        displayActiveUserGroupX,
        displayConfirmSignX,
        displayActiveDeliverableX,
        displayActiveDataDashboardX,
        encryptDecryptFileContractX,
        displayLifeCycleX,
        displayRegisterX,
        displayConfirmRegisterX,
        signatureAndPaymentX,
        displayColourLetterTagX,
        active_after_publishedX ) => {
          this.setState({ iContractTable: i });
          this.setState({ editListContract: true });
          const {userSession} = this.state
          const storage = new Storage({ userSession });
          let options = {}
          if (typeContract !== 'simulate' && displayRoleX !== 'Creator'){
             options = { username: displayOriginX, decrypt: false, verify: false }
          }else{
            options = { decrypt: false, verify: false }
          }
          if (typeContract === 'maintenance') {
            new Promise((resolve11)=>{
              this.associatedToMaintenance().then(resolve11());
               })
               .then()
          }
          localStorage.removeItem('jsonBlockstack2')
          getFileDB(displayOriginX,`${typeContract}_${configurationContractNumber}.json`)
             .then((fileContents) => {
               if(fileContents) {
                 const jsonBlockstack1 = JSON.parse(fileContents)
                 const jsonBlockstack2 = jsonBlockstack1.data
                 let jsonBlockstack5 = '[]'
                 if (jsonBlockstack2 !== null){
                    const jsonBlockstack3 = jsonBlockstack2.dataobject
                    const jsonBlockstack4 = jsonBlockstack3.replace(/\\/g,"");
                    if (jsonBlockstack4.substring(0,1) === '"') {
                       jsonBlockstack5 = jsonBlockstack4.substring(1,jsonBlockstack4.length - 1)
                    } else {
                       jsonBlockstack5 = jsonBlockstack4
                    }
                 }
                 let jsonBlockstack6 = JSON.parse(jsonBlockstack5)

                 this.setState({ jsonBlockstack: jsonBlockstack5 });
                 localStorage.setItem('searchContract',`${typeContract}_${configurationContractNumber}.json`)
                 localStorage.setItem('jsonBlockstack2',jsonBlockstack5)
                 this.setState({ searchContract2: true,
                                 modeContract: 'list',
                                 JSONTemplateName: typeContract,
                                 typeContractSign: typeContract,
                                 configurationContractNumberSign: configurationContractNumber})
                 if (displayRoleX === 'Support') {
                   new Promise((resolve11)=>{
                     this.llenaTablaEnrollment(typeContract,configurationContractNumber).then(resolve11());
                      })
                      .then(
                        () =>{
                            this.setState({displayLink: true});
                        }
                      )
                 }else{
                    this.setState({displayLink: false});
                 }
                 this.setState({displayAttach: false,
                                displayBlockchain: false,
                                displayCryptoCurrency: false,
                                displayDocument: true,
                                displayRules: false,
                                displayAssociated: false,
                                displayShare: false,
                                displayActiveParticipants: false,
                                displayUser: false,
                                displaySign: false,
                                displayRegister: false,
                                displayDashboard: false,
                                displayDeliverable: false,
                                displayReport: false,
                                displayChat: false,
                                displayTag: false,
                                displayRulesDisable: true,
                                ningunoSign: ningunoSign,
                                algunosSign: algunosSign,
                                todosSign: todosSign,
                                ningunoDevice: ningunoDevice,
                                algunosDevice: algunosDevice,
                                todosDevice: todosDevice,
                                whatUserRole: displayRoleX,
                                whatUserOrigin: displayOriginX,
                                activeContract: active,
                                displayWriteUp: false,
                                nameContractEditor: nameContractEditor,
                                showLoader: false,
                                icondisplayReportX: displayReportX,
                                icondisplayUserX: displayUserX,
                                icondisplaySignatureX: displaySignatureX,
                                icondisplayRegisterX: displayRegisterX,
                                icondisplayLinkX: displayLinkX,
                                icondisplayEyeX: displayEyeX,
                                icondisplayChatX: displayChatX,
                                icondisplayTagX: displayTagX,
                                icondisplayDeliverableX: displayDeliverableX,
                                icondisplayFormsDeliverableX: displayFormsDeliverableX,
                                icondisplayAuthorizersDeliverableX: displayAuthorizersDeliverableX,
                                icondisplayRolDeliverableX: displayRolDeliverableX,
                                icondisplayTagDeliverableX: displayTagDeliverableX,
                                icondisplayReporteTurnoDeliverableX: displayReporteTurnoDeliverableX,
                                icontypeContract: typeContract,
                                iconconfigurationContractNumber: configurationContractNumber,
                                icondisplayRoleX: displayRoleX,
                                icondisplayOriginX: displayOriginX,
                                icondisplaySubjectX: displaySubjectX,
                                icondisplayCryptoCurrencyX: displayCryptoCurrencyX,
                                icondisplayBlockchainX: displayBlockchainX,
                                icondisplayAssociatedX: displayAssociatedX,
                                icondisplayRulesX: displayRulesX,
                                icondisplayDocumentX: displayDocumentX,
                                icondisplayShareX: displayShareX,
                                icondisplayActiveParticipantsX: displayActiveParticipantsX,
                                displayStringTagX: displayStringTagX,
                                displayColourTagX: displayColourTagX,
                                displayColourLetterTagX: displayColourLetterTagX,
                                active_after_publishedX: active_after_publishedX,
                                displayCircleGreenX: displayCircleGreenX,
                                displayIconsRed: false,
                                activeUserGroupX: displayActiveUserGroupX,
                                confirmSignX: displayConfirmSignX,
                                confirmRegisterX: displayConfirmRegisterX,
                                activeDeliverableX: displayActiveDeliverableX,
                                activeDataDashboardX: displayActiveDataDashboardX,
                                encryptDecryptFileContract: encryptDecryptFileContractX,
                                displayLifeCycleX:displayLifeCycleX})

                 if (signatureAndPaymentX === undefined){this.setState({ selectedSignaturePayment: 'SignatureAndPayment' }) }else{this.setState({ selectedSignaturePayment: signatureAndPaymentX })}

                 if (this.state.modeDisplay === 'Mail'){ this.setState({modeDisplayCollapsed: false}) }
                 if (this.state.modeDisplay === 'Editor'){ this.setState({modeDisplayCollapsed: true}) }
                 this.verifySign(typeContract, configurationContractNumber)
                 this.llenaDatosLocalStorage(displayOriginX)
                 this.putCircleGreen(typeContract, configurationContractNumber, displayOriginX)
               } else {}
             })
              .catch(error => {
              });
      }

      putCircleGreen(typeContract, configurationContractNumber, displayOriginX){
        let jsonCircleGreen = this.state.jsonCircleGreen
        const {userSession} = this.state
        const storage = new Storage({ userSession });
        const options = {contentType: 'application/json', encrypt: false, dangerouslyIgnoreEtag: true }
        const infoCircleGreen = [...jsonCircleGreen,{"typecontract":typeContract,"contractnumber":configurationContractNumber,"origin":displayOriginX}]
        putFileDB(displayOriginX,`circlegreen.json`, 'Crosscheck_Contract', JSON.stringify(infoCircleGreen), JSON.stringify(options))
           .then(() => {
           })
           .catch(error => {
           });

      }

      stateContractPaginacion = () => {
        this.setState({ searchContract2: false,
                        displayLink: false,
                        displayAttach: false,
                        displayBlockchain: false,
                        displayCryptoCurrency: false,
                        displayDocument: false,
                        displayRules: false,
                        displayAssociated: false,
                        displayShare: false,
                        displayActiveParticipants: false,
                        displayUser: false,
                        displaySign: false,
                        displayRegister: false,
                        displayDashboard: false,
                        displayDeliverable: false,
                        displayReport: false,
                        displayChat: false,
                        displayTag: false,
                        seeAttachX: false,
                        newUploadedX: false,
                        showLoader: false})
      }

      displayPaginacion(pathname) {
              let scrollAuxiliar = 0
              let scrollAuxiliar2 = this.state.scrollEnd
              if (this.state.scrollEnd > this.state.scrollLength) {
                 scrollAuxiliar2 = this.state.scrollLength
              }
              let contractPageX = `Document ${this.state.scrollInitial} to ${scrollAuxiliar2} of ${this.state.scrollLength}`
              if (this.state.language === 'English'){contractPageX = `Document ${this.state.scrollInitial} to ${scrollAuxiliar2} of ${this.state.scrollLength}`}
              if (this.state.language === 'French'){contractPageX = `Document ${this.state.scrollInitial} une ${scrollAuxiliar2} de ${this.state.scrollLength}`}
              if (this.state.language === 'Spanish'){contractPageX = `Documento ${this.state.scrollInitial} a ${scrollAuxiliar2} de ${this.state.scrollLength}`}
              if (this.state.language === 'Portuguese'){contractPageX = `Documento ${this.state.scrollInitial} um ${scrollAuxiliar2} do ${this.state.scrollLength}`}
              if (this.state.language === 'Swedish'){contractPageX = `Dokumentera ${this.state.scrollInitial} en ${scrollAuxiliar2} av ${this.state.scrollLength}`}
              if (this.state.language === 'Netherlands'){contractPageX = `Document ${this.state.scrollInitial} een ${scrollAuxiliar2} van ${this.state.scrollLength}`}
              if (this.state.language === 'Russian'){contractPageX = `Документ ${this.state.scrollInitial} в ${scrollAuxiliar2} из ${this.state.scrollLength}`}
              if (this.state.language === 'Japanese'){contractPageX = `資料 ${this.state.scrollInitial} 私は ${scrollAuxiliar2} の ${this.state.scrollLength}`}
              if (this.state.language === 'Chinese'){contractPageX = `文獻 ${this.state.scrollInitial} 至 ${scrollAuxiliar2} 的 ${this.state.scrollLength}`}
              if (this.state.language === 'German'){contractPageX = `Dokumentieren ${this.state.scrollInitial} Ich bin ${scrollAuxiliar2} von ${this.state.scrollLength}`}
              if (this.state.language === 'Italian'){contractPageX = `Documento ${this.state.scrollInitial} a ${scrollAuxiliar2} di ${this.state.scrollLength}`}

              return (
                <div>
                  <Table size="sm" style={{"color": 'black'}} className="text-center">
                    <tbody>
                        <tr style={this.props.colorDark ? {color: 'white'} : {color: 'black'}}>
                          <td>{contractPageX}</td>
                          <td><strong style={{cursor: 'pointer'}} onClick={()=>{
                                  if (this.state.scrollInitial > this.state.pageContracts){
                                     this.setState({scrollInitial:1,scrollEnd:this.state.pageContracts})
                                     this.stateContractPaginacion()
                                     this.listContract(this.state.username)
                                  }
                              }}><img src="images/initial.png" weight="15" height="15" alt=""/></strong></td>
                          <td><strong style={{cursor: 'pointer'}} onClick={()=>{
                                  if (this.state.scrollInitial > this.state.pageContracts){
                                    scrollAuxiliar = this.state.scrollInitial - this.state.pageContracts
                                    if (scrollAuxiliar<1){
                                    }else{
                                      this.setState({scrollInitial:scrollAuxiliar,scrollEnd:scrollAuxiliar + (this.state.pageContracts - 1)})
                                    }
                                    this.stateContractPaginacion()
                                    this.listContract(this.state.username)
                                  }
                              }}><img src="images/previous.png" weight="20" height="20" alt=""/></strong></td>
                          <td><strong style={{cursor: 'pointer'}} onClick={()=>{
                                      if (this.state.scrollInitial + this.state.pageContracts <= this.state.scrollLength){
                                        scrollAuxiliar = this.state.scrollInitial + this.state.pageContracts
                                        this.setState({scrollEnd:scrollAuxiliar + (this.state.pageContracts - 1),scrollInitial:scrollAuxiliar})
                                        this.stateContractPaginacion()
                                        this.listContract(this.state.username)
                                      }
                              }}><img src="images/next.png" weight="20" height="20" alt=""/></strong></td>
                          <td><strong style={{cursor: 'pointer'}} onClick={()=>{
                                    if (this.state.scrollInitial + this.state.pageContracts <= this.state.scrollLength) {
                                      scrollAuxiliar = parseInt(this.state.scrollLength / this.state.pageContracts)
                                      scrollAuxiliar = (scrollAuxiliar * this.state.pageContracts) + 1
                                      this.setState({scrollInitial:scrollAuxiliar,scrollEnd:this.state.scrollLength})
                                      this.stateContractPaginacion()
                                      this.listContract(this.state.username)
                                    }
                              }}><img src="images/end.png" weight="15" height="15" alt=""/></strong></td>
                        </tr>
                    </tbody>
                  </Table>
                </div>
              )
      }

      displayNewContract(pathname) {
          let arrayTemplateDBX = []
          let displayTemplateX = false
          if (this.state.bringContractTemplateFrom === 'Server'){
            if (this.props.templatesAll.length > 0) {
              arrayTemplateDBX = this.props.templatesAll[0]
              arrayTemplateDBX.sort(function(a, b){
                return a.priority-b.priority
              })
              displayTemplateX = true
            }
          }else{
            arrayTemplateDBX = this.state.templatesAllLocal
            arrayTemplateDBX.sort(function(a, b){
              return a.priority-b.priority
            })
            displayTemplateX = true
          }
          const newContractX = this.state.newcontract
          return (
            <div>
              <Table size="sm" style={{"color": 'black'}} className="text-center">
                <tbody>
                    {displayTemplateX ?
                      <tr>
                        <td><FormSelect
                            id="TypeContract"
                            innerRef={this.c01ConfigurationContract}
                            placeholder="Select an Option"
                            onChange={e=>this.searchContracts(e,1)}
                            disabled={this.state.displayTemplateDetail}
                            style={{backgroundColor:"#F2EACE"}}
                          >
                          <option value={``} selected disabled hidden>{newContractX}</option>
                          {arrayTemplateDBX.map((todo, key) => {
                              let isActiveX = todo.isActive
                              return (
                               <option style={this.props.colorDark ? {color:'orange'} : {color:'darkblue'}} key={todo._id} disabled={!isActiveX} value={`${todo._id}#$%${todo.secondaryName}#$%${todo.isAttachFile}#$%${todo.isRules}#$%${todo.isAssociatedTo}#$%${todo.tax}#$%${todo.title}`} >{todo.name}</option>
                          )})}
                        </FormSelect>
                        </td>
                      </tr>
                    :
                      null
                    }
                </tbody>
              </Table>
            </div>
          )
      }

      displayConfigContract(pathname) {
          const {tagList} = this.state
          const {userlistRemote} = this.state
          const myContactX = this.state.mycontact
          const myTagX = this.state.mytag

          let inboxX=''
          let archiveX=''
          let trashX=''
          let activeX=''
          let inactiveX=''
          let allX=''
          if (this.state.language === 'English'){inboxX='Execution Documents'; archiveX='Archived Documents'; trashX='Trash'; activeX='Active'; inactiveX='Inactive'; allX='All'}
          if (this.state.language === 'French'){inboxX=`Documents d'exécution`; archiveX='Documents archivés'; trashX='Corbeille'; activeX='Active'; inactiveX='Inactive'; allX='All'}
          if (this.state.language === 'Spanish'){inboxX='Documentos en ejecución'; archiveX='Documentos Archivados'; trashX='Papelera'; activeX='Activo'; inactiveX='Inactivo'; allX='Todo'}
          if (this.state.language === 'Portuguese'){inboxX='Documentos de execução'; archiveX='Documentos Arquivados'; trashX='Reciclagem'; activeX='Active'; inactiveX='Inactive'; allX='All'}
          if (this.state.language === 'Swedish'){inboxX='Utförande dokument'; archiveX='Arkiverade dokument'; trashX='Papperskorg'; activeX='Active'; inactiveX='Inactive'; allX='All'}
          if (this.state.language === 'Netherlands'){inboxX='Uitvoeringsdocumenten'; archiveX='Gearchiveerde documenten'; trashX='Prullenbak'; activeX='Active'; inactiveX='Inactive'; allX='All'}
          if (this.state.language === 'Russian'){inboxX='Оформление документов'; archiveX='Архивные документы'; trashX='Kорзина'; activeX='Active'; inactiveX='Inactive'; allX='All'}
          if (this.state.language === 'Japanese'){inboxX='実行文書'; archiveX='アーカイブされたドキュメント'; trashX='バスケット'; activeX='Active'; inactiveX='Inactive'; allX='All'}
          if (this.state.language === 'Chinese'){inboxX='執行文件'; archiveX='存檔文件'; trashX='垃圾'; activeX='Active'; inactiveX='Inactive'; allX='All'}
          if (this.state.language === 'German'){inboxX='Ausführungsdokumente'; archiveX='Archivierte Dokumente'; trashX='Gelöscht'; activeX='Active'; inactiveX='Inactive'; allX='All'}
          if (this.state.language === 'Italian'){inboxX='Documenti di esecuzione'; archiveX='Documenti archiviati'; trashX='Cestino'; activeX='Active'; inactiveX='Inactive'; allX='All'}

          let true10=false,true15=false,true20=false,true50=false,true100=false,true500=false;
          if (this.state.pageContracts===10){true10=true}
          if (this.state.pageContracts===15){true15=true}
          if (this.state.pageContracts===20){true20=true}
          if (this.state.pageContracts===50){true50=true}
          if (this.state.pageContracts===100){true100=true}
          if (this.state.pageContracts===500){true500=true}
          const jsonPageContracts = [{contractbypage:'10',default:true10},{contractbypage:'15',default:true15},{contractbypage:'20',default:true20},{contractbypage:'50',default:true50},{contractbypage:'100',default:true100},{contractbypage:'500',default:true500}]

          return (
            <div>
              <Table style={{"color": 'black'}} borderless size="sm">
                <tbody>
                  <tr>
                    <td>
                        <FormSelect
                            id="UserRemote"
                            innerRef={this.cUserRemote}
                            placeholder=""
                            onChange={this.userRemoteContracts}
                            style={ this.props.colorDark ? {backgroundColor:"#0b151d", color:'white'} : {backgroundColor:"#F2EACE"}}
                        >
                          <option style={this.props.colorDark ? {color:'orange'} : {color:'darkblue'}} value="My Contacts">{myContactX}</option>
                          {userlistRemote.map((todo,i)=>{
                            if (todo.active){
                              if (this.state.userRemoteX === todo.remoteuser) {
                                  return (
                                    <option style={this.props.colorDark ? {color:'orange'} : {color:'darkblue'}} key={i} value={todo.remoteuser} selected>{todo.remoteuser}</option>)
                              }else {
                                 if (todo.remoteuser !== '' && todo.remoteuser !== null){
                                    return (
                                      <option style={this.props.colorDark ? {color:'orange'} : {color:'darkblue'}} key={i} value={todo.remoteuser}>{todo.remoteuser}</option>)
                                 }
                              }
                          }})}
                        </FormSelect>
                    </td>
                    <td>
                        <FormSelect
                            id="Tags"
                            innerRef={this.cTagList}
                            placeholder=""
                            onChange={this.tagListContracts}
                            style={ this.props.colorDark ? {backgroundColor:"#0b151d", color:'white'} : {backgroundColor:"#F2EACE"}}
                        >
                          <option style={this.props.colorDark ? {color:'orange'} : {color:'darkblue'}} value="My Tags" selected>{myTagX}</option>
                          {tagList.map((todo,i)=>{
                            if (this.state.tagListX !== ''){
                              if (this.state.tagListX === todo.code) {
                                  return (
                                    <option style={this.props.colorDark ? {color:'orange'} : {color:'darkblue'}} key={i} value={todo.code} selected>{todo.code}</option>)
                              }else {
                                  return (
                                    <option style={this.props.colorDark ? {color:'orange'} : {color:'darkblue'}} key={i} value={todo.code}>{todo.code}</option>)
                              }
                            }else{
                              return (
                                <option style={this.props.colorDark ? {color:'orange'} : {color:'darkblue'}} key={i} value={todo.code}>{todo.code}</option>)
                            }
                          })}
                        </FormSelect>
                    </td>
                    <td>
                        <FormSelect
                            id="Active-Inactive"
                            innerRef={this.cActiveInactiveAll}
                            placeholder=""
                            onChange={this.activeInactiveAllContracts}
                            style={ this.props.colorDark ? {backgroundColor:"#0b151d", color:'white'} : {backgroundColor:"#F2EACE"}}
                        >
                           <option style={this.props.colorDark ? {color:'white'} : {color:'darkblue'}} value="Active" selected>{activeX}</option>
                           <option style={this.props.colorDark ? {color:'orange'} : {color:'darkblue'}} value="Inactive">{inactiveX}</option>
                           <option style={this.props.colorDark ? {color:'orange'} : {color:'darkblue'}} value="All">{allX}</option>
                        </FormSelect>
                    </td>
                    <td>
                        <FormSelect
                            id="Carpets"
                            innerRef={this.cCarpetList}
                            placeholder=""
                            onChange={this.carpetListContracts}
                            style={ this.props.colorDark ? {backgroundColor:"#0b151d", color:'white'} : {backgroundColor:"#F2EACE"}}
                        >
                           <option style={this.props.colorDark ? {color:'white'} : {color:'darkblue'}} value="inbox" selected>{inboxX}</option>
                           <option style={this.props.colorDark ? {color:'orange'} : {color:'darkblue'}} value="archive">{archiveX}</option>
                        </FormSelect>
                    </td>
                    <td>
                      <FormSelect
                          id="ContractByPage"
                          innerRef={this.cContractByPage}
                          placeholder=""
                          onChange={this.pageContracts}
                          style={ this.props.colorDark ? {backgroundColor:"#0b151d", color:'white'} : {backgroundColor:"#F2EACE"}}
                        >
                        {jsonPageContracts.map((todo,i)=>{
                          return (
                            <option style={this.props.colorDark ? {color:'orange'} : {color:'darkblue'}}  key={i} value={`${todo.contractbypage}`} selected={todo.default}>{todo.contractbypage}</option>)
                        })}
                      </FormSelect>
                    </td>
                    {this.state.showLoader ?
                        <td>
                           <ContractLoader colorDark={this.props.colorDark} /> &nbsp;&nbsp;
                        </td>
                    :
                        <td>
                           <Button outline pill theme="warning" size="sm" className="mb-2" onClick={this.listContractPreviousPrevious}>
                               <i className="material-icons mr-1">replay</i> <FormattedMessage id="contract.refresh" />
                           </Button>
                        </td>
                    }
                  </tr>
                </tbody>
              </Table>
            </div>
          )
      }

      displayConfigContractArchive(pathname) {
          let inboxX=''
          let archiveX=''
          let trashX=''
          if (this.state.language === 'English'){inboxX='Execution Documents'; archiveX='Archived Documents'; trashX='Trash'}
          if (this.state.language === 'French'){inboxX=`Documents d'exécution`; archiveX='Documents archivés'; trashX='Corbeille'}
          if (this.state.language === 'Spanish'){inboxX='Documentos en ejecución'; archiveX='Documentos Archivados'; trashX='Papelera'}
          if (this.state.language === 'Portuguese'){inboxX='Documentos de execução'; archiveX='Documentos Arquivados'; trashX='Reciclagem'}
          if (this.state.language === 'Swedish'){inboxX='Utförande dokument'; archiveX='Arkiverade dokument'; trashX='Papperskorg'}
          if (this.state.language === 'Netherlands'){inboxX='Uitvoeringsdocumenten'; archiveX='Gearchiveerde documenten'; trashX='Prullenbak'}
          if (this.state.language === 'Russian'){inboxX='Оформление документов'; archiveX='Архивные документы'; trashX='Kорзина'}
          if (this.state.language === 'Japanese'){inboxX='実行文書'; archiveX='アーカイブされたドキュメント'; trashX='バスケット'}
          if (this.state.language === 'Chinese'){inboxX='執行文件'; archiveX='存檔文件'; trashX='垃圾'}
          if (this.state.language === 'German'){inboxX='Ausführungsdokumente'; archiveX='Archivierte Dokumente'; trashX='Gelöscht'}
          if (this.state.language === 'Italian'){inboxX='Documenti di esecuzione'; archiveX='Documenti archiviati'; trashX='Cestino'}

          let true10=false,true15=false,true20=false,true50=false,true100=false,true500=false;
          if (this.state.pageContracts===10){true10=true}
          if (this.state.pageContracts===15){true15=true}
          if (this.state.pageContracts===20){true20=true}
          if (this.state.pageContracts===50){true50=true}
          if (this.state.pageContracts===100){true100=true}
          if (this.state.pageContracts===500){true100=true}
          const jsonPageContracts = [{contractbypage:'10',default:true10},{contractbypage:'15',default:true15},{contractbypage:'20',default:true20},{contractbypage:'50',default:true50},{contractbypage:'100',default:true100},{contractbypage:'500',default:true500}]

          return (
            <div>
              <Table style={{"color": 'black'}} borderless size="sm">
                <tbody>
                  <tr>
                    <td>
                        <FormSelect
                            id="Carpets"
                            innerRef={this.cCarpetList}
                            placeholder=""
                            onChange={this.carpetListContracts}
                            style={ this.props.colorDark ? {backgroundColor:"#0b151d", color:'white'} : {backgroundColor:"#F2EACE"}}
                        >
                           <option style={this.props.colorDark ? {color:'orange'} : {color:'darkblue'}} value="inbox">{inboxX}</option>
                           <option style={this.props.colorDark ? {color:'orange'} : {color:'darkblue'}} value="archive" selected>{archiveX}</option>
                           {/*<option value="trash">{trashX}</option>*/}
                        </FormSelect>
                    </td>
                  </tr>
                </tbody>
              </Table>
            </div>
          )
      }

      displayArrowCollapsed(titleX, messageSubtittle, titleX2, messageSubtittle2) {
          let enterDrawerRight = false
          let enterDrawerLeft = false
          if (this.state.existContract===true){
              enterDrawerRight = true
          }
          if (this.state.existContract===true){
            enterDrawerLeft = true
          }
          let openSidebar = "Open Sidebar"
          let closeSidebar = "Close Sidebar"
          if (this.state.language === 'English'){openSidebar = "Open Sidebar"; closeSidebar = "Close Sidebar";}
          if (this.state.language === 'French'){openSidebar = "Ouvrez la Barre Latérale"; closeSidebar = "Fermez la Barre Latérale";}
          if (this.state.language === 'Spanish'){openSidebar = "Abrir la Barra Lateral"; closeSidebar = "Cerrar la Barra Lateral";}
          if (this.state.language === 'Portuguese'){openSidebar = "Abra a Barra Lateral"; closeSidebar = "Feche a Barra lLeral";}
          if (this.state.language === 'Swedish'){openSidebar = "Öppna Sidofältet"; closeSidebar = "Stäng Sidofältet";}
          if (this.state.language === 'Netherlands'){openSidebar = "Open de Zijbalk"; closeSidebar = "Sluit de Zijbalk";}
          if (this.state.language === 'Russian'){openSidebar = "Откройте боковую панель"; closeSidebar = "Закройте боковую панель";}
          if (this.state.language === 'Japanese'){openSidebar = "サイドバーを開く"; closeSidebar = "サイドバーを閉じる";}
          if (this.state.language === 'Chinese'){openSidebar = "打開邊欄"; closeSidebar = "關閉側邊欄";}
          if (this.state.language === 'German'){openSidebar = "Öffnen Sie die Seitenleiste"; closeSidebar = "Schließen Sie die Seitenleiste";}
          if (this.state.language === 'Italian'){openSidebar = "Apri la Barra Laterale"; closeSidebar = "Chiudi la Barra Laterale";}

          let titleX3 = ''
          if (messageSubtittle2 === null || messageSubtittle2 === ''){
            titleX3 = `${titleX2}`
          }else{
            titleX3 = `${titleX2} / ${messageSubtittle2}`
          }

          return (
            <div>
              <Container fluid className="main-content-container px-2" style={ this.props.colorDark ? { backgroundColor:'#0b151d'} : {}}>

                  <Table borderless responsive>
                    <tbody>
                      <tr>
                        <td style={{width: "3%"}}>
                          {enterDrawerLeft ?
                            <Row noGutters className="page-header py-2">
                                <TemporaryDrawerLeft typeContract={this.state.icontypeContract}
                                                 numberContract={this.state.iconconfigurationContractNumber}
                                                 title={titleX2}
                                                 subtitle={messageSubtittle2}
                                                 userRole={this.state.whatUserRole}
                                                 userOrigin={this.state.whatUserOrigin}
                                                 openSidebar={openSidebar}
                                                 closeSidebar={closeSidebar}
                                                 documentSidebarStartsOpen={this.state.documentSidebarStartsOpen}
                                                 encryptDecryptFile={this.state.encryptDecryptFile}
                                                 encryptDecryptFileContract={this.state.encryptDecryptFileContract}
                                                 colorDark={this.props.colorDark}
                                 />
                            </Row>
                          : null }
                        </td>
                        <td style={{width: "94%"}}>
                          <Row noGutters className="page-header py-2">
                            <TituloPagina3
                              sm="10"
                              title={titleX3}
                              subtitle={messageSubtittle}
                              className="text-center"
                            />
                          </Row>
                        </td>
                        <td style={{width: "3%"}}>
                          {enterDrawerRight ?
                            <Row noGutters className="page-header py-2">
                                <TemporaryDrawer typeContract={this.state.icontypeContract}
                                                 numberContract={this.state.iconconfigurationContractNumber}
                                                 title={titleX2}
                                                 subtitle={messageSubtittle2}
                                                 userRole={this.state.whatUserRole}
                                                 userOrigin={this.state.whatUserOrigin}
                                                 openSidebar={openSidebar}
                                                 closeSidebar={closeSidebar}
                                                 documentSidebarStartsOpen={this.state.documentSidebarStartsOpen}
                                                 encryptDecryptFile={this.state.encryptDecryptFile}
                                                 encryptDecryptFileContract={this.state.encryptDecryptFileContract}
                                                 colorDark={this.props.colorDark}
                                                 displayChatDocument={this.state.displayChatDocument}
                                 />
                            </Row>
                          : null }
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </Container>
            </div>
          )
      }

      displayButtonsTab(typeContract, configurationContractNumber, displayRoleX, displayOriginX, displaySubjectX, displayCryptoCurrencyX, displayBlockchainX, displayReportX, displayUserX, displaySignatureX, displayLinkX, displayEyeX, displayChatX, displayTagX, displayAssociatedX, displayRulesX, displayDocumentX, displayShareX, displayActiveParticipantsX, displayDeliverableX, displayFormsDeliverableX, displayAuthorizersDeliverableX, displayRolDeliverableX, displayTagDeliverableX, displayReporteTurnoDeliverableX, displayLifeCycleX, displayRegisterX){
        let modeContractX = false
        if (this.state.modeContract === 'button'){
          modeContractX = true
        }
        let displayRoleX2 = false
        if (displayRoleX === 'Support'){
          displayRoleX2 = true
          modeContractX = false
        }
        const templatesAllLocalX = this.state.templatesAllLocal

        let paymentform = true
        let participants = true
        let pay = true
        let certification = true
        let trace = true
        let deliverable = true
        let network = true
        let addons = true
        let certificates = true

        let activarparticipants = true
        let certificarfirma = true
        let activarentregable = true
        let certificarreglas = true

        let selectedSignaturePaymentX = false
        if (this.state.selectedSignaturePayment === 'SignatureAndPayment'){
          selectedSignaturePaymentX = true
        }

        templatesAllLocalX.map((todoTemplate,t) => {
           if (todoTemplate.secondaryName === typeContract){

             if (todoTemplate.paymentform === undefined){  paymentform = true }else{ paymentform = todoTemplate.paymentform}
             if (todoTemplate.participants === undefined){  participants = true }else{ participants = todoTemplate.participants}
             if (todoTemplate.pay === undefined){  pay = true }else{ pay = todoTemplate.pay}
             if (todoTemplate.certification === undefined){  certification = true }else{ certification = todoTemplate.certification}
             if (todoTemplate.trace === undefined){  trace = true }else{ trace = todoTemplate.trace}
             if (todoTemplate.deliverable === undefined){  deliverable = true }else{ deliverable = todoTemplate.deliverable}
             if (todoTemplate.network === undefined){  network = true }else{ network = todoTemplate.network}
             if (todoTemplate.addons === undefined){  addons = true }else{ addons = todoTemplate.addons}
             if (todoTemplate.certificates === undefined){  certificates = true }else{ certificates = todoTemplate.certificates}

             if (todoTemplate.activarparticipants === undefined){  activarparticipants = true }else{ activarparticipants = todoTemplate.activarparticipants}
             if (todoTemplate.certificarfirma === undefined){  certificarfirma = true }else{ certificarfirma = todoTemplate.certificarfirma}
             if (todoTemplate.activarentregable === undefined){  activarentregable = true }else{ activarentregable = todoTemplate.activarentregable}
             if (todoTemplate.certificarreglas === undefined){  certificarreglas = true }else{ certificarreglas = todoTemplate.certificarreglas}

             const jsonBlockstackZX = this.state.jsonBlockstackZ

             jsonBlockstackZX.map((todo,key)=>{
                 if (todo.code === displayRoleX){
                   if (paymentform){ paymentform = todo.paymentform }
                   if (participants){ participants = todo.participants }
                   if (pay){ pay = todo.pay }
                   if (certification){ certification = todo.certification}
                   if (trace){ trace = todo.trace }
                   if (deliverable){ deliverable = todo.deliverable}
                   if (network){ network = todo.network }
                   if (addons){ addons = todo.addons}
                   if (certificates){ certificates = todo.certificates}
                 }
             })
           }

        })

        return (
          <div>
              <ContractTab typeContract={typeContract}
                           configurationContractNumber={configurationContractNumber}
                           displayRoleX={displayRoleX}
                           displayOriginX={displayOriginX}
                           displaySubjectX={displaySubjectX}
                           username={this.state.username}
                           displayCryptoCurrencyX={displayCryptoCurrencyX}
                           displayBlockchainX={displayBlockchainX}
                           displayReportX={displayReportX}
                           displayUserX={displayUserX}
                           displaySignatureX={displaySignatureX}
                           displayRegisterX={displayRegisterX}
                           displayLinkX={displayLinkX}
                           displayEyeX={displayEyeX}
                           displayChatX={displayChatX}
                           displayTagX={displayTagX}
                           displayAssociatedX={displayAssociatedX}
                           displayRulesX={displayRulesX}
                           displayDocumentX={displayDocumentX}
                           displayShareX={displayShareX}
                           displayActiveParticipantsX={displayActiveParticipantsX}
                           displayDeliverableX={displayDeliverableX}
                           displayFormsDeliverableX={displayFormsDeliverableX}
                           displayAuthorizersDeliverableX={displayAuthorizersDeliverableX}
                           displayRolDeliverableX={displayRolDeliverableX}
                           displayTagDeliverableX={displayTagDeliverableX}
                           displayReporteTurnoDeliverableX={displayReporteTurnoDeliverableX}
                           displayDocument={this.state.displayDocument}
                           displayRoleX2={displayRoleX2}
                           modeContractX={modeContractX}
                           buttonArrow1={this.buttonArrow1}
                           buttonArrow2={this.buttonArrow2}
                           buttonArrow3={this.buttonArrow3}
                           button0={this.button0}
                           button1={this.button1}
                           button2={this.button2}
                           button3={this.button3}
                           button4={this.button4}
                           button5={this.button5}
                           button6={this.button6}
                           button7={this.button7}
                           button8={this.button8}
                           button9={this.button9}
                           button10={this.button10}
                           button11={this.button11}
                           button12={this.button12}
                           button13={this.button13}
                           button14={this.button14}
                           button15={this.button15}
                           button16={this.button16}
                           button17={this.button17}
                           button18={this.button18}
                           button19={this.button19}
                           button20={this.button20}
                           button21={this.button21}
                           button22={this.button22}
                           button23={this.button23}
                           button24={this.button24}
                           button25={this.button25}
                           button26={this.button26}
                           button27={this.button27}
                           button28={this.button28}
                           button29={this.button29}
                           button30={this.button30}
                           backTypeContract={this.backTypeContract}
                           editListContractDialog={this.editListContractDialog}
                           icondisplayOriginX={this.state.icondisplayOriginX}
                           icondisplayRoleX={this.state.icondisplayRoleX}
                           icontypeContract={this.state.icontypeContract}
                           iconconfigurationContractNumber={this.state.iconconfigurationContractNumber}
                           ningunoSign={this.state.ningunoSign}
                           algunosSign={this.state.algunosSign}
                           todosSign={this.state.todosSign}
                           ningunoDevice={this.state.ningunoDevice}
                           algunosDevice={this.state.algunosDevice}
                           todosDevice={this.state.todosDevice}
                           icondisplayRoleX={this.state.icondisplayRoleX}
                           icondisplayOriginX={this.state.icondisplayOriginX}
                           activeContract={this.state.activeContract}
                           nameContractEditor={this.state.nameContractEditor}
                           icondisplayReportX={this.state.icondisplayReportX}
                           icondisplayUserX={this.state.icondisplayUserX}
                           icondisplaySignatureX={this.state.icondisplaySignatureX}
                           icondisplayRegisterX={this.state.icondisplayRegisterX}
                           icondisplayLinkX={this.state.icondisplayLinkX}
                           icondisplayEyeX={this.state.icondisplayEyeX}
                           icondisplayChatX={this.state.icondisplayChatX}
                           icondisplayTagX={this.state.icondisplayTagX}
                           icondisplaySubjectX={this.state.icondisplaySubjectX}
                           icondisplayCryptoCurrencyX={this.state.icondisplayCryptoCurrencyX}
                           icondisplayBlockchainX={this.state.icondisplayBlockchainX}
                           icondisplayAssociatedX={this.state.icondisplayAssociatedX}
                           icondisplayRulesX={this.state.icondisplayRulesX}
                           icondisplayDocumentX={this.state.icondisplayDocumentX}
                           icondisplayShareX={this.state.icondisplayShareX}
                           icondisplayActiveParticipantsX={this.state.icondisplayActiveParticipantsX}
                           icondisplayDeliverableX={this.state.icondisplayDeliverableX}
                           icondisplayFormsDeliverableX={this.state.icondisplayFormsDeliverableX}
                           icondisplayAuthorizersDeliverableX={this.state.icondisplayAuthorizersDeliverableX}
                           icondisplayRolDeliverableX={this.state.icondisplayRolDeliverableX}
                           icondisplayTagDeliverableX={this.state.icondisplayTagDeliverableX}
                           icondisplayReporteTurnoDeliverableX={this.state.icondisplayReporteTurnoDeliverableX}
                           displayStringTagX={this.state.displayStringTagX}
                           displayColourTagX={this.state.displayColourTagX}
                           displayColourLetterTagX={this.state.displayColourLetterTagX}
                           active_after_publishedX={this.state.active_after_publishedX}
                           displayCircleGreenX={this.state.displayCircleGreenX}
                           pageContracts={this.state.pageContracts}
                           scrollEnd={this.state.scrollEnd}
                           activeUserGroupX={this.state.activeUserGroupX}
                           confirmSignX={this.state.confirmSignX}
                           confirmRegisterX={this.state.confirmRegisterX}
                           activeDeliverableX={this.state.activeDeliverableX}
                           activeDataDashboardX={this.state.activeDataDashboardX}
                           encryptDecryptFileContractX={this.state.encryptDecryptFileContract}
                           encryptDecryptFileX={this.state.encryptDecryptFile}
                           paymentform={paymentform}
                           participants={participants}
                           pay={pay}
                           certification={certification}
                           trace={trace}
                           deliverable={deliverable}
                           network={network}
                           addons={addons}
                           certificates={certificates}
                           activarparticipants={activarparticipants}
                           certificarfirma={certificarfirma}
                           activarentregable={activarentregable}
                           certificarreglas={certificarreglas}
                           displayLifeCycleX={displayLifeCycleX}
                           colorDark={this.props.colorDark}
                           selectedSignaturePaymentX={selectedSignaturePaymentX}
                           deliverableFormsX={this.state.deliverableFormsX}
                           active_after_publishedX={this.state.active_after_publishedX}
              />
          </div>
         )
      }

      buttonSetState = () =>{
        this.setState({displayTemplateDetail: false,searchContract2: false,displayBlockchain: false,displayCryptoCurrency: false,displayDocument: false, displayRules: false,displayAssociated: false,displayShare: false,displayActiveParticipants: false,displayUser: false,displaySign: false,displayRegister: false,displayLink: false,displayAttach: false,displayDashboard: false,displayDeliverable: false,displayFormsDeliverable: false, displayAuthorizersDeliverable:false, displayRolDeliverable:false, displayTagDeliverable:false, displayReporteTurnoDeliverable:false, displayInformeDeliverable:false, displayReport: false,signTrue: true,dialogOpenContractExist: false,modeDisplayCollapsed: false,deleteListContract: false,editListContract: false, generatePdfX: false, displayCertificatePaymentsMade: false, displayCertificateContract: false})
      }

      buttonSetState2 = (typeContract,configurationContractNumber,displaySubjectX,displayRoleX) =>{
        this.setState({ modeContract: 'button', searchContract2: false, displayLink: false, displayAttach: false, displayBlockchain: false, displayCryptoCurrency: false, displayDocument: false, displayRules: false, displayAssociated: false, displayShare: false,displayActiveParticipants: false, displayUser: false, displaySign: false, displayRegister: false, displayDashboard: false, displayDeliverable: false, displayFormsDeliverable: false, displayAuthorizersDeliverable:false, displayRolDeliverable:false, displayTagDeliverable:false, displayReporteTurnoDeliverable:false, displayInformeDeliverable:false, displayReport: false, displayChat: false, displayTag: false, displayPaymentForm: false, displayPay: false, typeContractTable: typeContract, numberContractTable: configurationContractNumber, subjectContractTable: displaySubjectX, whatUserRole: displayRoleX, generatePdfX: false, displayCertificatePaymentsMade: false, displayCertificateContract: false})
      }

      buttonSetState3 = () =>{
        this.setState({ modeContract: 'button', searchContract2: false, displayLink: false, displayAttach: false, displayBlockchain: false, displayCryptoCurrency: false, displayDocument: false, displayRules: false, displayAssociated: false, displayShare: false,displayActiveParticipants: false, displayUser: false, displaySign: false, displayRegister: false, displayDashboard: false, displayDeliverable: false, displayFormsDeliverable: false, displayAuthorizersDeliverable:false, displayRolDeliverable:false, displayTagDeliverable:false, displayReporteTurnoDeliverable:false, displayInformeDeliverable:false, displayReport: false, displayChat: false, displayTag: false, displayPaymentForm: false, displayPay: false, generatePdfX: false, displayCertificatePaymentsMade: false, displayCertificateContract: false})
      }

      buttonArrow1(e, icontypeContract, iconconfigurationContractNumber, ningunoSign, algunosSign, todosSign, ningunoDevice, algunosDevice, todosDevice, icondisplayRoleX, icondisplayOriginX, activeContract, nameContractEditor, icondisplayReportX, icondisplayUserX, icondisplaySignatureX, icondisplayLinkX, icondisplayEyeX, icondisplayChatX, icondisplayTagX, icondisplaySubjectX, icondisplayCryptoCurrencyX, icondisplayBlockchainX, icondisplayAssociatedX, icondisplayRulesX, icondisplayDocumentX, icondisplayShareX, icondisplayActiveParticipantsX, icondisplayDeliverableX, icondisplayFormsDeliverableX, icondisplayAuthorizersDeliverableX, icondisplayRolDeliverableX, icondisplayTagDeliverableX, icondisplayReporteTurnoDeliverableX, displayStringTagX, displayColourTagX, displayCircleGreenX, displayActiveUserGroupX, displayConfirmSignX, displayActiveDeliverableX, displayActiveDataDashboardX, displayRoleX, displayOriginX, encryptDecryptFileContractX, encryptDecryptFileX, displayLifeCycleX, icondisplayRegisterX, displayConfirmRegisterX, signaturePaymentX, displayColourLetterTagX, active_after_publishedX){
        this.setState({encryptDecryptFile: encryptDecryptFileX, generatePdfX: false, displayCertificatePaymentsMade: false, displayCertificateContract: false })
        this.editListContractDialog(e, 0, icondisplayOriginX, icondisplayRoleX, icontypeContract, iconconfigurationContractNumber, ningunoSign, algunosSign, todosSign, ningunoDevice, algunosDevice, todosDevice, displayRoleX, displayOriginX, activeContract, nameContractEditor, icondisplayReportX, icondisplayUserX, icondisplaySignatureX, icondisplayLinkX, icondisplayEyeX, icondisplayChatX, icondisplayTagX, icondisplaySubjectX, icondisplayCryptoCurrencyX, icondisplayBlockchainX, icondisplayAssociatedX, icondisplayRulesX, icondisplayDocumentX, icondisplayShareX, icondisplayActiveParticipantsX, icondisplayDeliverableX, icondisplayFormsDeliverableX, icondisplayAuthorizersDeliverableX, icondisplayRolDeliverableX, icondisplayTagDeliverableX, icondisplayReporteTurnoDeliverableX, displayStringTagX, displayColourTagX, displayCircleGreenX, displayActiveUserGroupX, displayConfirmSignX, displayActiveDeliverableX, displayActiveDataDashboardX, encryptDecryptFileContractX, displayLifeCycleX, icondisplayRegisterX, displayConfirmRegisterX, signaturePaymentX, displayColourLetterTagX, active_after_publishedX)
      }
      buttonArrow2(){
        this.listContractPreviousPrevious()
      }
      buttonArrow3(pageContractsX,scrollEndX){
        this.setState({pageContracts: pageContractsX, scrollEnd: scrollEndX })
        this.buttonSetState()
        this.listContractPreviousPrevious()
      }
      button0(){
        this.buttonSetState3()
      }
      button1(
        e,
        icontypeContract,
        iconconfigurationContractNumber,
        ningunoSign,
        algunosSign,
        todosSign,
        ningunoDevice,
        algunosDevice,
        todosDevice,
        icondisplayRoleX,
        icondisplayOriginX,
        activeContract,
        nameContractEditor,
        icondisplayReportX,
        icondisplayUserX,
        icondisplaySignatureX,
        icondisplayLinkX,
        icondisplayEyeX,
        icondisplayChatX,
        icondisplayTagX,
        icondisplaySubjectX,
        icondisplayCryptoCurrencyX,
        icondisplayBlockchainX,
        icondisplayAssociatedX,
        icondisplayRulesX,
        icondisplayDocumentX,
        icondisplayShareX,
        icondisplayActiveParticipantsX,
        icondisplayDeliverableX,
        icondisplayFormsDeliverableX,
        icondisplayAuthorizersDeliverableX,
        icondisplayRolDeliverableX,
        icondisplayTagDeliverableX,
        icondisplayReporteTurnoDeliverableX,
        displayStringTagX,
        displayColourTagX,
        displayCircleGreenX,
        displayActiveUserGroupX,
        displayConfirmSignX,
        displayActiveDeliverableX,
        displayActiveDataDashboardX,
        displayRoleX,
        displayOriginX,
        encryptDecryptFileContractX,
        encryptDecryptFileX,
        displayLifeCycleX,
        icondisplayRegisterX,
        displayConfirmRegisterX,
        signaturePaymentX,
        displayColourLetterTagX,
        active_after_publishedX){

        this.setState({whatUserRole: displayRoleX, displayProformaSearchSender: false,displayProformaSearchReceiver: false, encryptDecryptFile: encryptDecryptFileX, generatePdfX: false })

        this.editListContractDialog(
          e,
          0,
          icondisplayOriginX,
          icondisplayRoleX,
          icontypeContract,
          iconconfigurationContractNumber,
          ningunoSign,
          algunosSign,
          todosSign,
          ningunoDevice,
          algunosDevice,
          todosDevice,
          displayRoleX,
          displayOriginX,
          activeContract,
          nameContractEditor,
          icondisplayReportX,
          icondisplayUserX,
          icondisplaySignatureX,
          icondisplayLinkX,
          icondisplayEyeX,
          icondisplayChatX,
          icondisplayTagX,
          icondisplaySubjectX,
          icondisplayCryptoCurrencyX,
          icondisplayBlockchainX,
          icondisplayAssociatedX,
          icondisplayRulesX,
          icondisplayDocumentX,
          icondisplayShareX,
          icondisplayActiveParticipantsX,
          icondisplayDeliverableX,
          icondisplayFormsDeliverableX,
          icondisplayAuthorizersDeliverableX,
          icondisplayRolDeliverableX,
          icondisplayTagDeliverableX,
          icondisplayReporteTurnoDeliverableX,
          displayStringTagX,
          displayColourTagX,
          displayCircleGreenX,
          displayActiveUserGroupX,
          displayConfirmSignX,
          displayActiveDeliverableX,
          displayActiveDataDashboardX,
          encryptDecryptFileContractX,
          displayLifeCycleX,
          icondisplayRegisterX,
          displayConfirmRegisterX,
          signaturePaymentX,
          displayColourLetterTagX,
          active_after_publishedX)
      }
      button2(typeContract, configurationContractNumber, displaySubjectX, displayAssociatedX, displayRoleX){
        this.buttonSetState2(typeContract,configurationContractNumber,displaySubjectX,displayRoleX)
        if (displayAssociatedX !== "images/associated2Grey25p.png"){
          if (displayRoleX==="Creator"){
            this.setState({displayAssociated: true});
          }
        }
      }
      button3(typeContract, configurationContractNumber, displaySubjectX, displayRulesX, displayRoleX){
        this.buttonSetState2(typeContract,configurationContractNumber,displaySubjectX,displayRoleX)
        if (displayRulesX !== "images/rulesGrey25p.png"){
          if (displayRoleX==="Creator"){
            this.setState({displayRules: true});
          }
        }
      }
      button4(typeContract, configurationContractNumber, displaySubjectX, displayReportX, displayRoleX, displayOriginX){
        this.buttonSetState2(typeContract,configurationContractNumber,displaySubjectX,displayRoleX)
        this.setState({ whatUserOrigin: displayOriginX})
        if (displayReportX !== "images/attachGrey25p.png"){
          if (displayRoleX==="Authorizer" || displayRoleX==="Authorizer-Inviter" || displayRoleX==="Observer" || displayRoleX==="PayTo"){
            new Promise((resolve11)=>{
              //this.goAttachFile(typeContract,configurationContractNumber,displayOriginX).then(resolve11());
              this.goUserGroupAttachFileCreatorRemoto(typeContract,configurationContractNumber,displayOriginX).then(resolve11());
               })
               .then(
                 () =>{
                   new Promise((resolve11)=>{
                     this.goAttachFile(typeContract,configurationContractNumber,this.state.username).then(resolve11());
                      })
                      .then(
                        () =>{
                          this.setState({displayAttach: true});
                        }
                      )
                 }
               )
          }else{
            new Promise((resolve11)=>{
              this.goUserGroupAttachFileCreator(typeContract,configurationContractNumber).then(resolve11());
               })
               .then(
                 () =>{
            this.setState({displayAttach: true});
                 }
               )
          }
        }
      }
      button5(typeContract, configurationContractNumber, displaySubjectX, displayUserX, displayRoleX, displayOriginX,displayActiveUserGroupX){
        this.buttonSetState2(typeContract,configurationContractNumber,displaySubjectX,displayRoleX)
        this.setState({ whatUserOrigin: displayOriginX, activeUserGroupX: displayActiveUserGroupX})
        if (displayRoleX==="Creator"){
            if (displayUserX !== "images/userRed.png"){
                new Promise((resolve11)=>{
                  this.goUserGroup(typeContract,configurationContractNumber).then(resolve11());
                   })
                   .then(
                     () =>{
                       new Promise((resolve11)=>{
                         this.goRoleList(typeContract,configurationContractNumber,this.state.username).then(resolve11());
                          })
                          .then(
                            () =>{
                              this.setState({displayUser: true})
                              this.setState({displaySign: false})
                              this.setState({displayRegister: false})
                            }
                          )
                     }
                   )
              }
        }else{
          if (displayUserX !== "images/userRed.png"){
             if (displayRoleX==="Authorizer" || displayRoleX==="Authorizer-Inviter" || displayRoleX==="Observer"){
                 new Promise((resolve11)=>{
                   this.goUserGroupOrigin(typeContract,configurationContractNumber,displayOriginX).then(resolve11());
                    })
                    .then(
                      () =>{
                        this.setState({displayUser: true})
                      }
                    )
             }
          }
        }
      }
      button6(typeContract, configurationContractNumber, displaySubjectX, displaySignatureX, displayRoleX, displayUserX, confirmSignX, displayRegisterX){
        this.buttonSetState2(typeContract,configurationContractNumber,displaySubjectX,displayRoleX )
        if (displayRoleX==="Creator" || displayRoleX==="Authorizer" || displayRoleX==="Authorizer-Inviter"){
            if (displayUserX !== "images/userRed.png"){
                new Promise((resolve11)=>{
                  this.goSignList(typeContract,configurationContractNumber,displayRoleX).then(resolve11());
                   })
                   .then(
                     () =>{
                       new Promise((resolve11)=>{
                         this.goRoleList(typeContract,configurationContractNumber,this.state.username).then(resolve11());
                          })
                          .then(
                            () =>{
                                this.setState({displaySign: true, confirmSignX});
                            }
                          )
                     }
                   )
            }
        }
      }
      button7(typeContract, configurationContractNumber, displaySubjectX, displayCryptoCurrencyX, displayRoleX){
        this.buttonSetState2(typeContract,configurationContractNumber,displaySubjectX,displayRoleX)
      }
      button8(typeContract, configurationContractNumber, displaySubjectX, displayBlockchainX, displayRoleX){
        this.buttonSetState2(typeContract,configurationContractNumber,displaySubjectX,displayRoleX)
      }
      button9(typeContract, configurationContractNumber, displaySubjectX, displayLinkX, displayRoleX){
        this.buttonSetState2(typeContract,configurationContractNumber,displaySubjectX,displayRoleX)
        if (displayRoleX==="Creator" || displayRoleX==="Support" ){
          if (displayLinkX === "images/linkGrey25pSupport.png"){
            this.alertSupport()
          }else{
            if (displayLinkX !== "images/linkGrey25p.png"){
              new Promise((resolve11)=>{
                this.llenaTablaEnrollment(typeContract,configurationContractNumber).then(resolve11());
                 })
                 .then(
                   () =>{
                       this.setState({displayLink: true});
                   }
                 )
            }
          }
        }
      }
      button10(typeContract, configurationContractNumber, displaySubjectX, displayEyeX, displayRoleX, displayOriginX){
        this.buttonSetState2(typeContract,configurationContractNumber,displaySubjectX,displayRoleX)
        this.setState({ whatUserOrigin: displayOriginX})
        if (displayRoleX !== "Support" && displayEyeX !== "images/eyeGrey25p.png"){
            new Promise((resolve11)=>{
              this.llenaTablaEnrollment(typeContract,configurationContractNumber,displayOriginX).then(resolve11());
               })
               .then(
                 () =>{
                     this.setState({displayDashboard: true});
                 }
               )
        }
      }
      button11(typeContract, configurationContractNumber, displaySubjectX, displayDeliverableX, displayFormsDeliverableX, displayAuthorizersDeliverableX, displayRolDeliverableX, displayTagDeliverableX, displayReporteTurnoDeliverableX, displayRoleX){
        this.buttonSetState2(typeContract,configurationContractNumber,displaySubjectX,displayRoleX)
        this.setState({displayDeliverable: true});
        this.setState({displayFormsDeliverable: false});
        this.setState({displayAuthorizersDeliverable: false});
        this.setState({displayRolDeliverable: false});
        this.setState({displayTagDeliverable: false});
        this.setState({displayInformeDeliverable: false});
        this.setState({displayReporteTurnoDeliverable: false});
      }
      button12(typeContract, configurationContractNumber, displaySubjectX, displayChatX, icondisplayTagX, displayRoleX){
        this.buttonSetState2(typeContract,configurationContractNumber,displaySubjectX,displayRoleX)
        this.setState({whatUserRole: displayRoleX, displayChat: true })
      }
      button13(typeContract, configurationContractNumber, displaySubjectX, displayShareX, displayRoleX){
        this.buttonSetState2(typeContract,configurationContractNumber,displaySubjectX,displayRoleX)
      }
      button14(typeContract, configurationContractNumber, displaySubjectX, displayTagX, displayRoleX){
        this.buttonSetState2(typeContract,configurationContractNumber,displaySubjectX,displayRoleX)
        this.setState({displayTag: true});
      }
      button15(typeContract, configurationContractNumber, displaySubjectX, displayActiveParticipantsX, displayRoleX){
        this.buttonSetState2(typeContract,configurationContractNumber,displaySubjectX,displayRoleX)
        this.setState({displayActiveParticipants: true});
      }
      button16(typeContract, configurationContractNumber, displaySubjectX, displayActiveParticipantsX, displayRoleX){
        this.buttonSetState2(typeContract,configurationContractNumber,displaySubjectX,displayRoleX)
      }
      button17(typeContract, configurationContractNumber, displaySubjectX, displayActiveParticipantsX, displayRoleX){
        this.buttonSetState2(typeContract,configurationContractNumber,displaySubjectX,displayRoleX)
      }
      button18(typeContract, configurationContractNumber, displaySubjectX, displayActiveParticipantsX, displayRoleX){
        this.buttonSetState2(typeContract,configurationContractNumber,displaySubjectX,displayRoleX)
      }

      button19(){
      }

      button20(typeContract, configurationContractNumber, displaySubjectX, displayRoleX){
        this.buttonSetState2(typeContract,configurationContractNumber,displaySubjectX,displayRoleX)
        if (displayRoleX==="Creator"){
           this.setState({displayPaymentForm: true});
        }else{
          this.setState({displayPaymentForm: false});
        }
      }

      button21(typeContract, configurationContractNumber, displaySubjectX, displayRoleX, displayUserX, displayOriginX, displayActiveUserGroupX){
        this.buttonSetState2(typeContract,configurationContractNumber,displaySubjectX,displayRoleX)
        this.setState({ whatUserOrigin: displayOriginX, activeUserGroupX: displayActiveUserGroupX})

        if (displayRoleX==="Creator"){
            new Promise((resolve11)=>{
              this.goUserGroup(typeContract,configurationContractNumber).then(resolve11());
               })
               .then(
                 () =>{
                    this.setState({displayPay: true})
                 })
        }else{
          if (displayRoleX==="Payer"){
             new Promise((resolve11)=>{
               this.goUserGroupOrigin(typeContract,configurationContractNumber,displayOriginX).then(resolve11());
                })
                .then(
                  () =>{
                    this.setState({displayPay: true})
                  }
                )
          }else{
            if (displayRoleX==="PayTo"){
               new Promise((resolve11)=>{
                 this.goUserGroupOrigin(typeContract,configurationContractNumber,displayOriginX).then(resolve11());
                  })
                  .then(
                    () =>{
                      this.setState({displayPay: true})
                    }
                  )
            }else{
              if (displayRoleX!=="Authorizer" && displayRoleX!=="Observer" && displayRoleX!=="Support" ){
                 new Promise((resolve11)=>{
                   this.goUserGroupOrigin(typeContract,configurationContractNumber,displayOriginX).then(resolve11());
                    })
                    .then(
                      () =>{
                        this.setState({displayPay: true})
                      }
                    )
              }else{
                this.setState({displayPay: false});
              }
            }
          }
        }
      }

      button22(typeContract, configurationContractNumber, displaySubjectX, displayRegisterX, displayRoleX, displayUserX, confirmRegisterX){
        this.buttonSetState2(typeContract,configurationContractNumber,displaySubjectX,displayRoleX )
        if (displayRoleX==="Creator" || displayRoleX==="Authorizer" || displayRoleX==="Authorizer-Inviter"){
            if (displayUserX !== "images/userRed.png"){
                new Promise((resolve11)=>{
                  this.goSignList(typeContract,configurationContractNumber,displayRoleX).then(resolve11());
                   })
                   .then(
                     () =>{
                       new Promise((resolve11)=>{
                         this.goRoleList(typeContract,configurationContractNumber,this.state.username).then(resolve11());
                          })
                          .then(
                            () =>{
                              this.setState({displayRegister: true, confirmRegisterX});
                            }
                          )
                     }
                   )
            }
        }
      }

      button23(typeContract, configurationContractNumber, displaySubjectX, displayRoleX, displayUserX, displayOriginX, displayActiveUserGroupX){
        this.buttonSetState2(typeContract,configurationContractNumber,displaySubjectX,displayRoleX)
        this.setState({ whatUserOrigin: displayOriginX, activeUserGroupX: displayActiveUserGroupX})
        this.setState({displayCertificatePaymentsMade: true, displayCertificateContract: false});
      }

      button24(typeContract, configurationContractNumber, displaySubjectX, displayRoleX, displayUserX, displayOriginX, displayActiveUserGroupX){
        this.buttonSetState2(typeContract,configurationContractNumber,displaySubjectX,displayRoleX)
        this.setState({ whatUserOrigin: displayOriginX, activeUserGroupX: displayActiveUserGroupX})
        this.setState({displayCertificatePaymentsMade: false, displayCertificateContract: true});
      }

      button25(typeContract, configurationContractNumber, displaySubjectX, displayDeliverableX, displayFormsDeliverableX, displayAuthorizersDeliverableX, displayRolDeliverableX, displayTagDeliverableX, displayReporteTurnoDeliverableX, displayRoleX){
        this.buttonSetState2(typeContract,configurationContractNumber,displaySubjectX,displayRoleX)
        this.setState({displayDeliverable: false});
        this.setState({displayAuthorizersDeliverable: false});
        this.setState({displayFormsDeliverable: true});
        this.setState({displayRolDeliverable: false});
        this.setState({displayTagDeliverable: false});
        this.setState({displayInformeDeliverable: false});
        this.setState({displayReporteTurnoDeliverable: false});
      }

      button26(typeContract, configurationContractNumber, displaySubjectX, displayDeliverableX, displayFormsDeliverableX, displayAuthorizersDeliverableX, displayRolDeliverableX, displayTagDeliverableX, displayReporteTurnoDeliverableX, displayRoleX){
        this.buttonSetState2(typeContract,configurationContractNumber,displaySubjectX,displayRoleX)
        this.setState({displayDeliverable: false});
        this.setState({displayAuthorizersDeliverable: true});
        this.setState({displayFormsDeliverable: false});
        this.setState({displayRolDeliverable: false});
        this.setState({displayTagDeliverable: false});
        this.setState({displayInformeDeliverable: false});
        this.setState({displayReporteTurnoDeliverable: false});
      }

      button27(typeContract, configurationContractNumber, displaySubjectX, displayDeliverableX, displayFormsDeliverableX, displayAuthorizersDeliverableX, displayRolDeliverableX, displayTagDeliverableX, displayReporteTurnoDeliverableX, displayRoleX){
        this.buttonSetState2(typeContract,configurationContractNumber,displaySubjectX,displayRoleX)
        this.setState({displayDeliverable: false});
        this.setState({displayAuthorizersDeliverable: false});
        this.setState({displayFormsDeliverable: false});
        this.setState({displayRolDeliverable: true});
        this.setState({displayTagDeliverable: false});
        this.setState({displayInformeDeliverable: false});
        this.setState({displayReporteTurnoDeliverable: false});
      }

      button28(typeContract, configurationContractNumber, displaySubjectX, displayDeliverableX, displayFormsDeliverableX, displayAuthorizersDeliverableX, displayRolDeliverableX, displayTagDeliverableX, displayReporteTurnoDeliverableX, displayRoleX){
        this.buttonSetState2(typeContract,configurationContractNumber,displaySubjectX,displayRoleX)
        this.setState({displayDeliverable: false});
        this.setState({displayAuthorizersDeliverable: false});
        this.setState({displayFormsDeliverable: false});
        this.setState({displayRolDeliverable: false});
        this.setState({displayTagDeliverable: true});
        this.setState({displayInformeDeliverable: false});
        this.setState({displayReporteTurnoDeliverable: false});
      }

      button29(typeContract, configurationContractNumber, displaySubjectX, displayDeliverableX, displayFormsDeliverableX, displayAuthorizersDeliverableX, displayRolDeliverableX, displayTagDeliverableX, displayReporteTurnoDeliverableX, displayRoleX){
        this.buttonSetState2(typeContract,configurationContractNumber,displaySubjectX,displayRoleX)
        this.setState({displayDeliverable: false});
        this.setState({displayAuthorizersDeliverable: false});
        this.setState({displayFormsDeliverable: false});
        this.setState({displayRolDeliverable: false});
        this.setState({displayTagDeliverable: false});
        this.setState({displayInformeDeliverable: false});
        this.setState({displayReporteTurnoDeliverable: true});
      }

      button30(typeContract, configurationContractNumber, displaySubjectX, displayDeliverableX, displayFormsDeliverableX, displayAuthorizersDeliverableX, displayRolDeliverableX, displayTagDeliverableX, displayReporteTurnoDeliverableX, displayRoleX){
        this.buttonSetState2(typeContract,configurationContractNumber,displaySubjectX,displayRoleX)
        this.setState({displayDeliverable: false});
        this.setState({displayAuthorizersDeliverable: false});
        this.setState({displayFormsDeliverable: false});
        this.setState({displayRolDeliverable: false});
        this.setState({displayTagDeliverable: false});
        this.setState({displayReporteTurnoDeliverable: false});
        this.setState({displayInformeDeliverable: true});
      }

      displayButtonsTabRed(){
      }

      displayButtons(typeContract, configurationContractNumber, displayRoleX, displayOriginX, displaySubjectX, displayCryptoCurrencyX, displayBlockchainX, displayReportX, displayUserX, displaySignatureX, displayLinkX, displayEyeX, displayChatX, displayTagX, displayAssociatedX, displayRulesX, displayDocumentX, displayShareX, displayDeliverableX, displayFormsDeliverableX, displayAuthorizersDeliverableX, displayRolDeliverableX, displayTagDeliverableX, displayReporteTurnoDeliverableX, displayRegisterX){

        let modeContractX = false
        if (this.state.modeContract === 'button'){
          modeContractX = true
        }
        let displayRoleX2 = false
        if (displayRoleX === 'Support'){
          displayRoleX2 = true
          modeContractX = false
        }

        return (
          <div>
              <Table size="sm" style={{fontSize:10}} className="text-center" borderless responsive hover striped>
              <thead>
                  <tr>
                    <th style={{ width: "60px" }}></th>
                    { this.state.displayDocument ?
                      <React.Fragment>
                        {displayRoleX2 ?
                          <td><img src="images/numberRed1.png" weight="25" height="25" alt=""/></td>
                        :
                          <td><img src="images/number2Green1.png" weight="25" height="25" alt=""/></td>
                        }
                      </React.Fragment>
                    :
                      <td><img src="images/numberRed1.png" weight="25" height="25" alt=""/></td>
                    }
                    { this.state.displayAssociated ?
                      <td><img src="images/number2Green2.png" weight="25" height="25" alt=""/></td>
                    :
                      <td><img src="images/numberRed2.png" weight="25" height="25" alt=""/></td>
                    }
                    { this.state.displayRules ?
                      <td><img src="images/number2Green3.png" weight="25" height="25" alt=""/></td>
                    :
                      <td><img src="images/numberRed3.png" weight="25" height="25" alt=""/></td>
                    }
                    { this.state.displayAttach ?
                      <td><img src="images/number2Green4.png" weight="25" height="25" alt=""/></td>
                    :
                      <td><img src="images/numberRed4.png" weight="25" height="25" alt=""/></td>
                    }
                    { this.state.displayTag ?
                      <td><img src="images/number2Green5.png" weight="25" height="25" alt=""/></td>
                    :
                      <td><img src="images/numberRed5.png" weight="25" height="25" alt=""/></td>
                    }
                    { this.state.displayUser ?
                      <td><img src="images/number2Green6.png" weight="25" height="25" alt=""/></td>
                    :
                      <td><img src="images/numberRed6.png" weight="25" height="25" alt=""/></td>
                    }
                    { this.state.displaySign ?
                      <td><img src="images/number2Green7.png" weight="25" height="25" alt=""/></td>
                    :
                      <td><img src="images/numberRed7.png" weight="25" height="25" alt=""/></td>
                    }
                    { this.state.displayCryptoCurrency ?
                      <td><img src="images/number2Green8.png" weight="25" height="25" alt=""/></td>
                    :
                      <td><img src="images/numberRed8.png" weight="25" height="25" alt=""/></td>
                    }
                    { this.state.displayBlockchain ?
                      <td><img src="images/number2Green9.png" weight="25" height="25" alt=""/></td>
                    :
                      <td><img src="images/numberRed9.png" weight="25" height="25" alt=""/></td>
                    }
                    { this.state.displayLink ?
                      <td><img src="images/number2Green10.png" weight="25" height="25" alt=""/></td>
                    :
                      <td><img src="images/numberRed10.png" weight="25" height="25" alt=""/></td>
                    }
                    { this.state.displayDashboard ?
                      <td><img src="images/number2Green11.png" weight="25" height="25" alt=""/></td>
                    :
                      <td><img src="images/numberRed11.png" weight="25" height="25" alt=""/></td>
                    }
                    { this.state.displayDeliverable ?
                      <td><img src="images/number2Green12.png" weight="25" height="25" alt=""/></td>
                    :
                      <td><img src="images/numberRed12.png" weight="25" height="25" alt=""/></td>
                    }
                    { this.state.displayChat ?
                      <td><img src="images/number2Green13.png" weight="25" height="25" alt=""/></td>
                    :
                      <td><img src="images/numberRed13.png" weight="25" height="25" alt=""/></td>
                    }
                    { this.state.displayShare ?
                      <td><img src="images/number2Green14.png" weight="27" height="27" alt=""/></td>
                    :
                      <td><img src="images/numberRed14.png" weight="27" height="27" alt=""/></td>
                    }
                  </tr>
              </thead>
              <tbody>
                  <tr>
                    { modeContractX ?
                       <>
                         <td>
                           <strong style={{cursor: 'pointer'}} onClick={e=>this.editListContractDialog(e, 0, this.state.icondisplayOriginX, this.state.icondisplayRoleX, this.state.icontypeContract, this.state.iconconfigurationContractNumber, this.state.ningunoSign, this.state.algunosSign, this.state.todosSign, this.state.ningunoDevice, this.state.algunosDevice, this.state.todosDevice, this.state.icondisplayRoleX, this.state.icondisplayOriginX, this.state.activeContract, this.state.nameContractEditor, this.state.icondisplayReportX, this.state.icondisplayUserX, this.state.icondisplaySignatureX, this.state.icondisplayLinkX, this.state.icondisplayEyeX, this.state.icondisplayChatX, this.state.icondisplayTagX, this.state.icondisplaySubjectX, this.state.icondisplayCryptoCurrencyX, this.state.icondisplayBlockchainX, this.state.icondisplayAssociatedX, this.state.icondisplayRulesX, this.state.icondisplayDocumentX, this.state.icondisplayShareX, this.state.icondisplayDeliverableX, this.state.icondisplayFormsDeliverableX, this.state.icondisplayAuthorizersDeliverableX, this.state.icondisplayRolDeliverableX, this.state.icondisplayTagDeliverableX, this.state.icondisplayReporteTurnoDeliverableX, this.state.activeDataDashboardX, this.state.encryptDecryptFileContract, this.state.displayLifeCycleX, this.state.icondisplayRegisterX, this.state.confirmRegisterX, this.state.signatureAndPaymentX)}
                           >
                             {this.props.colorDark ?
                               <>
                                 <img src="images/arrowleftgrey.png" weight="25" height="25" alt=""/>
                               </>
                             :
                               <>
                                   <img src="images/arrowleft.png" weight="25" height="25" alt=""/>
                               </>
                             }
                            </strong>
                         </td>
                       </>
                    :
                       <React.Fragment>

                         {displayRoleX2 ?
                           <td>
                             {this.props.colorDark ?
                               <strong style={{cursor: 'pointer'}} onClick={this.listContract(this.state.username)}><img src="images/arrowleftgrey.png" weight="25" height="25" alt=""/></strong>
                             :
                               <strong style={{cursor: 'pointer'}} onClick={this.listContract(this.state.username)}><img src="images/arrowleft.png" weight="25" height="25" alt=""/></strong>
                             }
                           </td>
                         :
                           <td>
                             {this.props.colorDark ?
                               <strong style={{cursor: 'pointer'}} onClick={this.backTypeContract}><img src="images/arrowleftgrey.png" weight="25" height="25" alt=""/></strong>
                             :
                               <strong style={{cursor: 'pointer'}} onClick={this.backTypeContract}><img src="images/arrowleft.png" weight="25" height="25" alt=""/></strong>
                             }
                           </td>
                         }

                       </React.Fragment>
                    }
                    <td><strong style={{cursor: 'pointer'}} onClick={e=>this.editListContractDialog(e, 0, this.state.icondisplayOriginX, this.state.icondisplayRoleX, this.state.icontypeContract, this.state.iconconfigurationContractNumber, this.state.ningunoSign, this.state.algunosSign, this.state.todosSign, this.state.ningunoDevice, this.state.algunosDevice, this.state.todosDevice, this.state.icondisplayRoleX, this.state.icondisplayOriginX, this.state.activeContract, this.state.nameContractEditor, this.state.icondisplayReportX, this.state.icondisplayUserX, this.state.icondisplaySignatureX, this.state.icondisplayLinkX, this.state.icondisplayEyeX, this.state.icondisplayChatX, this.state.icondisplayTagX, this.state.icondisplaySubjectX, this.state.icondisplayCryptoCurrencyX, this.state.icondisplayBlockchainX, this.state.icondisplayAssociatedX, this.state.icondisplayRulesX, this.state.icondisplayDocumentX, this.state.icondisplayShareX, this.state.icondisplayDeliverableX, this.state.icondisplayFormsDeliverableX, this.state.icondisplayAuthorizersDeliverableX, this.state.icondisplayRolDeliverableX, this.state.icondisplayTagDeliverableX, this.state.icondisplayReporteTurnoDeliverableX, this.state.activeDataDashboardX, this.state.encryptDecryptFileContract, this.state.displayLifeCycleX, this.state.icondisplayRegisterX, this.state.confirmRegisterX, this.state.signatureAndPaymentX)
                       }><img src={displayDocumentX} weight="25" height="25" alt=""/></strong></td>
                    <td><strong style={{cursor: 'pointer'}} onClick={()=>{
                            this.stateContract(typeContract,configurationContractNumber,displaySubjectX,displayRoleX,displayOriginX)
                            if (displayAssociatedX !== "images/associated2Grey25p.png"){
                              if (displayRoleX==="Creator"){
                                this.setState({displayAssociated: true});
                              }
                            }
                        }}><img src={displayAssociatedX} weight="23" height="23" alt=""/></strong></td>
                    <td><strong style={{cursor: 'pointer'}} onClick={()=>{
                            this.stateContract(typeContract,configurationContractNumber,displaySubjectX,displayRoleX,displayOriginX)
                            if (displayTagX !== "images/rulesGrey25p.png"){
                              if (displayRoleX !== "Creator"){
                                this.setState({displayRules: true});
                              }
                            }
                        }}><img src={displayRulesX} weight="25" height="25" alt=""/></strong></td>
                    <td><strong style={{cursor: 'pointer'}} onClick={()=>{
                            this.stateContract(typeContract,configurationContractNumber,displaySubjectX,displayRoleX,displayOriginX)
                            if (displayReportX !== "images/attachGrey25p.png"){
                              if (displayRoleX==="Authorizer" || displayRoleX==="Authorizer-Inviter" || displayRoleX==="Observer" || displayRoleX==="PayTo"){
                                new Promise((resolve11)=>{
                                  //this.goAttachFile(typeContract,configurationContractNumber,displayOriginX).then(resolve11());
                                  this.goUserGroupAttachFileCreatorRemoto(typeContract,configurationContractNumber,displayOriginX).then(resolve11());

                                   })
                                   .then(
                                     () =>{
                                       new Promise((resolve11)=>{
                                         this.goAttachFile(typeContract,configurationContractNumber,this.state.username).then(resolve11());
                                          })
                                          .then(
                                            () =>{
                                              this.setState({displayAttach: true});
                                            }
                                          )
                                     }
                                   )
                              }else{
                                new Promise((resolve11)=>{
                                  this.goUserGroupAttachFileCreator(typeContract,configurationContractNumber).then(resolve11());
                                   })
                                   .then(
                                     () =>{
                                        this.setState({displayAttach: true});
                                     }
                                   )
                              }
                            }
                        }}><img src={displayReportX} weight="25" height="25" alt=""/></strong></td>
                    <td><strong style={{cursor: 'pointer'}} onClick={()=>{
                            this.stateContract(typeContract,configurationContractNumber,displaySubjectX,displayRoleX,displayOriginX)
                            if (displayTagX !== "images/tagGrey25p.png"){
                                this.setState({displayTag: true});
                            }
                        }}><img src={displayTagX} weight="25" height="25" alt=""/></strong></td>
                    <td><strong style={{cursor: 'pointer'}} onClick={()=>{
                            this.stateContract(typeContract,configurationContractNumber,displaySubjectX,displayRoleX,displayOriginX)
                            if (displayRoleX==="Creator"){
                                if (displayUserX !== "images/userRed.png"){
                                    new Promise((resolve11)=>{
                                      this.goUserGroup(typeContract,configurationContractNumber).then(resolve11());
                                       })
                                       .then(
                                         () =>{
                                           new Promise((resolve11)=>{
                                             this.goRoleList(typeContract,configurationContractNumber,this.state.username).then(resolve11());
                                              })
                                              .then(
                                                () =>{
                                                  this.setState({displayUser: true})
                                                  this.setState({displaySign: false})
                                                  this.setState({displayRegister: false})
                                                }
                                              )
                                         }
                                       )
                                }
                            }else{
                              if (displayRoleX==="Authorizer" || displayRoleX==="Authorizer-Inviter" || displayRoleX==="Observer"){
                                if (displayUserX !== "images/userRed.png"){
                                      new Promise((resolve11)=>{
                                        this.goUserGroupOrigin(typeContract,configurationContractNumber,displayOriginX).then(resolve11());
                                         })
                                         .then(
                                           () =>{
                                             this.setState({displayUser: true})
                                           }
                                         )
                                }
                              }
                            }
                        }}><img src={displayUserX} weight="25" height="25" alt=""/></strong></td>
                    <td><strong style={{cursor: 'pointer'}} onClick={()=>{
                            this.stateContract(typeContract,configurationContractNumber,displaySubjectX,displayRoleX,displayOriginX)
                            if (displayRoleX==="Creator" || displayRoleX==="Authorizer" || displayRoleX==="Authorizer-Inviter"){
                                if (displayUserX !== "images/userRed.png"){
                                    new Promise((resolve11)=>{
                                      this.goSignList(typeContract,configurationContractNumber,displayRoleX).then(resolve11());
                                       })
                                       .then(
                                         () =>{
                                           new Promise((resolve11)=>{
                                             this.goRoleList(typeContract,configurationContractNumber,this.state.username).then(resolve11());
                                              })
                                              .then(
                                                () =>{
                                                    this.setState({displaySign: true});
                                                }
                                              )
                                         }
                                       )
                                }
                            }
                        }}><img src={displaySignatureX} weight="25" height="25" alt=""/></strong></td>
                    <td><strong style={{cursor: 'pointer'}}><img src={displayCryptoCurrencyX} weight="25" height="25" alt=""/></strong></td>
                    <td><strong style={{cursor: 'pointer'}}><img src={displayBlockchainX} weight="25" height="25" alt=""/></strong></td>
                    <td><strong style={{cursor: 'pointer'}} onClick={()=>{
                            this.stateContract(typeContract,configurationContractNumber,displaySubjectX,displayRoleX,displayOriginX)
                            if (displayRoleX==="Creator" || displayRoleX==="Support" ){
                              if (displayLinkX === "images/linkGrey25pSupport.png"){
                                this.alertSupport()
                              }else{
                                if (displayLinkX !== "images/linkGrey25p.png"){
                                  new Promise((resolve11)=>{
                                    this.llenaTablaEnrollment(typeContract,configurationContractNumber).then(resolve11());
                                     })
                                     .then(
                                       () =>{
                                           this.setState({displayLink: true});
                                       }
                                     )
                                }
                              }
                            }
                        }}><img src={displayLinkX} weight="25" height="25" alt=""/></strong></td>
                    <td><strong style={{cursor: 'pointer'}} onClick={()=>{
                            this.stateContract(typeContract,configurationContractNumber,displaySubjectX,displayRoleX,displayOriginX)
                            if (displayRoleX !== "Support" && displayEyeX !== "images/eyeGrey25p.png"){
                                new Promise((resolve11)=>{
                                  this.llenaTablaEnrollment(typeContract,configurationContractNumber,displayOriginX).then(resolve11());
                                   })
                                   .then(
                                     () =>{
                                         this.setState({displayDashboard: true});
                                     }
                                   )
                            }
                        }}><img src={displayEyeX} weight="25" height="25" alt=""/></strong></td>
                    <td><strong style={{cursor: 'pointer'}} onClick={()=>{
                            this.stateContract(typeContract,configurationContractNumber,displaySubjectX,displayRoleX,displayOriginX)
                            this.setState({displayDeliverable: true});
                        }}><img src="images/deliverableGrey.png" weight="25" height="25" alt=""/></strong></td>
                    <td><strong style={{cursor: 'pointer'}} onClick={()=>{
                            this.stateContract(typeContract,configurationContractNumber,displaySubjectX,displayRoleX,displayOriginX)
                            this.setState({displayChat: true});
                        }}><img src={displayChatX} weight="25" height="25" alt=""/></strong></td>
                    <td><strong style={{cursor: 'pointer'}}><img src={displayShareX} weight="25" height="25" alt=""/></strong></td>
                  </tr>
                  <tr>
                    <th style={{ width: "60px" }}><FormattedMessage id="contract.listcol19" /></th>
                    <th style={{ width: "60px" }}><FormattedMessage id="contract.listcol17" /></th>
                    <th style={{ width: "60px" }}><FormattedMessage id="configuration.associatedto" /></th>
                    <th style={{ width: "60px" }}><FormattedMessage id="configuration.rules" /></th>
                    <th style={{ width: "60px" }}><FormattedMessage id="contract.listcol9" /></th>
                    <th style={{ width: "60px" }}><FormattedMessage id="configuration.tag" /></th>
                    <th style={{ width: "60px" }}><FormattedMessage id="contract.listcol10" /></th>
                    <th style={{ width: "60px" }}><FormattedMessage id="contract.listcol11" /></th>
                    <th style={{ width: "60px" }}><FormattedMessage id="contract.listcol12" /></th>
                    <th style={{ width: "60px" }}><FormattedMessage id="contract.listcol13" /></th>
                    <th style={{ width: "60px" }}><FormattedMessage id="contract.listcol14" /></th>
                    <th style={{ width: "60px" }}><FormattedMessage id="contract.listcol15" /></th>
                    <th style={{ width: "60px" }}><FormattedMessage id="contract.listcol20" /></th>
                    <th style={{ width: "60px" }}><FormattedMessage id="contract.listcol16" /></th>
                    <th style={{ width: "60px" }}><FormattedMessage id="contract.listcol18" /></th>
                  </tr>
              </tbody>
            </Table>
          </div>
        )
      }

      displayButtonsRed(){
        return (
          <div>
            <Table size="sm"  style={{fontSize:10}} className="text-center" borderless responsive hover striped>
              <thead>
                  <tr>
                    <th style={{ width: "60px" }}></th>
                    <td><img src="images/number2Green1.png" weight="25" height="25" alt=""/></td>
                    <td><img src="images/numberGrey2.png" weight="25" height="25" alt=""/></td>
                    <td><img src="images/numberGrey3.png" weight="25" height="25" alt=""/></td>
                    <td><img src="images/numberGrey4.png" weight="25" height="25" alt=""/></td>
                    <td><img src="images/numberGrey5.png" weight="25" height="25" alt=""/></td>
                    <td><img src="images/numberGrey6.png" weight="25" height="25" alt=""/></td>
                    <td><img src="images/numberGrey7.png" weight="25" height="25" alt=""/></td>
                    <td><img src="images/numberGrey8.png" weight="25" height="25" alt=""/></td>
                    <td><img src="images/numberGrey9.png" weight="25" height="25" alt=""/></td>
                    <td><img src="images/numberGrey10.png" weight="25" height="25" alt=""/></td>
                    <td><img src="images/numberGrey11.png" weight="25" height="25" alt=""/></td>
                    <td><img src="images/numberGrey12.png" weight="25" height="25" alt=""/></td>
                    <td><img src="images/numberGrey13.png" weight="25" height="25" alt=""/></td>
                    <td><img src="images/numberGrey14.png" weight="25" height="25" alt=""/></td>
                  </tr>
              </thead>
              <tbody>
                  <tr>
                    <td>
                      <strong style={{cursor: 'pointer'}} onClick={this.backTypeContract}>
                        {this.props.colorDark ?
                          <>
                            <img src="images/arrowleftgrey.png" weight="25" height="25" alt=""/>
                          </>
                        :
                          <>
                              <img src="images/arrowleft.png" weight="25" height="25" alt=""/>
                          </>
                        }
                      </strong>
                    </td>
                    <td><img src="images/documentGreen.png" weight="25" height="25" alt=""/></td>
                    <td><img src="images/associated2Grey25p.png" weight="23" height="23" alt=""/></td>
                    <td><img src="images/rulesGrey25p.png" weight="25" height="25" alt=""/></td>
                    <td><img src="images/attachGrey25p.png" weight="25" height="25" alt=""/></td>
                    <td><img src="images/tagGrey25p.png" weight="25" height="25" alt=""/></td>
                    <td><img src="images/userGrey25p.png" weight="25" height="25" alt=""/></td>
                    <td><img src="images/signGrey25p.png" weight="25" height="25" alt=""/></td>
                    <td><img src="images/cryptocurrencyGrey25p.png" weight="25" height="25" alt=""/></td>
                    <td><img src="images/blockchainGrey25p.png" weight="25" height="25" alt=""/></td>
                    <td><img src="images/linkGrey25p.png" weight="25" height="25" alt=""/></td>
                    <td><img src="images/eyeGrey25p.png" weight="25" height="25" alt=""/></td>
                    <td><img src="images/deliverableGrey25p.png" weight="25" height="25" alt=""/></td>
                    <td><img src="images/chatGrey25p.png" weight="25" height="25" alt=""/></td>
                    <td><img src="images/shareGrey25p.png" weight="25" height="25" alt=""/></td>
                  </tr>
                  <tr>
                    <th style={{ width: "60px" }}><FormattedMessage id="contract.listcol19" /></th>
                    <th style={{ width: "60px" }}><FormattedMessage id="contract.listcol17" /></th>
                    <th style={{ width: "60px" }}><FormattedMessage id="configuration.associatedto" /></th>
                    <th style={{ width: "60px" }}><FormattedMessage id="configuration.rules" /></th>
                    <th style={{ width: "60px" }}><FormattedMessage id="contract.listcol9" /></th>
                    <th style={{ width: "60px" }}><FormattedMessage id="configuration.tag" /></th>
                    <th style={{ width: "60px" }}><FormattedMessage id="contract.listcol10" /></th>
                    <th style={{ width: "60px" }}><FormattedMessage id="contract.listcol11" /></th>
                    <th style={{ width: "60px" }}><FormattedMessage id="contract.listcol12" /></th>
                    <th style={{ width: "60px" }}><FormattedMessage id="contract.listcol13" /></th>
                    <th style={{ width: "60px" }}><FormattedMessage id="contract.listcol14" /></th>
                    <th style={{ width: "60px" }}><FormattedMessage id="contract.listcol15" /></th>
                    <th style={{ width: "60px" }}><FormattedMessage id="contract.listcol20" /></th>
                    <th style={{ width: "60px" }}><FormattedMessage id="contract.listcol16" /></th>
                    <th style={{ width: "60px" }}><FormattedMessage id="contract.listcol18" /></th>
                  </tr>
              </tbody>
            </Table>
          </div>
        )
      }

      pageContracts(){
        this.setState({pageContracts:parseInt(this.cContractByPage.current.value),
                       scrollEnd:parseInt(this.cContractByPage.current.value),
                       scrollInitial: 1})
        this.listContract(this.state.username)
      }

      userRemoteContracts(){
        if (this.cUserRemote.current.value === 'My Contacts'){
          this.setState({userRemoteX:''})
        }else{
           this.setState({userRemoteX:this.cUserRemote.current.value})
        }
        this.setState({scrollInitial: 1,
                       pageContracts:parseInt(this.cContractByPage.current.value),
                       scrollEnd:parseInt(this.cContractByPage.current.value)})
        this.listContractPrevious()
      }

      tagListContracts(){
        if (this.cTagList.current.value === 'My Tags'){
          this.setState({tagListX:''})
        }else{
           this.setState({tagListX:this.cTagList.current.value})
        }
        this.setState({scrollInitial: 1,
                       pageContracts:parseInt(this.cContractByPage.current.value),
                       scrollEnd:parseInt(this.cContractByPage.current.value)})
        this.listContractPrevious()
      }

      carpetListContracts(){
        this.setState({carpetListX:this.cCarpetList.current.value})
        if (this.cCarpetList.current.value === 'archive'){
           this.getContractListArchive()
        }
      }

      activeInactiveAllContracts(){
        this.setState({activeInactiveAllX:this.cActiveInactiveAll.current.value})
        this.setState({scrollInitial: 1,
                       pageContracts:parseInt(this.cContractByPage.current.value),
                       scrollEnd:parseInt(this.cContractByPage.current.value)})
        this.listContractPrevious()
      }

      getContractListArchive = () => {
        return new Promise ((resolve, reject) =>{
          const {userSession} = this.state
          const storage = new Storage({ userSession });
          const options = { decrypt: false, verify: false }
          let jsonBlockstack4 = []
          var existNewContract3 = false
          this.setState({jsonArchive: []}, () => {
             getFileDB(this.state.username, `contractlistarchive.json`)
              .then((fileContents) => {
                 if(fileContents) {
                   this.setState({existListContract: true})
                   const jsonBlockstack1 = JSON.parse(fileContents)
                   const jsonBlockstack2 = jsonBlockstack1.data
                   let jsonBlockstack5 = '[]'
                   if (jsonBlockstack2 !== null){
                      const jsonBlockstack3 = jsonBlockstack2.dataobject
                      const jsonBlockstack4 = jsonBlockstack3.replace(/\\/g,"");
                      if (jsonBlockstack4.substring(0,1) === '"') {
                         jsonBlockstack5 = jsonBlockstack4.substring(1,jsonBlockstack4.length - 1)
                      } else {
                         jsonBlockstack5 = jsonBlockstack4
                      }
                   }
                   let jsonBlockstack6 = JSON.parse(jsonBlockstack5)
                   this.setState({jsonArchive: jsonBlockstack6})
                 }
                 resolve()
               })
              .catch(error => {
                resolve()
              })
            })
        })
      }

      llenaTablaEnrollment(typeContractTable,numberContractTable,userX) {
          const {userSession} = this.state
          const storage = new Storage({ userSession });
          let options = ''
          if (typeContractTable !== 'simulate'){
            if (userX !== this.state.username ){options = { username: userX, decrypt: false, verify: false }}else{options = { decrypt: false, verify: false }}
          }else{
            options = { decrypt: false, verify: false }
          }
          let user2X = userX
          if (userX === '') { user2X = this.state.username}
          return new Promise ((resolve, reject) =>{
            getFileDB(user2X, `${typeContractTable}_${numberContractTable}_rules.json`)
               .then((fileContents) => {
                 if(fileContents) {
                   const jsonBlockstack1 = JSON.parse(fileContents)
                   const jsonBlockstack2 = jsonBlockstack1.data
                   let jsonBlockstack5 = '[]'
                   if (jsonBlockstack2 !== null){
                      const jsonBlockstack3 = jsonBlockstack2.dataobject
                      const jsonBlockstack4 = jsonBlockstack3.replace(/\\/g,"");
                      if (jsonBlockstack4.substring(0,1) === '"') {
                         jsonBlockstack5 = jsonBlockstack4.substring(1,jsonBlockstack4.length - 1)
                      } else {
                         jsonBlockstack5 = jsonBlockstack4
                      }
                   }
                   let jsonBlockstack6 = JSON.parse(jsonBlockstack5)

                   new Promise((resolve22)=>{this.llenaTablaEnrollment2(jsonBlockstack6,typeContractTable,numberContractTable);
                     resolve22();
                      })
                      .then(
                        () =>{
                            resolve();
                        }
                      )
                 } else {
                     resolve();
                 }
               })
                .catch(error => {
                   resolve();
               })
          })
      }

      llenaTablaEnrollment2(jsonBlockstack7,typeContractTable,numberContractTable){
        const {userSession} = this.state
        const storage = new Storage({ userSession });
        let options = ''
        let user2X = this.state.username
        if (typeContractTable !== 'simulate'){
          if (this.state.whatUserOrigin !== this.state.username ){
             options = { username: this.state.whatUserOrigin, decrypt: false, verify: false }
             user2X = this.state.whatUserOrigin
          }else{
             options = { decrypt: false, verify: false }
          }
        }else{
          options = { decrypt: false, verify: false }
        }
        let jsonBlockstack4cx = []
        let largo = 0
        this.setState({jsonEnrollmentChange: []})
        return new Promise ((resolve2) =>{
            jsonBlockstack7.map((todo,i) => {
              getFileDB(user2X, `${typeContractTable}_${numberContractTable}_${todo.enrollment}_device.json`)
                 .then((fileContents) => {
                   if(fileContents) {
                     const jsonBlockstack1 = JSON.parse(fileContents)
                     const jsonBlockstack2 = jsonBlockstack1.data
                     let jsonBlockstack5 = '[]'
                     if (jsonBlockstack2 !== null){
                        const jsonBlockstack3 = jsonBlockstack2.dataobject
                        const jsonBlockstack4 = jsonBlockstack3.replace(/\\/g,"");
                        if (jsonBlockstack4.substring(0,1) === '"') {
                           jsonBlockstack5 = jsonBlockstack4.substring(1,jsonBlockstack4.length - 1)
                        } else {
                           jsonBlockstack5 = jsonBlockstack4
                        }
                     }
                     let jsonBlockstack6 = JSON.parse(jsonBlockstack5)

                     jsonBlockstack4cx = JSON.parse(jsonBlockstack5)

                     if (jsonBlockstack4cx.length === 0){
                       todo.link = "images/linkbrokenRed.png"
                       todo.sensor = "images/sensorRed.png"
                       todo.dashboard = "images/eyeRed.png"
                       this.setState({jsonEnrollmentChange: jsonBlockstack7})
                     }else{
                       let yesSensor = false
                       let noSensor = false
                       largo = jsonBlockstack4cx.length
                       jsonBlockstack4cx.map((todo2,j) => {
                         if (todo2.activate){
                            yesSensor = true
                         }else{
                            noSensor = true
                         }
                         if (yesSensor && noSensor){
                            todo.sensor = "images/sensorOrange.png"
                            todo.dashboard = "images/eyeRed.png"
                            todo.link = "images/linkOrange.png"
                         }
                         if (yesSensor && !noSensor){
                            todo.sensor = "images/sensorGreen.png"
                            todo.dashboard = "images/eyeGreen.png"
                            todo.link = "images/linkGreen.png"
                         }
                         if (!yesSensor && noSensor){
                            todo.sensor = "images/sensorRed.png"
                            todo.dashboard = "images/eyeRed.png"
                            todo.link = "images/linkOrange.png"
                         }
                         if (!yesSensor && !noSensor){
                            todo.sensor = "images/sensorRed.png"
                            todo.dashboard = "images/eyeRed.png"
                            todo.link = "images/linkOrange.png"
                         }
                         if (j === largo-1){
                           this.setState({jsonEnrollmentChange: jsonBlockstack7})
                           resolve2();
                         }
                       })
                     }
                   } else {
                     todo.link = "images/linkbrokenRed.png"
                     todo.sensor = "images/sensorRed.png"
                     todo.dashboard = "images/eyeRed.png"
                     this.setState({jsonEnrollmentChange: jsonBlockstack7})
                     resolve2();
                   }
                 })
                  .catch(error => {
                    resolve2();
                });
            })
        })
      }

      goSignList(typeContract,numberContract,displayRole) {
        this.setState({idx: this.props.numberContract})
        this.setState({jsonBlockstackY: []})

        console.log('goSignList','this.state.username',this.state.username)



        return new Promise ((resolve, reject) =>{
          getFileDB(this.state.username, `${typeContract}_${numberContract}_usergroup.json`)
             .then((fileContents) => {
               if(fileContents) {

                 console.log('goSignList','fileContents',fileContents)

                 const jsonBlockstack1 = JSON.parse(fileContents)
                 const jsonBlockstack2 = jsonBlockstack1.data
                 let jsonBlockstack5 = '[]'
                 if (jsonBlockstack2 !== null){
                    const jsonBlockstack3 = jsonBlockstack2.dataobject
                    const jsonBlockstack4 = jsonBlockstack3.replace(/\\/g,"");
                    if (jsonBlockstack4.substring(0,1) === '"') {
                       jsonBlockstack5 = jsonBlockstack4.substring(1,jsonBlockstack4.length - 1)
                    } else {
                       jsonBlockstack5 = jsonBlockstack4
                    }
                    let jsonBlockstack6 = JSON.parse(jsonBlockstack5)

                    console.log('goSignList','jsonBlockstack6',jsonBlockstack6)


                    this.setState({jsonBlockstackY: jsonBlockstack6})
                    this.completaNameAndAvatar(jsonBlockstack6,2)
                    //-----------------------------------------------------------------------------
                    Promise.all([this.goSignListRemoto(typeContract,numberContract,jsonBlockstack6)]).then((resolve) =>{resolve()},(reject) =>{resolve()})
                    //-----------------------------------------------------------------------------
                  } else {
                    if (displayRole==="Authorizer" || displayRole==="Authorizer-Inviter"){
                      const options = {contentType: 'application/json', encrypt: false, dangerouslyIgnoreEtag: true }
                      const infoUserGoup=`[{"id":"${this.state.username}","name":"${this.state.nameBlockstack}","role":"${displayRole}","active":"true","signature":"${this.state.pubKey}","identityAddress":"${this.state.identityAddress}","statusInvite":true,"email":"","publicKey":"${this.state.pubKey}"}]`
                      this.setState({jsonBlockstackY: JSON.parse(infoUserGoup)})
                      this.completaNameAndAvatar(JSON.parse(infoUserGoup),2)
                      putFileDB(this.state.username,`${typeContract}_${numberContract}_usergroup.json`, 'Crosscheck_Contract', JSON.stringify(infoUserGoup), JSON.stringify(options))
                         .then(() => {
                         })
                         .catch(error => {
                         });
                    }
                    resolve()
                  }
               } else {
                 if (displayRole==="Authorizer" || displayRole==="Authorizer-Inviter"){
                   const options = {contentType: 'application/json', encrypt: false, dangerouslyIgnoreEtag: true }
                   const infoUserGoup=`[{"id":"${this.state.username}","name":"${this.state.nameBlockstack}","role":"${displayRole}","active":"true","signature":"${this.state.pubKey}","identityAddress":"${this.state.identityAddress}","statusInvite":true,"email":"","publicKey":"${this.state.pubKey}"}]`
                   this.setState({jsonBlockstackY: JSON.parse(infoUserGoup)})
                   this.completaNameAndAvatar(JSON.parse(infoUserGoup),2)
                   putFileDB(this.state.username,`${typeContract}_${numberContract}_usergroup.json`, 'Crosscheck_Contract', JSON.stringify(infoUserGoup), JSON.stringify(options))
                      .then(() => {
                      })
                      .catch(error => {
                      });
                 }
                 resolve()
               }
             })
              .catch(error => {
                if (displayRole==="Authorizer" || displayRole==="Authorizer-Inviter"){
                  const options = {contentType: 'application/json', encrypt: false, dangerouslyIgnoreEtag: true }
                  const infoUserGoup=`[{"id":"${this.state.username}","name":"${this.state.nameBlockstack}","role":"${displayRole}","active":"true","signature":"${this.state.pubKey}","identityAddress":"${this.state.identityAddress}","statusInvite":true,"email":"","publicKey":"${this.state.pubKey}"}]`
                  this.setState({jsonBlockstackY: JSON.parse(infoUserGoup)})
                  this.completaNameAndAvatar(JSON.parse(infoUserGoup),2)
                  putFileDB(this.state.username,`${typeContract}_${numberContract}_usergroup.json`, 'Crosscheck_Contract', JSON.stringify(infoUserGoup), JSON.stringify(options))
                     .then(() => {})
                     .catch(error => {});
                }
                resolve()
              });
          })
      }

      goSignListRemoto(typeContract,configurationContractNumber,jsonBlockstack4c){
        const largo = jsonBlockstack4c.length

        console.log('goSignListRemoto','jsonBlockstack4c',jsonBlockstack4c)


        return new Promise ((resolve2, reject2) =>{
          jsonBlockstack4c.map((todoUserRemote,keyUserRemote)=>{
            if ((todoUserRemote.role === 'Authorizer' || todoUserRemote.role === 'Authorizer-Inviter') && todoUserRemote.id !== this.state.username){
              let jsonBlockstack4d = []
              this.setState({jsonUserGroupPactRemoto: []})
              new Promise ((resolve3, reject3) =>{
                  getFileDB(todoUserRemote.id, `${typeContract}_${configurationContractNumber}_usergroup.json`)
                   .then((fileContents) => {
                     if(fileContents) {
                         const jsonBlockstack1 = JSON.parse(fileContents)
                         const jsonBlockstack2 = jsonBlockstack1.data
                         let jsonBlockstack5 = '[]'
                         if (jsonBlockstack2 !== null){
                            const jsonBlockstack3 = jsonBlockstack2.dataobject
                            const jsonBlockstack4 = jsonBlockstack3.replace(/\\/g,"");
                            if (jsonBlockstack4.substring(0,1) === '"') {
                               jsonBlockstack5 = jsonBlockstack4.substring(1,jsonBlockstack4.length - 1)
                            } else {
                               jsonBlockstack5 = jsonBlockstack4
                            }
                            let jsonBlockstack6 = JSON.parse(jsonBlockstack5)
                            jsonBlockstack4d = JSON.parse(jsonBlockstack5)

                            const {signature} = jsonBlockstack4d[0]

                            console.log('goSignListRemoto','jsonBlockstack4d',jsonBlockstack4d)
                            console.log('goSignListRemoto','jsonBlockstack4d[0]',jsonBlockstack4d[0])
                            console.log('goSignListRemoto','todoUserRemote.signature',todoUserRemote.signature)
                            console.log('goSignListRemoto','signature',signature)

                            if (todoUserRemote.signature !== signature){
                               todoUserRemote.signature = signature
                               this.setState({jsonBlockstackY: jsonBlockstack4c})
                               this.completaNameAndAvatar(jsonBlockstack4c,2)
                               //---------------------------------------------------------------------------------------
                               Promise.all([this.goSignListRemotoSignature(typeContract,configurationContractNumber,jsonBlockstack4c)]).then((resolve) =>{resolve3()},(reject) =>{resolve3()})
                               //---------------------------------------------------------------------------------------
                            }else{
                              resolve3()
                            }
                       } else {
                         resolve3()
                       }
                     } else {
                        resolve3()
                     }
                   })
                 .catch(error => {
                    resolve3()
                 });
              })
            }
            if (keyUserRemote === largo - 1){
              resolve2()
            }
          })
        })
      }

      goSignListRemotoSignature = (typeContract,configurationContractNumber,jsonBlockstack5) => {
        const options = {contentType: 'application/json', encrypt: false, dangerouslyIgnoreEtag: true }
        jsonBlockstack5 = JSON.stringify(jsonBlockstack5)
        return new Promise ((resolve4, reject4) =>{
          putFileDB(this.state.username,`${typeContract}_${configurationContractNumber}_usergroup.json}`, 'Crosscheck_Contract', jsonBlockstack5, JSON.stringify(options))
               .then(() => {
                  resolve4()
               })
               .catch(error => {
                 resolve4()
               });
         })
      }

      goRoleList(typeContract, numberContract, usernameX) {
        const options = { decrypt: false, verify: false }
        this.setState({jsonBlockstackZ: []})
        let roleX = ''
        if (typeContract === null){roleX = `role.json`}else{roleX = `role_${typeContract}.json`}
        return new Promise ((resolve, reject) =>{
          getFileDB(usernameX, `${roleX}`)
             .then((fileContents) => {
               if(fileContents) {
                 const jsonBlockstack1 = JSON.parse(fileContents)
                 const jsonBlockstack2 = jsonBlockstack1.data
                 let jsonBlockstack5 = '[]'
                 if (jsonBlockstack2 !== null){
                    const jsonBlockstack3 = jsonBlockstack2.dataobject
                    const jsonBlockstack4 = jsonBlockstack3.replace(/\\/g,"");
                    if (jsonBlockstack4.substring(0,1) === '"') {
                       jsonBlockstack5 = jsonBlockstack4.substring(1,jsonBlockstack4.length - 1)
                    } else {
                       jsonBlockstack5 = jsonBlockstack4
                    }
                    let jsonBlockstack6 = JSON.parse(jsonBlockstack5)
                    this.setState({jsonBlockstackZ: jsonBlockstack6})
                 } else {
                   this.goRoleList2(usernameX)
                 }
               } else {
                 this.goRoleList2(usernameX)
               }
               resolve()
             })
              .catch(error => {
                 this.goRoleList2(usernameX)
                 resolve()
              });
          })
      }

      goRoleList2 = (usernameX) => {
        const options = { decrypt: false, verify: false }
        this.setState({jsonBlockstackZ: []})
        let roleX = `role.json`
        return new Promise ((resolve, reject) =>{
          getFileDB(usernameX, `${roleX}`)
             .then((fileContents) => {
               if(fileContents) {
                 const jsonBlockstack1 = JSON.parse(fileContents)
                 const jsonBlockstack2 = jsonBlockstack1.data
                 let jsonBlockstack5 = '[]'
                 if (jsonBlockstack2 !== null){
                    const jsonBlockstack3 = jsonBlockstack2.dataobject
                    const jsonBlockstack4 = jsonBlockstack3.replace(/\\/g,"");
                    if (jsonBlockstack4.substring(0,1) === '"') {
                       jsonBlockstack5 = jsonBlockstack4.substring(1,jsonBlockstack4.length - 1)
                    } else {
                       jsonBlockstack5 = jsonBlockstack4
                    }
                 }
                 let jsonBlockstack6 = JSON.parse(jsonBlockstack5)
                 this.setState({jsonBlockstackZ: jsonBlockstack6})
                 resolve()
               } else {
                 resolve()
               }
             })
              .catch(error => {
                 resolve()
             });
          })
      }

      completaNameAndAvatar = async (jsonUserGroup,mode) => {
        const salida = []
        const resultado = await Promise.all(jsonUserGroup.map( async (todo) => {
           let userX = ''
           if (todo.id !== this.state.username){
              userX = todo.id
           }
           return await Promise.all([this.readRemoteNameAvatar(userX)])
             .then(
               (resolve) =>{
                 if (mode === 1){
                   let emailRX = todo.email
                   if (todo.email === null || todo.email === '' || todo.email === undefined){
                     emailRX = resolve[0].emailRX
                   }
                   salida.push({active:todo.active, email:emailRX, id:todo.id, identityAddress:todo.identityAddress, publicKey:todo.publicKey, role:todo.role, signature:todo.signature, statusInvite:todo.statusInvite, name:resolve[0].nameX, avatar:resolve[0].avatarX})
                 }else{
                   if (mode === 2){
                     salida.push({id:todo.id, role:todo.role, signature:todo.signature, identityAddress: todo.identityAddress, name:resolve[0].nameX, avatar:resolve[0].avatarX})
                   }
                 }
               },
               (reject)  =>{
                 if (mode === 1){
                   salida.push({active:todo.active, email:todo.email, id:todo.id, identityAddress:todo.identityAddress, publicKey:todo.publicKey, role:todo.role, signature:todo.signature, statusInvite:todo.statusInvite, name:'', avatar:''})
                 }else{
                   if (mode === 2){
                     salida.push({id:todo.id, role:todo.role, signature:todo.signature, identityAddress: todo.identityAddress, name:'', avatar:''})
                   }
                 }
               }
             )
        }))
        this.setState({jsonUserGroup: salida},()=>{})
      }

      readRemoteNameAvatar = (userX) => {
        const {userSession} = this.state
        const storage = new Storage({ userSession });
        let options = {}
        if (userX === '') {
           options = { decrypt: false, verify: false }
        }else{
          options = { username: userX, decrypt: false, verify: false }
        }
        let user2X = userX
        if (userX === '') { user2X = this.state.username}
        return new Promise ((resolve, reject) =>{
          getFileDB(user2X, `myUserConfig.json`)
             .then((fileContents) => {
               if (fileContents) {
                 const jsonBlockstack1 = JSON.parse(fileContents)
                 const jsonBlockstack2 = jsonBlockstack1.data
                 let jsonBlockstack5 = '[]'
                 if (jsonBlockstack2 !== null){
                    const jsonBlockstack3 = jsonBlockstack2.dataobject
                    const jsonBlockstack4 = jsonBlockstack3.replace(/\\/g,"");
                    if (jsonBlockstack4.substring(0,1) === '"') {
                       jsonBlockstack5 = jsonBlockstack4.substring(1,jsonBlockstack4.length - 1)
                    } else {
                       jsonBlockstack5 = jsonBlockstack4
                    }
                 }
                 let jsonBlockstack6 = JSON.parse(jsonBlockstack5)
                  resolve({nameX: jsonBlockstack6.profileName, avatarX: jsonBlockstack6.profileAvatar, emailRX: jsonBlockstack6.emailNotifications})
               }else{
                 reject()
               }
             })
            .catch(error => {
          });
        });
      }

      goUserGroupOrigin(typeContract,numberContract, userX) {
        const {userSession} = this.state
        const storage = new Storage({ userSession });
        const options = { username: userX, decrypt: false, verify: false }
        let user2X = userX
        if (userX === '') { user2X = this.state.username}
        this.setState({jsonUserGroup: []})
        return new Promise ((resolve, reject) =>{
          getFileDB(user2X, `${typeContract}_${numberContract}_usergroup.json`)
             .then((fileContents) => {
               if(fileContents) {
                 const jsonBlockstack1 = JSON.parse(fileContents)
                 const jsonBlockstack2 = jsonBlockstack1.data
                 let jsonBlockstack5 = '[]'
                 if (jsonBlockstack2 !== null){
                    const jsonBlockstack3 = jsonBlockstack2.dataobject
                    const jsonBlockstack4 = jsonBlockstack3.replace(/\\/g,"");
                    if (jsonBlockstack4.substring(0,1) === '"') {
                       jsonBlockstack5 = jsonBlockstack4.substring(1,jsonBlockstack4.length - 1)
                    } else {
                       jsonBlockstack5 = jsonBlockstack4
                    }
                 }
                 let jsonBlockstack6 = JSON.parse(jsonBlockstack5)

                 this.setState({jsonUserGroup: jsonBlockstack6})
                 this.completaNameAndAvatar(jsonBlockstack6,1)
                 resolve()
               } else {
                 resolve()
               }
             })
              .catch(error => {
                resolve()
              });
          })
      }

      goUserGroup(typeContract,numberContract) {
        const {userSession} = this.state
        const storage = new Storage({ userSession });
        const options = { decrypt: false, verify: false }
        this.setState({jsonUserGroup: []})
        return new Promise ((resolve, reject) =>{
          getFileDB(this.state.username, `${typeContract}_${numberContract}_usergroup.json`)
             .then((fileContents) => {
               if(fileContents) {
                 const jsonBlockstack1 = JSON.parse(fileContents)
                 const jsonBlockstack2 = jsonBlockstack1.data
                 let jsonBlockstack5 = '[]'
                 if (jsonBlockstack2 !== null){
                    const jsonBlockstack3 = jsonBlockstack2.dataobject
                    const jsonBlockstack4 = jsonBlockstack3.replace(/\\/g,"");
                    if (jsonBlockstack4.substring(0,1) === '"') {
                       jsonBlockstack5 = jsonBlockstack4.substring(1,jsonBlockstack4.length - 1)
                    } else {
                       jsonBlockstack5 = jsonBlockstack4
                    }
                 }
                 let jsonBlockstack6 = JSON.parse(jsonBlockstack5)
                 this.setState({jsonUserGroup: jsonBlockstack6},() =>{})
                 this.completaNameAndAvatar(jsonBlockstack6,1)
                 resolve()
               } else {
                 resolve()
               }
             })
              .catch(error => {
                resolve()
              });
          })
      }

      goUserGroupAttachFileCreator(typeContract,numberContract) {
        const {userSession} = this.state
        const storage = new Storage({ userSession });
        const options = { decrypt: false, verify: false }
        this.setState({jsonUserGroup: []})
        return new Promise ((resolve, reject) =>{
          getFileDB(this.state.username, `${typeContract}_${numberContract}_usergroup.json`)
             .then((fileContents) => {
               if(fileContents) {
                 const jsonBlockstack1 = JSON.parse(fileContents)
                 const jsonBlockstack2 = jsonBlockstack1.data
                 let jsonBlockstack5 = '[]'
                 if (jsonBlockstack2 !== null){
                    const jsonBlockstack3 = jsonBlockstack2.dataobject
                    const jsonBlockstack4 = jsonBlockstack3.replace(/\\/g,"");
                    if (jsonBlockstack4.substring(0,1) === '"') {
                       jsonBlockstack5 = jsonBlockstack4.substring(1,jsonBlockstack4.length - 1)
                    } else {
                       jsonBlockstack5 = jsonBlockstack4
                    }
                 }
                 let jsonBlockstack6 = JSON.parse(jsonBlockstack5)
                 this.setState({jsonUserGroup: jsonBlockstack6})
                 this.completaNameAndAvatar(jsonBlockstack6,1)
                 //-------------------------------------------------------------------
                 this.goAttachFileCreator(typeContract,numberContract,jsonBlockstack6)
                 //-------------------------------------------------------------------
                 resolve()
               } else {
                 resolve()
               }
             })
              .catch(error => {
                resolve()
              });
          })
      }

      goUserGroupAttachFileCreatorRemoto(typeContract,numberContract,originX) {
        const {userSession} = this.state
        const storage = new Storage({ userSession });
        const options = { username: originX, decrypt: false, verify: false }
        this.setState({jsonUserGroup: []})
        return new Promise ((resolve, reject) =>{
          getFileDB(originX, `${typeContract}_${numberContract}_usergroup.json`)
             .then((fileContents) => {
               if(fileContents) {
                 const jsonBlockstack1 = JSON.parse(fileContents)
                 const jsonBlockstack2 = jsonBlockstack1.data
                 let jsonBlockstack5 = '[]'
                 if (jsonBlockstack2 !== null){
                    const jsonBlockstack3 = jsonBlockstack2.dataobject
                    const jsonBlockstack4 = jsonBlockstack3.replace(/\\/g,"");
                    if (jsonBlockstack4.substring(0,1) === '"') {
                       jsonBlockstack5 = jsonBlockstack4.substring(1,jsonBlockstack4.length - 1)
                    } else {
                       jsonBlockstack5 = jsonBlockstack4
                    }
                 }
                 let jsonBlockstack6 = JSON.parse(jsonBlockstack5)

                 this.setState({jsonUserGroup: jsonBlockstack6})
                 this.completaNameAndAvatar(jsonBlockstack6,1)
                 //-------------------------------------------------------------------
                 this.goAttachFileCreator(typeContract,numberContract,jsonBlockstack6)
                 //-------------------------------------------------------------------
                 resolve()
               } else {
                 resolve()
               }
             })
              .catch(error => {
                 resolve()
              });
          })
      }

      goAttachFile(typeContract,numberContract,userX) {
        const {userSession} = this.state
        const storage = new Storage({ userSession });
        let options = ''
        if (userX !== this.state.username){
          options = { username: userX, decrypt: false, verify: false }
        }else{
          options = { decrypt: false, verify: false }
        }
        let user2X = userX
        if (userX === '') { user2X = this.state.username}
        this.setState({jsonAttachFile: []})
        this.setState({jsonAttachFile1: []})
        this.setState({jsonAttachFile2: []})
        return new Promise ((resolve, reject) =>{
          getFileDB(user2X, `${typeContract}_${numberContract}_attachlist.json`)
             .then((fileContents) => {
               if(fileContents) {
                 const jsonBlockstack1 = JSON.parse(fileContents)
                 const jsonBlockstack2 = jsonBlockstack1.data
                 let jsonBlockstack5 = '[]'
                 if (jsonBlockstack2 !== null){
                    const jsonBlockstack3 = jsonBlockstack2.dataobject
                    const jsonBlockstack4 = jsonBlockstack3.replace(/\\/g,"");
                    if (jsonBlockstack4.substring(0,1) === '"') {
                       jsonBlockstack5 = jsonBlockstack4.substring(1,jsonBlockstack4.length - 1)
                    } else {
                       jsonBlockstack5 = jsonBlockstack4
                    }
                    let jsonBlockstack6 = JSON.parse(jsonBlockstack5)

                    let jsonAttachFileX = {}
                    let jsonAttachFile  = {}
                    if (this.state.jsonAttachFile > 0){
                      let jsonBlockstack3X = JSON.stringify(this.state.jsonAttachFile)
                      if (jsonBlockstack3X.substring(0,1)==='"') {
                         jsonBlockstack3X = jsonBlockstack3X.substring(1,jsonBlockstack3X.length - 1);
                      }
                      if (jsonBlockstack3X.substring(0,1)==='[') {
                         jsonBlockstack3X = jsonBlockstack3X.substring(1,jsonBlockstack3X.length - 1);
                      }
                      jsonAttachFileX = jsonBlockstack3X
                      jsonAttachFile =`${jsonAttachFileX},${jsonBlockstack5}`
                    }else{
                      jsonAttachFile =`${jsonBlockstack5}`
                    }
                    let jsonBlockstack7 = `${jsonAttachFile}`
                    jsonBlockstack7 = JSON.parse(jsonBlockstack7)

                    jsonBlockstack7.map((todoattach2,keyattach2)=>{
                        if (user2X !== this.state.username){
                          todoattach2.deleteAttach = false
                        }else{
                          todoattach2.deleteAttach = true
                        }
                    })

                    this.setState({jsonAttachFile: jsonBlockstack7})
                    if (user2X !== this.state.username){
                      this.setState({jsonAttachFile1: jsonBlockstack7})
                    }else{
                     this.setState({jsonAttachFile2: jsonBlockstack7})
                    }
                    resolve()
                 } else {
                   resolve()
                 }
               } else {
                 resolve()
               }
             })
              .catch(error => {
                resolve()
              });
          })
      }

      goAttachFileCreator(typeContract,numberContract,jsondisplayUser) {
        const {userSession} = this.state
        const storage = new Storage({ userSession });
        const largo = jsondisplayUser.length
        return new Promise ((resolve, reject) =>{
            this.setState({jsonAttachFile: [],jsonAttachFile1: [],jsonAttachFile2: []})
            jsondisplayUser.map((todouser,keyuser)=>{
                let options = ''
                let user2X = this.state.username
                if (todouser.id !== this.state.username){
                  user2X = todouser.id
                }
                return new Promise ((resolve2, reject2) =>{
                    getFileDB(user2X, `${typeContract}_${numberContract}_attachlist.json`)
                       .then((fileContents) => {
                         if(fileContents) {
                           const jsonBlockstack1 = JSON.parse(fileContents)
                           const jsonBlockstack2 = jsonBlockstack1.data
                           let jsonBlockstack5 = '[]'
                           if (jsonBlockstack2 !== null){
                              const jsonBlockstack3 = jsonBlockstack2.dataobject
                              const jsonBlockstack4 = jsonBlockstack3.replace(/\\/g,"");
                              if (jsonBlockstack4.substring(0,1) === '"') {
                                 jsonBlockstack5 = jsonBlockstack4.substring(1,jsonBlockstack4.length - 1)
                              } else {
                                 jsonBlockstack5 = jsonBlockstack4
                              }
                              let jsonBlockstack6 = JSON.parse(jsonBlockstack5)

                              let jsonAttachFileX = {}
                              let jsonAttachFile  = {}
                              if (this.state.jsonAttachFile > 0){
                                let jsonBlockstack3X = JSON.stringify(this.state.jsonAttachFile)
                                if (jsonBlockstack3X.substring(0,1)==='"') {
                                   jsonBlockstack3X = jsonBlockstack3X.substring(1,jsonBlockstack3X.length - 1);
                                }
                                if (jsonBlockstack3X.substring(0,1)==='[') {
                                   jsonBlockstack3X = jsonBlockstack3X.substring(1,jsonBlockstack3X.length - 1);
                                }
                                jsonAttachFileX = jsonBlockstack3X
                                jsonAttachFile =`${jsonAttachFileX},${jsonBlockstack5}`
                              }else{
                                jsonAttachFile =`${jsonBlockstack5}`
                              }
                              let jsonBlockstack7 = `${jsonAttachFile}`
                              jsonBlockstack7 = JSON.parse(jsonBlockstack7)
                              jsonBlockstack7.map((todoattach2,keyattach2)=>{
                                  if (todouser.id !== this.state.username){
                                    todoattach2.deleteAttach = false
                                  }else{
                                    todoattach2.deleteAttach = true
                                  }
                              })
                              if (todouser.id !== this.state.username){
                                    let jsonAttachFile = []
                                    let jsonBlockstack1 = []
                                    jsonBlockstack1 = jsonBlockstack7
                                    jsonBlockstack1 = JSON.stringify(jsonBlockstack7)
                                    if (jsonBlockstack1.substring(0,1)==='"') {
                                       jsonBlockstack1 = jsonBlockstack1.substring(1,jsonBlockstack1.length - 1);
                                    }
                                    if (jsonBlockstack1.substring(0,1)==='[') {
                                       jsonBlockstack1 = jsonBlockstack1.substring(1,jsonBlockstack1.length - 1);
                                    }
                                    let jsonBlockstack2 = []
                                    jsonBlockstack2 = this.state.jsonAttachFile1
                                    jsonBlockstack2 = JSON.stringify(jsonBlockstack2)
                                    if (jsonBlockstack2.substring(0,1)==='"') {
                                       jsonBlockstack2 = jsonBlockstack2.substring(1,jsonBlockstack2.length - 1);
                                    }
                                    if (jsonBlockstack2.substring(0,1)==='[') {
                                       jsonBlockstack2 = jsonBlockstack2.substring(1,jsonBlockstack2.length - 1);
                                    }
                                    if ((jsonBlockstack1.length===0) && jsonBlockstack2.length>0 ){
                                        jsonAttachFile =`[${jsonBlockstack2}]`
                                    }
                                    if ((jsonBlockstack1.length>0) && jsonBlockstack2.length===0 ){
                                        jsonAttachFile =`[${jsonBlockstack1}]`
                                    }
                                    if ((jsonBlockstack1.length===0) && jsonBlockstack2.length===0 ){
                                        jsonAttachFile =`[]`
                                    }
                                    if ((jsonBlockstack1.length>0) && jsonBlockstack2.length>0 ){
                                        jsonAttachFile =`[${jsonBlockstack1},${jsonBlockstack2}]`
                                    }
                                    jsonAttachFile = JSON.parse(jsonAttachFile)
                                    this.setState({jsonAttachFile1: jsonAttachFile,jsonAttachFile: jsonAttachFile})
                              }else{
                                    this.setState({jsonAttachFile2: jsonBlockstack7,jsonAttachFile: jsonBlockstack7})
                              }
                              resolve2()
                           } else {
                             resolve2()
                           }
                         } else {
                           resolve2()
                         }
                       })
                        .catch(error => {
                          resolve2()
                       });
                })
                if (keyuser === (largo - 1)){
                  resolve()
                }
           })
        })
      }

      goDeliverableFile(typeContract,numberContract,userX) {
      }

      goDeliverableFileCreator(typeContract,numberContract,userX) {
      }

      newDetail(e,templateName){
        if (this.state.JSONTemplateName === 'proforma'){
          if (this.c02ConfigurationContract.current.value === undefined || this.c02ConfigurationContract.current.value === null || this.c02ConfigurationContract.current.value === ''){
              this.errorNumberContract()
          }else{
              const Productid = this.c25FieldContract.current.value,
                    Description = this.c40FieldContract.current.value,
                    Quantity = this.c27FieldContract.current.value,
                    Unitprice = this.c28FieldContract.current.value

              let totalProformaDetail1 = parseFloat(Quantity) * parseFloat(Unitprice)
              totalProformaDetail1 = totalProformaDetail1.toFixed(2)
              let totalProformaDetail2 = parseFloat(this.state.subtotalProformaDetail) + parseFloat(totalProformaDetail1)
              totalProformaDetail2 = totalProformaDetail2.toFixed(2)

              const jsonProformaDetail = [...this.state.jsonProformaDetail,{"productid":Productid,"description":Description,"quantity":Quantity,"unitprice":Unitprice,"active":false}]

              if (this.c29FieldContract.current.value === undefined || this.c29FieldContract.current.value === null || this.c29FieldContract.current.value === ''){this.c29FieldContract.current.value = 0}
              if (this.c30FieldContract.current.value === undefined || this.c30FieldContract.current.value === null || this.c30FieldContract.current.value === ''){this.c30FieldContract.current.value = 0}
              if (this.c31FieldContract.current.value === undefined || this.c31FieldContract.current.value === null || this.c31FieldContract.current.value === ''){this.c31FieldContract.current.value = 0}
              if (this.c32FieldContract.current.value === undefined || this.c32FieldContract.current.value === null || this.c32FieldContract.current.value === ''){this.c32FieldContract.current.value = 0}
              if (this.c33FieldContract.current.value === undefined || this.c33FieldContract.current.value === null || this.c33FieldContract.current.value === ''){this.c33FieldContract.current.value = 0}
              if (this.c34FieldContract.current.value === undefined || this.c34FieldContract.current.value === null || this.c34FieldContract.current.value === ''){this.c34FieldContract.current.value = 0}
              this.setState({subtotalProformaDetail: parseFloat(totalProformaDetail2)})
              const c29 = parseFloat(totalProformaDetail2)
              this.c29FieldContract.current.value = c29.toFixed(2)
              this.c31FieldContract.current.value = parseFloat(this.state.tax30X)
              const c32 = (parseFloat(this.state.tax30X) * ((parseFloat(totalProformaDetail2) - parseFloat(this.c30FieldContract.current.value)))) / 100
              this.c32FieldContract.current.value = c32.toFixed(2)
              const c34 = parseFloat(this.c29FieldContract.current.value) - parseFloat(this.c30FieldContract.current.value) + parseFloat(this.c32FieldContract.current.value) + parseFloat(this.c33FieldContract.current.value)
              this.c34FieldContract.current.value = c34.toFixed(2)
              this.setState({modifyItemProformaDetail: false})
              this.setState({jsonProformaDetail})
              const {userSession} = this.state
              const storage = new Storage({ userSession });
              const options = {contentType: 'application/json', encrypt: false, dangerouslyIgnoreEtag: true }
              putFileDB(this.state.username,`${this.state.JSONTemplateName}_${this.c02ConfigurationContract.current.value}_proformadetail.json`, 'Crosscheck_Contract', JSON.stringify(jsonProformaDetail), JSON.stringify(options))
                  .then(() => {})
              this.c25FieldContract.current.value = ''
              this.c40FieldContract.current.value = ''
              this.c27FieldContract.current.value = ''
              this.c28FieldContract.current.value = ''
          }
        }
      }

    modifyDetail(e,templateName){
        this.setState({modifyItemProformaDetail: false})
        const i = localStorage.getItem('correlativoProformaDetail')
        let jsonProformaDetail = this.state.jsonProformaDetail
        jsonProformaDetail[i].productid = this.c25FieldContract.current.value
        jsonProformaDetail[i].description = this.c40FieldContract.current.value
        jsonProformaDetail[i].quantity = this.c27FieldContract.current.value
        jsonProformaDetail[i].unitprice = this.c28FieldContract.current.value

        const Productid = this.c25FieldContract.current.value,
              Description = this.c40FieldContract.current.value,
              Quantity = this.c27FieldContract.current.value,
              Unitprice = this.c28FieldContract.current.value


        let totalProformaDetail1 = parseFloat(Quantity) * parseFloat(Unitprice)
        totalProformaDetail1 = totalProformaDetail1.toFixed(2)
        let totalProformaDetail2 = parseFloat(this.state.subtotalProformaDetail) - parseFloat(this.state.subtotalProformaDetailPrev) + parseFloat(totalProformaDetail1)
        totalProformaDetail2 = totalProformaDetail2.toFixed(2)

        if (this.c29FieldContract.current.value === undefined || this.c29FieldContract.current.value === null || this.c29FieldContract.current.value === ''){this.c29FieldContract.current.value = 0}
        if (this.c30FieldContract.current.value === undefined || this.c30FieldContract.current.value === null || this.c30FieldContract.current.value === ''){this.c30FieldContract.current.value = 0}
        if (this.c31FieldContract.current.value === undefined || this.c31FieldContract.current.value === null || this.c31FieldContract.current.value === ''){this.c31FieldContract.current.value = 0}
        if (this.c32FieldContract.current.value === undefined || this.c32FieldContract.current.value === null || this.c32FieldContract.current.value === ''){this.c32FieldContract.current.value = 0}
        if (this.c33FieldContract.current.value === undefined || this.c33FieldContract.current.value === null || this.c33FieldContract.current.value === ''){this.c33FieldContract.current.value = 0}
        if (this.c34FieldContract.current.value === undefined || this.c34FieldContract.current.value === null || this.c34FieldContract.current.value === ''){this.c34FieldContract.current.value = 0}
        this.setState({subtotalProformaDetail: parseFloat(totalProformaDetail2)})
        const c29 = parseFloat(totalProformaDetail2)
        this.c29FieldContract.current.value = c29.toFixed(2)
        this.c31FieldContract.current.value = parseFloat(this.state.tax30X)
        const c32 = (parseFloat(this.state.tax30X) * ((parseFloat(totalProformaDetail2) - parseFloat(this.c30FieldContract.current.value)))) / 100
        this.c32FieldContract.current.value = c32.toFixed(2)
        const c34 = parseFloat(this.c29FieldContract.current.value) - parseFloat(this.c30FieldContract.current.value) + parseFloat(this.c32FieldContract.current.value) + parseFloat(this.c33FieldContract.current.value)
        this.c34FieldContract.current.value = c34.toFixed(2)
        this.setState({modifyItemProformaDetail: false,
                       subtotalProformaDetailPrev: 0,
                       jsonProformaDetail})
        const {userSession} = this.state
        const storage = new Storage({ userSession });
        const options = {contentType: 'application/json', encrypt: false, dangerouslyIgnoreEtag: true }
        putFileDB(this.state.username,`${this.state.JSONTemplateName}_${this.c02ConfigurationContract.current.value}_proformadetail.json`, 'Crosscheck_Contract', JSON.stringify(jsonProformaDetail), JSON.stringify(options))
            .then(() => {})
        this.c25FieldContract.current.value = ''
        this.c40FieldContract.current.value = ''
        this.c27FieldContract.current.value = ''
        this.c28FieldContract.current.value = ''
      }

      clickRemoveAttach = (e,optx) => {
          const masterfile = this.state.jsonAttachFile
          masterfile.splice(optx,1);
          this.setState({jsonAttachFile: masterfile})
          const {userSession} = this.state
          const storage = new Storage({ userSession });
          const options = {contentType: 'application/json', encrypt: false, dangerouslyIgnoreEtag: true }
          putFileDB(this.state.username,`${this.state.typeContractSign}_${this.state.configurationContractNumberSign}_attachlist.json`, 'Crosscheck_Contract', JSON.stringify(masterfile), JSON.stringify(options))
            .then(() => {})
      }

      clickRemoveProformaDetail = (e,optx) => {
        const masterfile = this.state.jsonProformaDetail
        const {jsonProformaDetail} = this.state
        let totalProformaDetail1 = 0
        jsonProformaDetail.map((todo,i)=>{
          if (parseInt(i) === parseInt(optx)){
           totalProformaDetail1 = parseFloat(todo.quantity) * parseFloat(todo.unitprice)
             totalProformaDetail1 = totalProformaDetail1.toFixed(2)
          }
        })
        let totalProformaDetail2 = parseFloat(this.state.subtotalProformaDetail) - parseFloat(totalProformaDetail1)
        totalProformaDetail2 = totalProformaDetail2.toFixed(2)
        this.setState({subtotalProformaDetail: parseFloat(totalProformaDetail2)})

        if (this.c29FieldContract.current.value === undefined || this.c29FieldContract.current.value === null || this.c29FieldContract.current.value === ''){this.c29FieldContract.current.value = 0}
        if (this.c30FieldContract.current.value === undefined || this.c30FieldContract.current.value === null || this.c30FieldContract.current.value === ''){this.c30FieldContract.current.value = 0}
        if (this.c31FieldContract.current.value === undefined || this.c31FieldContract.current.value === null || this.c31FieldContract.current.value === ''){this.c31FieldContract.current.value = 0}
        if (this.c32FieldContract.current.value === undefined || this.c32FieldContract.current.value === null || this.c32FieldContract.current.value === ''){this.c32FieldContract.current.value = 0}
        if (this.c33FieldContract.current.value === undefined || this.c33FieldContract.current.value === null || this.c33FieldContract.current.value === ''){this.c33FieldContract.current.value = 0}
        if (this.c34FieldContract.current.value === undefined || this.c34FieldContract.current.value === null || this.c34FieldContract.current.value === ''){this.c34FieldContract.current.value = 0}
        this.setState({subtotalProformaDetail: parseFloat(totalProformaDetail2)})
        const c29 = parseFloat(totalProformaDetail2)
        this.c29FieldContract.current.value = c29.toFixed(2)
        this.c31FieldContract.current.value = parseFloat(this.state.tax30X)
        const c32 = (parseFloat(this.state.tax30X) * ((parseFloat(totalProformaDetail2) - parseFloat(this.c30FieldContract.current.value)))) / 100
        this.c32FieldContract.current.value = c32.toFixed(2)
        const c34 = parseFloat(this.c29FieldContract.current.value) - parseFloat(this.c30FieldContract.current.value) + parseFloat(this.c32FieldContract.current.value) + parseFloat(this.c33FieldContract.current.value)
        this.c34FieldContract.current.value = c34.toFixed(2)

        masterfile.splice(optx,1);
        this.setState({jsonProformaDetail: masterfile})
        const {userSession} = this.state
        const storage = new Storage({ userSession });
        const options = {contentType: 'application/json', encrypt: false, dangerouslyIgnoreEtag: true }
        putFileDB(this.state.username,`${this.state.JSONTemplateName}_${this.c02ConfigurationContract.current.value}_proformadetail.json`, 'Crosscheck_Contract', JSON.stringify(masterfile), JSON.stringify(options))
          .then(() => {})
      }

      clickEditProformaDetail(e, optx){
          let jsonProformaDetail = this.state.jsonProformaDetail
          this.setState({modifyItemProformaDetail: true })

          this.c25FieldContract.current.value = jsonProformaDetail[optx].productid
          this.c40FieldContract.current.value = jsonProformaDetail[optx].description
          this.c27FieldContract.current.value = jsonProformaDetail[optx].quantity
          this.c28FieldContract.current.value = jsonProformaDetail[optx].unitprice

          let totalProformaDetail1 = parseFloat(jsonProformaDetail[optx].quantity) * parseFloat(jsonProformaDetail[optx].unitprice)
          totalProformaDetail1 = totalProformaDetail1.toFixed(2)
          this.setState({subtotalProformaDetailPrev: parseFloat(totalProformaDetail1)})
      }

      nuevoContract = async (e,optx, statblock) => {
          this.setState({showLoader:true});
          const {userSession} = this.state
          const storage = new Storage({ userSession });
          const options = {contentType: 'application/json', encrypt: false, dangerouslyIgnoreEtag: true }
          let StatusBlockchain = ''
          let StatusLifeCycle = ''
          if (statblock==='cloud'){
            StatusBlockchain = 'Cloud'
            if (this.state.todosSign){
              StatusLifeCycle = "Signed"
            }else{
              if (this.state.algunosSign){
                StatusLifeCycle = "Signing"
              }else{
                StatusLifeCycle = "Draft"
              }
            }
            StatusLifeCycle = "Draft"
          }else{
            if (statblock==='blockchain'){
              StatusBlockchain = 'Blockchain'
              StatusLifeCycle = "Published"
            }else{
              StatusBlockchain = this.c07ConfigurationContract.current.value
            }
          }
          //--------------------------------------------------
          //Datos Fijos
          //--------------------------------------------------
          const IdParadigma = uuid(),
                TypeContract = this.state.JSONTemplateName,
                ConfigurationContractNumber = this.c02ConfigurationContract.current.value,
                StartDate = this.state.startDate,
                EndDate = this.state.endDate,
                //PactID = this.c06ConfigurationContract.current.value,
                UsernameInsert = this.state.username,
                DateInsert = this.state.nowDate,
                UsernameUpdate = "",
                DateUpdate = "",
                UsernameDelete = "",
                DateDelete = ""

          let Subject = ""
          if (this.c09ConfigurationContract.current.value !== undefined){
             Subject = this.c09ConfigurationContract.current.value
          }
          let StatusActive = ''
          let StatusActiveAfterPublished = ''
          if (optx==='delete'){
            StatusActive = 'false'
          }else{
            StatusActive = 'true'
          }

          if (optx==='inactive_after_published'){
            StatusActiveAfterPublished = 'false'
          }else{
            StatusActiveAfterPublished = 'true'
          }

          //--------------------------------------------------
          //Datos Variables
          //--------------------------------------------------
          if (this.state.JSONTemplateName === 'delivery' || this.state.JSONTemplateName === 'simulate'){

            const TransportOriginDestination = this.state.c03ConfigurationContract,
                  ConditionsIntegrityMaterials = this.state.c04ConfigurationContract,
                  UseAssets = this.state.c05ConfigurationContract

            const IdContainer = this.c02FieldContract.current.value,
                  //IdBillOfLading = this.c03FieldContract.current.value,
                  IdBillOfLading = this.c02ConfigurationContract.current.value,
                  IdTypeBillOfLading = this.c04FieldContract.current.value,
                  DateContract = this.state.startDate,
                  Shipper = this.c06FieldContract.current.value,
                  Consignee = this.c07FieldContract.current.value,
                  NotifyParty = this.c08FieldContract.current.value,
                  Carrier = this.c09FieldContract.current.value,
                  PlaceOfAceptance = this.c10FieldContract.current.value,
                  PortOfLading = this.c11FieldContract.current.value,
                  Vessel = this.c12FieldContract.current.value,
                  PortOfDischarge = this.c13FieldContract.current.value,
                  PlaceOfDelivery = this.c14FieldContract.current.value,
                  FinalDestination = this.c15FieldContract.current.value,
                  Currency = this.c16FieldContract.current.value,
                  Amount = this.c20FieldContract.current.value,
                  ContractPolicy = this.state.cContractPolicy,
                  SignatureAndPayment = this.state.selectedSignaturePayment,
                  CurrencyType = 'FIAT Money'
            const Signature  = this.c26FieldContract.current.value,
                  SignatureB = ''
            //--------------------------------------------------
            if(ConfigurationContractNumber === '' || IdBillOfLading === '' || DateContract === '' ) {
                 this.props.validarFormulario(true);
                 this.setState({isErrorWrite: true,
                                isErrorWriteConfigurationContractNumber: false,
                                isErrorWriteIdBillOfLading: false,
                                isErrorWriteIdTypeBillOfLading: false,
                                isErrorWriteDateContract: false});
                 if (ConfigurationContractNumber === ''){this.setState({isErrorWriteConfigurationContractNumber: true});}
                 if (IdBillOfLading === ''){this.setState({isErrorWriteIdBillOfLading: true});}
                 if (DateContract === ''){this.setState({isErrorWriteDateContract: true});}
                 return;
            } else {
                 if ((this.state.cContractPolicy === true && optx === 'insert') || optx !== 'insert') {
                   this.props.validarFormulario(false);
                   this.setState({isLoading: true, isErrorWrite: false});
                   //-------------------------------------------
                   // enviar a Blockstack (Cloud Storage)
                   //-------------------------------------------
                   const jsonBlockstack =`{"idParadigma":"${IdParadigma}","idLogisticContract":"${ConfigurationContractNumber}","idContainer":"${IdContainer}","idBillOfLading":"${IdBillOfLading}","idTypeBillOfLading":"${IdTypeBillOfLading}","dateContract":"${DateContract}","shipper":"${Shipper}","consignee":"${Consignee}","notifyParty":"${NotifyParty}","carrier":"${Carrier}","placeOfAceptance":"${PlaceOfAceptance}","portOfLading":"${PortOfLading}","vessel":"${Vessel}","portOfDischarge":"${PortOfDischarge}","placeOfDelivery":"${PlaceOfDelivery}","finalDestination":"${FinalDestination}","amount":"${Amount}","signature":"${SignatureB}","statusLifeCycle":"${StatusLifeCycle}","contractPolicy":"${ContractPolicy}","statusActive":"${StatusActive}","statusActiveAfterPublished":"${StatusActiveAfterPublished}","statusBlockchain":"${StatusBlockchain}","usernameInsert":"${UsernameInsert}","dateInsert":"${DateInsert}","usernameUpdate":"${UsernameUpdate}","dateUpdate":"${DateUpdate}","usernameDelete":"${UsernameDelete}","dateDelete":"${DateDelete}","typeContract":"${TypeContract}","configurationContractNumber":"${ConfigurationContractNumber}","startDate":"${StartDate}","endDate":"${EndDate}","transportOriginDestination":"${TransportOriginDestination}","conditionsIntegrityMaterials":"${ConditionsIntegrityMaterials}","useAssets":"${UseAssets}","subject":"${Subject}","currency":"${Currency}","signatureAndPayment":"${SignatureAndPayment}","currencyType":"${CurrencyType}"}`

                   this.setState({ jsonBlockstack })
                   putFileDB(this.state.username,`${this.state.JSONTemplateName}_${ConfigurationContractNumber}.json`, 'Crosscheck_Contract', JSON.stringify(jsonBlockstack), JSON.stringify(options))
                     .then(() => {
                        this.createListContract(this.state.existListContract,this.state.jsonBlockstackZ,IdParadigma,TypeContract,ConfigurationContractNumber,IdContainer,IdBillOfLading,IdTypeBillOfLading,DateContract,optx,Subject,StatusBlockchain,UsernameInsert,Signature,SignatureAndPayment);
                     })
                }
            }
          }
          if (this.state.JSONTemplateName === 'maintenance'){
              const IdContainer = this.c02FieldContract.current.value,
                    //IdBillOfLading = this.c03FieldContract.current.value,
                    IdBillOfLading = this.c02ConfigurationContract.current.value,
                    DateContract = this.state.startDate,
                    Yournamecompany = this.c06FieldContract.current.value,
                    Youraddress = this.c07FieldContract.current.value,
                    Clientnamecompany = this.c10FieldContract.current.value,
                    Clientaddress = this.c11FieldContract.current.value,
                    Currency = this.c16FieldContract.current.value,
                    Observations = this.c30FieldContract.current.value,
                    Responsible = this.c31FieldContract.current.value,
                    Frecuency = this.c32FieldContract.current.value,
                    Project = this.c33FieldContract.current.value,
                    Amount = this.c20FieldContract.current.value,
                    ContractPolicy = this.state.cContractPolicy,
                    SignatureAndPayment = this.state.selectedSignaturePayment,
                    CurrencyType = 'FIAT Money'

              const Signature  = this.c26FieldContract.current.value,
                    SignatureB = ''

              const TypeMaintenance = this.state.selectedTypeMaintenance

              const palabra = this.c04FieldContract.current.value
              const ArrayIdValue = palabra.split('#$%')
              const IdTypeBillOfLading = ArrayIdValue[0]
              const IdTypeBillOfLadingDescription = ArrayIdValue[1]
              //--------------------------------------------------
              if(ConfigurationContractNumber === '' || IdBillOfLading === '' || DateContract === '' ) {
                   this.props.validarFormulario(true);
                   this.setState({isErrorWrite: true,
                                  isErrorWriteConfigurationContractNumber: false,
                                  isErrorWriteIdBillOfLading: false,
                                  isErrorWriteIdTypeBillOfLading: false,
                                  isErrorWriteDateContract: false});
                   if (ConfigurationContractNumber === ''){this.setState({isErrorWriteConfigurationContractNumber: true});}
                   if (IdBillOfLading === ''){this.setState({isErrorWriteIdBillOfLading: true});}
                   if (DateContract === ''){this.setState({isErrorWriteDateContract: true});}
                   return;
              } else {
                if ((this.state.cContractPolicy === true && optx === 'insert') || optx !== 'insert') {
                     this.props.validarFormulario(false);
                     this.setState({isLoading: true,isErrorWrite: false});
                     //-------------------------------------------
                     // enviar a Blockstack (Cloud Storage)
                     //-------------------------------------------
                     const jsonBlockstack =`{"idParadigma":"${IdParadigma}","idLogisticContract":"${ConfigurationContractNumber}","idContainer":"${IdContainer}","idBillOfLading":"${IdBillOfLading}","idTypeBillOfLading":"${IdTypeBillOfLading}","dateContract":"${DateContract}","yournamecompany":"${Yournamecompany}","youraddress":"${Youraddress}","clientnamecompany":"${Clientnamecompany}","clientaddress":"${Clientaddress}",                    "amount":"${Amount}","signature":"${SignatureB}","statusLifeCycle":"${StatusLifeCycle}","contractPolicy":"${ContractPolicy}","statusActive":"${StatusActive}","statusActiveAfterPublished":"${StatusActiveAfterPublished}","statusBlockchain":"${StatusBlockchain}","usernameInsert":"${UsernameInsert}","dateInsert":"${DateInsert}","usernameUpdate":"${UsernameUpdate}","dateUpdate":"${DateUpdate}","usernameDelete":"${UsernameDelete}","dateDelete":"${DateDelete}","typeContract":"${TypeContract}","configurationContractNumber":"${ConfigurationContractNumber}","startDate":"${StartDate}","endDate":"${EndDate}","subject":"${Subject}","currency":"${Currency}","observations":"${Observations}","responsible":"${Responsible}","frecuency":"${Frecuency}","project":"${Project}","typemaintenance":"${TypeMaintenance}","idTypeBillOfLadingDescription":"${IdTypeBillOfLadingDescription}","signatureAndPayment":"${SignatureAndPayment}","currencyType":"${CurrencyType}"}`

                     this.setState({ jsonBlockstack })
                     putFileDB(this.state.username,`${this.state.JSONTemplateName}_${ConfigurationContractNumber}.json`, 'Crosscheck_Contract', JSON.stringify(jsonBlockstack), JSON.stringify(options))
                       .then(() => {
                          this.createListContract(this.state.existListContract,this.state.jsonBlockstackZ,IdParadigma,TypeContract,ConfigurationContractNumber,IdContainer,IdBillOfLading,IdTypeBillOfLading,DateContract,optx,Subject,StatusBlockchain,UsernameInsert,Signature,SignatureAndPayment);
                       })
                  }
              }
          }
          if (this.state.JSONTemplateName === 'proforma'){

              const IdContainer = this.c02FieldContract.current.value,
                    IdBillOfLading = this.c02ConfigurationContract.current.value

              const IdTypeBillOfLading = this.state.JSONTemplateName,
                    DateContract = this.state.startDate,
                    Shippername = this.c06FieldContract.current.value,
                    Shippercompanyname = this.c07FieldContract.current.value,
                    Shippercontactperson = this.c08FieldContract.current.value,
                    Shipperstreetaddress = this.c09FieldContract.current.value,
                    Shippercitystzipcode = this.c10FieldContract.current.value,
                    Shipperphone = this.c11FieldContract.current.value,
                    Shipperemail = this.c12FieldContract.current.value,
                    Receivername = this.c13FieldContract.current.value,
                    Receivercompanyname = this.c14FieldContract.current.value,
                    Receivercontactperson = this.c15FieldContract.current.value,
                    Currency = this.c16FieldContract.current.value,
                    Receiverstreetaddress = this.c17FieldContract.current.value,
                    Receivercitystzipcode = this.c18FieldContract.current.value,
                    Receiverphone = this.c19FieldContract.current.value,
                    Receiveremail = this.c20FieldContract.current.value,
                    Reference = this.c21FieldContract.current.value,
                    Modeoftransport = this.c22FieldContract.current.value,
                    Totalnumberpackages = this.c23FieldContract.current.value,
                    Totalgrossweight = this.c24FieldContract.current.value,
                    Proformasubtotal = this.c29FieldContract.current.value,
                    Proformadiscount = this.c30FieldContract.current.value,
                    Proformataxrate = this.c31FieldContract.current.value,
                    Proformasalesrate = this.c32FieldContract.current.value,
                    Proformashipping = this.c33FieldContract.current.value,
                    Proformatotal = this.c34FieldContract.current.value,
                    Countryoforigin = this.c35FieldContract.current.value,
                    Portofembarcation = this.c36FieldContract.current.value,
                    Reasonforexport = this.c37FieldContract.current.value,
                    Portofdischarge = this.c38FieldContract.current.value,
                    Termsaleothercomments = this.c39FieldContract.current.value

              const ContractPolicy = this.state.cContractPolicy
              const Signature  = this.c26FieldContract.current.value,
                    SignatureAndPayment = this.state.selectedSignaturePayment,
                    SignatureB = '',
                    CurrencyType = 'FIAT Money'

              //--------------------------------------------------
              if(ConfigurationContractNumber === '' || IdTypeBillOfLading === '' || DateContract === '' ) {
                   this.props.validarFormulario(true);
                   this.setState({isErrorWrite: true,
                                  isErrorWriteConfigurationContractNumber: false,
                                  isErrorWriteIdBillOfLading: false,
                                  isErrorWriteIdTypeBillOfLading: false,
                                  isErrorWriteDateContract: false});
                   if (ConfigurationContractNumber === ''){this.setState({isErrorWriteConfigurationContractNumber: true});}
                   if (IdBillOfLading === ''){this.setState({isErrorWriteIdBillOfLading: true});}
                   //if (IdTypeBillOfLading === ''){this.setState({isErrorWriteIdTypeBillOfLading: true});}
                   if (DateContract === ''){this.setState({isErrorWriteDateContract: true});}
                   return;
              } else {

                if ((this.state.cContractPolicy === true && optx === 'insert') || optx !== 'insert') {
                     this.props.validarFormulario(false);
                     this.setState({isLoading: true,isErrorWrite: false});
                     //-------------------------------------------
                     // enviar a Blockstack (Cloud Storage)
                     //-------------------------------------------
                     const jsonBlockstack = `{"idParadigma":"${IdParadigma}","idLogisticContract":"${ConfigurationContractNumber}","idContainer":"${IdContainer}","idBillOfLading":"${IdBillOfLading}","idTypeBillOfLading":"${IdTypeBillOfLading}","dateContract":"${DateContract}","shippername":"${Shippername}","shippercompanyname":"${Shippercompanyname}","shippercontactperson":"${Shippercontactperson}","shipperstreetaddress":"${Shipperstreetaddress}","shippercitystzipcode":"${Shippercitystzipcode}","shipperphone":"${Shipperphone}","shipperemail":"${Shipperemail}","receivername":"${Receivername}","receivercompanyname":"${Receivercompanyname}","receivercontactperson":"${Receivercontactperson}","currency":"${Currency}","receiverstreetaddress":"${Receiverstreetaddress}","receivercitystzipcode":"${Receivercitystzipcode}","receiverphone":"${Receiverphone}","receiveremail":"${Receiveremail}","reference":"${Reference}","modeoftransport":"${Modeoftransport}","totalnumberpackages":"${Totalnumberpackages}","totalgrossweight":"${Totalgrossweight}","proformasubtotal":"${Proformasubtotal}","proformadiscount":"${Proformadiscount}","proformataxrate":"${Proformataxrate}","proformasalesrate":"${Proformasalesrate}","proformashipping":"${Proformashipping}","proformatotal":"${Proformatotal}","countryoforigin":"${Countryoforigin}","portofembarcation":"${Portofembarcation}","reasonforexport":"${Reasonforexport}","portofdischarge":"${Portofdischarge}","termsaleothercomments":"${Termsaleothercomments}","signature":"${SignatureB}","statusLifeCycle":"${StatusLifeCycle}","contractPolicy":"${ContractPolicy}","statusActive":"${StatusActive}","statusActiveAfterPublished":"${StatusActiveAfterPublished}","statusBlockchain":"${StatusBlockchain}","usernameInsert":"${UsernameInsert}","dateInsert":"${DateInsert}","usernameUpdate":"${UsernameUpdate}","dateUpdate":"${DateUpdate}","usernameDelete":"${UsernameDelete}","dateDelete":"${DateDelete}","typeContract":"${TypeContract}","configurationContractNumber":"${ConfigurationContractNumber}","startDate":"${StartDate}","endDate":"${EndDate}","subject":"${Subject}","currency":"${Currency}","signatureAndPayment":"${SignatureAndPayment}","currencyType":"${CurrencyType}"}`
                     this.setState({ jsonBlockstack })

                     Promise.all(
                        [this.proformaSaveSender(),
                         this.proformaSaveReceiver()]
                     ).then(
                       (resolve) =>{
                         putFileDB(this.state.username,`${this.state.JSONTemplateName}_${ConfigurationContractNumber}.json`, 'Crosscheck_Contract', JSON.stringify(jsonBlockstack), JSON.stringify(options))
                           .then(() => {
                              this.createListContract(this.state.existListContract,this.state.jsonBlockstackZ,IdParadigma,TypeContract,ConfigurationContractNumber,IdContainer,IdBillOfLading,IdTypeBillOfLading,DateContract,optx,Subject,StatusBlockchain,UsernameInsert,Signature,SignatureAndPayment);
                           })
                       }
                     )
                  }
              }
          }
          if (this.state.JSONTemplateName === 'blank'){
              const IdContainer = this.c02FieldContract.current.value,
                    IdBillOfLading = this.c02ConfigurationContract.current.value,
                    Currency = this.c16FieldContract.current.value,
                    Amount = this.c20FieldContract.current.value,
                    IdTypeBillOfLading = this.state.JSONTemplateName,
                    DateContract = this.state.startDate,
                    BlankDetail = JSON.stringify(this.state.contentState, null, 4),
                    ContractPolicy = this.state.cContractPolicy,
                    Signature  = this.c26FieldContract.current.value,
                    SignatureAndPayment = this.state.selectedSignaturePayment,
                    SignatureB = '',
                    CurrencyType = this.c60FieldContract.current.value
              //--------------------------------------------------
              if(ConfigurationContractNumber === '' ||IdTypeBillOfLading === '' || DateContract === '' ) {
                   this.props.validarFormulario(true);
                   this.setState({isErrorWrite: true,
                                  isErrorWriteConfigurationContractNumber: false,
                                  isErrorWriteIdBillOfLading: false,
                                  isErrorWriteIdTypeBillOfLading: false,
                                  isErrorWriteDateContract: false});
                   if (ConfigurationContractNumber === ''){this.setState({isErrorWriteConfigurationContractNumber: true});}
                   //if (IdBillOfLading === ''){this.setState({isErrorWriteIdBillOfLading: true});}
                   if (IdTypeBillOfLading === ''){this.setState({isErrorWriteIdTypeBillOfLading: true});}
                   if (DateContract === ''){this.setState({isErrorWriteDateContract: true});}
                   return;
              } else {
                if ((this.state.cContractPolicy === true && optx === 'insert') || optx !== 'insert') {
                     this.props.validarFormulario(false);
                     this.setState({isLoading: true,isErrorWrite: false});
                     //-------------------------------------------
                     // enviar a Blockstack (Cloud Storage)
                     //-------------------------------------------

                     const jsonBlockstack = `{"idParadigma":"${IdParadigma}","idLogisticContract":"${ConfigurationContractNumber}","idContainer":"${IdContainer}","idBillOfLading":"${IdBillOfLading}","idTypeBillOfLading":"${IdTypeBillOfLading}","dateContract":"${DateContract}","signature":"${SignatureB}","statusLifeCycle":"${StatusLifeCycle}","contractPolicy":"${ContractPolicy}","statusActive":"${StatusActive}","statusActiveAfterPublished":"${StatusActiveAfterPublished}","statusBlockchain":"${StatusBlockchain}","usernameInsert":"${UsernameInsert}","dateInsert":"${DateInsert}","usernameUpdate":"${UsernameUpdate}","dateUpdate":"${DateUpdate}","usernameDelete":"${UsernameDelete}","dateDelete":"${DateDelete}","typeContract":"${TypeContract}","configurationContractNumber":"${ConfigurationContractNumber}","startDate":"${StartDate}","endDate":"${EndDate}","subject":"${Subject}","signatureAndPayment":"${SignatureAndPayment}","amount":"${Amount}","currency":"${Currency}","currencyType":"${CurrencyType}"}`
                     this.setState({ jsonBlockstack })
                     putFileDB(this.state.username,`${this.state.JSONTemplateName}_${ConfigurationContractNumber}.json`, 'Crosscheck_Contract', JSON.stringify(jsonBlockstack), JSON.stringify(options))
                       .then(() => {
                          if (this.state.editorChange){
                             this.newContractBlank(BlankDetail,IdParadigma,TypeContract,ConfigurationContractNumber,IdContainer,IdBillOfLading,IdTypeBillOfLading,DateContract,optx,Subject,StatusBlockchain,UsernameInsert,Signature,SignatureAndPayment);
                          }else{
                             this.createListContract(this.state.existListContract,this.state.jsonBlockstackZ,IdParadigma,TypeContract,ConfigurationContractNumber,IdContainer,IdBillOfLading,IdTypeBillOfLading,DateContract,optx,Subject,StatusBlockchain,UsernameInsert,Signature,SignatureAndPayment);
                          }
                       })
                  }
              }
          }
          if (this.state.JSONTemplateName === 'uploaded'){
              const IdContainer = this.c02FieldContract.current.value,
                    IdBillOfLading = this.c02ConfigurationContract.current.value,
                    Currency = this.c16FieldContract.current.value,
                    Amount = this.c20FieldContract.current.value,
                    IdTypeBillOfLading = this.state.JSONTemplateName,
                    DateContract = this.state.startDate,
                    UploadedfiledecodeAttachX = JSON.stringify(this.state.filedecodeAttachX),
                    UploadedfileAttachX = JSON.stringify(this.state.fileAttachX),
                    ContractPolicy = this.state.cContractPolicy,
                    Signature  = this.c26FieldContract.current.value,
                    SignatureAndPayment = this.state.selectedSignaturePayment,
                    SignatureB = '',
                    CurrencyType = this.c60FieldContract.current.value
              //--------------------------------------------------
              if(ConfigurationContractNumber === '' ||IdTypeBillOfLading === '' || DateContract === '' ) {
                   this.props.validarFormulario(true);
                   this.setState({isErrorWrite: true,
                                  isErrorWriteConfigurationContractNumber: false,
                                  isErrorWriteIdBillOfLading: false,
                                  isErrorWriteIdTypeBillOfLading: false,
                                  isErrorWriteDateContract: false});
                   if (ConfigurationContractNumber === ''){this.setState({isErrorWriteConfigurationContractNumber: true});}
                   if (IdTypeBillOfLading === ''){this.setState({isErrorWriteIdTypeBillOfLading: true});}
                   if (DateContract === ''){this.setState({isErrorWriteDateContract: true});}
                   return;
              } else {
                if ((this.state.cContractPolicy === true && optx === 'insert') || optx !== 'insert') {
                     this.props.validarFormulario(false);
                     this.setState({isLoading: true,isErrorWrite: false});
                     //-------------------------------------------
                     // enviar a Blockstack (Cloud Storage)
                     //-------------------------------------------
                     const jsonBlockstack = `{"idParadigma":"${IdParadigma}","idLogisticContract":"${ConfigurationContractNumber}","idContainer":"${IdContainer}","idBillOfLading":"${IdBillOfLading}","idTypeBillOfLading":"${IdTypeBillOfLading}","dateContract":"${DateContract}","signature":"${SignatureB}","statusLifeCycle":"${StatusLifeCycle}","contractPolicy":"${ContractPolicy}","statusActive":"${StatusActive}","statusActiveAfterPublished":"${StatusActiveAfterPublished}","statusBlockchain":"${StatusBlockchain}","usernameInsert":"${UsernameInsert}","dateInsert":"${DateInsert}","usernameUpdate":"${UsernameUpdate}","dateUpdate":"${DateUpdate}","usernameDelete":"${UsernameDelete}","dateDelete":"${DateDelete}","typeContract":"${TypeContract}","configurationContractNumber":"${ConfigurationContractNumber}","startDate":"${StartDate}","endDate":"${EndDate}","subject":"${Subject}","signatureAndPayment":"${SignatureAndPayment}","amount":"${Amount}","currency":"${Currency}","currencyType":"${CurrencyType}"}`

                     this.setState({ jsonBlockstack })
                     putFileDB(this.state.username,`${this.state.JSONTemplateName}_${ConfigurationContractNumber}.json`, 'Crosscheck_Contract', JSON.stringify(jsonBlockstack), JSON.stringify(options))
                       .then(() => {
                          this.newContractUploaded(UploadedfiledecodeAttachX,UploadedfileAttachX,IdParadigma,TypeContract,ConfigurationContractNumber,IdContainer,IdBillOfLading,IdTypeBillOfLading,DateContract,optx,Subject,StatusBlockchain,UsernameInsert,Signature,SignatureAndPayment);
                       })
                  }
              }
          }
          if (this.state.JSONTemplateName === 'spreadsheet'){
              const IdContainer = this.c02FieldContract.current.value,
                    IdBillOfLading = this.c02ConfigurationContract.current.value,
                    Currency = this.c16FieldContract.current.value,
                    Amount = this.c20FieldContract.current.value,
                    IdTypeBillOfLading = this.state.JSONTemplateName,
                    DateContract = this.state.startDate,
                    SpreadsheetDetail = '',
                    ContractPolicy = this.state.cContractPolicy,
                    Signature  = this.c26FieldContract.current.value,
                    SignatureAndPayment = this.state.selectedSignaturePayment,
                    SignatureB = '',
                    CurrencyType = this.c60FieldContract.current.value
              //--------------------------------------------------
              if(ConfigurationContractNumber === '' ||IdTypeBillOfLading === '' || DateContract === '' ) {
                   this.props.validarFormulario(true);
                   this.setState({isErrorWrite: true,
                                  isErrorWriteConfigurationContractNumber: false,
                                  isErrorWriteIdBillOfLading: false,
                                  isErrorWriteIdTypeBillOfLading: false,
                                  isErrorWriteDateContract: false});
                   if (ConfigurationContractNumber === ''){this.setState({isErrorWriteConfigurationContractNumber: true});}
                   //if (IdBillOfLading === ''){this.setState({isErrorWriteIdBillOfLading: true});}
                   if (IdTypeBillOfLading === ''){this.setState({isErrorWriteIdTypeBillOfLading: true});}
                   if (DateContract === ''){this.setState({isErrorWriteDateContract: true});}
                   return;
              } else {
                 if ((this.state.cContractPolicy === true && optx === 'insert') || optx !== 'insert') {
                     this.props.validarFormulario(false);
                     this.setState({isLoading: true,isErrorWrite: false});
                     //-------------------------------------------
                     // enviar a Blockstack (Cloud Storage)
                     //-------------------------------------------
                     const jsonBlockstack = `{"idParadigma":"${IdParadigma}","idLogisticContract":"${ConfigurationContractNumber}","idContainer":"${IdContainer}","idBillOfLading":"${IdBillOfLading}","idTypeBillOfLading":"${IdTypeBillOfLading}","dateContract":"${DateContract}","signature":"${SignatureB}","statusLifeCycle":"${StatusLifeCycle}","contractPolicy":"${ContractPolicy}","statusActive":"${StatusActive}","statusActiveAfterPublished":"${StatusActiveAfterPublished}","statusBlockchain":"${StatusBlockchain}","usernameInsert":"${UsernameInsert}","dateInsert":"${DateInsert}","usernameUpdate":"${UsernameUpdate}","dateUpdate":"${DateUpdate}","usernameDelete":"${UsernameDelete}","dateDelete":"${DateDelete}","typeContract":"${TypeContract}","configurationContractNumber":"${ConfigurationContractNumber}","startDate":"${StartDate}","endDate":"${EndDate}","subject":"${Subject}","signatureAndPayment":"${SignatureAndPayment}","amount":"${Amount}","currency":"${Currency}","currencyType":"${CurrencyType}"}`
                     this.setState({ jsonBlockstack })
                     putFileDB(this.state.username,`${this.state.JSONTemplateName}_${ConfigurationContractNumber}.json`, 'Crosscheck_Contract', JSON.stringify(jsonBlockstack), JSON.stringify(options))
                       .then(() => {
                          this.newContractSpreadsheet(SpreadsheetDetail,IdParadigma,TypeContract,ConfigurationContractNumber,IdContainer,IdBillOfLading,IdTypeBillOfLading,DateContract,optx,Subject,StatusBlockchain,UsernameInsert,Signature,SignatureAndPayment);
                       })
                 }
              }
          }
          if (this.state.JSONTemplateName === 'workorder'){
              const IdWorkOrder = this.c02ConfigurationContract.current.value,
                    IdContainer = this.c02FieldContract.current.value

              let   IdTypeWorkOrder = this.state.JSONTemplateName,
                    DateContract = this.state.startDate,
                    workordercliente = this.c06FieldContract.current.value,
                    workordercampaña = this.c07FieldContract.current.value,
                    workordersondaje = this.c08FieldContract.current.value,
                    workorderrecomendado = this.c09FieldContract.current.value,
                    workordertipoperforacion = this.c10FieldContract.current.value,
                    workorderfase = this.c11FieldContract.current.value,
                    workordernumerocontrato = this.c12FieldContract.current.value,
                    workorderprimerobjetivo = this.c13FieldContract.current.value,
                    workordersegundoobjetivo = this.c14FieldContract.current.value,
                    workordereste = this.c15FieldContract.current.value,
                    workordernorte = this.c17FieldContract.current.value,
                    workordercotainicio = this.c18FieldContract.current.value,
                    workordercotfinal = this.c19FieldContract.current.value,
                    workorderlargo = this.c21FieldContract.current.value,
                    workorderantepozo = this.c22FieldContract.current.value,
                    workorderfechainiciopozo = this.state.workorderfechainiciopozo,
                    workorderfechaterminoperforacion = this.state.workorderfechaterminoperforacion,
                    workorderfechaterminosondaje = this.state.workorderfechaterminosondaje,
                    workorderdesde = this.c27FieldContract.current.value,
                    workorderhasta = this.c28FieldContract.current.value,
                    workorderazimut = this.c29FieldContract.current.value,
                    workorderdeclinacion = this.c30FieldContract.current.value,
                    workordersobrecargadesde1 = this.c31FieldContract.current.value,
                    workordersobrecargahasta1 = this.c32FieldContract.current.value,
                    workorderantepozodesde1 = this.c33FieldContract.current.value,
                    workorderantepozohasta1 = this.c34FieldContract.current.value,
                    workorderpolvodesde1 = this.c35FieldContract.current.value,
                    workorderpolvohasta1 = this.c36FieldContract.current.value,
                    workorderdiamantinodesde1 = this.c37FieldContract.current.value,
                    workorderdiamantinohasta1 = this.c38FieldContract.current.value,
                    workordersobrecargadesde2 = this.c39FieldContract.current.value,
                    workordersobrecargahasta2 = this.c40FieldContract.current.value,
                    workorderantepozodesde2 = this.c41FieldContract.current.value,
                    workorderantepozohasta2 = this.c42FieldContract.current.value,
                    workorderpolvodesde2 = this.c43FieldContract.current.value,
                    workorderpolvohasta2 = this.c44FieldContract.current.value,
                    workorderdiamantinodesde2 = this.c45FieldContract.current.value,
                    workorderdiamantinohasta2 = this.c46FieldContract.current.value,
                    workorderobservacion = this.c47FieldContract.current.value,
                    workorderfecharealinicio = this.state.workorderfecharealinicio,
                    workordermetaturnodia = this.c48FieldContract.current.value,
                    workordermetaturnonoche = this.c49FieldContract.current.value

              //area para permitir modificaciones post publicacion (aprovechando iocion desactivar)
              //if (ConfigurationContractNumber === 'OT N° 86'){
              //   workorderrecomendado = 'INFILL2023 N99430 P02'
              //   workorderprimerobjetivo = 'INFILL2023'
              //   workordersegundoobjetivo = ''
              //}
              //-----------------------------------------------------------------------------------

              const ContractPolicy = this.state.cContractPolicy
              const Signature  = this.c26FieldContract.current.value,
                    SignatureAndPayment = this.state.selectedSignaturePayment,
                    SignatureB = '',
                    CurrencyType = 'FIAT Money'

              //--------------------------------------------------
              if(ConfigurationContractNumber === '' || IdTypeWorkOrder === '' || DateContract === '' ) {
                   this.props.validarFormulario(true);
                   this.setState({isErrorWrite: true,
                                  isErrorWriteConfigurationContractNumber: false,
                                  isErrorWriteIdWorkOrder: false,
                                  isErrorWriteIdTypeWorkOrder: false,
                                  isErrorWriteDateContract: false});
                   if (ConfigurationContractNumber === ''){this.setState({isErrorWriteConfigurationContractNumber: true});}
                   if (IdWorkOrder === ''){this.setState({isErrorWriteIdWorkOrder: true});}
                   if (DateContract === ''){this.setState({isErrorWriteDateContract: true});}
                   return;
              } else {

                  if ((this.state.cContractPolicy === true && optx === 'insert') || optx !== 'insert') {
                     this.props.validarFormulario(false);
                     this.setState({isLoading: true,isErrorWrite: false});
                     //-------------------------------------------
                     // enviar a Blockstack (Cloud Storage)
                     //-------------------------------------------
                     const jsonBlockstack = `{"idParadigma":"${IdParadigma}","IdTypeWorkOrder":"${IdTypeWorkOrder}","IdWorkOrder":"${ConfigurationContractNumber}","workordercampaña":"${workordercampaña}","workordersondaje":"${workordersondaje}","workorderrecomendado":"${workorderrecomendado}","workordertipoperforacion":"${workordertipoperforacion}","workorderfase":"${workorderfase}","workordernumerocontrato":"${workordernumerocontrato}","workorderprimerobjetivo":"${workorderprimerobjetivo}","workordersegundoobjetivo":"${workordersegundoobjetivo}","workordereste":"${workordereste}","workordernorte":"${workordernorte}","workordercotainicio":"${workordercotainicio}","workordercotfinal":"${workordercotfinal}","workorderlargo":"${workorderlargo}","workorderantepozo":"${workorderantepozo}","workorderfechainiciopozo":"${workorderfechainiciopozo}","workorderfechaterminoperforacion":"${workorderfechaterminoperforacion}","workorderfechaterminosondaje":"${workorderfechaterminosondaje}","workorderdesde":"${workorderdesde}","workorderhasta":"${workorderhasta}","workorderazimut":"${workorderazimut}","workorderdeclinacion":"${workorderdeclinacion}","workordersobrecargadesde1":"${workordersobrecargadesde1}","workordersobrecargahasta1":"${workordersobrecargahasta1}","workorderantepozodesde1":"${workorderantepozodesde1}","workorderantepozohasta1":"${workorderantepozohasta1}","workorderpolvodesde1":"${workorderpolvodesde1}","workorderpolvohasta1":"${workorderpolvohasta1}","workorderdiamantinodesde1":"${workorderdiamantinodesde1}","workorderdiamantinohasta1":"${workorderdiamantinohasta1}","workordersobrecargadesde2":"${workordersobrecargadesde2}","workordersobrecargahasta2":"${workordersobrecargahasta2}","workorderantepozodesde2":"${workorderantepozodesde2}","workorderantepozohasta2":"${workorderantepozohasta2}","workorderpolvodesde2":"${workorderpolvodesde2}","workorderpolvohasta2":"${workorderpolvohasta2}","workorderdiamantinodesde2":"${workorderdiamantinodesde2}","workorderdiamantinohasta2":"${workorderdiamantinohasta2}","workorderobservacion":"${workorderobservacion}","signature":"${SignatureB}","statusLifeCycle":"${StatusLifeCycle}","contractPolicy":"${ContractPolicy}","statusActive":"${StatusActive}","statusActiveAfterPublished":"${StatusActiveAfterPublished}","statusBlockchain":"${StatusBlockchain}","usernameInsert":"${UsernameInsert}","dateInsert":"${DateInsert}","usernameUpdate":"${UsernameUpdate}","dateUpdate":"${DateUpdate}","usernameDelete":"${UsernameDelete}","dateDelete":"${DateDelete}","typeContract":"${TypeContract}","configurationContractNumber":"${ConfigurationContractNumber}","startDate":"${StartDate}","endDate":"${EndDate}","subject":"${Subject}","signatureAndPayment":"${SignatureAndPayment}","dateContract":"${DateContract}","workordercliente":"${workordercliente}","workorderfecharealinicio":"${workorderfecharealinicio}","workordermetaturnodia":"${workordermetaturnodia}","workordermetaturnonoche":"${workordermetaturnonoche}"}`
                     this.setState({ jsonBlockstack })
                     putFileDB(this.state.username,`${this.state.JSONTemplateName}_${ConfigurationContractNumber}.json`, 'Crosscheck_Contract', JSON.stringify(jsonBlockstack), JSON.stringify(options))
                       .then(() => {
                            this.createListContract(this.state.existListContract,this.state.jsonBlockstackZ,IdParadigma,TypeContract,ConfigurationContractNumber,IdContainer,IdWorkOrder,IdTypeWorkOrder,DateContract,optx,Subject,StatusBlockchain,UsernameInsert,Signature,SignatureAndPayment);
                     })
                  }
              }
          }
     }

     modifyWorkOrderDatoExtra = async (e) => {
         const {userSession} = this.state
         const storage = new Storage({ userSession });
         const options = {contentType: 'application/json', encrypt: false, dangerouslyIgnoreEtag: true }
         const TypeContract = this.state.JSONTemplateName
         const ConfigurationContractNumber = this.c02ConfigurationContract.current.value

         const workorderfecharealinicio = this.state.workorderfecharealinicio
         const workordermetaturnodia = this.c48FieldContract.current.value
         const workordermetaturnonoche = this.c49FieldContract.current.value

         const workordersobrecargadesde2 = this.c39FieldContract.current.value
         const workordersobrecargahasta2 = this.c40FieldContract.current.value
         const workorderantepozodesde2 = this.c41FieldContract.current.value
         const workorderantepozohasta2 = this.c42FieldContract.current.value
         const workorderpolvodesde2 = this.c43FieldContract.current.value
         const workorderpolvohasta2 = this.c44FieldContract.current.value
         const workorderdiamantinodesde2 = this.c45FieldContract.current.value
         const workorderdiamantinohasta2 = this.c46FieldContract.current.value
         const workorderobservacion = this.c47FieldContract.current.value

         const workorderfechainiciopozo = this.state.workorderfechainiciopozo
         const workorderfechaterminoperforacion = this.state.workorderfechaterminoperforacion
         const workorderfechaterminosondaje = this.state.workorderfechaterminosondaje

         const jsonBlockstack = `{"workorderfecharealinicio":"${workorderfecharealinicio}","workordermetaturnodia":"${workordermetaturnodia}","workordermetaturnonoche":"${workordermetaturnonoche}","workordersobrecargadesde2":"${workordersobrecargadesde2}","workordersobrecargahasta2":"${workordersobrecargahasta2}","workorderantepozodesde2":"${workorderantepozodesde2}","workorderantepozohasta2":"${workorderantepozohasta2}","workorderpolvodesde2":"${workorderpolvodesde2}","workorderpolvohasta2":"${workorderpolvohasta2}","workorderdiamantinodesde2":"${workorderdiamantinodesde2}","workorderdiamantinohasta2":"${workorderdiamantinohasta2}","workorderobservacion":"${workorderobservacion}","workorderfechainiciopozo":"${workorderfechainiciopozo}","workorderfechaterminoperforacion":"${workorderfechaterminoperforacion}","workorderfechaterminosondaje":"${workorderfechaterminosondaje}"}`
         this.setState({ jsonBlockstack })
         putFileDB(this.state.username,`${TypeContract}_${ConfigurationContractNumber}_workorder_datoextra.json`, 'Crosscheck_Contract', JSON.stringify(jsonBlockstack), JSON.stringify(options))
           .then(() => {
         })
     }

     readWorkOrderDatoExtra = async (e) => {
       const {userSession} = this.state
       const storage = new Storage({ userSession });
       const options = { decrypt: false, verify: false }
       const typeContract = this.state.typeContractSign
       const configurationContractNumber = this.state.configurationContractNumberSign
       await getFileDB(this.state.username,`${typeContract}_${configurationContractNumber}_workorder_datoextra.json`)
         .then((fileContents) => {
           if(fileContents) {
              const jsonBlockstack1 = JSON.parse(fileContents)
              const jsonBlockstack2 = jsonBlockstack1.data
              let jsonBlockstack4 = ''
              let jsonBlockstack5 = '[]'
              if (jsonBlockstack2 !== null){
                 const jsonBlockstack3 = jsonBlockstack2.dataobject
                 jsonBlockstack4 = jsonBlockstack3.replace(/\\/g,"");
                 if (jsonBlockstack4.substring(0,1) === '"') {
                    jsonBlockstack5 = jsonBlockstack4.substring(1,jsonBlockstack4.length - 1)
                 } else {
                    jsonBlockstack5 = jsonBlockstack4
                 }
              }
              let jsonBlockstack6 = JSON.parse(jsonBlockstack5)
              jsonBlockstack4 = JSON.parse(jsonBlockstack5)

              this.c48FieldContract.current.value = jsonBlockstack4.workordermetaturnodia
              this.c49FieldContract.current.value = jsonBlockstack4.workordermetaturnonoche
              this.setState({workordermetaturnodia:jsonBlockstack4.workordermetaturnodia})
              this.setState({workordermetaturnonoche:jsonBlockstack4.workordermetaturnonoche})
              if (isNaN(Date.parse(jsonBlockstack4.workorderfecharealinicio))){
                 this.setState({workorderfecharealinicio: new Date()})
              }else{
                this.setState({workorderfecharealinicio: new Date(jsonBlockstack4.workorderfecharealinicio)})
              }

              this.c39FieldContract.current.value = jsonBlockstack4.workordersobrecargadesde2
              this.c40FieldContract.current.value = jsonBlockstack4.workordersobrecargahasta2
              this.c41FieldContract.current.value = jsonBlockstack4.workorderantepozodesde2
              this.c42FieldContract.current.value = jsonBlockstack4.workorderantepozohasta2
              this.c43FieldContract.current.value = jsonBlockstack4.workorderpolvodesde2
              this.c44FieldContract.current.value = jsonBlockstack4.workorderpolvohasta2
              this.c45FieldContract.current.value = jsonBlockstack4.workorderdiamantinodesde2
              this.c46FieldContract.current.value = jsonBlockstack4.workorderdiamantinohasta2
              this.c47FieldContract.current.value = jsonBlockstack4.workorderobservacion

              if (isNaN(Date.parse(jsonBlockstack4.workorderfechainiciopozo))){
                 this.setState({workorderfechainiciopozo: new Date()})
              }else{
                 this.setState({workorderfechainiciopozo: new Date(jsonBlockstack4.workorderfechainiciopozo)})
              }
              if (isNaN(Date.parse(jsonBlockstack4.workorderfechaterminoperforacion))){
                 this.setState({workorderfechaterminoperforacion: new Date()})
              }else{
                 this.setState({workorderfechaterminoperforacion: new Date(jsonBlockstack4.workorderfechaterminoperforacion)})
              }
              if (isNaN(Date.parse(jsonBlockstack4.workorderfechaterminosondaje))){
                 this.setState({workorderfechaterminosondaje: new Date()})
              }else{
                 this.setState({workorderfechaterminosondaje: new Date(jsonBlockstack4.workorderfechaterminosondaje)})
              }
           }
         })
        .catch(error => {});
     }


     newContractBlank(BlankDetail,IdParadigma,TypeContract,ConfigurationContractNumber,IdContainer,IdBillOfLading,IdTypeBillOfLading,DateContract,optx,Subject,StatusBlockchain,UsernameInsert,Signature,SignatureAndPayment){
       const {userSession} = this.state
       const storage = new Storage({ userSession });
       const options = {contentType: 'application/json', encrypt: false, dangerouslyIgnoreEtag: true }
       putFileDB(this.state.username,`${TypeContract}_${ConfigurationContractNumber}_blankdetail.json`, 'Crosscheck_Contract', BlankDetail, JSON.stringify(options))
         .then(() => {
            this.createListContract(this.state.existListContract,this.state.jsonBlockstackZ,IdParadigma,TypeContract,ConfigurationContractNumber,IdContainer,IdBillOfLading,IdTypeBillOfLading,DateContract,optx,Subject,StatusBlockchain,UsernameInsert,Signature,SignatureAndPayment);
         })
     }

     newContractUploaded(UploadedfiledecodeAttachX,UploadedfileAttachX,IdParadigma,TypeContract,ConfigurationContractNumber,IdContainer,IdBillOfLading,IdTypeBillOfLading,DateContract,optx,Subject,StatusBlockchain,UsernameInsert,Signature,SignatureAndPayment){
       const {userSession} = this.state
       const storage = new Storage({ userSession });
       const options = {contentType: 'application/json', encrypt: false, dangerouslyIgnoreEtag: true }
       const jsonAttachFileX=`{"file":${UploadedfileAttachX}}`
       putFileDB(this.state.username,`${TypeContract}_${ConfigurationContractNumber}_uploadeddetail.json`, 'Crosscheck_Contract', JSON.stringify(jsonAttachFileX), JSON.stringify(options))
         .then(() => {
            this.createListContract(this.state.existListContract,this.state.jsonBlockstackZ,IdParadigma,TypeContract,ConfigurationContractNumber,IdContainer,IdBillOfLading,IdTypeBillOfLading,DateContract,optx,Subject,StatusBlockchain,UsernameInsert,Signature,SignatureAndPayment);
         })
     }

     newContractSpreadsheet(SpreadsheetfileAttachX,IdParadigma,TypeContract,ConfigurationContractNumber,IdContainer,IdBillOfLading,IdTypeBillOfLading,DateContract,optx,Subject,StatusBlockchain,UsernameInsert,Signature,SignatureAndPayment){
       const {userSession} = this.state
       const storage = new Storage({ userSession });
       const options = {contentType: 'application/json', encrypt: false, dangerouslyIgnoreEtag: true }
       const jsonAttachFileX=`{"file":${SpreadsheetfileAttachX}}`
       putFileDB(this.state.username,`${TypeContract}_${ConfigurationContractNumber}_uploadeddetail.json`, 'Crosscheck_Contract', JSON.stringify(jsonAttachFileX), JSON.stringify(options))
         .then(() => {
            this.createListContract(this.state.existListContract,this.state.jsonBlockstackZ,IdParadigma,TypeContract,ConfigurationContractNumber,IdContainer,IdBillOfLading,IdTypeBillOfLading,DateContract,optx,Subject,StatusBlockchain,UsernameInsert,Signature,SignatureAndPayment);
         })
     }

     saveBlockchainPact = async (e) => {
       let {jsonEnrollment} = this.state
       if (this.state.JSONTemplateName === 'delivery' || this.state.JSONTemplateName === 'simulate'){
           jsonEnrollment.map((todo,i) => {
             const StatusBlockchain = 'Blockchain'
             //const StatusActive = 'true'
             //--------------------------------------------------
             //Datos Fijos
             //--------------------------------------------------
             const IdParadigma = uuid(),
                   TypeContract = this.state.JSONTemplateName,
                   ConfigurationContractNumber = this.c02ConfigurationContract.current.value,
                   StartDate = this.state.startDate,
                   EndDate = this.state.endDate,
                   TransportOriginDestination = this.state.c03ConfigurationContract,
                   ConditionsIntegrityMaterials = this.state.c04ConfigurationContract,
                   UseAssets = this.state.c05ConfigurationContract,
                   //PactID = this.c06ConfigurationContract.current.value,
                   UsernameInsert = this.state.username,
                   DateInsert = this.state.nowDate,
                   UsernameUpdate = "",
                   DateUpdate = "",
                   UsernameDelete = "",
                   DateDelete = ""
             //let Subject = ""
             if (this.c09ConfigurationContract.current.value !== undefined){
                //Subject = this.c09ConfigurationContract.current.value
             }
             //--------------------------------------------------
             //Datos Variables
             //--------------------------------------------------
             const //IdContainer = this.c02FieldContract.current.value,
                   //IdBillOfLading = this.c03FieldContract.current.value,
                   //IdBillOfLading = this.c02ConfigurationContract.current.value,
                   IdTypeBillOfLading = this.c04FieldContract.current.value,
                   DateContract = this.state.startDate,
                   Shipper = this.c06FieldContract.current.value,
                   Consignee = this.c07FieldContract.current.value,
                   NotifyParty = this.c08FieldContract.current.value,
                   Carrier = this.c09FieldContract.current.value,
                   PlaceOfAceptance = this.c10FieldContract.current.value,
                   PortOfLading = this.c11FieldContract.current.value,
                   Vessel = this.c12FieldContract.current.value,
                   PortOfDischarge = this.c13FieldContract.current.value,
                   PlaceOfDelivery = this.c14FieldContract.current.value,
                   FinalDestination = this.c15FieldContract.current.value,
                   Currency = this.c16FieldContract.current.value,
                   Amount = this.c20FieldContract.current.value,
                   StatusLifeCycle = "Published",
                   ContractPolicy = this.state.cContractPolicy
              const Signature = this.state.jsonUserGroupPact
              //--------------------------------------------------
              this.props.validarFormulario(false);
              this.setState({isLoading: true,isErrorWrite: false});
              this.props.saveNewPactLogisticConfig(IdParadigma,
                                                   TypeContract,
                                                   ConfigurationContractNumber,
                                                   StartDate,
                                                   EndDate,
                                                   TransportOriginDestination,
                                                   ConditionsIntegrityMaterials,
                                                   UseAssets,
                                                   StatusBlockchain,
                                                   UsernameInsert,
                                                   DateInsert,
                                                   UsernameUpdate,
                                                   DateUpdate,
                                                   UsernameDelete,
                                                   DateDelete,
                                                   IdTypeBillOfLading,
                                                   DateContract,
                                                   Shipper,
                                                   Consignee,
                                                   NotifyParty,
                                                   Carrier,
                                                   PlaceOfAceptance,
                                                   PortOfLading,
                                                   Vessel,
                                                   PortOfDischarge,
                                                   PlaceOfDelivery,
                                                   FinalDestination,
                                                   Amount,
                                                   Currency,
                                                   Signature,
                                                   StatusLifeCycle,
                                                   ContractPolicy)
/*
              this.props.saveNewPactLogisticRules(IdParadigma,
                                                  TypeContract,
                                                  ConfigurationContractNumber,
                                                  todo.enrollment,
                                                  IdTypeBillOfLading,
                                                  todo.temperature,
                                                  todo.humidity,
                                                  todo.gascontrol,
                                                  todo.impact,
                                                  todo.vibration,
                                                  todo.proximity,
                                                  todo.sealIntegrity,
                                                  todo.gps,
                                                  todo.temperatureLowerThreshold,
                                                  todo.temperatureUpperThreshold,
                                                  todo.temperatureFrecuency,
                                                  todo.temperatureUnitFrecuency,
                                                  todo.temperatureUnitMeasurement,
                                                  todo.temperatureErrorTime,
                                                  todo.temperatureErrorTimeUnit,
                                                  todo.temperatureErrorAction,
                                                  todo.temperatureActiveRule,
                                                  todo.humidityLowerThreshold,
                                                  todo.humidityUpperThreshold,
                                                  todo.humidityFrecuency,
                                                  todo.humidityUnitFrecuency,
                                                  todo.humidityUnitMeasurement,
                                                  todo.humidityErrorTime,
                                                  todo.humidityErrorTimeUnit,
                                                  todo.humidityErrorAction,
                                                  todo.humidityActiveRule,
                                                  todo.gascontrolLowerThreshold,
                                                  todo.gascontrolUpperThreshold,
                                                  todo.gascontrolFrecuency,
                                                  todo.gascontrolUnitFrecuency,
                                                  todo.gascontrolUnitMeasurement,
                                                  todo.gascontrolErrorTime,
                                                  todo.gascontrolErrorTimeUnit,
                                                  todo.gascontrolErrorAction,
                                                  todo.gascontrolActiveRule,
                                                  todo.GPSFrecuency,
                                                  todo.GPSUnitFrecuency,
                                                  todo.GPSUnitMeasurement,
                                                  todo.GPSErrorTime,
                                                  todo.GPSErrorTimeUnit,
                                                  todo.GPSErrorAction,
                                                  todo.GPSActiveRule)
*/
           })
        }else{
          if (this.state.JSONTemplateName === 'maintenance'){
            jsonEnrollment.map((todo,i) => {
              const StatusBlockchain = 'Blockchain'
              //const StatusActive = 'true'
              //--------------------------------------------------
              //Datos Fijos
              //--------------------------------------------------
              const IdParadigma = uuid(),
                    TypeContract = this.state.JSONTemplateName,
                    ConfigurationContractNumber = this.c02ConfigurationContract.current.value,
                    StartDate = this.state.startDate,
                    EndDate = this.state.endDate,
                    UsernameInsert = this.state.username,
                    DateInsert = this.state.nowDate,
                    UsernameUpdate = "",
                    DateUpdate = "",
                    UsernameDelete = "",
                    DateDelete = ""
              //let Subject = ""
              if (this.c09ConfigurationContract.current.value !== undefined){
                 //Subject = this.c09ConfigurationContract.current.value
              }
              //--------------------------------------------------
              //Datos Variables
              //--------------------------------------------------
              const IdTypeBillOfLading = this.c04FieldContract.current.value,
                    DateContract = this.state.startDate,
                    YourNameCompany = this.c06FieldContract.current.value,
                    YourAddress = this.c07FieldContract.current.value,
                    ClientNameCompany = this.c10FieldContract.current.value,
                    ClientAddress = this.c11FieldContract.current.value,
                    Currency = this.c16FieldContract.current.value,
                    Amount = this.c20FieldContract.current.value,
                    Observations = this.c30FieldContract.current.value,
                    Responsible = this.c31FieldContract.current.value,
                    Frecuency = this.c32FieldContract.current.value,
                    Proyect = this.c33FieldContract.current.value,
                    StatusLifeCycle = "Published",
                    ContractPolicy = this.state.cContractPolicy
               const Signature = this.state.jsonUserGroupPact
               const TypeMaintenance = this.state.selectedTypeMaintenance
               //--------------------------------------------------
               this.props.validarFormulario(false);
               this.setState({isLoading: true,isErrorWrite: false});
               this.props.saveNewPactMaintenanceConfig(IdParadigma,
                                                    TypeContract,
                                                    ConfigurationContractNumber,
                                                    StartDate,
                                                    EndDate,
                                                    StatusBlockchain,
                                                    UsernameInsert,
                                                    DateInsert,
                                                    UsernameUpdate,
                                                    DateUpdate,
                                                    UsernameDelete,
                                                    DateDelete,
                                                    IdTypeBillOfLading,
                                                    DateContract,
                                                    YourNameCompany,
                                                    YourAddress,
                                                    ClientNameCompany,
                                                    ClientAddress,
                                                    Amount,
                                                    Currency,
                                                    Signature,
                                                    StatusLifeCycle,
                                                    ContractPolicy)
/*
               this.props.saveNewPactMaintenanceRules(IdParadigma,
                                                   TypeContract,
                                                   ConfigurationContractNumber,
                                                   todo.enrollment,
                                                   IdTypeBillOfLading,
                                                   todo.fire,
                                                   todo.flood,
                                                   todo.sealintegrity,
                                                   todo.motion,
                                                   todo.smoke,
                                                   todo.fireErrorAction,
                                                   todo.fireActiveRule,
                                                   todo.floodErrorAction,
                                                   todo.floodActiveRule,
                                                   todo.sealintegrityErrorAction,
                                                   todo.sealintegrityActiveRule,
                                                   todo.motionErrorAction,
                                                   todo.motionActiveRule,
                                                   todo.smokeErrorAction,
                                                   todo.smokeActiveRule)
*/
            })
          }else{
            if (this.state.JSONTemplateName === 'proforma'){
                const StatusBlockchain = 'Blockchain'
                //const StatusActive = 'true'
                //--------------------------------------------------
                //Datos Fijos
                //--------------------------------------------------
                const IdParadigma = uuid(),
                      TypeContract = this.state.JSONTemplateName,
                      ConfigurationContractNumber = this.c02ConfigurationContract.current.value,
                      StartDate = this.state.startDate,
                      EndDate = this.state.endDate,
                      UsernameInsert = this.state.username,
                      DateInsert = this.state.nowDate,
                      UsernameUpdate = "",
                      DateUpdate = "",
                      UsernameDelete = "",
                      DateDelete = ""
                //let Subject = ""
                if (this.c09ConfigurationContract.current.value !== undefined){
                   //Subject = this.c09ConfigurationContract.current.value
                }
                //--------------------------------------------------
                //Datos Variables
                //--------------------------------------------------
                const IdTypeBillOfLading = this.c04FieldContract.current.value,
                      DateContract = this.state.startDate,
                      Shippername = this.c06FieldContract.current.value,
                      Shippercompanyname = this.c07FieldContract.current.value,
                      Shippercontactperson = this.c08FieldContract.current.value,
                      Shipperstreetaddress = this.c09FieldContract.current.value,
                      Shippercitystzipcode = this.c10FieldContract.current.value,
                      Shipperphone = this.c11FieldContract.current.value,
                      Shipperemail = this.c12FieldContract.current.value,
                      Receivername = this.c13FieldContract.current.value,
                      Receivercompanyname = this.c14FieldContract.current.value,
                      Receivercontactperson = this.c15FieldContract.current.value,
                      Currency = this.c16FieldContract.current.value,
                      Receiverstreetaddress = this.c17FieldContract.current.value,
                      Receivercitystzipcode = this.c18FieldContract.current.value,
                      Receiverphone = this.c19FieldContract.current.value,
                      Receiveremail = this.c20FieldContract.current.value,
                      Reference = this.c21FieldContract.current.value,
                      Modeoftransport = this.c22FieldContract.current.value,
                      Totalnumberpackages = this.c23FieldContract.current.value,
                      Totalgrossweight = this.c24FieldContract.current.value,
                      Productid = this.c25FieldContract.current.value,
                      Description = this.c40FieldContract.current.value,
                      Quantity = this.c27FieldContract.current.value,
                      Unitprice = this.c28FieldContract.current.value,
                      Proformasubtotal = this.c29FieldContract.current.value,
                      Proformadiscount = this.c30FieldContract.current.value,
                      Proformataxrate = this.c31FieldContract.current.value,
                      Proformasalesrate = this.c32FieldContract.current.value,
                      Proformashipping = this.c33FieldContract.current.value,
                      Proformatotal = this.c34FieldContract.current.value,
                      Countryoforigin = this.c35FieldContract.current.value,
                      Portofembarcation = this.c36FieldContract.current.value,
                      Reasonforexport = this.c37FieldContract.current.value,
                      Portofdischarge = this.c38FieldContract.current.value,
                      Termsaleothercomments = this.c39FieldContract.current.value

                 const StatusLifeCycle = "Published",
                       ContractPolicy = this.state.cContractPolicy
                 const Signature = this.state.jsonUserGroupPact
                 //--------------------------------------------------
                 this.props.validarFormulario(false);
                 this.setState({isLoading: true,isErrorWrite: false});
                 this.props.saveNewPactProformaConfig(IdParadigma,
                                                      TypeContract,
                                                      ConfigurationContractNumber,
                                                      StartDate,
                                                      EndDate,
                                                      StatusBlockchain,
                                                      UsernameInsert,
                                                      DateInsert,
                                                      UsernameUpdate,
                                                      DateUpdate,
                                                      UsernameDelete,
                                                      DateDelete,
                                                      IdTypeBillOfLading,
                                                      DateContract,
                                                      Shippername,
                                                      Shippercompanyname,
                                                      Shippercontactperson,
                                                      Shipperstreetaddress,
                                                      Shippercitystzipcode,
                                                      Shipperphone,
                                                      Shipperemail,
                                                      Receivername,
                                                      Receivercompanyname,
                                                      Receivercontactperson,
                                                      Currency,
                                                      Receiverstreetaddress,
                                                      Receivercitystzipcode,
                                                      Receiverphone,
                                                      Receiveremail,
                                                      Reference,
                                                      Modeoftransport,
                                                      Totalnumberpackages,
                                                      Totalgrossweight,
                                                      Productid,
                                                      Description,
                                                      Quantity,
                                                      Unitprice,
                                                      Proformasubtotal,
                                                      Proformadiscount,
                                                      Proformataxrate,
                                                      Proformasalesrate,
                                                      Proformashipping,
                                                      Proformatotal,
                                                      Countryoforigin,
                                                      Portofembarcation,
                                                      Reasonforexport,
                                                      Portofdischarge,
                                                      Termsaleothercomments,
                                                      Signature,
                                                      StatusLifeCycle,
                                                      ContractPolicy)
/*
                  this.props.saveNewPactProformaRules(IdParadigma,
                                                      TypeContract,
                                                      ConfigurationContractNumber,
                                                      StartDate,
                                                      EndDate,
                                                      StatusBlockchain,
                                                      UsernameInsert,
                                                      DateInsert,
                                                      UsernameUpdate,
                                                      DateUpdate,
                                                      UsernameDelete,
                                                      DateDelete,
                                                      IdTypeBillOfLading,
                                                      DateContract,
                                                      Gps,
                                                      GPSFrecuency,
                                                      GPSUnitFrecuency,
                                                      GPSUnitMeasurement,
                                                      GPSErrorTime,
                                                      GPSErrorTimeUnit,
                                                      GPSErrorAction,
                                                      GPSActiveRule)
*/
            }else{
              if (this.state.JSONTemplateName === 'blank'){
              }else{
                if (this.state.JSONTemplateName === 'uploaded'){
                }else{
                  if (this.state.JSONTemplateName === 'spreadsheet'){
                  }else{
                    if (this.state.JSONTemplateName === 'workorder'){
                    }
                  }
                }
              }
            }
          }
        }
     }

     sendContract = async () => {
       const {userSession} = this.state
       const storage = new Storage({ userSession });
       const options = { decrypt: false, verify: false }
       const typeContract = this.state.typeContractSign
       const configurationContractNumber = this.state.configurationContractNumberSign
       await getFileDB(this.state.username, `${typeContract}_${configurationContractNumber}_usergroup.json`)
         .then((fileContents) => {
           if(fileContents) {
              const jsonBlockstack1 = JSON.parse(fileContents)
              const jsonBlockstack2 = jsonBlockstack1.data
              let jsonBlockstack5 = '[]'
              if (jsonBlockstack2 !== null){
                 const jsonBlockstack3 = jsonBlockstack2.dataobject
                 const jsonBlockstack4 = jsonBlockstack3.replace(/\\/g,"");
                 if (jsonBlockstack4.substring(0,1) === '"') {
                    jsonBlockstack5 = jsonBlockstack4.substring(1,jsonBlockstack4.length - 1)
                 } else {
                    jsonBlockstack5 = jsonBlockstack4
                 }
              }
              let jsonBlockstack6 = JSON.parse(jsonBlockstack5)
              jsonBlockstack6.map((todo2,key2)=>{
                  if ((todo2.role === 'Authorizer' || todo2.role === 'Authorizer-Inviter' || todo2.role === 'Observer') && (todo2.publicKey !== '' && todo2.publicKey !== undefined)){
                  }
              })
           } else {}
         })
        .catch(error => {});
       localStorage.removeItem('jsonBlockstack2')
       localStorage.removeItem('idsmartcontract')
       localStorage.removeItem('searchContract')
       localStorage.removeItem('jsonBlockstack50L')
       this.setState({displayTemplateDetail: false,searchContract2: false})
       //this.listContract(this.state.username)
       this.returnProps('returnWithFilter',typeContract,configurationContractNumber)
     }

     createListContract = (existListContract,jsonBlockstackZ,Id,TypeContract,ConfigurationContractNumber,IdContainer,IdBillOfLading,IdTypeBillOfLading,DateLogisticContract,optx,Subject,StatusBlockchain,UsernameInsert,Signature,SignatureAndPayment) => {
       const {userSession} = this.state
       const storage = new Storage({ userSession });
       const options = {contentType: 'application/json', encrypt: false, dangerouslyIgnoreEtag: true }
       let jsonBlockstack2 = ''
       let infoListContract = ''
       let active = true
       let active_after_published = true

       if (optx==='delete'){
         active = false;
       }
       if (optx==='inactive_after_published'){
         active_after_published = false;
       }
       let encryptDecryptFileX = false
       if (this.state.encryptDecryptFile === 'Yes'){
          encryptDecryptFileX = true
       }
       if (optx === 'insert'){
           if (localStorage["jsonBlockstack50L"]) {
             jsonBlockstack2 = localStorage.getItem('jsonBlockstack50L')
             const jsonBlockstack3 = jsonBlockstack2.substring(1,jsonBlockstack2.length - 1)
             if (jsonBlockstack3 === '') {
                infoListContract=`[{"id":"${Id}","typeContract":"${TypeContract}","configurationContractNumber":"${ConfigurationContractNumber}","idContainer":"${IdContainer}","idBillOfLading":"${IdBillOfLading}","idTypeBillOfLading":"${IdTypeBillOfLading}","dateLogisticContract":"${DateLogisticContract}","active":"${active}","subject":"${Subject}","statusBlockchain":"${StatusBlockchain}","activeUserGroup":false,"confirmSign":false,"activeDeliverable":false,"activeDataDashboard":false,"encryptDecryptFile":${encryptDecryptFileX},"signatureAndPayment":"${SignatureAndPayment}","active_after_published":"${active_after_published}"}]`
             }else{
                infoListContract =`[${jsonBlockstack3},{"id":"${Id}","typeContract":"${TypeContract}","configurationContractNumber":"${ConfigurationContractNumber}","idContainer":"${IdContainer}","idBillOfLading":"${IdBillOfLading}","idTypeBillOfLading":"${IdTypeBillOfLading}","dateLogisticContract":"${DateLogisticContract}","active":"${active}","subject":"${Subject}","statusBlockchain":"${StatusBlockchain}","activeUserGroup":false,"confirmSign":false,"activeDeliverable":false,"activeDataDashboard":false,"encryptDecryptFile":${encryptDecryptFileX},"signatureAndPayment":"${SignatureAndPayment}","active_after_published":"${active_after_published}"}]`
             }
           }else{
             infoListContract =`[{"id":"${Id}","typeContract":"${TypeContract}","configurationContractNumber":"${ConfigurationContractNumber}","idContainer":"${IdContainer}","idBillOfLading":"${IdBillOfLading}","idTypeBillOfLading":"${IdTypeBillOfLading}","dateLogisticContract":"${DateLogisticContract}","active":"${active}","subject":"${Subject}","statusBlockchain":"${StatusBlockchain}","activeUserGroup":false,"confirmSign":false,"activeDeliverable":false,"activeDataDashboard":false,"encryptDecryptFile":${encryptDecryptFileX},"signatureAndPayment":"${SignatureAndPayment}","active_after_published":"${active_after_published}"}]`
           }
           this.setState({ infoListContract })
           putFileDB(this.state.username,`contractlist.json`, 'Crosscheck_Contract', JSON.stringify(infoListContract), JSON.stringify(options))
             .then(() => {
                this.createUserGroup(existListContract,jsonBlockstackZ,Id,TypeContract,ConfigurationContractNumber,IdContainer,IdBillOfLading,IdTypeBillOfLading,DateLogisticContract,optx,Subject,StatusBlockchain,UsernameInsert);
             })
             .catch(error => {});
       }
       if (optx === 'delete'){
         if (localStorage["jsonBlockstack50L"]) {
           jsonBlockstack2 = localStorage.getItem('jsonBlockstack50L')
           const jsonBlockstack3a = JSON.parse(jsonBlockstack2)
           jsonBlockstack3a.map((todo, i) => {
                if (todo.typeContract === TypeContract && todo.configurationContractNumber === ConfigurationContractNumber) {
                   if (todo.statusBlockchain==="Cloud"){
                      todo.active = "false"
                   }
                }
           })
           putFileDB(this.state.username,`contractlist.json`, 'Crosscheck_Contract', JSON.stringify(jsonBlockstack3a), JSON.stringify(options))
             .then(() => {
                localStorage.removeItem('jsonBlockstack2')
                localStorage.removeItem('idsmartcontract')
                localStorage.removeItem('searchContract')
                localStorage.removeItem('jsonBlockstack50L')
                this.setState({displayTemplateDetail: false,searchContract2: false})
                //this.listContract(this.state.username)
                this.returnProps('returnWithFilter',TypeContract,ConfigurationContractNumber)
             })
             .catch(error => {});
         }
       }
       if (optx === 'modify'){
         if (localStorage["jsonBlockstack50L"]) {
           jsonBlockstack2 = localStorage.getItem('jsonBlockstack50L')
           const jsonBlockstack3a = JSON.parse(jsonBlockstack2)
           jsonBlockstack3a.map((todo, i) => {
                if (todo.typeContract === TypeContract && todo.configurationContractNumber === ConfigurationContractNumber) {
                   if (todo.statusBlockchain !== StatusBlockchain){
                       todo.statusBlockchain = StatusBlockchain
                   }
                   todo.active = "true"
                   todo.subject = Subject
                   todo.encryptDecryptFile = encryptDecryptFileX
                   todo.signatureAndPayment = SignatureAndPayment
                }
           })
           putFileDB(this.state.username,`contractlist.json`, 'Crosscheck_Contract', JSON.stringify(jsonBlockstack3a), JSON.stringify(options))
             .then(() => {
                this.signUserGroup(TypeContract,ConfigurationContractNumber,UsernameInsert,Signature)
             })
             .catch(error => {});
         }
       }
       if (optx === 'inactive_after_published'){
         if (localStorage["jsonBlockstack50L"]) {
           jsonBlockstack2 = localStorage.getItem('jsonBlockstack50L')
           const jsonBlockstack3a = JSON.parse(jsonBlockstack2)
           jsonBlockstack3a.map((todo, i) => {
                if (todo.typeContract === TypeContract && todo.configurationContractNumber === ConfigurationContractNumber) {
                    todo.active_after_published = "false"
                }
           })
           putFileDB(this.state.username,`contractlist.json`, 'Crosscheck_Contract', JSON.stringify(jsonBlockstack3a), JSON.stringify(options))
             .then(() => {
                localStorage.removeItem('jsonBlockstack2')
                localStorage.removeItem('idsmartcontract')
                localStorage.removeItem('searchContract')
                localStorage.removeItem('jsonBlockstack50L')
                this.setState({displayTemplateDetail: false,searchContract2: false})
                //this.listContract(this.state.username)
                this.returnProps('returnWithFilter',TypeContract,ConfigurationContractNumber)
             })
             .catch(error => {});
         }
       }
       if (optx === 'active_after_published'){
         if (localStorage["jsonBlockstack50L"]) {
           jsonBlockstack2 = localStorage.getItem('jsonBlockstack50L')
           const jsonBlockstack3a = JSON.parse(jsonBlockstack2)
           jsonBlockstack3a.map((todo, i) => {
                if (todo.typeContract === TypeContract && todo.configurationContractNumber === ConfigurationContractNumber) {
                    todo.active_after_published = "true"
                }
           })
           putFileDB(this.state.username,`contractlist.json`, 'Crosscheck_Contract', JSON.stringify(jsonBlockstack3a), JSON.stringify(options))
             .then(() => {
                localStorage.removeItem('jsonBlockstack2')
                localStorage.removeItem('idsmartcontract')
                localStorage.removeItem('searchContract')
                localStorage.removeItem('jsonBlockstack50L')
                this.setState({displayTemplateDetail: false,searchContract2: false})
                //this.listContract(this.state.username)
                this.returnProps('returnWithFilter',TypeContract,ConfigurationContractNumber)
             })
             .catch(error => {});
         }
       }
       localStorage.removeItem('jsonBlockstack50L')
       localStorage.removeItem('jsonBlockstack2')
       localStorage.removeItem('idsmartcontract')
       localStorage.removeItem('searchContract')
       this.setState({displayTemplateDetail: false,searchContract2: false})
     }

     createUserGroup = (existListContract,jsonBlockstackZ,Id,TypeContract,ConfigurationContractNumber,IdContainer,IdBillOfLading,IdTypeBillOfLading,DateLogisticContract,optx,Subject,StatusBlockchain,UsernameInsert) => {
       const {userSession} = this.state
       const storage = new Storage({ userSession });
       const options = {contentType: 'application/json', encrypt: false, dangerouslyIgnoreEtag: true }
       const { nameBlockstack } = this.state
       const infoUserGoup=`[{"id":"${UsernameInsert}","name":"${nameBlockstack}","role":"Creator","active":"true","signature":"","identityAddress":"${this.state.identityAddress}","statusInvite":true,"email":"","publicKey":""}]`
       putFileDB(this.state.username,`${TypeContract}_${ConfigurationContractNumber}_usergroup.json`, 'Crosscheck_Contract', JSON.stringify(infoUserGoup), JSON.stringify(options))
          .then(() => {
             localStorage.removeItem('jsonBlockstack2')
             localStorage.removeItem('idsmartcontract')
             localStorage.removeItem('searchContract')
             localStorage.removeItem('jsonBlockstack50L')
             this.setState({displayTemplateDetail: false,searchContract2: false})
             //this.listContract(this.state.username)
             this.returnProps('returnWithFilter',TypeContract,ConfigurationContractNumber)
          })
          .catch(error => {});
     }

     signUserGroup = (TypeContract,ConfigurationContractNumber,UsernameInsert,Signature) => {
       const {userSession} = this.state
       const storage = new Storage({ userSession });
       const options = { decrypt: false, verify: false }
       getFileDB(this.state.username, `${TypeContract}_${ConfigurationContractNumber}_usergroup.json`)
         .then((fileContents) => {
           if(fileContents) {
              const jsonBlockstack1 = JSON.parse(fileContents)
              const jsonBlockstack2 = jsonBlockstack1.data
              let jsonBlockstack5 = '[]'
              if (jsonBlockstack2 !== null){
                 const jsonBlockstack3 = jsonBlockstack2.dataobject
                 const jsonBlockstack4 = jsonBlockstack3.replace(/\\/g,"");
                 if (jsonBlockstack4.substring(0,1) === '"') {
                    jsonBlockstack5 = jsonBlockstack4.substring(1,jsonBlockstack4.length - 1)
                 } else {
                    jsonBlockstack5 = jsonBlockstack4
                 }
              }
              let jsonBlockstack6 = JSON.parse(jsonBlockstack5)

              let cambiaSignature = false
              jsonBlockstack6.map ((todo, key) => {
                 if (todo.id === UsernameInsert && todo.signature !== Signature){
                    todo.signature=Signature
                    cambiaSignature = true
                 }
              })
              if (cambiaSignature===true){
                let jsonBlockstack5 = JSON.stringify(jsonBlockstack6)
                this.signUserGroupWrite(TypeContract,ConfigurationContractNumber,jsonBlockstack5)
              }
           } else {
              const jsonBlockstack6=`[{"id":"${this.state.username}","name":"${this.state.nameBlockstack}","role":"${this.state.whatUserRole}","active":"true","signature":"${this.state.pubKey}","identityAddress":"${this.state.identityAddress}","statusInvite":true,"email":"","publicKey":"${this.state.pubKey}"}]`
              let jsonBlockstack5 = JSON.stringify(jsonBlockstack6)
              this.signUserGroupWrite(TypeContract,ConfigurationContractNumber,jsonBlockstack5)
           }
         })
        .catch(error => {
              const jsonBlockstack6=`[{"id":"${this.state.username}","name":"${this.state.nameBlockstack}","role":"${this.state.whatUserRole}","active":"true","signature":"${this.state.pubKey}","identityAddress":"${this.state.identityAddress}","statusInvite":true,"email":"","publicKey":"${this.state.pubKey}"}]`
              let jsonBlockstack5 = JSON.stringify(jsonBlockstack6)
              this.signUserGroupWrite(TypeContract,ConfigurationContractNumber,jsonBlockstack5)
         });
       localStorage.removeItem('jsonBlockstack2')
       localStorage.removeItem('idsmartcontract')
       localStorage.removeItem('searchContract')
       localStorage.removeItem('jsonBlockstack50L')
       this.setState({displayTemplateDetail: false,searchContract2: false})
     }

     signUserGroupWrite = (TypeContract,ConfigurationContractNumber,jsonBlockstack5) => {
       const {userSession} = this.state
       const storage = new Storage({ userSession });
       const options = {contentType: 'application/json', encrypt: false, dangerouslyIgnoreEtag: true }
       putFileDB(this.state.username,`${TypeContract}_${ConfigurationContractNumber}_usergroup.json`, 'Crosscheck_Contract', jsonBlockstack5, JSON.stringify(options))
          .then(() => {
             localStorage.removeItem('jsonBlockstack2')
             localStorage.removeItem('idsmartcontract')
             localStorage.removeItem('searchContract')
             this.setState({displayTemplateDetail: false,searchContract2: false})
          })
          .catch(error => {});
     }

     deleteListContractDialog = (e,optx,displayDeleteX,displayDeleteX2, typeContract, configurationContractNumber, displayRoleX, displayLifeCycleX) => {
         if (displayDeleteX2==="images/deleteRed.png") {
           if (this.state.language === 'English'){this.setState({dialogOpen: true, dialogMessage: 'Are you sure of delete the Document?', dialogTitle: 'Confirm: 3001', iContractTable: optx, typeContractSign: typeContract, configurationContractNumberSign: configurationContractNumber, })}
           if (this.state.language === 'French'){this.setState({dialogOpen: true, dialogMessage: 'Êtes-vous sûr de supprimer le Document?', dialogTitle: 'Confirm: 3001', iContractTable: optx, typeContractSign: typeContract, configurationContractNumberSign: configurationContractNumber, })}
           if (this.state.language === 'Spanish'){this.setState({dialogOpen: true, dialogMessage: '¿Está seguro de eliminar el Documento?', dialogTitle: 'Confirm: 3001', iContractTable: optx, typeContractSign: typeContract, configurationContractNumberSign: configurationContractNumber, })}
           if (this.state.language === 'Portuguese'){this.setState({dialogOpen: true, dialogMessage: 'Tem certeza de que deseja excluir o Documento?', dialogTitle: 'Confirm: 3001', iContractTable: optx, typeContractSign: typeContract, configurationContractNumberSign: configurationContractNumber, })}
           if (this.state.language === 'Swedish'){this.setState({dialogOpen: true, dialogMessage: 'Är du säker på att radera Dokumentet?', dialogTitle: 'Confirm: 3001', iContractTable: optx, typeContractSign: typeContract, configurationContractNumberSign: configurationContractNumber, })}
           if (this.state.language === 'Netherlands'){this.setState({dialogOpen: true, dialogMessage: 'Weet u zeker dat u het Document wilt verwijderen?', dialogTitle: 'Confirm: 3001', iContractTable: optx, typeContractSign: typeContract, configurationContractNumberSign: configurationContractNumber, })}
           if (this.state.language === 'Russian'){this.setState({dialogOpen: true, dialogMessage: 'Вы уверены, что хотите удалить документ?', dialogTitle: 'Confirm: 3001', iContractTable: optx, typeContractSign: typeContract, configurationContractNumberSign: configurationContractNumber, })}
           if (this.state.language === 'Japanese'){this.setState({dialogOpen: true, dialogMessage: 'ドキュメントを削除してもよろしいですか？', dialogTitle: 'Confirm: 3001', iContractTable: optx, typeContractSign: typeContract, configurationContractNumberSign: configurationContractNumber, })}
           if (this.state.language === 'Chinese'){this.setState({dialogOpen: true, dialogMessage: '您確定要刪除文檔嗎？', dialogTitle: 'Confirm: 3001', iContractTable: optx, typeContractSign: typeContract, configurationContractNumberSign: configurationContractNumber, })}
           if (this.state.language === 'German'){this.setState({dialogOpen: true, dialogMessage: 'Sind Sie sicher, das Dokument zu löschen?', dialogTitle: 'Confirm: 3001', iContractTable: optx, typeContractSign: typeContract, configurationContractNumberSign: configurationContractNumber, })}
           if (this.state.language === 'Italian'){this.setState({dialogOpen: true, dialogMessage: 'Sei sicuro di eliminare il Documento?', dialogTitle: 'Confirm: 3001', iContractTable: optx, typeContractSign: typeContract, configurationContractNumberSign: configurationContractNumber, })}
         }else{
           this.deleteContract(displayRoleX, displayLifeCycleX)
         }
     }

     unarchiveListContractArchiveDialog = (e, optx, typeContract, configurationContractNumber, displayRoleX) => {
         const archiveContractX = `{"iContractTable": "${optx}", "typeContractSign": "${typeContract}", "configurationContractNumberSign": "${configurationContractNumber}" }`
         localStorage.setItem('archiveContract',archiveContractX)
         if (this.state.language === 'English'){this.setState({dialogOpen: true, dialogMessage: 'Are you sure of unarchive the Document?', dialogTitle: 'Confirm: 3012', iContractTable: optx, typeContractSign: typeContract, configurationContractNumberSign: configurationContractNumber, })}
         if (this.state.language === 'French'){this.setState({dialogOpen: true, dialogMessage: `Êtes-vous sûr de désarchiver le Document?`, dialogTitle: 'Confirm: 3012', iContractTable: optx, typeContractSign: typeContract, configurationContractNumberSign: configurationContractNumber, })}
         if (this.state.language === 'Spanish'){this.setState({dialogOpen: true, dialogMessage: '¿Está seguro de desarchivar el Documento?', dialogTitle: 'Confirm: 3012', iContractTable: optx, typeContractSign: typeContract, configurationContractNumberSign: configurationContractNumber, })}
         if (this.state.language === 'Portuguese'){this.setState({dialogOpen: true, dialogMessage: 'Você tem certeza de desarquivar o Documento?', dialogTitle: 'Confirm: 3012', iContractTable: optx, typeContractSign: typeContract, configurationContractNumberSign: configurationContractNumber, })}
         if (this.state.language === 'Swedish'){this.setState({dialogOpen: true, dialogMessage: 'Är du säker på att inte arkivera Dokumentet?', dialogTitle: 'Confirm: 3012', iContractTable: optx, typeContractSign: typeContract, configurationContractNumberSign: configurationContractNumber, })}
         if (this.state.language === 'Netherlands'){this.setState({dialogOpen: true, dialogMessage: 'Weet u zeker dat u het document uit het archief haalt?', dialogTitle: 'Confirm: 3012', iContractTable: optx, typeContractSign: typeContract, configurationContractNumberSign: configurationContractNumber, })}
         if (this.state.language === 'Russian'){this.setState({dialogOpen: true, dialogMessage: 'Вы уверены, что разархивировать документ?', dialogTitle: 'Confirm: 3012', iContractTable: optx, typeContractSign: typeContract, configurationContractNumberSign: configurationContractNumber, })}
         if (this.state.language === 'Japanese'){this.setState({dialogOpen: true, dialogMessage: 'ドキュメントをアーカイブ解除してもよろしいですか？', dialogTitle: 'Confirm: 3012', iContractTable: optx, typeContractSign: typeContract, configurationContractNumberSign: configurationContractNumber, })}
         if (this.state.language === 'Chinese'){this.setState({dialogOpen: true, dialogMessage: '您確定要取消存檔文檔嗎？', dialogTitle: 'Confirm: 3012', iContractTable: optx, typeContractSign: typeContract, configurationContractNumberSign: configurationContractNumber, })}
         if (this.state.language === 'German'){this.setState({dialogOpen: true, dialogMessage: 'Sind Sie sicher, dass Sie das Dokument nicht archivieren können?', dialogTitle: 'Confirm: 3012', iContractTable: optx, typeContractSign: typeContract, configurationContractNumberSign: configurationContractNumber, })}
         if (this.state.language === 'Italian'){this.setState({dialogOpen: true, dialogMessage: `Sei sicuro di annullare l'archiviazione del documento?`, dialogTitle: 'Confirm: 3012', iContractTable: optx, typeContractSign: typeContract, configurationContractNumberSign: configurationContractNumber, })}
     }

     storeListContractDialog = (e, optx, displayStoreX2, typeContract, configurationContractNumber, displayRoleX) => {
         if (displayStoreX2==="images/storeGrey.png") {
           const archiveContractX = `{"iContractTable": "${optx}", "typeContractSign": "${typeContract}", "configurationContractNumberSign": "${configurationContractNumber}" }`
           localStorage.setItem('archiveContract',archiveContractX)
           if (this.state.language === 'English'){this.setState({dialogOpen: true, dialogMessage: 'Are you sure of archive the Document?', dialogTitle: 'Confirm: 3011', iContractTable: optx, typeContractSign: typeContract, configurationContractNumberSign: configurationContractNumber, })}
           if (this.state.language === 'French'){this.setState({dialogOpen: true, dialogMessage: `Êtes-vous sûr d'archiver le Document?`, dialogTitle: 'Confirm: 3011', iContractTable: optx, typeContractSign: typeContract, configurationContractNumberSign: configurationContractNumber, })}
           if (this.state.language === 'Spanish'){this.setState({dialogOpen: true, dialogMessage: '¿Está seguro de archivar el Documento?', dialogTitle: 'Confirm: 3011', iContractTable: optx, typeContractSign: typeContract, configurationContractNumberSign: configurationContractNumber, })}
           if (this.state.language === 'Portuguese'){this.setState({dialogOpen: true, dialogMessage: 'Você tem certeza de arquivar o Documento?', dialogTitle: 'Confirm: 3011', iContractTable: optx, typeContractSign: typeContract, configurationContractNumberSign: configurationContractNumber, })}
           if (this.state.language === 'Swedish'){this.setState({dialogOpen: true, dialogMessage: 'Är du säker på att arkivera Dokumentet?', dialogTitle: 'Confirm: 3011', iContractTable: optx, typeContractSign: typeContract, configurationContractNumberSign: configurationContractNumber, })}
           if (this.state.language === 'Netherlands'){this.setState({dialogOpen: true, dialogMessage: 'Weet u zeker dat u het document archiveert?', dialogTitle: 'Confirm: 3011', iContractTable: optx, typeContractSign: typeContract, configurationContractNumberSign: configurationContractNumber, })}
           if (this.state.language === 'Russian'){this.setState({dialogOpen: true, dialogMessage: 'Вы уверены, что заархивировали документ?', dialogTitle: 'Confirm: 3011', iContractTable: optx, typeContractSign: typeContract, configurationContractNumberSign: configurationContractNumber, })}
           if (this.state.language === 'Japanese'){this.setState({dialogOpen: true, dialogMessage: 'ドキュメントをアーカイブしてもよろしいですか？', dialogTitle: 'Confirm: 3011', iContractTable: optx, typeContractSign: typeContract, configurationContractNumberSign: configurationContractNumber, })}
           if (this.state.language === 'Chinese'){this.setState({dialogOpen: true, dialogMessage: '您確定要存檔文檔嗎？', dialogTitle: 'Confirm: 3011', iContractTable: optx, typeContractSign: typeContract, configurationContractNumberSign: configurationContractNumber, })}
           if (this.state.language === 'German'){this.setState({dialogOpen: true, dialogMessage: 'Sind Sie sicher, das Dokument zu archivieren?', dialogTitle: 'Confirm: 3011', iContractTable: optx, typeContractSign: typeContract, configurationContractNumberSign: configurationContractNumber, })}
           if (this.state.language === 'Italian'){this.setState({dialogOpen: true, dialogMessage: 'Sei sicuro di archiviare il documento?', dialogTitle: 'Confirm: 3011', iContractTable: optx, typeContractSign: typeContract, configurationContractNumberSign: configurationContractNumber, })}
         }else{
           this.archiveContract(displayRoleX)
         }
     }

     unarchiveListContract = (optx,typeContract,configurationContractNumber) => {
       const {userSession} = this.state
       const storage = new Storage({ userSession });
       const options = { decrypt: false, verify: false }
       let jsondisplayListContract = this.state.jsonArchive
       let jsonContractList = []
       getFileDB(this.state.username, `contractlist.json`)
         .then((fileContents) => {
            if(fileContents) {
              const jsonBlockstack1 = JSON.parse(fileContents)
              const jsonBlockstack2 = jsonBlockstack1.data
              let jsonBlockstack5 = '[]'
              if (jsonBlockstack2 !== null){
                 const jsonBlockstack3 = jsonBlockstack2.dataobject
                 const jsonBlockstack4 = jsonBlockstack3.replace(/\\/g,"");
                 if (jsonBlockstack4.substring(0,1) === '"') {
                    jsonBlockstack5 = jsonBlockstack4.substring(1,jsonBlockstack4.length - 1)
                 } else {
                    jsonBlockstack5 = jsonBlockstack4
                 }
              }
              let jsonBlockstack6 = JSON.parse(jsonBlockstack5)
              jsonContractList = JSON.parse(jsonBlockstack5)
            }
            jsonContractList = [...jsonContractList, jsondisplayListContract[optx]]
            this.unarchiveListContract2(optx,typeContract,configurationContractNumber,jsonContractList)
          })
         .catch(error => {});
     }

     unarchiveListContract2 = (optx,typeContract,configurationContractNumber,jsonContractList) => {
       const {userSession} = this.state
       const storage = new Storage({ userSession });
       const options = {contentType: 'application/json', encrypt: false, dangerouslyIgnoreEtag: true }
       const jsonContractList2 = JSON.stringify(jsonContractList)
       putFileDB(this.state.username,`contractlist.json`, 'Crosscheck_Contract', jsonContractList2, JSON.stringify(options))
         .then(() => {
              this.deleteListContractArchive(optx,typeContract,configurationContractNumber)
         })
     }

     deleteListContractArchive = (optx,typeContract,configurationContractNumber) => {
         const masterfile = this.state.jsonArchive
         let optx2 = null
         masterfile.map((todo20,key20)=>{
             if (todo20.typeContract === typeContract && todo20.configurationContractNumber === configurationContractNumber){
                optx2 = key20
             }
         })
         if (optx2 !== null){
             masterfile.splice(optx2,1);
             this.setState({jsonArchive: masterfile})
             const jsonBlockstack1 = JSON.stringify(masterfile)
             const {userSession} = this.state
             const storage = new Storage({ userSession });
             const options = {contentType: 'application/json', encrypt: false, dangerouslyIgnoreEtag: true }
             putFileDB(this.state.username,`contractlistarchive.json`, 'Crosscheck_Contract', jsonBlockstack1, JSON.stringify(options))
               .then(() => {
                  this.setState({
                     status: true,
                     scrollLength: this.state.scrollLength - 1,
                     scrollEnd:  this.state.scrollEnd - 1
                  })
                  this.returnProps('',typeContract,configurationContractNumber)
               })
             this.setState({searchContract2:false})
         }
     }

     storeListContract = (optx,typeContract,configurationContractNumber) => {
         let jsondisplayListContract = this.state.jsonBlockstackZ50
         let optx2 = null
         jsondisplayListContract.map((todo20,key20)=>{
             if (todo20.typeContract === typeContract && todo20.configurationContractNumber === configurationContractNumber && todo20.origin === this.state.username){
                optx2 = key20
             }
         })
         const {userSession} = this.state
         const storage = new Storage({ userSession });
         const options = { decrypt: false, verify: false }
         let jsonContractListArchive = []
         getFileDB(this.state.username, `contractlistarchive.json`)
           .then((fileContents) => {
              if(fileContents) {
                const jsonBlockstack1 = JSON.parse(fileContents)
                const jsonBlockstack2 = jsonBlockstack1.data
                let jsonBlockstack5 = '[]'
                if (jsonBlockstack2 !== null){
                   const jsonBlockstack3 = jsonBlockstack2.dataobject
                   const jsonBlockstack4 = jsonBlockstack3.replace(/\\/g,"");
                   if (jsonBlockstack4.substring(0,1) === '"') {
                      jsonBlockstack5 = jsonBlockstack4.substring(1,jsonBlockstack4.length - 1)
                   } else {
                      jsonBlockstack5 = jsonBlockstack4
                   }
                }
                let jsonBlockstack6 = JSON.parse(jsonBlockstack5)
                jsonContractListArchive = JSON.parse(jsonBlockstack5)
              }
              jsonContractListArchive = [...jsonContractListArchive, jsondisplayListContract[optx2]]
              this.storeListContract2(optx,typeContract,configurationContractNumber,jsonContractListArchive)
            })
           .catch(error => {
              jsonContractListArchive = [...jsonContractListArchive, jsondisplayListContract[optx2]]
              this.storeListContract2(optx,typeContract,configurationContractNumber,jsonContractListArchive)
           });
     }

     storeListContract2 = (optx,typeContract,configurationContractNumber,jsondisplayListContract) => {
       const {userSession} = this.state
       const storage = new Storage({ userSession });
       const options = {contentType: 'application/json', encrypt: false, dangerouslyIgnoreEtag: true }
       jsondisplayListContract = JSON.stringify(jsondisplayListContract)
       putFileDB(this.state.username,`contractlistarchive.json`, 'Crosscheck_Contract', jsondisplayListContract, JSON.stringify(options))
         .then(() => {
              this.storeListContract3(optx,typeContract,configurationContractNumber)
         })
     }

     storeListContract3 = (optx,typeContract,configurationContractNumber) => {
       const {userSession} = this.state
       const storage = new Storage({ userSession });
       const options = { decrypt: false, verify: false }
       let jsonContractList = []
       getFileDB(this.state.username, `contractlist.json`)
         .then((fileContents) => {
            if(fileContents) {
              const jsonBlockstack1 = JSON.parse(fileContents)
              const jsonBlockstack2 = jsonBlockstack1.data
              let jsonBlockstack5 = '[]'
              if (jsonBlockstack2 !== null){
                 const jsonBlockstack3 = jsonBlockstack2.dataobject
                 const jsonBlockstack4 = jsonBlockstack3.replace(/\\/g,"");
                 if (jsonBlockstack4.substring(0,1) === '"') {
                    jsonBlockstack5 = jsonBlockstack4.substring(1,jsonBlockstack4.length - 1)
                 } else {
                    jsonBlockstack5 = jsonBlockstack4
                 }
              }
              let jsonBlockstack6 = JSON.parse(jsonBlockstack5)
              jsonContractList = JSON.parse(jsonBlockstack5)
            }
            this.deleteListContract4(optx,typeContract,configurationContractNumber,jsonContractList)
          })
         .catch(error => {});
     }

     deleteListContract4 = (optx,typeContract,configurationContractNumber,jsonContractList) => {
             const masterfile = jsonContractList
             let optx2 = null
             masterfile.map((todo20,key20)=>{
                 if (todo20.typeContract === typeContract && todo20.configurationContractNumber === configurationContractNumber){
                    optx2 = key20
                 }
             })
             if (optx2 !== null){
                 masterfile.splice(optx2,1);
                 const jsonBlockstack1 = JSON.stringify(masterfile)
                 const {userSession} = this.state
                 const storage = new Storage({ userSession });
                 const options = {contentType: 'application/json', encrypt: false, dangerouslyIgnoreEtag: true }
                 putFileDB(this.state.username,`contractlist.json`, 'Crosscheck_Contract', jsonBlockstack1, JSON.stringify(options))
                   .then(() => {
                      this.setState({
                         status: true,
                         scrollLength: this.state.scrollLength - 1,
                         scrollEnd:  this.state.scrollEnd - 1
                      })
                      this.returnProps('',typeContract,configurationContractNumber)
                   })
                 this.setState({searchContract2:false})
             }
     }

     deleteListContract = (optx,typeContract,configurationContractNumber) => {
             const masterfile = this.state.jsonBlockstackZ50c
             let optx2 = null
             masterfile.map((todo20,key20)=>{
                 if (todo20.typeContract === typeContract && todo20.configurationContractNumber === configurationContractNumber){
                    optx2 = key20
                 }
             })
             if (optx2 !== null){
                 // borrarlo del objeto
                 masterfile.splice(optx2,1);
                 // actualizar state
                 this.setState({jsonBlockstackZ50c: masterfile,jsonBlockstackZ50a: masterfile})
                 const jsonBlockstack4 = masterfile.concat(this.state.jsonBlockstackZ50b)
                 this.setState({scrollLength: jsonBlockstack4.length,jsonBlockstackZ50: jsonBlockstack4,existListContractX: true})
                 const jsonBlockstack1 = JSON.stringify(masterfile)
                 const {userSession} = this.state
                 const storage = new Storage({ userSession });
                 const options = {contentType: 'application/json', encrypt: false, dangerouslyIgnoreEtag: true }
                 putFileDB(this.state.username,`contractlist.json`, 'Crosscheck_Contract', jsonBlockstack1, JSON.stringify(options))
                   .then(() => {
                      this.setState({
                         status: true,
                         scrollLength: this.state.scrollLength - 1,
                         scrollEnd:  this.state.scrollEnd - 1
                      })
                      localStorage.setItem('jsonBlockstack50L',jsonBlockstack1)
                      this.returnProps('',typeContract,configurationContractNumber)
                   })
                 this.setState({searchContract2:false})
           }
     }

     messageErrorWrite() {
        if (this.state.isErrorWrite){
          return (
              <React.Fragment>
                <br></br>
                <Row form>
                  <Col md="6">
                      <Card theme="secondary" style={{ color: "white" }}>
                        <table>
                          <tbody>
                            <tr>
                              <td>
                                <div className="fa fa-info-circle mx-2"></div>
                              </td>
                              <td>
                                 <FormattedMessage id="contract.missingdata" />
                              </td>
                              <td>
                                &nbsp;&nbsp;
                                <Button pill theme="light" onClick={() => {this.setState({ isErrorWrite: false, showLoader: false })}}><FormattedMessage id="contract.understood" /></Button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </Card>
                  </Col>
                </Row>
              </React.Fragment>
          )
        }
      }

      messageDelete() {
         if (this.state.isDelete){
           return (
               <React.Fragment>
                 <br></br>
                 <Row form>
                   <Col md="4">
                       <Card theme="secondary" style={{ color: "white" }}>
                         <table>
                           <tbody>
                             <tr>
                               <td>
                                 <div className="fa fa-info-circle mx-2"></div>
                               </td>
                               <td>
                                  <FormattedMessage id="contract.cautioncontractwillbedeleted" /> &nbsp;&nbsp;&nbsp;
                               </td>
                               <td>
                                 &nbsp;&nbsp;
                                 <Button pill theme="light" onClick={() => {this.setState({ isErrorWrite: false, showLoader: false })}}><FormattedMessage id="contract.understood" /></Button>
                               </td>
                             </tr>
                           </tbody>
                         </table>
                       </Card>
                   </Col>
                 </Row>
               </React.Fragment>
           )
         }
      }

      messageExistContract() {
         if (this.state.existNewContract) {
           return (
               <React.Fragment>
                 <br></br>
                 <Row form>
                   <Col md="11">
                       <Card theme="danger" style={{ color: "white" }}>
                         <table>
                           <tbody>
                             <tr>
                               <td>
                                 <div className="fa fa-info-circle mx-2"></div>
                               </td>
                               <td>
                                  <FormattedMessage id="contract.contractexist" /> &nbsp;&nbsp;&nbsp;
                               </td>
                             </tr>
                           </tbody>
                         </table>
                       </Card>
                   </Col>
                 </Row>
               </React.Fragment>
           )
         }
      }

      messageErrorNumber() {
         if (this.state.errorNumber) {
           return (
               <React.Fragment>
                 <br></br>
                 <Row form>
                   <Col md="11">
                       <Card theme="danger" style={{ color: "white" }}>
                         <table>
                           <tbody>
                             <tr>
                               <td>
                                 <div className="fa fa-info-circle mx-2"></div>
                               </td>
                               <td>
                                  <FormattedMessage id="contract.higheramount" /> &nbsp;&nbsp;&nbsp;
                               </td>
                             </tr>
                           </tbody>
                         </table>
                       </Card>
                   </Col>
                 </Row>
               </React.Fragment>
           )
         }
      }

      messageErrorTemplates(pathname) {
         if (this.state.errorMensajeTemplates) {
           return (
               <React.Fragment>
                 <br></br>
                 <Row form>
                   <Col md="11">
                       <Card theme="danger" style={{ color: "white" }}>
                         <table>
                           <tbody>
                             <tr>
                               <td>
                                 <div className="fa fa-info-circle mx-2"></div>
                               </td>
                               <td>
                                  <FormattedMessage id="contract.templatesnotfound" /> &nbsp;&nbsp;&nbsp;
                               </td>
                             </tr>
                           </tbody>
                         </table>
                       </Card>
                   </Col>
                 </Row>
               </React.Fragment>
           )
         }
      }

      returnProps(returnWithFilter,typeContractTable,numberContractTable){
        if ( returnWithFilter === 'returnWithFilter'){
           this.setState({categorySearch: '2ReturnProps'})
           this.setState({fromSearchListSearch: `${typeContractTable}_${numberContractTable}abcde`})
           this.setState({searchContract2: false, fromSearchList: true})
           this.listContract(this.state.username)
        }else{
           this.setState({searchContract2: false, fromSearchList: false})
           this.listContract(this.state.username)
        }
      }

      backTypeContract = e => {
        this.backConfigurationContract(e)
        this.setState({displayTemplateDetailTypeContract: false})
        this.listContract(this.state.username)
      }

      backConfigurationContract = e => {
          e.preventDefault();
          localStorage.removeItem('jsonBlockstack2')
          localStorage.removeItem('idsmartcontract')
          localStorage.removeItem('searchContract')
          this.setState({errorNumber: false,
                         searchContract2: false,
                         signTrue: true,
                         dialogOpenContractExist: false,
                         modeDisplayCollapsed: false,
                         tagListX:'',
                         carpetListX: 'inbox',
                         activeInactiveAllX: 'Active',
                         selectedTypeMaintenance: '',})
          this.c02ConfigurationContract.current.value = ''
          this.c06ConfigurationContract.current.value = ''
          this.c07ConfigurationContract.current.value = ''
          this.c08ConfigurationContract.current.value = ''
          this.c09ConfigurationContract.current.value = ''
          this.c10ConfigurationContract.current.value = ''
          this.setState({c03ConfigurationContract: true,
                         c04ConfigurationContract: true,
                         c05ConfigurationContract: true})
          this.c01FieldContract.current.value = ''
          if (this.state.JSONTemplateName === 'workorder'){
            this.c02FieldContract.current.value = ''
            this.c03FieldContract.current.value = ''
            this.c06FieldContract.current.value = ''
            this.c07FieldContract.current.value = ''
            this.c08FieldContract.current.value = ''
            this.c09FieldContract.current.value = ''
            this.c10FieldContract.current.value = ''
            this.c11FieldContract.current.value = ''
            this.c12FieldContract.current.value = ''
            this.c13FieldContract.current.value = ''
            this.c14FieldContract.current.value = ''
            this.c15FieldContract.current.value = ''
            this.c17FieldContract.current.value = ''
            this.c18FieldContract.current.value = ''
            this.c19FieldContract.current.value = ''
            this.c21FieldContract.current.value = ''
            this.c22FieldContract.current.value = ''
            this.c27FieldContract.current.value = ''
            this.c28FieldContract.current.value = ''
            this.c29FieldContract.current.value = ''
            this.c30FieldContract.current.value = ''
            this.c31FieldContract.current.value = ''
            this.c32FieldContract.current.value = ''
            this.c33FieldContract.current.value = ''
            this.c34FieldContract.current.value = ''
            this.c35FieldContract.current.value = ''
            this.c36FieldContract.current.value = ''
            this.c37FieldContract.current.value = ''
            this.c38FieldContract.current.value = ''
            this.c39FieldContract.current.value = ''
            this.c40FieldContract.current.value = ''
            this.c41FieldContract.current.value = ''
            this.c42FieldContract.current.value = ''
            this.c43FieldContract.current.value = ''
            this.c44FieldContract.current.value = ''
            this.c45FieldContract.current.value = ''
            this.c46FieldContract.current.value = ''
            this.c47FieldContract.current.value = ''
            this.c48FieldContract.current.value = ''
            this.c49FieldContract.current.value = ''
          }
          if (this.state.JSONTemplateName === 'delivery'){
            this.c02FieldContract.current.value = ''
            this.c03FieldContract.current.value = ''
            this.c04FieldContract.current.value = ''
            this.c06FieldContract.current.value = ''
            this.c07FieldContract.current.value = ''
            this.c08FieldContract.current.value = ''
            this.c09FieldContract.current.value = ''
            this.c10FieldContract.current.value = ''
            this.c11FieldContract.current.value = ''
            this.c12FieldContract.current.value = ''
            this.c13FieldContract.current.value = ''
            this.c14FieldContract.current.value = ''
            this.c15FieldContract.current.value = ''
            this.c16FieldContract.current.value = ''
            this.c20FieldContract.current.value = ''
          }
          if (this.state.JSONTemplateName === 'maintenance'){
            this.c03FieldContract.current.value = ''
            this.c04FieldContract.current.value = ''
            this.c06FieldContract.current.value = ''
            this.c07FieldContract.current.value = ''
            this.c10FieldContract.current.value = ''
            this.c11FieldContract.current.value = ''
            this.c16FieldContract.current.value = ''
            this.c20FieldContract.current.value = ''
            this.c30FieldContract.current.value = ''
            this.c31FieldContract.current.value = ''
            this.c32FieldContract.current.value = ''
            this.c33FieldContract.current.value = ''
          }
          if (this.state.JSONTemplateName === 'proforma'){
            this.c06FieldContract.current.value = ''
            this.c07FieldContract.current.value = ''
            this.c08FieldContract.current.value = ''
            this.c09FieldContract.current.value = ''
            this.c10FieldContract.current.value = ''
            this.c11FieldContract.current.value = ''
            this.c12FieldContract.current.value = ''
            this.c13FieldContract.current.value = ''
            this.c14FieldContract.current.value = ''
            this.c15FieldContract.current.value = ''
            this.c16FieldContract.current.value = ''
            this.c20FieldContract.current.value = ''
          }
          if (this.state.JSONTemplateName === 'blank' ||
              this.state.JSONTemplateName === 'uploaded' ||
              this.state.JSONTemplateName === 'spreadsheet'){
          }
          this.c16FieldContract.current.value = this.state.FIACurrency
          this.c17FieldContract.current.value = ''
          this.c18FieldContract.current.value = ''
          this.c19FieldContract.current.value = ''
          this.c20FieldContract.current.value = ''
          this.c21FieldContract.current.value = ''
          this.c22FieldContract.current.value = ''
          this.c23FieldContract.current.value = ''
          this.c24FieldContract.current.value = ''
          this.c25FieldContract.current.value = ''
          this.c26FieldContract.current.value = ''
          this.c27FieldContract.current.value = ''
          this.c28FieldContract.current.value = ''
          this.c29FieldContract.current.value = ''
          this.c30FieldContract.current.value = ''
          this.c31FieldContract.current.value = ''
          this.c32FieldContract.current.value = ''
          this.c33FieldContract.current.value = ''
          this.c34FieldContract.current.value = ''
          this.c35FieldContract.current.value = ''
          this.c36FieldContract.current.value = ''
          this.c37FieldContract.current.value = ''
          this.c38FieldContract.current.value = ''
          this.c39FieldContract.current.value = ''
          this.c40FieldContract.current.value = ''
          this.c41FieldContract.current.value = ''
          this.c42FieldContract.current.value = ''
          this.c43FieldContract.current.value = ''
          this.c44FieldContract.current.value = ''
          this.c45FieldContract.current.value = ''
          this.c46FieldContract.current.value = ''
          this.c47FieldContract.current.value = ''
          this.c48FieldContract.current.value = ''
          this.c49FieldContract.current.value = ''
          this.c50FieldContract.current.value = ''
          this.c51FieldContract.current.value = ''
          this.c52FieldContract.current.value = ''
          this.c53FieldContract.current.value = ''
          this.c54FieldContract.current.value = ''
          this.c55FieldContract.current.value = ''
          this.c56FieldContract.current.value = ''
          this.c57FieldContract.current.value = ''
          this.c58FieldContract.current.value = ''
          this.c59FieldContract.current.value = ''
          this.c60FieldContract.current.value = 'FIAT Money'
          this.setState({nowDate2: new Date(),
                         startDate: new Date(),
                         endDate: new Date(),
                         nowDate: new Date(),
                         cContractPolicy: false,
                         existContract: false,
                         statusActive2: true,
                         isErrorWrite: false,
                         existNewContract: false})
      }

      getDetailPaymentForms(){
        const {userSession} = this.state
        const storage = new Storage({ userSession });
        const options = { username: this.state.whatUserOrigin, decrypt: false, verify: false }
         let jsonBlockstack4 = []
         return new Promise ((resolve, reject) =>{
           getFileDB(this.state.whatUserOrigin, `${this.state.typeContractSign}_${this.state.configurationContractNumberSign}_detail_payment_form.json`)
            .then((fileContents) => {
              if(fileContents) {
                const jsonBlockstack1 = JSON.parse(fileContents)
                const jsonBlockstack2 = jsonBlockstack1.data
                let jsonBlockstack5 = '[]'
                if (jsonBlockstack2 !== null){
                   const jsonBlockstack3 = jsonBlockstack2.dataobject
                   const jsonBlockstack4 = jsonBlockstack3.replace(/\\/g,"");
                   if (jsonBlockstack4.substring(0,1) === '"') {
                      jsonBlockstack5 = jsonBlockstack4.substring(1,jsonBlockstack4.length - 1)
                   } else {
                      jsonBlockstack5 = jsonBlockstack4
                   }
                }
                let jsonBlockstack6 = JSON.parse(jsonBlockstack5)
                this.setState({jsonPaymentForm:jsonBlockstack6},() =>{resolve();});
              } else {
                reject();
              }
            })
             .catch(error => {
                 reject();
            });
         });
      }

      signContract(){
        if (this.state.typeContractSign !== 'simulate'){
          Promise.all([this.getDetailPaymentForms()])
            .then(
              (resolve) =>{
                let total_percent = 0
                this.state.jsonPaymentForm.map((todo, i) => {
                    total_percent = total_percent + parseFloat(todo.percent)
                })
                if (total_percent < 100){
                   this.validatePaymentForm1()
                }else{
                   this.signContract2()
                }
              },
              (reject) =>{
                   this.validatePaymentForm2()
              }
            )
        }else{
          this.signContract2()
        }
      }

      signContract2(){
        const { userSession } = this.state
        const {username} = this.state;
        this.setState({signTrue: false})
        const url2x = `${this.state.url2}${username}`
        axios.get(url2x)
          .then(result => {
            this.setState({ person: '',
                            exist: true })
             const jsonBlockstack1 = JSON.stringify(result.data)
             const var_a_remp = `{"${username}":`
             const jsonBlockstack2 = jsonBlockstack1.replace(var_a_remp,"'");
             const jsonBlockstack3 = jsonBlockstack2 + "'";
             const jsonBlockstack4 = JSON.parse(jsonBlockstack3.substring(1,jsonBlockstack3.length - 2))
             const public_key = jsonBlockstack4.public_key
             this.setState({ pubKey: public_key })
             this.c26FieldContract.current.value = public_key
             this.signUserGroup(this.state.typeContractSign,this.state.configurationContractNumberSign,username,public_key)
             if (this.state.whatUserRole !== 'Creator'){
                 this.sendMailSigned(username)
             }
          })
          .catch(error => {
            this.setState({ error, exist: false })
            const public_key = this.state.publicKey
            this.setState({ pubKey: public_key })
            this.c26FieldContract.current.value = public_key
            this.signUserGroup(this.state.typeContractSign,this.state.configurationContractNumberSign,username,public_key)
            if (this.state.whatUserRole !== 'Creator'){
                this.sendMailSigned(username)
            }
          });
      }

      unsignContract(){
        const { userSession } = this.state
        const {username} = this.state;
        this.setState({signTrue: true})
        this.c26FieldContract.current.value = ''
        this.signUserGroup(this.state.typeContractSign,this.state.configurationContractNumberSign,username,"")
        if (this.state.whatUserRole !== 'Creator'){
            this.sendMailUnSigned(username)
        }
      }

      sendMailSigned(usernameX){
        const {userSession} = this.state
        const storage = new Storage({ userSession });
        const options = { username: this.state.whatUserOrigin, decrypt: false, verify: false }
        getFileDB(this.state.whatUserOrigin, `myUserConfig.json`)
           .then((fileContents) => {
             if(fileContents) {
               const jsonBlockstack1 = JSON.parse(fileContents)
               const jsonBlockstack2 = jsonBlockstack1.data
               let jsonBlockstack5 = '[]'
               if (jsonBlockstack2 !== null){
                  const jsonBlockstack3 = jsonBlockstack2.dataobject
                  const jsonBlockstack4 = jsonBlockstack3.replace(/\\/g,"");
                  if (jsonBlockstack4.substring(0,1) === '"') {
                     jsonBlockstack5 = jsonBlockstack4.substring(1,jsonBlockstack4.length - 1)
                  } else {
                     jsonBlockstack5 = jsonBlockstack4
                  }
               }
               let jsonBlockstack6 = JSON.parse(jsonBlockstack5)

               const subject = 'A participant has signed your contract using CrossCheck'
               const senderName = ''
               emailjs.send("service_9dv38as", "template_7fs3bhn",
                         {
                             receiverUserName: this.state.whatUserOrigin,
                             address: jsonBlockstack6.emailNotifications,
                             signerUserName: usernameX,
                             typeContract: this.state.typeContractSign,
                             numberContract: this.state.configurationContractNumberSign,
                             role: this.state.whatUserRole,
                             subject,
                             senderName
                         }, "user_djYXBdBTeG1Km5qtyqkDl")
                   .then(response => {
                      console.log('SUCCESS!', response.status, response.text)
                   }, error => {
                      console.log('FAILED...', error)
                   });

               /*
               fetch("https://xck.app:5443/sendContractSigned",
                     {
                       method: "POST",
                       headers:{
                         'Content-Type': 'application/json',
                         "token": `${token}`
                       },
                       body: JSON.stringify({
                         receiverUserName: this.state.whatUserOrigin,
                         address: jsonBlockstack6.emailNotifications,
                         signerUserName: usernameX,
                         typeContract: this.state.typeContractSign,
                         numberContract: this.state.configurationContractNumberSign,
                         role: this.state.whatUserRole
                       })
                     }
               ).then((response)=>{
                 if (response.status === 200) {
                   //console.log('email sended');
                 }
                 else{
                   //console.log('error sending the email')
                 }
               }).catch(()=>{
                 //console.log('error sending the email')
               })
               */
             } else {
               //console.log("No Data");
             }
           })
            .catch(error => {
           });
      }

      sendMailUnSigned(usernameX){
        const {userSession} = this.state
        const storage = new Storage({ userSession });
        const options = { username: this.state.whatUserOrigin, decrypt: false, verify: false }
        getFileDB(this.state.whatUserOrigin, `myUserConfig.json`)
           .then((fileContents) => {
             if(fileContents) {
               const jsonBlockstack1 = JSON.parse(fileContents)
               const jsonBlockstack2 = jsonBlockstack1.data
               let jsonBlockstack5 = '[]'
               if (jsonBlockstack2 !== null){
                  const jsonBlockstack3 = jsonBlockstack2.dataobject
                  const jsonBlockstack4 = jsonBlockstack3.replace(/\\/g,"");
                  if (jsonBlockstack4.substring(0,1) === '"') {
                     jsonBlockstack5 = jsonBlockstack4.substring(1,jsonBlockstack4.length - 1)
                  } else {
                     jsonBlockstack5 = jsonBlockstack4
                  }
               }
               let jsonBlockstack6 = JSON.parse(jsonBlockstack5)
               const subject = 'A participant has unsigned your contract using CrossCheck'
               const senderName = ''

               emailjs.send("service_9dv38as", "template_bn997nf",
                       {
                         receiverUserName: this.state.whatUserOrigin,
                         address: jsonBlockstack6.emailNotifications,
                         signerUserName: usernameX,
                         typeContract: this.state.typeContractSign,
                         numberContract: this.state.configurationContractNumberSign,
                         role: this.state.whatUserRole,
                         subject,
                         senderName
                       }, "user_djYXBdBTeG1Km5qtyqkDl")
                   .then(response => {
                      console.log('SUCCESS!', response.status, response.text)
                   }, error => {
                      console.log('FAILED...', error)
                   });


               /*
               fetch("https://xck.app:5443/sendContractUnsigned",
                     {
                       method: "POST",
                       headers:{
                         'Content-Type': 'application/json',
                         "token": `${token}`
                       },
                       body: JSON.stringify({
                         receiverUserName: this.state.whatUserOrigin,
                         address: jsonBlockstack6.emailNotifications,
                         signerUserName: usernameX,
                         typeContract: this.state.typeContractSign,
                         numberContract: this.state.configurationContractNumberSign,
                         role: this.state.whatUserRole
                       })
                     }
               ).then((response)=>{
                 if (response.status === 200) {
                   //console.log('email sended');
                 }
                 else{
                   //console.log('error sending the email')
                 }
               }).catch(()=>{
                 //console.log('error sending the email')
               })
               */
             } else {
               //console.log("No Data");
             }
           })
            .catch(error => {
           });
      }

      blockchainContract(){
        if (this.state.language === 'English'){this.setState({dialogOpenWriteBlockchain: true,dialogMessage: 'Are you sure of write the Document in Blockchain?',dialogTitle: 'Confirm: 3002',})}
        if (this.state.language === 'French'){this.setState({dialogOpenWriteBlockchain: true,dialogMessage: "Êtes-vous sûr d'écrire le document dans Blockchain?",dialogTitle: 'Confirm: 3002',})}
        if (this.state.language === 'Spanish'){this.setState({dialogOpenWriteBlockchain: true,dialogMessage: '¿Estás seguro de grabar el Documento en Blockchain?',dialogTitle: 'Confirm: 3002',})}
        if (this.state.language === 'Portuguese'){this.setState({dialogOpenWriteBlockchain: true,dialogMessage: 'Você tem certeza de escrever o documento no Blockchain?',dialogTitle: 'Confirm: 3002',})}
        if (this.state.language === 'Swedish'){this.setState({dialogOpenWriteBlockchain: true,dialogMessage: 'Är du säker på att skriva dokumentet i Blockchain?',dialogTitle: 'Confirm: 3002',})}
        if (this.state.language === 'Netherlands'){this.setState({dialogOpenWriteBlockchain: true,dialogMessage: 'Weet u zeker dat u het document in Blockchain wilt schrijven?',dialogTitle: 'Confirm: 3002',})}
        if (this.state.language === 'Russian'){this.setState({dialogOpenWriteBlockchain: true,dialogMessage: 'Вы уверены, что написали документ в блокчейне?',dialogTitle: 'Confirm: 3002',})}
        if (this.state.language === 'Japanese'){this.setState({dialogOpenWriteBlockchain: true,dialogMessage: 'ドキュメントをブロックチェーンで作成してもよろしいですか？',dialogTitle: 'Confirm: 3002',})}
        if (this.state.language === 'Chinese'){this.setState({dialogOpenWriteBlockchain: true,dialogMessage: '您確定要在區塊鏈中編寫文檔嗎？',dialogTitle: 'Confirm: 3002',})}
        if (this.state.language === 'German'){this.setState({dialogOpenWriteBlockchain: true,dialogMessage: 'Sind Sie sicher, das Dokument in Blockchain zu schreiben?',dialogTitle: 'Confirm: 3002',})}
        if (this.state.language === 'Italian'){this.setState({dialogOpenWriteBlockchain: true,dialogMessage: 'Sei sicuro di scrivere il documento in Blockchain?',dialogTitle: 'Confirm: 3002',})}
      }

      sendConfirm(){
        if (this.state.language === 'English'){this.setState({dialogOpen: true,dialogMessage: 'Are you sure to send the document to the counterpart?',dialogTitle: 'Confirm: 3007',})}
        if (this.state.language === 'French'){this.setState({dialogOpen: true,dialogMessage: 'Voulez-vous vraiment envoyer le document à la contrepartie?',dialogTitle: 'Confirm: 3007',})}
        if (this.state.language === 'Spanish'){this.setState({dialogOpen: true,dialogMessage: '¿Está seguro de enviar el documento al contraparte?',dialogTitle: 'Confirm: 3007',})}
        if (this.state.language === 'Portuguese'){this.setState({dialogOpen: true,dialogMessage: 'Você tem certeza de enviar o documento para a contraparte?',dialogTitle: 'Confirm: 3007',})}
        if (this.state.language === 'Swedish'){this.setState({dialogOpen: true,dialogMessage: 'Är du säker på att skicka dokumentet till motsvarigheten?',dialogTitle: 'Confirm: 3007',})}
        if (this.state.language === 'Netherlands'){this.setState({dialogOpen: true,dialogMessage: 'Weet u zeker dat u het document naar de tegenpartij wilt verzenden?',dialogTitle: 'Confirm: 3007',})}
        if (this.state.language === 'Russian'){this.setState({dialogOpen: true,dialogMessage: 'Вы уверены, что отправили документ контрагенту?',dialogTitle: 'Confirm: 3007',})}
        if (this.state.language === 'Japanese'){this.setState({dialogOpen: true,dialogMessage: 'ドキュメントを相手に送信してもよろしいですか？',dialogTitle: 'Confirm: 3007',})}
        if (this.state.language === 'Chinese'){this.setState({dialogOpen: true,dialogMessage: '您確定要將文件發送給對方嗎？',dialogTitle: 'Confirm: 3007',})}
        if (this.state.language === 'German'){this.setState({dialogOpen: true,dialogMessage: 'Sind Sie sicher, dass Sie das Dokument an das Gegenstück senden?',dialogTitle: 'Confirm: 3007',})}
        if (this.state.language === 'Italian'){this.setState({dialogOpen: true,dialogMessage: 'Sei sicuro di inviare il documento alla controparte?',dialogTitle: 'Confirm: 3007',})}
      }

      alertSupport(){
        if (this.state.language === 'English'){this.setState({dialogOpenWalletSinSaldo: true,dialogMessage: 'You have user SUPPORT enabled, to enable this functionality you must delete user SUPPORT',dialogTitle: 'Warning: 2002',})}
        if (this.state.language === 'French'){this.setState({dialogOpenWalletSinSaldo: true,dialogMessage: 'Vous avez activé le SUPPORT utilisateur, pour activer cette fonctionnalité, vous devez supprimer le SUPPORT utilisateur',dialogTitle: 'Warning: 2002',})}
        if (this.state.language === 'Spanish'){this.setState({dialogOpenWalletSinSaldo: true,dialogMessage: 'Tiene habilitado usuario SOPORTE, para habilitar esta funcionalidad debe eliminar usuario SOPORTE',dialogTitle: 'Warning: 2002',})}
        if (this.state.language === 'Portuguese'){this.setState({dialogOpenWalletSinSaldo: true,dialogMessage: 'Você tem o usuário SUPPORT ativado, para habilitar esta funcionalidade, você deve excluir o usuário SUPPORT',dialogTitle: 'Warning: 2002',})}
        if (this.state.language === 'Swedish'){this.setState({dialogOpenWalletSinSaldo: true,dialogMessage: 'Du har användarsupport aktiverat, för att aktivera den här funktionen måste du radera användarsupport',dialogTitle: 'Warning: 2002',})}
        if (this.state.language === 'Netherlands'){this.setState({dialogOpenWalletSinSaldo: true,dialogMessage: 'U hebt gebruiker SUPPORT ingeschakeld, om deze functionaliteit in te schakelen moet u gebruiker SUPPORT verwijderen',dialogTitle: 'Warning: 2002',})}
        if (this.state.language === 'Russian'){this.setState({dialogOpenWalletSinSaldo: true,dialogMessage: 'У вас включен пользователь SUPPORT, чтобы включить эту функцию, вы должны удалить пользователя SUPPORT',dialogTitle: 'Warning: 2002',})}
        if (this.state.language === 'Japanese'){this.setState({dialogOpenWalletSinSaldo: true,dialogMessage: 'ユーザーのサポートが有効になっています。この機能を有効にするには、ユーザーのサポートを削除する必要があります',dialogTitle: 'Warning: 2002',})}
        if (this.state.language === 'Chinese'){this.setState({dialogOpenWalletSinSaldo: true,dialogMessage: '您已启用用户SUPPORT，要启用此功能，必须删除用户SUPPORT',dialogTitle: 'Warning: 2002',})}
        if (this.state.language === 'German'){this.setState({dialogOpenWalletSinSaldo: true,dialogMessage: 'Sie haben den Benutzer SUPPORT aktiviert. Um diese Funktionalität zu aktivieren, müssen Sie den Benutzer SUPPORT löschen',dialogTitle: 'Warning: 2002',})}
        if (this.state.language === 'Italian'){this.setState({dialogOpenWalletSinSaldo: true,dialogMessage: `L'utente SUPPORT è abilitato, per abilitare questa funzionalità è necessario eliminare l'utente SUPPORT`,dialogTitle: 'Warning: 2002',})}
      }

      walletSinSaldoContract(){
        if (this.state.language === 'English'){this.setState({dialogOpenWalletSinSaldo: true,dialogMessage: 'No balance in the wallet',logTitle: 'Error: 1001',})}
        if (this.state.language === 'French'){this.setState({dialogOpenWalletSinSaldo: true,dialogMessage: "Pas d'équilibre dans le portefeuille",logTitle: 'Error: 1001',})}
        if (this.state.language === 'Spanish'){this.setState({dialogOpenWalletSinSaldo: true,dialogMessage: 'No hay saldo en la billetera',logTitle: 'Error: 1001',})}
        if (this.state.language === 'Portuguese'){this.setState({dialogOpenWalletSinSaldo: true,dialogMessage: 'Sem saldo na carteira',logTitle: 'Error: 1001',})}
        if (this.state.language === 'Swedish'){this.setState({dialogOpenWalletSinSaldo: true,dialogMessage: 'Ingen balans i plånboken',logTitle: 'Error: 1001',})}
        if (this.state.language === 'Netherlands'){this.setState({dialogOpenWalletSinSaldo: true,dialogMessage: 'Geen balans in de portemonnee',logTitle: 'Error: 1001',})}
        if (this.state.language === 'Russian'){this.setState({dialogOpenWalletSinSaldo: true,dialogMessage: 'Нет баланса в кошельке',logTitle: 'Error: 1001',})}
        if (this.state.language === 'Japanese'){this.setState({dialogOpenWalletSinSaldo: true,dialogMessage: 'ウォレットに残高がありません',logTitle: 'Error: 1001',})}
        if (this.state.language === 'Chinese'){this.setState({dialogOpenWalletSinSaldo: true,dialogMessage: '钱包里没有余额e',logTitle: 'Error: 1001',})}
        if (this.state.language === 'German'){this.setState({dialogOpenWalletSinSaldo: true,dialogMessage: 'Kein Guthaben in der Brieftaschee',logTitle: 'Error: 1001',})}
        if (this.state.language === 'Italian'){this.setState({dialogOpenWalletSinSaldo: true,dialogMessage: 'Nessun equilibrio nel portafoglio',logTitle: 'Error: 1001',})}
      }

      deactivateConfirm(){
        if (this.state.language === 'English'){this.setState({dialogOpenDeactivate: true,dialogMessage: 'Are you sure of deactivate the Document?',dialogTitle: 'Confirm: 3005',})}
        if (this.state.language === 'French'){this.setState({dialogOpenDeactivate: true,dialogMessage: 'Êtes-vous sûr de désactiver le Document?',dialogTitle: 'Confirm: 3005',})}
        if (this.state.language === 'Spanish'){this.setState({dialogOpenDeactivate: true,dialogMessage: '¿Está seguro de desactivar el Documento?',dialogTitle: 'Confirm: 3005',})}
        if (this.state.language === 'Portuguese'){this.setState({dialogOpenDeactivate: true,dialogMessage: 'Você tem certeza de que deseja desativar o Documento?',dialogTitle: 'Confirm: 3005',})}
        if (this.state.language === 'Swedish'){this.setState({dialogOpenDeactivate: true,dialogMessage: 'Är du säker på att inaktivera Dokumentet?',dialogTitle: 'Confirm: 3005',})}
        if (this.state.language === 'Netherlands'){this.setState({dialogOpenDeactivate: true,dialogMessage: 'Weet u zeker dat u het Document wilt deactiveren?',dialogTitle: 'Confirm: 3005',})}
        if (this.state.language === 'Russian'){this.setState({dialogOpenDeactivate: true,dialogMessage: 'Вы уверены, что деактивировать документ?',dialogTitle: 'Confirm: 3005',})}
        if (this.state.language === 'Japanese'){this.setState({dialogOpenDeactivate: true,dialogMessage: 'ドキュメントを無効にしますか？',dialogTitle: 'Confirm: 3005',})}
        if (this.state.language === 'Chinese'){this.setState({dialogOpenDeactivate: true,dialogMessage: '您確定要停用文檔嗎？',dialogTitle: 'Confirm: 3005',})}
        if (this.state.language === 'German'){this.setState({dialogOpenDeactivate: true,dialogMessage: 'Sind Sie sicher, das Dokument zu deaktivieren?',dialogTitle: 'Confirm: 3005',})}
        if (this.state.language === 'Italian'){this.setState({dialogOpenDeactivate: true,dialogMessage: 'Sei sicuro di disattivare il Documento?',dialogTitle: 'Confirm: 3005',})}
      }

      deactivateConfirmAfterPublished = (e) =>{
        if (this.state.language === 'English'){this.setState({dialogOpenDeactivate: true,dialogMessage: 'Are you sure of deactivate the Document?',dialogTitle: 'Confirm: 3015',})}
        if (this.state.language === 'French'){this.setState({dialogOpenDeactivate: true,dialogMessage: 'Êtes-vous sûr de désactiver le Document?',dialogTitle: 'Confirm: 3015',})}
        if (this.state.language === 'Spanish'){this.setState({dialogOpenDeactivate: true,dialogMessage: '¿Está seguro de desactivar el Documento?',dialogTitle: 'Confirm: 3015',})}
        if (this.state.language === 'Portuguese'){this.setState({dialogOpenDeactivate: true,dialogMessage: 'Você tem certeza de que deseja desativar o Documento?',dialogTitle: 'Confirm: 3015',})}
        if (this.state.language === 'Swedish'){this.setState({dialogOpenDeactivate: true,dialogMessage: 'Är du säker på att inaktivera Dokumentet?',dialogTitle: 'Confirm: 3015',})}
        if (this.state.language === 'Netherlands'){this.setState({dialogOpenDeactivate: true,dialogMessage: 'Weet u zeker dat u het Document wilt deactiveren?',dialogTitle: 'Confirm: 3015',})}
        if (this.state.language === 'Russian'){this.setState({dialogOpenDeactivate: true,dialogMessage: 'Вы уверены, что деактивировать документ?',dialogTitle: 'Confirm: 3015',})}
        if (this.state.language === 'Japanese'){this.setState({dialogOpenDeactivate: true,dialogMessage: 'ドキュメントを無効にしますか？',dialogTitle: 'Confirm: 3015',})}
        if (this.state.language === 'Chinese'){this.setState({dialogOpenDeactivate: true,dialogMessage: '您確定要停用文檔嗎？',dialogTitle: 'Confirm: 3015',})}
        if (this.state.language === 'German'){this.setState({dialogOpenDeactivate: true,dialogMessage: 'Sind Sie sicher, das Dokument zu deaktivieren?',dialogTitle: 'Confirm: 3015',})}
        if (this.state.language === 'Italian'){this.setState({dialogOpenDeactivate: true,dialogMessage: 'Sei sicuro di disattivare il Documento?',dialogTitle: 'Confirm: 3015',})}
      }

      activateConfirm(){
        if (this.state.language === 'English'){this.setState({dialogOpenDeactivate: true,dialogMessage: 'Are you sure of activate the Document?',dialogTitle: 'Confirm: 3006',})}
        if (this.state.language === 'French'){this.setState({dialogOpenDeactivate: true,dialogMessage: "Voulez-vous vraiment activer le Document?",dialogTitle: 'Confirm: 3006',})}
        if (this.state.language === 'Spanish'){this.setState({dialogOpenDeactivate: true,dialogMessage: '¿Está seguro de activar el Documento?',dialogTitle: 'Confirm: 3006',})}
        if (this.state.language === 'Portuguese'){this.setState({dialogOpenDeactivate: true,dialogMessage: 'Você tem certeza de ativar o Documento?',dialogTitle: 'Confirm: 3006',}) }
        if (this.state.language === 'Swedish'){this.setState({dialogOpenDeactivate: true,dialogMessage: 'Är du säker på att aktivera Dokumentet?',dialogTitle: 'Confirm: 3006',})}
        if (this.state.language === 'Netherlands'){this.setState({dialogOpenDeactivate: true,dialogMessage: 'Weet u zeker dat u het Document wilt activeren?',dialogTitle: 'Confirm: 3006',})}
        if (this.state.language === 'Russian'){this.setState({dialogOpenDeactivate: true,dialogMessage: 'Вы уверены, что активировать документ?',dialogTitle: 'Confirm: 3006',})}
        if (this.state.language === 'Japanese'){this.setState({dialogOpenDeactivate: true,dialogMessage: 'ドキュメントをアクティブにしますか？',dialogTitle: 'Confirm: 3006',})}
        if (this.state.language === 'Chinese'){this.setState({dialogOpenDeactivate: true,dialogMessage: '您確定要激活文檔嗎？',dialogTitle: 'Confirm: 3006',})}
        if (this.state.language === 'German'){this.setState({dialogOpenDeactivate: true,dialogMessage: 'Sind Sie sicher, das Dokument zu aktivieren?',dialogTitle: 'Confirm: 3006',})}
        if (this.state.language === 'Italian'){this.setState({dialogOpenDeactivate: true,dialogMessage: 'Sei sicuro di attivare il Documento?',dialogTitle: 'Confirm: 3006',})}
      }

      activateConfirmAfterPublished = (e) =>{
        if (this.state.language === 'English'){this.setState({dialogOpenDeactivate: true,dialogMessage: 'Are you sure of activate the Document?',dialogTitle: 'Confirm: 3016',})}
        if (this.state.language === 'French'){this.setState({dialogOpenDeactivate: true,dialogMessage: "Voulez-vous vraiment activer le Document?",dialogTitle: 'Confirm: 3016',})}
        if (this.state.language === 'Spanish'){this.setState({dialogOpenDeactivate: true,dialogMessage: '¿Está seguro de activar el Documento?',dialogTitle: 'Confirm: 3016',})}
        if (this.state.language === 'Portuguese'){this.setState({dialogOpenDeactivate: true,dialogMessage: 'Você tem certeza de ativar o Documento?',dialogTitle: 'Confirm: 3016',}) }
        if (this.state.language === 'Swedish'){this.setState({dialogOpenDeactivate: true,dialogMessage: 'Är du säker på att aktivera Dokumentet?',dialogTitle: 'Confirm: 3016',})}
        if (this.state.language === 'Netherlands'){this.setState({dialogOpenDeactivate: true,dialogMessage: 'Weet u zeker dat u het Document wilt activeren?',dialogTitle: 'Confirm: 3016',})}
        if (this.state.language === 'Russian'){this.setState({dialogOpenDeactivate: true,dialogMessage: 'Вы уверены, что активировать документ?',dialogTitle: 'Confirm: 3016',})}
        if (this.state.language === 'Japanese'){this.setState({dialogOpenDeactivate: true,dialogMessage: 'ドキュメントをアクティブにしますか？',dialogTitle: 'Confirm: 3016',})}
        if (this.state.language === 'Chinese'){this.setState({dialogOpenDeactivate: true,dialogMessage: '您確定要激活文檔嗎？',dialogTitle: 'Confirm: 3016',})}
        if (this.state.language === 'German'){this.setState({dialogOpenDeactivate: true,dialogMessage: 'Sind Sie sicher, das Dokument zu aktivieren?',dialogTitle: 'Confirm: 3016',})}
        if (this.state.language === 'Italian'){this.setState({dialogOpenDeactivate: true,dialogMessage: 'Sei sicuro di attivare il Documento?',dialogTitle: 'Confirm: 3016',})}
      }

      errorNumberContract(){
        if (this.state.language === 'English'){this.setState({dialogOpenSaveDraft: true,dialogMessage: 'You must enter the document number',dialogTitle: 'Error: 1006',})}
        if (this.state.language === 'French'){this.setState({dialogOpenSaveDraft: true,dialogMessage: 'Vous devez entrer le numéro de document',dialogTitle: 'Error: 1006',})}
        if (this.state.language === 'Spanish'){this.setState({dialogOpenSaveDraft: true,dialogMessage: 'Debe ingresar el número del documento',dialogTitle: 'Error: 1006',})}
        if (this.state.language === 'Portuguese'){this.setState({dialogOpenSaveDraft: true,dialogMessage: 'Você deve inserir o número do documento',dialogTitle: 'Error: 1006',})}
        if (this.state.language === 'Swedish'){this.setState({dialogOpenSaveDraft: true,dialogMessage: 'Du måste ange dokumentnumret',dialogTitle: 'Error: 1006',})}
        if (this.state.language === 'Netherlands'){this.setState({dialogOpenSaveDraft: true,dialogMessage: 'U moet het documentnummer invoeren',dialogTitle: 'Error: 1006',})}
        if (this.state.language === 'Russian'){this.setState({dialogOpenSaveDraft: true,dialogMessage: 'Вы должны ввести номер документа',dialogTitle: 'Error: 1006',})}
        if (this.state.language === 'Japanese'){this.setState({dialogOpenSaveDraft: true,dialogMessage: '文書番号を入力する必要があります',dialogTitle: 'Error: 1006',})}
        if (this.state.language === 'Chinese'){this.setState({dialogOpenSaveDraft: true,dialogMessage: '您必須輸入憑證編號',dialogTitle: 'Error: 1006',})}
        if (this.state.language === 'German'){this.setState({dialogOpenSaveDraft: true,dialogMessage: 'Sie müssen die Belegnummer eingeben',dialogTitle: 'Error: 1006',})}
        if (this.state.language === 'Italian'){this.setState({dialogOpenSaveDraft: true,dialogMessage: 'Devi inserire il numero del documento',dialogTitle: 'Error: 1006',})}

      }

      saveDraftConfirm(){
        if (this.state.language === 'English'){this.setState({dialogOpenSaveDraft: true,dialogMessage: 'The document contains signatures, you must delete the signatures before modifying the document',dialogTitle: 'Error: 1003',})}
        if (this.state.language === 'French'){this.setState({dialogOpenSaveDraft: true,dialogMessage: 'Le document contient des signatures, vous devez supprimer les signatures avant de modifier le document',dialogTitle: 'Error: 1003',})}
        if (this.state.language === 'Spanish'){this.setState({dialogOpenSaveDraft: true,dialogMessage: 'El documento contiene firmas, debe eliminar las firmas antes de modificar el documento',dialogTitle: 'Error: 1003',})}
        if (this.state.language === 'Portuguese'){this.setState({dialogOpenSaveDraft: true,dialogMessage: 'O documento contém assinaturas. Você deve excluir as assinaturas antes de modificar o documento',dialogTitle: 'Error: 1003',})}
        if (this.state.language === 'Swedish'){this.setState({dialogOpenSaveDraft: true,dialogMessage: 'Dokumentet innehåller signaturer, du måste radera signaturerna innan du ändrar dokumentet',dialogTitle: 'Error: 1003',})}
        if (this.state.language === 'Netherlands'){this.setState({dialogOpenSaveDraft: true,dialogMessage: 'Het document bevat handtekeningen, u moet de handtekeningen verwijderen voordat u het document wijzigt',dialogTitle: 'Error: 1003',})}
        if (this.state.language === 'Russian'){this.setState({dialogOpenSaveDraft: true,dialogMessage: 'Документ содержит подписи, вы должны удалить подписи перед изменением документа',dialogTitle: 'Error: 1003',})}
        if (this.state.language === 'Japanese'){this.setState({dialogOpenSaveDraft: true,dialogMessage: 'ドキュメントに署名が含まれています。ドキュメントを変更する前に署名を削除する必要があります',dialogTitle: 'Error: 1003',})}
        if (this.state.language === 'Chinese'){this.setState({dialogOpenSaveDraft: true,dialogMessage: '該文檔包含簽名，您必須先刪除簽名，然後再修改文檔',dialogTitle: 'Error: 1003',})}
        if (this.state.language === 'German'){this.setState({dialogOpenSaveDraft: true,dialogMessage: 'Das Dokument enthält Signaturen. Sie müssen die Signaturen löschen, bevor Sie das Dokument ändern',dialogTitle: 'Error: 1003',})}
        if (this.state.language === 'Italian'){this.setState({dialogOpenSaveDraft: true,dialogMessage: 'Il documento contiene firme, è necessario eliminare le firme prima di modificare il documento',dialogTitle: 'Error: 1003',})}
      }

      deleteProformaDetailConfirm = (e,i) => {
        localStorage.setItem('correlativoProformaDetail',i)
        if (this.state.language === 'English'){this.setState({dialogOpen: true,dialogMessage: 'Are you sure of delete the element?',dialogTitle: 'Confirm: 3009'})}
        if (this.state.language === 'French'){this.setState({dialogOpen: true,dialogMessage: "Êtes-vous sûr de supprimer l'élément?",dialogTitle: 'Confirm: 3009'})}
        if (this.state.language === 'Spanish'){this.setState({dialogOpen: true,dialogMessage: '¿Está seguro de eliminar el elemento?',dialogTitle: 'Confirm: 3009'})}
        if (this.state.language === 'Portuguese'){this.setState({dialogOpen: true,dialogMessage: 'Tem certeza de que deseja excluir o elemento?',dialogTitle: 'Confirm: 3009'})}
        if (this.state.language === 'Swedish'){this.setState({dialogOpen: true,dialogMessage: 'Är du säker på att radera elementet?',dialogTitle: 'Confirm: 3009'})}
        if (this.state.language === 'Netherlands'){this.setState({dialogOpen: true,dialogMessage: 'Weet u zeker dat u het element wilt verwijderen?',dialogTitle: 'Confirm: 3009'})}
        if (this.state.language === 'Russian'){this.setState({dialogOpen: true,dialogMessage: 'Вы уверены, что хотите удалить элемент?',dialogTitle: 'Confirm: 3009'})}
        if (this.state.language === 'Japanese'){this.setState({dialogOpen: true,dialogMessage: '要素を削除してもよろしいですか？',dialogTitle: 'Confirm: 3009'})}
        if (this.state.language === 'Chinese'){this.setState({dialogOpen: true,dialogMessage: '您确定要删除该元素吗？',dialogTitle: 'Confirm: 3009'})}
        if (this.state.language === 'German'){this.setState({dialogOpen: true,dialogMessage: 'Sind Sie sicher, dass Sie das Element löschen möchten?',dialogTitle: 'Confirm: 3009'})}
        if (this.state.language === 'Italian'){this.setState({dialogOpenDeleteProformaDetail: true,dialogMessage: "Sei sicuro di eliminare l'elemento?",dialogTitle: 'Confirm: 3009'})}
      }

      editProformaDetailConfirm = (e,i) => {
        localStorage.setItem('correlativoProformaDetail',i)
        if (this.state.language === 'English'){this.setState({dialogOpen: true,dialogMessage: 'Are you sure of edit the element?',dialogTitle: 'Confirm: 3010'})}
        if (this.state.language === 'French'){this.setState({dialogOpen: true,dialogMessage: "Êtes-vous sûr de modifier l'élément?",dialogTitle: 'Confirm: 3010'})}
        if (this.state.language === 'Spanish'){this.setState({dialogOpen: true,dialogMessage: '¿Está seguro de editar el elemento?',dialogTitle: 'Confirm: 3010'})}
        if (this.state.language === 'Portuguese'){this.setState({dialogOpen: true,dialogMessage: 'Tem certeza de que deseja editar o elemento?',dialogTitle: 'Confirm: 3010'})}
        if (this.state.language === 'Swedish'){this.setState({dialogOpen: true,dialogMessage: 'Är du säker på att redigera elementet?',dialogTitle: 'Confirm: 3010'})}
        if (this.state.language === 'Netherlands'){this.setState({dialogOpen: true,dialogMessage: 'Weet u zeker dat u het element wilt bewerken?',dialogTitle: 'Confirm: 3010'})}
        if (this.state.language === 'Russian'){this.setState({dialogOpen: true,dialogMessage: 'Вы уверены, что можете отредактировать элемент?',dialogTitle: 'Confirm: 3010'})}
        if (this.state.language === 'Japanese'){this.setState({dialogOpen: true,dialogMessage: '要素を編集してもよろしいですか？',dialogTitle: 'Confirm: 3010'})}
        if (this.state.language === 'Chinese'){this.setState({dialogOpen: true,dialogMessage: '您确定要编辑元素吗？',dialogTitle: 'Confirm: 3010'})}
        if (this.state.language === 'German'){this.setState({dialogOpen: true,dialogMessage: 'Sind Sie sicher, dass Sie das Element bearbeiten möchten?',dialogTitle: 'Confirm: 3010'})}
        if (this.state.language === 'Italian'){this.setState({dialogOpen: true,dialogMessage: "Sei sicuro di modificare l'elemento?",dialogTitle: 'Confirm: 3010'})}
      }

      saveDraftAgreeConfirm(){
        if (this.state.language === 'English'){this.setState({dialogOpenSaveDraftAgree: true,dialogMessage: 'You must check the option: I agree with your Contract Policy',dialogTitle: 'Error: 1004',})}
        if (this.state.language === 'French'){this.setState({dialogOpenSaveDraftAgree: true,dialogMessage: "Vous devez cocher l'option: J'accepte les conditions de votre contrat",dialogTitle: 'Error: 1004',})}
        if (this.state.language === 'Spanish'){this.setState({dialogOpenSaveDraftAgree: true,dialogMessage: 'Debe marcar la opción: Acepto la Política de Contrato',dialogTitle: 'Error: 1004',})}
        if (this.state.language === 'Portuguese'){this.setState({dialogOpenSaveDraftAgree: true,dialogMessage: 'Você deve verificar a opção: Concordo com sua Política de Contratos',dialogTitle: 'Error: 1004',})}
        if (this.state.language === 'Swedish'){this.setState({dialogOpenSaveDraftAgree: true,dialogMessage: 'Du måste kontrollera alternativet: Jag accepterar din avtalspolicy',dialogTitle: 'Error: 1004',})}
        if (this.state.language === 'Netherlands'){this.setState({dialogOpenSaveDraftAgree: true,dialogMessage: 'U moet de optie aanvinken: ik ga akkoord met uw contractbeleid',dialogTitle: 'Error: 1004',})}
        if (this.state.language === 'Russian'){this.setState({dialogOpenSaveDraftAgree: true,dialogMessage: 'Вы должны проверить опцию: я согласен с вашей контрактной политикой',dialogTitle: 'Error: 1004',})}
        if (this.state.language === 'Japanese'){this.setState({dialogOpenSaveDraftAgree: true,dialogMessage: 'オプションを確認する必要があります：契約ポリシーに同意しますd',dialogTitle: 'Error: 1004',})}
        if (this.state.language === 'Chinese'){this.setState({dialogOpenSaveDraftAgree: true,dialogMessage: '您必须选中以下选项：我同意您的合同政策',dialogTitle: 'Error: 1004',})}
        if (this.state.language === 'German'){this.setState({dialogOpenSaveDraftAgree: true,dialogMessage: 'Sie müssen die Option aktivieren: Ich stimme Ihren Vertragsbedingungen zu',dialogTitle: 'Error: 1004',})}
        if (this.state.language === 'Italian'){this.setState({dialogOpenSaveDraftAgree: true,dialogMessage: "È necessario selezionare l'opzione: Accetto le condizioni del contratto",dialogTitle: 'Error: 1004',})}
      }

      signConfirm(){
        if (this.state.language === 'English'){this.setState({dialogOpenSign: true,dialogMessage: 'Are you sure of sign the Document?',dialogTitle: 'Confirm: 3003',})}
        if (this.state.language === 'French'){this.setState({dialogOpenSign: true,dialogMessage: 'Êtes-vous sûr de signer le Document?',dialogTitle: 'Confirm: 3003',})}
        if (this.state.language === 'Spanish'){this.setState({dialogOpenSign: true,dialogMessage: '¿Está seguro de firmar el Documento?',dialogTitle: 'Confirm: 3003',})}
        if (this.state.language === 'Portuguese'){this.setState({dialogOpenSign: true,dialogMessage: 'Você tem certeza de assinar o Documento?',dialogTitle: 'Confirm: 3003',})}
        if (this.state.language === 'Swedish'){this.setState({dialogOpenSign: true,dialogMessage: 'Är du säker på att skriva under dokumentet?',dialogTitle: 'Confirm: 3003',})}
        if (this.state.language === 'Netherlands'){this.setState({dialogOpenSign: true,dialogMessage: 'Weet u zeker dat u het document ondertekent?',dialogTitle: 'Confirm: 3003',})}
        if (this.state.language === 'Russian'){this.setState({dialogOpenSign: true,dialogMessage: 'Вы уверены, что подписали документ?',dialogTitle: 'Confirm: 3003',})}
        if (this.state.language === 'Japanese'){this.setState({dialogOpenSign: true,dialogMessage: 'ドキュメントに署名してもよろしいですか？',dialogTitle: 'Confirm: 3003',})}
        if (this.state.language === 'Chinese'){this.setState({dialogOpenSign: true,dialogMessage: '您確定要簽署文件嗎？',dialogTitle: 'Confirm: 3003',})}
        if (this.state.language === 'German'){this.setState({dialogOpenSign: true,dialogMessage: 'Sind Sie sicher, das Dokument zu unterschreiben?',dialogTitle: 'Confirm: 3003',})}
        if (this.state.language === 'Italian'){this.setState({dialogOpenSign: true,dialogMessage: 'Sei sicuro di firmare il documento?',dialogTitle: 'Confirm: 3003',})}
      }

      unsignConfirm(){
        if (this.state.language === 'English'){this.setState({dialogOpenUnSign: true,dialogMessage: 'Are you sure of cancel sign the Document?',dialogTitle: 'Confirm: 3004',})}
        if (this.state.language === 'French'){this.setState({dialogOpenUnSign: true,dialogMessage: `Êtes-vous sûr d'annuler la signature du Document?`,dialogTitle: 'Confirm: 3004',})}
        if (this.state.language === 'Spanish'){this.setState({dialogOpenUnSign: true,dialogMessage: '¿Está seguro de cancelar la firma del Documento?',dialogTitle: 'Confirm: 3004',})}
        if (this.state.language === 'Portuguese'){this.setState({dialogOpenUnSign: true,dialogMessage: 'Você tem certeza de cancelar assinar o Documento?',dialogTitle: 'Confirm: 3004',})}
        if (this.state.language === 'Swedish'){this.setState({dialogOpenUnSign: true,dialogMessage: 'Är du säker på att avbryta underteckna Dokumentet?',dialogTitle: 'Confirm: 3004',})}
        if (this.state.language === 'Netherlands'){this.setState({dialogOpenUnSign: true,dialogMessage: 'Weet u zeker dat u het Document wilt annuleren?',dialogTitle: 'Confirm: 3004',})}
        if (this.state.language === 'Russian'){this.setState({dialogOpenUnSign: true,dialogMessage: 'Вы уверены, что хотите отменить подписание документа?',dialogTitle: 'Confirm: 3004',})}
        if (this.state.language === 'Japanese'){this.setState({dialogOpenUnSign: true,dialogMessage: 'ドキュメントへの署名をキャンセルしてもよろしいですか？',dialogTitle: 'Confirm: 3004',})}
        if (this.state.language === 'Chinese'){this.setState({dialogOpenUnSign: true,dialogMessage: '您確定要取消對文檔的簽名嗎？',dialogTitle: 'Confirm: 3004',})}
        if (this.state.language === 'German'){this.setState({dialogOpenUnSign: true,dialogMessage: 'Sind Sie sicher, das Dokument abzubrechen?',dialogTitle: 'Confirm: 3004',})}
        if (this.state.language === 'Italian'){this.setState({dialogOpenUnSign: true,dialogMessage: 'Sei sicuro di annullare la firma del Documento?',dialogTitle: 'Confirm: 3004',})}
      }

      existContract(){
        if (this.state.language === 'English'){this.setState({dialogOpenContractExist: true,dialogMessage: 'The Document Exist',dialogTitle: 'Error: 1002',})}
        if (this.state.language === 'French'){this.setState({dialogOpenContractExist: true,dialogMessage: 'Le Document Exist',dialogTitle: 'Error: 1002',})}
        if (this.state.language === 'Spanish'){this.setState({dialogOpenContractExist: true,dialogMessage: 'El Documento existe',dialogTitle: 'Error: 1002',})}
        if (this.state.language === 'Portuguese'){this.setState({dialogOpenContractExist: true,dialogMessage: 'O Documento existente',dialogTitle: 'Error: 1002',})}
        if (this.state.language === 'Swedish'){this.setState({dialogOpenContractExist: true,dialogMessage: 'Dokumentet finns',dialogTitle: 'Error: 1002',})}
        if (this.state.language === 'Netherlands'){this.setState({dialogOpenContractExist: true,dialogMessage: 'Het document bestaat',dialogTitle: 'Error: 1002',})}
        if (this.state.language === 'Russian'){this.setState({dialogOpenContractExist: true,dialogMessage: 'Документ существует',dialogTitle: 'Error: 1002',})}
        if (this.state.language === 'Japanese'){this.setState({dialogOpenContractExist: true,dialogMessage: 'ドキュメントが存在します',dialogTitle: 'Error: 1002',})}
        if (this.state.language === 'Chinese'){this.setState({dialogOpenContractExist: true,dialogMessage: '該文件存在',dialogTitle: 'Error: 1002',})}
        if (this.state.language === 'German'){this.setState({dialogOpenContractExist: true,dialogMessage: 'Das Dokument ist vorhanden',dialogTitle: 'Error: 1002',})}
        if (this.state.language === 'Italian'){this.setState({dialogOpenContractExist: true,dialogMessage: 'Il documento esiste',dialogTitle: 'Error: 1002',})}
      }

      editContract(displayRoleX, displayLifeCycleX){
        if (this.state.language === 'English'){this.setState({dialogOpenContractExist: true,dialogMessage: `The Document cannot be edited. His state is ${displayLifeCycleX} and his role is ${displayRoleX}`,dialogTitle: 'Error: 1002',})}
        if (this.state.language === 'French'){this.setState({dialogOpenContractExist: true,dialogMessage: `Le Document ne peut pas être modifié. Son état est ${displayLifeCycleX} et son rôle est ${displayRoleX}`,dialogTitle: 'Error: 1002',})}
        if (this.state.language === 'Spanish'){this.setState({dialogOpenContractExist: true,dialogMessage: `El Documento no puede ser editado. Su estado es ${displayLifeCycleX} y su rol es ${displayRoleX}`,dialogTitle: 'Error: 1002',})}
        if (this.state.language === 'Portuguese'){this.setState({dialogOpenContractExist: true,dialogMessage: `O Documento não pode ser editado. Seu estado é ${displayLifeCycleX} e seu papel é ${displayRoleX}`,dialogTitle: 'Error: 1002',})}
        if (this.state.language === 'Swedish'){this.setState({dialogOpenContractExist: true,dialogMessage: `Dokumentet kan inte redigeras. Hans tillstånd är ${displayLifeCycleX} och hans roll är ${displayRoleX}`,dialogTitle: 'Error: 1002',})}
        if (this.state.language === 'Netherlands'){this.setState({dialogOpenContractExist: true,dialogMessage: `Het document kan niet worden bewerkt. Zijn staat is ${displayLifeCycleX} en zijn rol is ${displayRoleX}`,dialogTitle: 'Error: 1002',})}
        if (this.state.language === 'Russian'){this.setState({dialogOpenContractExist: true,dialogMessage: `Документ не может быть отредактирован. Его состояние ${displayLifeCycleX} и его роль ${displayRoleX}`,dialogTitle: 'Error: 1002',})}
        if (this.state.language === 'Japanese'){this.setState({dialogOpenContractExist: true,dialogMessage: `ドキュメントは編集できません. 彼の状態は ${displayLifeCycleX} そして彼の役割は ${displayRoleX}`,dialogTitle: 'Error: 1002',})}
        if (this.state.language === 'Chinese'){this.setState({dialogOpenContractExist: true,dialogMessage: `無法編輯文件. 彼の状態は ${displayLifeCycleX} そして彼の役割は ${displayRoleX}`,dialogTitle: 'Error: 1002',})}
        if (this.state.language === 'German'){this.setState({dialogOpenContractExist: true,dialogMessage: `Das Dokument kann nicht bearbeitet werden. Sein Zustand ist ${displayLifeCycleX} und seine Rolle ist ${displayRoleX}`,dialogTitle: 'Error: 1002',})}
        if (this.state.language === 'Italian'){this.setState({dialogOpenContractExist: true,dialogMessage: `Il documento non può essere modificato. Il suo stato è ${displayLifeCycleX} e il suo ruolo è ${displayRoleX}`,dialogTitle: 'Error: 1002',})}
      }

      deleteContract(displayRoleX, displayLifeCycleX){
        if (this.state.language === 'English'){this.setState({dialogOpenContractExist: true,dialogMessage: `The Document cannot be deleted. His state is ${displayLifeCycleX} and his role is ${displayRoleX}`,dialogTitle: 'Error: 1002',})}
        if (this.state.language === 'French'){this.setState({dialogOpenContractExist: true,dialogMessage: `Le Document ne peut pas être supprimé. Son état est ${displayLifeCycleX} et son rôle est ${displayRoleX}`,dialogTitle: 'Error: 1002',})}
        if (this.state.language === 'Spanish'){this.setState({dialogOpenContractExist: true,dialogMessage: `El Documento no puede ser eliminado. Su estado es ${displayLifeCycleX} y su rol es ${displayRoleX}`,dialogTitle: 'Error: 1002',})}
        if (this.state.language === 'Portuguese'){this.setState({dialogOpenContractExist: true,dialogMessage: `O Documento não pode ser excluído. Seu estado é ${displayLifeCycleX} e seu papel é ${displayRoleX}`,dialogTitle: 'Error: 1002',})}
        if (this.state.language === 'Swedish'){this.setState({dialogOpenContractExist: true,dialogMessage: `Dokumentet kan inte raderas. Hans tillstånd är ${displayLifeCycleX} och hans roll är ${displayRoleX}`,dialogTitle: 'Error: 1002',})}
        if (this.state.language === 'Netherlands'){this.setState({dialogOpenContractExist: true,dialogMessage: `Het document kan niet worden verwijderd. Zijn staat is ${displayLifeCycleX} en zijn rol is ${displayRoleX}`,dialogTitle: 'Error: 1002',})}
        if (this.state.language === 'Russian'){this.setState({dialogOpenContractExist: true,dialogMessage: `Документ не может быть удален. Его состояние ${displayLifeCycleX} и его роль ${displayRoleX}`,dialogTitle: 'Error: 1002',})}
        if (this.state.language === 'Japanese'){this.setState({dialogOpenContractExist: true,dialogMessage: `ドキュメントを削除できません. 彼の状態は ${displayLifeCycleX} そして彼の役割は ${displayRoleX}`,dialogTitle: 'Error: 1002',})}
        if (this.state.language === 'Chinese'){this.setState({dialogOpenContractExist: true,dialogMessage: `無法刪除文件. 他的状态是 ${displayLifeCycleX} 而他的角色是 ${displayRoleX}`,dialogTitle: 'Error: 1002',})}
        if (this.state.language === 'German'){this.setState({dialogOpenContractExist: true,dialogMessage: `Das Dokument kann nicht gelöscht werden. Sein Zustand ist ${displayLifeCycleX} und seine Rolle ist ${displayRoleX}`,dialogTitle: 'Error: 1002',})}
        if (this.state.language === 'Italian'){this.setState({dialogOpenContractExist: true,dialogMessage: `Il documento non può essere cancellato. Il suo stato è ${displayLifeCycleX} e il suo ruolo è ${displayRoleX}`,dialogTitle: 'Error: 1002',})}
      }

      archiveContract(displayRoleX){
        if (this.state.language === 'English'){this.setState({dialogOpenContractExist: true,dialogMessage: `The Document cannot be archived. His role is ${displayRoleX}`,dialogTitle: 'Error: 1002',})}
        if (this.state.language === 'French'){this.setState({dialogOpenContractExist: true,dialogMessage: `Le Document ne peut pas être archivé. Son rôle est ${displayRoleX}`,dialogTitle: 'Error: 1002',})}
        if (this.state.language === 'Spanish'){this.setState({dialogOpenContractExist: true,dialogMessage: `El Documento no puede ser archivado. Su rol es ${displayRoleX}`,dialogTitle: 'Error: 1002',})}
        if (this.state.language === 'Portuguese'){this.setState({dialogOpenContractExist: true,dialogMessage: `O Documento não pode ser arquivado. Seu papel é ${displayRoleX}`,dialogTitle: 'Error: 1002',})}
        if (this.state.language === 'Swedish'){this.setState({dialogOpenContractExist: true,dialogMessage: `Dokumentet kan inte arkiveras. Hans roll är ${displayRoleX}`,dialogTitle: 'Error: 1002',})}
        if (this.state.language === 'Netherlands'){this.setState({dialogOpenContractExist: true,dialogMessage: `Het document kan niet worden gearchiveerd. Zijn rol is ${displayRoleX}`,dialogTitle: 'Error: 1002',})}
        if (this.state.language === 'Russian'){this.setState({dialogOpenContractExist: true,dialogMessage: `Документ не может быть заархивирован. Его роль ${displayRoleX}`,dialogTitle: 'Error: 1002',})}
        if (this.state.language === 'Japanese'){this.setState({dialogOpenContractExist: true,dialogMessage: `ドキュメントをアーカイブできません. 彼の役割は ${displayRoleX}`,dialogTitle: 'Error: 1002',})}
        if (this.state.language === 'Chinese'){this.setState({dialogOpenContractExist: true,dialogMessage: `無法存檔文件. 他的角色是 ${displayRoleX}`,dialogTitle: 'Error: 1002',})}
        if (this.state.language === 'German'){this.setState({dialogOpenContractExist: true,dialogMessage: `Das Dokument kann nicht archiviert werden. Seine Rolle ist ${displayRoleX}`,dialogTitle: 'Error: 1002',})}
        if (this.state.language === 'Italian'){this.setState({dialogOpenContractExist: true,dialogMessage: `Il documento non può essere archiviato. Il ruolo è ${displayRoleX}`,dialogTitle: 'Error: 1002',})}
      }
      validatePaymentForm1(){
        if (this.state.language === 'English'){this.setState({dialogOpenPaymentForm: true,dialogMessage: 'The payment method is incomplete' ,dialogTitle: 'Error: 1007',})}
        if (this.state.language === 'French'){this.setState({dialogOpenPaymentForm: true,dialogMessage: 'Le moyen de paiement est incomplet',dialogTitle: 'Error: 1007',})}
        if (this.state.language === 'Spanish'){this.setState({dialogOpenPaymentForm: true,dialogMessage: 'La forma de Pago está incompleta',dialogTitle: 'Error: 1007',})}
        if (this.state.language === 'Portuguese'){this.setState({dialogOpenPaymentForm: true,dialogMessage: 'O método de pagamento está incompleto',dialogTitle: 'Error: 1007',})}
        if (this.state.language === 'Swedish'){this.setState({dialogOpenPaymentForm: true,dialogMessage: 'Betalningsmetoden är ofullständig',dialogTitle: 'Error: 1007',})}
        if (this.state.language === 'Netherlands'){this.setState({dialogOpenPaymentForm: true,dialogMessage: 'Betalningsmetoden är ofullständig',dialogTitle: 'Error: 1007',})}
        if (this.state.language === 'Russian'){this.setState({dialogOpenPaymentForm: true,dialogMessage: 'Способ оплаты не указан ',dialogTitle: 'Error: 1007',})}
        if (this.state.language === 'Japanese'){this.setState({dialogOpenPaymentForm: true,dialogMessage: '支払い方法が不完全です',dialogTitle: 'Error: 1007',})}
        if (this.state.language === 'Chinese'){this.setState({dialogOpenPaymentForm: true,dialogMessage: '付款方式不完整',dialogTitle: 'Error: 1007',})}
        if (this.state.language === 'German'){this.setState({dialogOpenPaymentForm: true,dialogMessage: 'Die Zahlungsmethode ist unvollständig',dialogTitle: 'Error: 1007',})}
        if (this.state.language === 'Italian'){this.setState({dialogOpenPaymentForm: true,dialogMessage: 'Il metodo di pagamento è incompleto',dialogTitle: 'Error: 1007',})}
      }

      validatePaymentForm2(){
        if (this.state.language === 'English'){this.setState({dialogOpenPaymentForm: true,dialogMessage: 'Missing to enter the Payment Method',dialogTitle: 'Error: 1008',})}
        if (this.state.language === 'French'){this.setState({dialogOpenPaymentForm: true,dialogMessage: 'Manque de saisir le mode de paiement',dialogTitle: 'Error: 1008',})}
        if (this.state.language === 'Spanish'){this.setState({dialogOpenPaymentForm: true,dialogMessage: 'Falta ingresar la Forma de Pago',dialogTitle: 'Error: 1008',})}
        if (this.state.language === 'Portuguese'){this.setState({dialogOpenPaymentForm: true,dialogMessage: 'Falta inserir o método de pagamento',dialogTitle: 'Error: 1008',})}
        if (this.state.language === 'Swedish'){this.setState({dialogOpenPaymentForm: true,dialogMessage: 'Saknar att ange betalningsmetod',dialogTitle: 'Error: 1008',})}
        if (this.state.language === 'Netherlands'){this.setState({dialogOpenPaymentForm: true,dialogMessage: 'Ontbrekend om de betalingsmethode in te voeren',dialogTitle: 'Error: 1008',})}
        if (this.state.language === 'Russian'){this.setState({dialogOpenPaymentForm: true,dialogMessage: 'Не удалось ввести способ оплаты',dialogTitle: 'Error: 1008',})}
        if (this.state.language === 'Japanese'){this.setState({dialogOpenPaymentForm: true,dialogMessage: 'お支払い方法の入力漏れ',dialogTitle: 'Error: 1008',})}
        if (this.state.language === 'Chinese'){this.setState({dialogOpenPaymentForm: true,dialogMessage: '缺少輸入付款方式',dialogTitle: 'Error: 1008',})}
        if (this.state.language === 'German'){this.setState({dialogOpenPaymentForm: true,dialogMessage: 'Es fehlt die Zahlungsmethode einzugeben',dialogTitle: 'Error: 1008',})}
        if (this.state.language === 'Italian'){this.setState({dialogOpenPaymentForm: true,dialogMessage: 'Manca per inserire il metodo di pagamento',dialogTitle: 'Error: 1008',})}
      }

      mostrarBotonesAbajo(){
        let displayGeneratePdfX = false
        let displayPrintPdfX = false
        if (this.state.JSONTemplateName === 'blank'){
          displayGeneratePdfX = true
        }
        if (this.state.JSONTemplateName === 'uploaded'){
          displayPrintPdfX = true
        }
        let active_after_publishedX = true
        if (this.state.active_after_publishedX === 'false'){
          active_after_publishedX = false
        }
        if (this.state.whatUserRole==="Creator"){
          if (this.state.statusActive2){
            if (this.state.existContract){
               if (this.state.jsonStatusIdPact !== '' && this.state.jsonStatusIdPact !== undefined) {
                 if (this.state.jsonStatusBlockchain === 'Cloud' && this.state.jsonStatusLifeCycle === 'Draft') {
                    return (
                      <Row form>
                          <table>
                            <tbody>
                            <tr>
                              <React.Fragment>
                                {this.state.todosSign ?
                                  <React.Fragment>
                                    {this.state.confirmSignX ?
                                      <>
                                        {displayGeneratePdfX ?
                                          <>
                                            <td><Button pill theme="info" onClick={this.generatePdf}><FormattedMessage id="contract.gerneratepdf" /></Button></td>
                                          </>
                                        : null }
                                        {displayPrintPdfX ?
                                          <>
                                            <td><Button pill theme="info" onClick={this.generatePdf}><FormattedMessage id="contract.gerneratepdf" /></Button></td>
                                          </>
                                        : null }
                                      </>
                                    : null }
                                  </React.Fragment>
                                : null }
                                {this.state.ningunoSign ?
                                  <React.Fragment>
                                    {this.state.showLoader ?
                                      <React.Fragment>
                                        <td><ContractLoader colorDark={this.props.colorDark} /> &nbsp;&nbsp; </td>
                                        <td><Button pill theme="danger" onClick={this.deactivateConfirm}><FormattedMessage id="button.deactivatecontract" /></Button></td>
                                      </React.Fragment>
                                    :
                                      <React.Fragment>
                                        <td><Button pill theme="success" onClick={e=>this.verifyContract(e, "modify", "cloud", this.state.JSONTemplateName, this.c02ConfigurationContract.current.value)}><FormattedMessage id="button.savedraft" /></Button></td>
                                        <td><Button pill theme="danger" onClick={this.deactivateConfirm}><FormattedMessage id="button.deactivatecontract" /></Button></td>
                                      </React.Fragment>
                                    }
                                  </React.Fragment>
                                : null }
                                <td>&nbsp;&nbsp;</td>
                                <td><Button pill theme="secondary" onClick={this.backTypeContract}><FormattedMessage id="button.contractlist" /></Button></td>
                              </React.Fragment>
                            </tr>
                            </tbody>
                          </table>
                      </Row>
                    )
                 }else{
                   return (
                     <Row form>
                       <table>
                         <tbody>
                           <tr>
                             {active_after_publishedX ?
                                <td><Button pill theme="warning" onClick={e=>this.deactivateConfirmAfterPublished(e)}><FormattedMessage id="button.deactivatecontract" /></Button></td>
                             :
                                <td><Button pill theme="success" onClick={e=>this.activateConfirmAfterPublished(e)}><FormattedMessage id="button.activatecontract" /></Button></td>
                             }
                             {displayGeneratePdfX ?
                              <>
                                <td><Button pill theme="info" onClick={this.generatePdf}><FormattedMessage id="contract.gerneratepdf" /></Button></td>
                                <td>&nbsp;&nbsp;</td>
                              </>
                             : null }
                             {displayPrintPdfX ?
                                <>
                                  <td><Button pill theme="info" onClick={this.generatePdf}><FormattedMessage id="contract.gerneratepdf" /></Button></td>
                                  <td>&nbsp;&nbsp;</td>
                                </>
                             : null }
                             <td><Button pill theme="secondary" onClick={this.backTypeContract}><FormattedMessage id="button.contractlist" /></Button></td>
                           </tr>
                         </tbody>
                       </table>
                     </Row>
                   )
                 }
              }else{
                return (
                  <Row form>
                      <table>
                        <tbody>
                          <tr>
                            <td><Button pill theme="secondary" onClick={this.backTypeContract}><FormattedMessage id="button.contractlist" /></Button></td>
                          </tr>
                        </tbody>
                      </table>
                  </Row>
                )
              }
            }else{
              return (
                <Row form>
                  <table>
                    <tbody>
                      <tr>
                        {this.state.showLoader ?
                          <React.Fragment>
                            <td><ContractLoader colorDark={this.props.colorDark}/> &nbsp;&nbsp; </td>
                            <td>&nbsp;&nbsp;</td>
                            <td><Button pill theme="secondary" onClick={this.backTypeContract}><FormattedMessage id="button.contractlist" /></Button></td>
                          </React.Fragment>
                        :
                          <React.Fragment>
                            <td><Button pill theme="success" onClick={e=>this.verifyContract(e, "insert", "cloud", this.state.JSONTemplateName, this.c02ConfigurationContract.current.value)}><FormattedMessage id="button.savedraft" /></Button></td>
                            <td>&nbsp;&nbsp;</td>
                            <td><Button pill theme="secondary" onClick={this.backTypeContract}><FormattedMessage id="button.contractlist" /></Button></td>
                          </React.Fragment>
                        }
                      </tr>
                    </tbody>
                  </table>
                </Row>
              )
            }
          }else{
            return (
              <div>
                <table>
                  <tbody>
                    <tr>
                      {!this.state.activeContract ?
                        <td><Button pill theme="danger" onClick={this.activateConfirm}><FormattedMessage id="button.activatecontract" /></Button></td>
                      : null }
                      <td><Button pill theme="danger" onClick={this.activateConfirm}><FormattedMessage id="button.activatecontract" /></Button></td>
                      <td><Button pill theme="secondary" onClick={this.backTypeContract}><FormattedMessage id="button.contractlist" /></Button></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            )
          }
        }else{
          if (this.state.whatUserRole==="Observer" || this.state.whatUserRole==="Payer" || this.state.whatUserRole==="PayTo"){
            if (this.state.jsonStatusBlockchain === 'Cloud' && this.state.jsonStatusLifeCycle === 'Draft') {
              return (
                <div>
                  <table>
                    <tbody>
                      <tr>
                        <td><Button pill theme="secondary" onClick={this.backTypeContract}><FormattedMessage id="button.contractlist" /></Button></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              )
            }else{
              return (
                <div>
                  <table>
                    <tbody>
                      <tr>
                        {displayGeneratePdfX ?
                          <>
                            <td><Button pill theme="info" onClick={this.generatePdf}><FormattedMessage id="contract.gerneratepdf" /></Button></td>
                            <td>&nbsp;&nbsp;</td>
                          </>
                        : null }
                        {displayPrintPdfX ?
                          <>
                            <td><Button pill theme="info" onClick={this.generatePdf}><FormattedMessage id="contract.gerneratepdf" /></Button></td>
                            <td>&nbsp;&nbsp;</td>
                          </>
                        : null }
                        <td><Button pill theme="secondary" onClick={this.backTypeContract}><FormattedMessage id="button.contractlist" /></Button></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              )
            }
          }else{
            if (this.state.whatUserRole==="Authorizer" || this.state.whatUserRole==="Authorizer-Inviter"){
              if (this.state.statusActive2){
                if (this.state.existContract){
                  if (this.state.jsonStatusIdPact !== ''  && this.state.jsonStatusIdPact !== undefined) {
                    if (this.state.jsonStatusBlockchain === 'Cloud' && this.state.jsonStatusLifeCycle === 'Draft') {
                        return (
                          <React.Fragment>
                            <Row>&nbsp;</Row>
                            <Row form>
                              <table>
                                <tbody>
                                  <tr>
                                    {this.state.confirmSignX ?
                                      <>
                                        {displayGeneratePdfX ?
                                          <>
                                            <td><Button pill theme="info" onClick={this.generatePdf}><FormattedMessage id="contract.gerneratepdf" /></Button></td>
                                            <td>&nbsp;&nbsp;</td>
                                          </>
                                        : null }
                                        {displayPrintPdfX ?
                                          <>
                                            <td><Button pill theme="info" onClick={this.generatePdf}><FormattedMessage id="contract.gerneratepdf" /></Button></td>
                                            <td>&nbsp;&nbsp;</td>
                                          </>
                                        : null }
                                        <td><Button pill theme="secondary" onClick={this.backTypeContract}><FormattedMessage id="button.contractlist" /></Button></td>
                                      </>
                                    :
                                      <React.Fragment>
                                        {this.state.signTrue ?
                                          null
                                        :
                                          <>
                                            {displayGeneratePdfX ?
                                              <>
                                              <td><Button pill theme="info" onClick={this.generatePdf}><FormattedMessage id="contract.gerneratepdf" /></Button></td>
                                              </>
                                            : null }
                                            {displayPrintPdfX ?
                                              <>
                                              <td><Button pill theme="info" onClick={this.generatePdf}><FormattedMessage id="contract.gerneratepdf" /></Button></td>
                                              </>
                                            : null }
                                            <td>&nbsp;&nbsp;</td>
                                          </>
                                        }
                                        <td>&nbsp;&nbsp;</td>
                                        <td><Button pill theme="secondary" onClick={this.backTypeContract}><FormattedMessage id="button.contractlist" /></Button></td>
                                      </React.Fragment>
                                    }
                                  </tr>
                                </tbody>
                              </table>
                            </Row>
                          </React.Fragment>
                        )
                    }else{
                       return (
                         <React.Fragment>
                           <Row>&nbsp;</Row>
                           <Row form>
                             <table>
                               <tbody>
                                 <tr>
                                   {displayGeneratePdfX ?
                                     <>
                                       <td><Button pill theme="info" onClick={this.generatePdf}><FormattedMessage id="contract.gerneratepdf" /></Button></td>
                                       <td>&nbsp;&nbsp;</td>
                                     </>
                                   : null }
                                   {displayPrintPdfX ?
                                     <>
                                       <td><Button pill theme="info" onClick={this.generatePdf}><FormattedMessage id="contract.gerneratepdf" /></Button></td>
                                       <td>&nbsp;&nbsp;</td>
                                     </>
                                   : null }
                                   <td><Button pill theme="secondary" onClick={this.backTypeContract}><FormattedMessage id="button.contractlist" /></Button></td>
                                 </tr>
                               </tbody>
                             </table>
                           </Row>
                         </React.Fragment>
                       )
                     }
                  }else{
                    return (
                      <React.Fragment>
                        <Row>&nbsp;</Row>
                        <Row form>
                          <Button pill theme="secondary" onClick={this.backTypeContract}><FormattedMessage id="button.contractlist" /></Button>
                        </Row>
                      </React.Fragment>
                    )
                  }
                }else{
                  return (
                    <React.Fragment>
                      <Row>&nbsp;</Row>
                      <Row form>
                        <Button pill theme="secondary" onClick={this.backTypeContract}><FormattedMessage id="button.contractlist" /></Button>
                      </Row>
                    </React.Fragment>
                  )
                }
              }else{
                return (
                  <div>
                    <table>
                      <tbody>
                        <tr>
                          <td><Button pill theme="secondary" onClick={this.backTypeContract}><FormattedMessage id="button.contractlist" /></Button></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                )
              }
            }else{
              return (
                <div>
                  <table>
                    <tbody>
                      <tr>
                        <td><Button pill theme="secondary" onClick={this.backTypeContract}><FormattedMessage id="button.contractlist" /></Button></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              )
            }
          }
        }
      }

      proformaSearchSender = async () => {
        if (this.state.displayProformaSearchSender === true){
          this.setState({displayProformaSearchSender: false})
        }else{
          this.setState({displayProformaSearchSender: true,jsonProformaSender: []})
          const {userSession} = this.state
          const storage = new Storage({ userSession });
          const options = { decrypt: false, verify: false }
          await getFileDB(this.state.username, `proforma_sender.json`)
             .then((fileContents) => {
               if(fileContents) {
                 const jsonBlockstack1 = JSON.parse(fileContents)
                 const jsonBlockstack2 = jsonBlockstack1.data
                 let jsonBlockstack5 = '[]'
                 if (jsonBlockstack2 !== null){
                    const jsonBlockstack3 = jsonBlockstack2.dataobject
                    const jsonBlockstack4 = jsonBlockstack3.replace(/\\/g,"");
                    if (jsonBlockstack4.substring(0,1) === '"') {
                       jsonBlockstack5 = jsonBlockstack4.substring(1,jsonBlockstack4.length - 1)
                    } else {
                       jsonBlockstack5 = jsonBlockstack4
                    }
                 }
                 let jsonBlockstack6 = JSON.parse(jsonBlockstack5)
                 this.setState({jsonProformaSender: JSON.parse(jsonBlockstack6)})
               }
             })
              .catch(error => {});
        }
      }

      proformaSaveSender = () => {
        const {userSession} = this.state
        const storage = new Storage({ userSession });
        const options = {contentType: 'application/json', encrypt: false, dangerouslyIgnoreEtag: true }
        let jsonProformaSenderY = this.state.jsonProformaSender
        if (jsonProformaSenderY.length === 0){
          jsonProformaSenderY = [{value:this.c06FieldContract.current.value,company:this.c07FieldContract.current.value,contact:this.c08FieldContract.current.value,direction:this.c09FieldContract.current.value,city:this.c10FieldContract.current.value,phone:this.c11FieldContract.current.value,email:this.c12FieldContract.current.value}]
        }else{
          jsonProformaSenderY = [...jsonProformaSenderY,{value:this.c06FieldContract.current.value,company:this.c07FieldContract.current.value,contact:this.c08FieldContract.current.value,direction:this.c09FieldContract.current.value,city:this.c10FieldContract.current.value,phone:this.c11FieldContract.current.value,email:this.c12FieldContract.current.value}]
        }
        return new Promise ((resolve, reject) =>{
          putFileDB(this.state.username,`proforma_sender.json`, 'Crosscheck_Contract', JSON.stringify(jsonProformaSenderY), JSON.stringify(options))
            .then(() => {
                 resolve()
            })
            .catch(error => {
                 reject()
            });
        })
      }

      proformaDeleteSender = async (e,disabledX) => {
         if (disabledX === false){
            const {userSession} = this.state
            const storage = new Storage({ userSession });
            const options = {contentType: 'application/json', encrypt: false, dangerouslyIgnoreEtag: true }
            const nameY = this.c06FieldContract.current.value
            const jsonProformaSenderY = this.state.jsonProformaSender
            let keyDelete = null
            let largo = jsonProformaSenderY.length
            jsonProformaSenderY.map((todo,i)=>{
              if (todo.value === nameY){
                 keyDelete = i
              }
              if (i === (largo - 1)){
              }
            })
            if (keyDelete !== null){
              jsonProformaSenderY.splice(keyDelete,1);
              putFileDB(this.state.username,`proforma_sender.json`, 'Crosscheck_Contract', JSON.stringify(jsonProformaSenderY), JSON.stringify(options))
                .then(() => {
                })
            }
            this.c06FieldContract.current.value = ''
            this.c07FieldContract.current.value = ''
            this.c08FieldContract.current.value = ''
            this.c09FieldContract.current.value = ''
            this.c10FieldContract.current.value = ''
            this.c11FieldContract.current.value = ''
            this.c12FieldContract.current.value = ''
          }
      }

      handleChangeProformaSender() {
        this.setState({displayProformaSearchSender: false})
        const nameY = this.c06FieldContractSearch.current.value
        const jsonProformaSenderY = this.state.jsonProformaSender
        jsonProformaSenderY.map((todo,i)=>{
           if (todo.value === nameY){
             this.c06FieldContract.current.value = todo.value
             this.c07FieldContract.current.value = todo.company
             this.c08FieldContract.current.value = todo.contact
             this.c09FieldContract.current.value = todo.direction
             this.c10FieldContract.current.value = todo.city
             this.c11FieldContract.current.value = todo.phone
             this.c12FieldContract.current.value = todo.email
           }
        })
      }

      proformaSearchReceiver = async () => {
        if (this.state.displayProformaSearchReceiver === true){
          this.setState({displayProformaSearchReceiver: false})
        }else{
          this.setState({displayProformaSearchReceiver: true})
          const {userSession} = this.state
          const storage = new Storage({ userSession });
          const options = { decrypt: false, verify: false }
          this.setState({jsonProformaReceiver: []})
          await getFileDB(this.state.username, `proforma_receiver.json`)
             .then((fileContents) => {
               if(fileContents) {
                 const jsonBlockstack1 = JSON.parse(fileContents)
                 const jsonBlockstack2 = jsonBlockstack1.data
                 let jsonBlockstack5 = '[]'
                 if (jsonBlockstack2 !== null){
                    const jsonBlockstack3 = jsonBlockstack2.dataobject
                    const jsonBlockstack4 = jsonBlockstack3.replace(/\\/g,"");
                    if (jsonBlockstack4.substring(0,1) === '"') {
                       jsonBlockstack5 = jsonBlockstack4.substring(1,jsonBlockstack4.length - 1)
                    } else {
                       jsonBlockstack5 = jsonBlockstack4
                    }
                 }
                 let jsonBlockstack6 = JSON.parse(jsonBlockstack5)
                 this.setState({jsonProformaReceiver: JSON.parse(jsonBlockstack5)})
               }
             })
              .catch(error => {});
        }
      }

      proformaSaveReceiver = () => {
        const {userSession} = this.state
        const storage = new Storage({ userSession });
        const options = {contentType: 'application/json', encrypt: false, dangerouslyIgnoreEtag: true }
        let jsonProformaReceiverY = this.state.jsonProformaReceiver
        if (jsonProformaReceiverY.length === 0){
          jsonProformaReceiverY = [{value:this.c13FieldContract.current.value,company:this.c14FieldContract.current.value,contact:this.c15FieldContract.current.value,direction:this.c16FieldContract.current.value,city:this.c17FieldContract.current.value,phone:this.c18FieldContract.current.value,email:this.c19FieldContract.current.value}]
        }else{
          jsonProformaReceiverY = [...jsonProformaReceiverY,{value:this.c13FieldContract.current.value,company:this.c14FieldContract.current.value,contact:this.c15FieldContract.current.value,direction:this.c16FieldContract.current.value,city:this.c17FieldContract.current.value,phone:this.c18FieldContract.current.value,email:this.c19FieldContract.current.value}]
        }
        return new Promise ((resolve, reject) =>{
          putFileDB(this.state.username,`proforma_receiver.json`, 'Crosscheck_Contract', JSON.stringify(jsonProformaReceiverY), JSON.stringify(options))
            .then(() => {
                 resolve()
            })
            .catch(error => {
                 reject()
            });
        })
      }

      proformaDeleteReceiver = async (e,disabledX) => {
        if (disabledX === false){
          const {userSession} = this.state
          const storage = new Storage({ userSession });
          const options = {contentType: 'application/json', encrypt: false, dangerouslyIgnoreEtag: true }
          const nameY = this.c13FieldContract.current.value
          const jsonProformaReceiverY = this.state.jsonProformaReceiver
          jsonProformaReceiverY.map((todo,i)=>{
            if (todo.value === nameY){
               jsonProformaReceiverY.splice(i,1);
               putFileDB(this.state.username,`proforma_receiver.json`, 'Crosscheck_Contract', JSON.stringify(jsonProformaReceiverY), JSON.stringify(options))
                 .then(() => {
                 })
             }
          })
          this.c13FieldContract.current.value = ''
          this.c14FieldContract.current.value = ''
          this.c15FieldContract.current.value = ''
          this.c16FieldContract.current.value = ''
          this.c17FieldContract.current.value = ''
          this.c18FieldContract.current.value = ''
          this.c19FieldContract.current.value = ''
        }
      }

      handleChangeProformaReceiver() {
        this.setState({displayProformaSearchReceiver: false})
        const nameY = this.c13FieldContractSearch.current.value
        const jsonProformaReceiverY = this.state.jsonProformaReceiver
        jsonProformaReceiverY.map((todo,i)=>{
           if (todo.value === nameY){
             this.c13FieldContract.current.value = todo.value
             this.c14FieldContract.current.value = todo.company
             this.c15FieldContract.current.value = todo.contact
             this.c16FieldContract.current.value = todo.direction
             this.c17FieldContract.current.value = todo.city
             this.c18FieldContract.current.value = todo.phone
             this.c19FieldContract.current.value = todo.email
           }
        })
      }

      searchContracts = (e,opcion) => {
        this.setState({displayTemplateDetail: false,
                       errorMensajeTemplates: false,
                       sinTemplateDetail: true,
                       displayTemplateDetailTypeContract: false,
                       existContract: false,
                       whatUserRole: "Creator",
                       jsonEnrollment: [],
                       jsonProformaDetail: [],
                       jsonAttachFile: [],
                       subtotalProformaDetail: 0,
                       subtotalProformaDetailPrev: 0,
                       configurationContractNumberSign: '',
                       typeContractSign: '',
                       modeContract: 'list',
                       displayProformaSearchSender: false,
                       displayProformaSearchReceiver: false,
                       modifyItemProformaDetail: false,
                       codeAssociatedToMaintenance: '',
                       jsonStatusBlockchain: '',
        })
        let idx = ''
        let namex = ''
        let attachFilex = ''
        let rulex = ''
        let associatetoxx = ''
        let taxxx = ''
        let titlexx = ''

        if (opcion === 1){
           this.setState({modeDisplayCollapsed: false,displayIconsRed: false})
           const palabra = this.c01ConfigurationContract.current.value
           const ArrayIdValue = palabra.split('#$%')
           idx = ArrayIdValue[0]
           namex = ArrayIdValue[1]
           attachFilex = ArrayIdValue[2]
           rulex = ArrayIdValue[3]
           associatetoxx = ArrayIdValue[4]
           taxxx = ArrayIdValue[5]
           titlexx = ArrayIdValue[6]
        }else{
           let arrayTemplateDBX = []
           this.setState({modeDisplayCollapsed: true,displayIconsRed: true})
           if (this.state.bringContractTemplateFrom === 'Server'){
             if (this.props.templatesAll.length > 0) {
               arrayTemplateDBX = this.props.templatesAll[0]
             }
           }else{
             arrayTemplateDBX = this.state.templatesAllLocal
           }
           arrayTemplateDBX.map((todo, key) => {
              if (opcion === 2 && todo.secondaryName === 'blank'){
                idx = todo._id
                namex = todo.secondaryName
                attachFilex = todo.isAttachFile
                rulex = todo.isRules
                associatetoxx = todo.isAssociatedTo
                taxxx = todo.tax
                titlexx = todo.title
              }else{
                if (opcion === 3 && todo.secondaryName === 'delivery'){
                  idx = todo._id
                  namex = todo.secondaryName
                  attachFilex = todo.isAttachFile
                  rulex = todo.isRules
                  associatetoxx = todo.isAssociatedTo
                  taxxx = todo.tax
                  titlexx = todo.title
                  if (this.state.DisplayCompanyLogoData === 'Yes'){
                      Promise.all(
                         [this.getDisplayCompanyLogo(this.state.username,todo.secondaryName),
                          this.getDisplayCompanyData(this.state.username,todo.secondaryName)
                         ]
                      ).then(
                        (resolve) =>{},
                        (reject) =>{}
                      )
                  }

                }else{
                  if (opcion === 4 && todo.secondaryName === 'proforma'){
                    idx = todo._id
                    namex = todo.secondaryName
                    attachFilex = todo.isAttachFile
                    rulex = todo.isRules
                    associatetoxx = todo.isAssociatedTo
                    taxxx = todo.tax
                    titlexx = todo.title
                    if (this.state.DisplayCompanyLogoData === 'Yes'){
                        Promise.all(
                           [this.getDisplayCompanyLogo(this.state.username,todo.secondaryName),
                            this.getDisplayCompanyData(this.state.username,todo.secondaryName)
                           ]
                        ).then(
                          (resolve) =>{},
                          (reject) =>{}
                        )
                    }

                  }else{
                    if (opcion === 5 && todo.secondaryName === 'maintenance'){
                      idx = todo._id
                      namex = todo.secondaryName
                      attachFilex = todo.isAttachFile
                      rulex = todo.isRules
                      associatetoxx = todo.isAssociatedTo
                      taxxx = todo.tax
                      titlexx = todo.title
                      if (this.state.DisplayCompanyLogoData === 'Yes'){
                          Promise.all(
                             [this.getDisplayCompanyLogo(this.state.username,todo.secondaryName),
                              this.getDisplayCompanyData(this.state.username,todo.secondaryName)
                             ]
                          ).then(
                            (resolve) =>{},
                            (reject) =>{}
                          )
                      }
                      Promise.all(
                         [this.associatedToMaintenance()
                         ]
                      ).then(
                        (resolve) =>{},
                        (reject) =>{}
                      )
                    }else{
                      if (opcion === 6 && todo.secondaryName === 'spreadsheet'){
                        idx = todo._id
                        namex = todo.secondaryName
                        attachFilex = todo.isAttachFile
                        rulex = todo.isRules
                        associatetoxx = todo.isAssociatedTo
                        taxxx = todo.tax
                        titlexx = todo.title
                      }else{
                        if (opcion === 8 && todo.secondaryName === 'workorder'){
                          idx = todo._id
                          namex = todo.secondaryName
                          attachFilex = todo.isAttachFile
                          rulex = todo.isRules
                          associatetoxx = todo.isAssociatedTo
                          taxxx = todo.tax
                          titlexx = todo.title
                          if (this.state.DisplayCompanyLogoData === 'Yes'){
                              Promise.all(
                                 [this.getDisplayCompanyLogo(this.state.username,todo.secondaryName),
                                  this.getDisplayCompanyData(this.state.username,todo.secondaryName)
                                 ]
                              ).then(
                                (resolve) =>{},
                                (reject) =>{}
                              )
                          }
                          Promise.all(
                             [this.getClient_WorkOrder()
                             ]
                          ).then(
                            (resolve) =>{},
                            (reject) =>{}
                          )
                          this.setState({selectedSignaturePayment:'SignatureOnly'})
                        }else{
                          if (opcion === 77){
                            idx = '987654321'
                            namex = 'uploaded'
                            attachFilex = true
                            rulex = false
                            associatetoxx = false
                            taxxx = 0
                            titlexx = ''
                            this.setState({ newUploadedX: true })
                          }
                        }
                      }
                    }
                  }
                }
              }
           })
        }

        if (idx !== ''){
          if (attachFilex === undefined || attachFilex === 'undefined'){
              attachFilex = true
          }
          if (rulex === undefined || rulex === 'undefined'){
              rulex = true
          }
          if (taxxx === undefined || taxxx === 'undefined'){
              taxxx = 0
          }
          if (titlexx === undefined || titlexx === 'undefined'){
              titlexx = ''
          }
          if (associatetoxx === undefined || associatetoxx === 'undefined'){
              if (namex.toLowerCase() === 'proforma'){
                associatetoxx = false
              }else{
                associatetoxx = true
              }
          }
          if (namex.toLowerCase() === 'blank'){
            this.setState({displayWriteUp: true})
            this.getBlankDetailLoremIpsum()
          }
          this.c10ConfigurationContract.current.value = namex.toLowerCase()
          this.props.mostrarTemplate('jfontirroig.id.blockstack',idx)

          this.setState({typeContractSign: namex.toLowerCase(),
                         JSONTemplateName: namex.toLowerCase(),
                         displayTemplateDetailTypeContract: true,
                         searchContract2: true,
                         sinTemplateDetail: false,
                         attachFile30X: attachFilex,
                         rules30X: rulex,
                         associatedTo30X: associatetoxx,
                         tax30X: taxxx,
                         title30X: titlexx,
                         nameContractEditor: titlexx,
                         sinTemplateDetail: false,
                         showLoader: false})
        }
      }

      displayTemplates(){
      }

      printContract(){
      }

      returnUploadContract(file, file64){
        this.setState({filedecodeAttachX: file, fileAttachX: file64, typeAttachX: '', nameAttachX: '', newUploaded: true, seeAttachX: true, typeAttachText: false, typeAttachImage: false, typeAttachPdf: true, typeAttachAudio: false, typeAttachVideo: false })
      }

      generatePdf(){
        let jsonPDF = {}
        let isocode = this.state.isocode
        let logoCompanyX = this.state.logoCompany
        if (logoCompanyX === null || logoCompanyX === undefined){logoCompanyX=''}

        if (this.state.JSONTemplateName === 'delivery') {
          this.setState({generatePdfX: false })
        }
        if (this.state.JSONTemplateName === 'maintenance') {
          this.setState({generatePdfX: false })
        }
        if (this.state.JSONTemplateName === 'proforma') {
          this.setState({generatePdfX: false })
        }
        if (this.state.JSONTemplateName === 'blank'){
          this.setState({generatePdfX: true })
        }
        if (this.state.JSONTemplateName === 'uploaded'){
          this.setState({generatePdfX: true })
        }
        if (this.state.JSONTemplateName === 'spreadsheet'){
          this.setState({generatePdfX: false })
        }
        if (this.state.JSONTemplateName === 'workorder'){
          this.setState({generatePdfX: false })
        }
      }

      printContract(){
      }

      savetodiscContract(){
      }

      getClient_WorkOrder = () => {
        const {userSession} = this.state
        const storage = new Storage({ userSession });
        const options = { decrypt: false, verify: false }
        return new Promise((resolve1, reject1) => {
            getFileDB(this.state.username, `client_work_order.json`)
               .then((fileContents) => {
                 if(fileContents) {
                   const jsonBlockstack1 = JSON.parse(fileContents)
                   const jsonBlockstack2 = jsonBlockstack1.data
                   let jsonBlockstack5 = '[]'
                   if (jsonBlockstack2 !== null){
                      const jsonBlockstack3 = jsonBlockstack2.dataobject
                      const jsonBlockstack4 = jsonBlockstack3.replace(/\\/g,"");
                      if (jsonBlockstack4.substring(0,1) === '"') {
                         jsonBlockstack5 = jsonBlockstack4.substring(1,jsonBlockstack4.length - 1)
                      } else {
                         jsonBlockstack5 = jsonBlockstack4
                      }
                   }
                   let jsonBlockstack6 = JSON.parse(jsonBlockstack5)
                   this.setState({clientWorkOrder:jsonBlockstack6})
                   resolve1()
                 } else {
                   resolve1()
                 }
               })
                .catch(error => {
                  resolve1()
               });
        });
      }

      getDeliverableForms = (typeContractX,numberContractX,displayOriginX) => {
        const {userSession} = this.state
        const storage = new Storage({ userSession });
        const options = { decrypt: false, verify: false }
        return new Promise((resolve1, reject1) => {
            getFileDB(displayOriginX, `${typeContractX}_${numberContractX}_deliverable_form.json`)
              .then((fileContents) => {
                 if(fileContents) {
                   const jsonBlockstack1 = JSON.parse(fileContents)
                   const jsonBlockstack2 = jsonBlockstack1.data
                   let jsonBlockstack5 = '[]'
                   if (jsonBlockstack2 !== null){
                      const jsonBlockstack3 = jsonBlockstack2.dataobject
                      const jsonBlockstack4 = jsonBlockstack3.replace(/\\/g,"");
                      if (jsonBlockstack4.substring(0,1) === '"') {
                         jsonBlockstack5 = jsonBlockstack4.substring(1,jsonBlockstack4.length - 1)
                      } else {
                         jsonBlockstack5 = jsonBlockstack4
                      }
                   }
                   let jsonBlockstack6 = JSON.parse(jsonBlockstack5)

                   this.setState({deliverableFormsX:jsonBlockstack6 })
                   let deliverableFormsX = false
                   jsonBlockstack6.map((todo, i) => {
                      if (todo.concept === 'ReporteTurno'){
                        deliverableFormsX = true
                      }
                   })
                   this.setState({deliverableFormsX})
                 }
                 resolve1()
              })
              .catch(error => {
                console.log(error)
                reject1()
              });
        });
      }

      render() {
          const {location} = this.props
          const {pathname} = location
          let isocode = this.state.isocode
          let pathnameStart = false
          let pathnameNew = false
          let pathnameOpen = false
          let modeDisplay = this.state.modeDisplay
          let modeDisplayMailX = false
          let modeDisplayEditorX = false
          let modeMenuContractX = false
          let modeDisplayCollapsedX = this.state.modeDisplayCollapsed
          let displayCompanyLogoDataX = false
          if (this.state.DisplayCompanyLogoData === 'Yes'){
            displayCompanyLogoDataX = true
          }
          let logoCompanyX = false
          let dataCompany2X = false
          if (this.state.logoCompany !== '' && this.state.logoCompany !== undefined && this.state.logoCompany !== null){logoCompanyX = true }
          if (this.state.dataCompany2 !== '' && this.state.dataCompany2 !== undefined && this.state.dataCompany2 !== null){dataCompany2X = true }

          if (pathname === '/start'){ pathnameStart = true }
          if (pathname === '/new'){ pathnameNew = true }
          if (pathname === '/open'){ pathnameOpen = true }
          if (this.state.modeDisplay === 'Mail'){ modeDisplayMailX = true }
          if (this.state.modeDisplay === 'Editor'){ modeDisplayEditorX = true }
          if (this.state.modeMenuContract === 'Tab' && this.state.JSONTemplateName !== 'simulate'){ modeMenuContractX = true }
          if (this.state.modeMenuContract === 'Tab' && this.state.JSONTemplateName === 'simulate'){ modeMenuContractX = false }

          let trimmedDataURLX = false
          if (this.state.signTrue === false){
              if (this.state.trimmedDataURL !== null){
                 trimmedDataURLX = true
              }
          }

          const channelX = `${this.state.typeContractTable}/${this.state.numberContractTable}`
          const countMessages = this.state.countMessages

          let displayProformaSearchSenderX = false
          let displayProformaSearchReceiverX = false
          let jsonProformaSenderX = []
          let jsonProformaReceiverX = []
          if (this.state.displayProformaSearchSender === true){
             displayProformaSearchSenderX = true
             jsonProformaSenderX = this.state.jsonProformaSender
          }
          if (this.state.displayProformaSearchReceiver === true){
             displayProformaSearchReceiverX = true
             jsonProformaReceiverX = this.state.jsonProformaReceiver
          }
          const seeAttachX = this.state.seeAttachX
          let newUploadedX = this.state.newUploadedX
          if (this.state.jsonStatusLifeCycle === 'Draft' && this.state.ningunoSign){
             newUploadedX = true
          }
          const jsonAssociatedToMaintenanceX = this.state.jsonAssociatedToMaintenance
          const { filedecodeAttachX, fileAttachX, typeAttachX } = this.state;
          const { typeAttachText, typeAttachImage, typeAttachPdf, typeAttachAudio, typeAttachVideo } = this.state;
          const scale = 1.0
          //const { contentState } = this.state;
          const { editorState } = this.state;
          const { displayWriteUp } = this.state;
          //let arrayTemplateDBX = []
          let displayTemplateDetailX = false
          let string1 = ''
          let JSONTemplateDetail = false
          let displayTemplateAutomatic = false
          let displayLinkX = false
          let displayAttachX = false
          let displayChatX = false
          let displayTagX = false
          let displaySignX = false
          let displayRegisterX = false
          let displayUserX = false
          let displayAssociatedX = false
          let displayRulesX = false
          //let displayShareX = false
          let displayActiveParticipantsX = false
          let displayDashboardX = false
          let displayDeliverableX = false
          let displayFormsDeliverableX = false
          let displayAuthorizersDeliverableX = false
          let displayRolDeliverableX = false
          let displayTagDeliverableX = false
          let displayReporteTurnoDeliverableX = false
          let displayInformeDeliverableX = false
          let displaySiguiente = true
          let displayRoleX = false
          let disabledX = true
          let displayPaymentFormX = false
          let displayCertificatePaymentsMadeX = false
          let displayCertificateContractX = true

          let displayPayX = false

          let templateName = this.state.JSONTemplateName
          //let activeContractX = this.state.activeContract
          //let displayRules = this.state.displayRules
          //let {jsonEnrollment} = this.state
          let {indiceRules} = this.state
          let {jsonProformaDetail} = this.state
          let correlativo = 0
          const currencyFiatX = currency.CcyNtry
          const currencyCryptoX = currencyCrypto.CcyNtry
          if (this.state.displayAttach===true) {
             displayAttachX = true
             displaySiguiente = false
          }
          let currencyTypeX = false
          if (this.state.currencyType==='FIAT Money') {
             currencyTypeX = true
          }
          if (this.state.displayLink===true) {
             displayLinkX = true
             displaySiguiente = false
          }
          if (this.state.displayDashboard===true) {
             displayDashboardX = true
             displaySiguiente = false
          }
          if (this.state.displayDeliverable===true) {
             displayDeliverableX = true
             displaySiguiente = false
          }
          if (this.state.displayFormsDeliverable===true) {
             displayFormsDeliverableX = true
             displaySiguiente = false
          }
          if (this.state.displayAuthorizersDeliverable===true) {
             displayAuthorizersDeliverableX = true
             displaySiguiente = false
          }
          if (this.state.displayRolDeliverable===true) {
             displayRolDeliverableX = true
             displaySiguiente = false
          }
          if (this.state.displayTagDeliverable===true) {
             displayTagDeliverableX = true
             displaySiguiente = false
          }
          if (this.state.displayReporteTurnoDeliverable===true) {
             displayReporteTurnoDeliverableX = true
             displaySiguiente = false
          }
          if (this.state.displayInformeDeliverable===true) {
             displayInformeDeliverableX = true
             displaySiguiente = false
          }
          if (this.state.displayChat===true) {
             displayChatX = true
             displaySiguiente = false
          }
          if (this.state.displayTag===true) {
             displayTagX = true
             displaySiguiente = false
          }
          if (this.state.displayUser===true) {
             displayUserX = true
             displaySiguiente = false
          }
          if (this.state.displaySign===true) {
             displaySignX = true
             displaySiguiente = false
          }
          if (this.state.displayRegister===true) {
             displayRegisterX = true
             displaySiguiente = false
          }
          if (this.state.displayAssociated===true) {
             displayAssociatedX = true
             displaySiguiente = false
          }
          if (this.state.displayRules===true) {
             displayRulesX = true
             displaySiguiente = false
          }
          if (this.state.displayShare===true) {
             //displayShareX = true
             displaySiguiente = false
          }
          if (this.state.displayActiveParticipants===true) {
             displayActiveParticipantsX = true
             displaySiguiente = false
          }
          if (this.state.displayPaymentForm===true) {
             displayPaymentFormX = true
             displaySiguiente = false
          }

          if (this.state.displayPay===true) {
             displayPayX = true
             displaySiguiente = false
          }

          if (this.state.displayCertificatePaymentsMade === true || this.state.displayCertificateContract === true){
              displayCertificatePaymentsMadeX = true
              displaySiguiente = false
          }

          if (displaySiguiente ===true){
            if (this.state.searchContract2===true) {
              displayTemplateDetailX = true
              templateName = this.state.JSONTemplateName
            }
            if (this.props.templates.length > 0) {
                //arrayTemplateDBX = this.props.templatesAll[0]
                if (this.state.sinTemplateDetail === false) {
                   if (this.props.templates[0] !== undefined){
                     string1 = this.props.templates[0]
                     JSONTemplateDetail = {template: string1.template.xmlTemplate.data[0].line }
                     displayTemplateDetailX = true
                   }
                }
            }
          }

          if (this.state.icondisplayRoleX === 'Support'){
             displayTemplateDetailX = false
          }

          let noEnrollmentX = false
          if (this.state.algunosSign || this.state.todosSign){
             noEnrollmentX = true
          }

          //displayRules = true

          let displaySaveRulesX = true

          if (this.state.jsonStatusBlockchain === 'Blockchain' || this.state.whatUserRole !== "Creator"){
             displaySaveRulesX = false
             noEnrollmentX = true
          }

          let todosSignX = this.state.todosSign
          let algunosSignX = this.state.algunosSign
          let ningunoSignX = this.state.ningunoSign
          if (this.state.todosSign === false && this.state.algunosSign === false){
             ningunoSignX = true
          }

          if (this.state.whatUserRole==="Creator"){
             displayRoleX = true
             if (ningunoSignX){
                if (this.state.jsonStatusBlockchain !== 'Blockchain'){
                   disabledX = false
                }
             }
          }

          let selectedSignaturePaymentX = false
          if (this.state.selectedSignaturePayment==="SignatureAndPayment"){
             selectedSignaturePaymentX = true
          }

          let {attachFile30X} = this.state
          let {rules30X} = this.state
          let {associatedTo30X} = this.state

          if (attachFile30X === 'true'){
            attachFile30X = true
          }
          if (attachFile30X === 'false'){
            attachFile30X = false
          }
          if (rules30X === 'true'){
            rules30X = true
          }
          if (rules30X === 'false'){
            rules30X = false
          }
          if (associatedTo30X === 'true'){
            associatedTo30X = true
          }
          if (associatedTo30X === 'false'){
            associatedTo30X = false
          }
          let templateNameDelivery = false
          let templateNameWorkOrder = false
          let templateNameMaintenance = false
          let templateNameProforma = false
          let templateNameBlank = false
          let templateNameUploaded = false
          let templateNameSpreadsheet = false
          let displayActions = true
          let displayDataPaymentX = false
          if (rules30X === 'false' || !rules30X){
              //displayRules = rules30X
          }
          if (templateName === 'delivery' || templateName === 'simulate'){
              templateNameDelivery = true
          }else{
            if (templateName === 'maintenance'){
               templateNameMaintenance = true
            }else{
              if (templateName === 'proforma'){
                 templateNameProforma = true
              }else{
                 if (templateName === 'blank'){
                    templateNameBlank = true
                    displayDataPaymentX = true
                  }else{
                     if (templateName === 'uploaded'){
                        templateNameUploaded = true
                        displayDataPaymentX = true
                     }else{
                       if (templateName === 'spreadsheet'){
                          templateNameSpreadsheet = true
                          displayDataPaymentX = true
                       }else{
                         if (templateName === 'workorder'){
                            templateNameWorkOrder = true
                            displayDataPaymentX = false
                         }
                       }
                     }
                  }
              }
            }
          }
          let placeholderX3 = "Select an Option"
          if (this.state.language === 'English'){placeholderX3 = "Select an Option"}
          if (this.state.language === 'French'){placeholderX3 = "Sélectionner une Option"}
          if (this.state.language === 'Spanish'){placeholderX3 = "Seleccione una Opción"}
          if (this.state.language === 'Portuguese'){placeholderX3 = "Selecione uma Opção"}
          if (this.state.language === 'Swedish'){placeholderX3 = "Välj ett Alternativ"}
          if (this.state.language === 'Netherlands'){placeholderX3 = "Kies een Optie"}
          if (this.state.language === 'Russian'){placeholderX3 = "Выберите опцию"}
          if (this.state.language === 'Japanese'){placeholderX3 = "オプションを選択"}
          if (this.state.language === 'Chinese'){placeholderX3 = "选择一个选项"}
          if (this.state.language === 'German'){placeholderX3 = "Wähle eine Option"}
          if (this.state.language === 'Italian'){placeholderX3 = "Seleziona un'opzione"}


          let configuration2X = 'View Configuration'
          let detail2X = 'View Detail'
          let associatedToX = 'Container'
          let actionsX = 'Actions'
          let rules2X = 'View Rules'
          let rules3X = 'Rules'
          let fire2X = 'Fire'
          let flood2X = 'Flood'
          let sealintegrity2X = 'Seal Integrity'
          let motion2X = 'Motion'
          let smoke2X = 'Smoke'
          let temperature2X = "Temperature Sensor"
          let humidity2X = "Humidity Sensor"
          let gascontrol2X = "Gas Control Sensor"
          let gps2X = "Geographic Location"

          if (this.state.language === 'English'){
            actionsX = 'Actions'
            rules3X = 'Rules'
            fire2X = 'Fire'
            flood2X = 'Flood'
            sealintegrity2X = 'Seal Integrity'
            motion2X = 'Motion'
            smoke2X = 'Smoke'
            temperature2X = "Temperature Sensor"
            humidity2X = "Humidity Sensor"
            gascontrol2X = "Gas Control Sensor"
            gps2X = "Geographic Location"
            if (this.state.existContract) {configuration2X = 'View Configuration'}else{configuration2X = 'Create Configuration'}
            if (this.state.existContract) {detail2X = 'View Detail'}else{detail2X = 'Create Detail'}
            if (this.state.existContract) {rules2X = 'View Rules'}else{rules2X = 'Create Rules'}
            if (templateNameDelivery) {associatedToX = 'Container'}
            if (templateNameMaintenance) {associatedToX = 'Warehouse'}
          }
          if (this.state.language === 'French'){
            actionsX = 'Actions'
            rules3X = 'Règles'
            fire2X = 'Incendie'
            flood2X = 'Inondation'
            sealintegrity2X = 'Intégrité Joint'
            motion2X = 'Mouvement'
            smoke2X = 'Fumée'
            temperature2X = "Capteur Température"
            humidity2X = "Capteur Humidité"
            gascontrol2X = "Capteur Contrôle Gaz"
            gps2X = "Capteur Position Géographique"
            if (this.state.existContract) {configuration2X = 'Voir la Configuration'}else{configuration2X = 'Créer une Configuration'}
            if (this.state.existContract) {detail2X = 'Voir le Détail'}else{detail2X = 'Créer un Détail'}
            if (this.state.existContract) {rules2X = 'Voir les règles'}else{rules2X = 'Créer des règles'}
            if (templateNameDelivery) {associatedToX = 'Récipient'}
            if (templateNameMaintenance) {associatedToX = 'Entrepôt'}
          }
          if (this.state.language === 'Spanish'){
            actionsX = 'Acciones'
            rules3X = 'Reglas'
            fire2X = 'Incendio'
            flood2X = 'Inundación'
            sealintegrity2X = 'Integridad Sello'
            motion2X = 'Movimiento'
            smoke2X = 'Humo'
            temperature2X = "Sensor Temperatura"
            humidity2X = "Sensor Humedad"
            gascontrol2X = "Sensor Control Gases"
            gps2X = "Sensor Posición Geográfica"
            if (this.state.existContract) {configuration2X = 'Ver Configuración'}else{configuration2X = 'Crear Configuración'}
            if (this.state.existContract) {detail2X = 'Ver Detalle'}else{detail2X = 'Crear Detalle'}
            if (this.state.existContract) {rules2X = 'Ver Reglas'}else{rules2X = 'Crear Reglas'}
            if (templateNameDelivery) {associatedToX = 'Contenedor'}
            if (templateNameMaintenance) {associatedToX = 'Bodega'}
          }
          if (this.state.language === 'Portuguese'){
            actionsX = 'Ações'
            rules3X = 'Regras'
            fire2X = 'Incêndio'
            flood2X = 'Inundação'
            sealintegrity2X = 'Integridade Selo'
            motion2X = 'Movimento'
            smoke2X = 'Fumaça'
            temperature2X = "Sensor Temperatura"
            humidity2X = "Sensor Umidade"
            gascontrol2X = "Sensor Controle Gás"
            gps2X = "Sensor Localização geográfica"
            if (this.state.existContract) {configuration2X = 'Exibir Configuração'}else{configuration2X = 'Criar Configuração'}
            if (this.state.existContract) {detail2X = 'Exibir Detalhes'}else{detail2X = 'Criar Detalhe'}
            if (this.state.existContract) {rules2X = 'Exibir Regras'}else{rules2X = 'Criar Regras'}
            if (templateNameDelivery) {associatedToX = 'Recipiente'}
            if (templateNameMaintenance) {associatedToX = 'Armazém'}
          }
          if (this.state.language === 'Swedish'){
            actionsX = 'Handlingar'
            rules3X = 'Regler'
            fire2X = 'Brandgivare'
            flood2X = 'Flomsensor'
            sealintegrity2X = 'Tätningsintegritetssensor'
            motion2X = 'Rörelsesensor'
            smoke2X = 'Rökgivare'
            temperature2X = "Temperatursensor"
            humidity2X = "Fuktighetssensor"
            gascontrol2X = "Gasregleringssensor"
            gps2X = "Geografisk Plats"
            if (this.state.existContract) {configuration2X = 'Visa Konfiguration'}else{configuration2X = 'Skapa Konfiguration'}
            if (this.state.existContract) {detail2X = 'Visa Detalj'}else{detail2X = 'Skapa Detalj'}
            if (this.state.existContract) {rules2X = 'Visa Regler'}else{rules2X = 'Skapa Regler'}
            if (templateNameDelivery) {associatedToX = 'Behållare'}
            if (templateNameMaintenance) {associatedToX = 'Lager'}
          }
          if (this.state.language === 'Netherlands'){
            actionsX = 'Acties'
            rules3X = 'Regels'
            fire2X = 'Vuursensor'
            flood2X = 'Overstromingssensor'
            sealintegrity2X = 'Seal Integrity Sensor'
            motion2X = 'Bewegingssensor'
            smoke2X = 'Rooksensor'
            temperature2X = "Temperatuursensor"
            humidity2X = "Vochtigheidssensor"
            gascontrol2X = "Gasregelsensor"
            gps2X = "Geografische Locatie"
            if (this.state.existContract) {configuration2X = 'Bekijk Configuratie'}else{configuration2X = 'Creëren Configuratie'}
            if (this.state.existContract) {detail2X = 'Bekijk Detail'}else{detail2X = 'Creëren Detail'}
            if (this.state.existContract) {rules2X = 'Bekijk Regels'}else{rules2X = 'Creëren Regels'}
            if (templateNameDelivery) {associatedToX = 'Vat'}
            if (templateNameMaintenance) {associatedToX = 'Magazijn'}
          }
          if (this.state.language === 'Russian'){
            actionsX = 'действия'
            rules3X = 'правила'
            fire2X = 'Пожар'
            flood2X = 'потоп'
            sealintegrity2X = 'Целостность печати'
            motion2X = 'движение'
            smoke2X = 'дым'
            temperature2X = "Датчик температуры"
            humidity2X = "Датчик влажности"
            gascontrol2X = "Датчик контроля газа"
            gps2X = "Geographic Location"
            if (this.state.existContract) {configuration2X = 'Посмотреть конфигурацию'}else{configuration2X = 'Создать конфигурацию'}
            if (this.state.existContract) {detail2X = 'Посмотреть детали'}else{detail2X = 'Создать деталь'}
            if (this.state.existContract) {rules2X = 'Посмотреть правила'}else{rules2X = 'Создать правила'}
            if (templateNameDelivery) {associatedToX = 'Контейнер'}
            if (templateNameMaintenance) {associatedToX = 'Склад'}
          }
          if (this.state.language === 'Japanese'){
            actionsX = '行動'
            rules3X = 'ルール'
            fire2X = '火'
            flood2X = '洪水'
            sealintegrity2X = 'シールの完全性'
            motion2X = 'モーション'
            smoke2X = '煙'
            temperature2X = "温度センサー"
            humidity2X = "湿度センサー"
            gascontrol2X = "ガス制御センサー"
            gps2X = "地理的位置"
            if (this.state.existContract) {configuration2X = '構成の表示'}else{configuration2X = '構成を作成する'}
            if (this.state.existContract) {detail2X = '詳細を表示'}else{detail2X = '詳細を作成'}
            if (this.state.existContract) {rules2X = 'ルールを見る'}else{rules2X = 'ルールを作成する'}
            if (templateNameDelivery) {associatedToX = '容器'}
            if (templateNameMaintenance) {associatedToX = '倉庫'}
          }
          if (this.state.language === 'Chinese'){
            actionsX = '操作'
            rules3X = '规则'
            fire2X = '火'
            flood2X = '洪水'
            sealintegrity2X = '密封完整性'
            motion2X = '运动'
            smoke2X = '抽烟'
            temperature2X = "温度感应器"
            humidity2X = "湿度传感器"
            gascontrol2X = "气体控制传感器"
            gps2X = "地理位置"
            if (this.state.existContract) {configuration2X = '查看配置'}else{configuration2X = '创建配置'}
            if (this.state.existContract) {detail2X = '查看详细'}else{detail2X = '创建细节'}
            if (this.state.existContract) {rules2X = '查看规则'}else{rules2X = '创建规则'}
            if (templateNameDelivery) {associatedToX = '容器'}
            if (templateNameMaintenance) {associatedToX = '仓库'}
          }
          if (this.state.language === 'German'){
            actionsX = 'Aktionen'
            rules3X = 'Regeln'
            fire2X = 'Feuer'
            flood2X = 'Flut'
            sealintegrity2X = 'Seal Integrity'
            motion2X = 'Bewegung'
            smoke2X = 'Rauch'
            temperature2X = "Temperatursensor"
            humidity2X = "Feuchtigkeitssensor"
            gascontrol2X = "Gasregelungssensor"
            gps2X = "Geographische Lage"
            if (this.state.existContract) {configuration2X = 'Konfiguration anzeigen'}else{configuration2X = 'Konfiguration erstellen'}
            if (this.state.existContract) {detail2X = 'Im Detail sehen'}else{detail2X = 'Detail erstellen'}
            if (this.state.existContract) {rules2X = 'Regeln anzeigen'}else{rules2X = 'Regeln erstellen'}
            if (templateNameDelivery) {associatedToX = 'Container'}
            if (templateNameMaintenance) {associatedToX = 'Warenhaus'}
          }
          if (this.state.language === 'Italian'){
            actionsX = 'Azioni'
            rules3X = 'Regole'
            fire2X = 'Fuoco'
            flood2X = 'Alluvione'
            sealintegrity2X = 'Integrità del sigillo'
            motion2X = 'Movimento'
            smoke2X = 'Fumo'
            temperature2X = "Termometro"
            humidity2X = "Sensore di umidità"
            gascontrol2X = "Sensore di controllo del gas"
            gps2X = "Posizione geografica"
            if (this.state.existContract) {configuration2X = 'Visualizza configurazione'}else{configuration2X = 'Crea configurazione'}
            if (this.state.existContract) {detail2X = 'Vedi dettag'}else{detail2X = 'Crea dettagli'}
            if (this.state.existContract) {rules2X = 'Visualizza le regole'}else{rules2X = 'Crea regole'}
            if (templateNameDelivery) {associatedToX = 'Contenitore'}
            if (templateNameMaintenance) {associatedToX = 'Magazzino'}
          }

          let tittleXX2 = ''
          let tittleXX3 = ''
          let messageSubtittleXX2 = ''
          let messageSubtittleXX3 = ''
          if (this.state.modeDisplay === 'Editor'){
              let typeContractSignX= ''
              if (this.state.typeContractSign === 'blank'){typeContractSignX = 'Blank Document'}
              if (this.state.typeContractSign === 'delivery'){typeContractSignX = 'Logistic, Transport & Delivery'}
              if (this.state.typeContractSign === 'proforma'){typeContractSignX = 'Proforma'}
              if (this.state.typeContractSign === 'maintenance'){typeContractSignX = 'Industrial Maintenance'}
              if (this.state.typeContractSign === 'simulate'){typeContractSignX = 'Simulation'}
              if (this.state.typeContractSign === 'uploaded'){typeContractSignX = 'Upload Document'}
              if (this.state.typeContractSign === 'spreadsheet'){typeContractSignX = 'Spreadsheet'}
              if (this.state.typeContractSign === 'workorder'){typeContractSignX = 'Work Order'}

              if (this.state.language === 'English'){
                if (this.state.typeContractSign === 'blank'){typeContractSignX = 'Blank Document'}
                if (this.state.typeContractSign === 'delivery'){typeContractSignX = 'Logistic, Transport & Delivery'}
                if (this.state.typeContractSign === 'proforma'){typeContractSignX = 'Proforma'}
                if (this.state.typeContractSign === 'maintenance'){typeContractSignX = 'Industrial Maintenance'}
                if (this.state.typeContractSign === 'simulate'){typeContractSignX = 'Simulation'}
                if (this.state.typeContractSign === 'uploaded'){typeContractSignX = 'Upload Document'}
                if (this.state.typeContractSign === 'spreadsheet'){typeContractSignX = 'Spreadsheet'}
                if (this.state.typeContractSign === 'workorder'){typeContractSignX = 'Work Order'}
              }
              if (this.state.language === 'French'){
                if (this.state.typeContractSign === 'blank'){typeContractSignX = 'Document Vierge'}
                if (this.state.typeContractSign === 'delivery'){typeContractSignX = 'Logistique, Transport et Livraison'}
                if (this.state.typeContractSign === 'proforma'){typeContractSignX = 'Proforma'}
                if (this.state.typeContractSign === 'maintenance'){typeContractSignX = 'Maintenance Industrielle'}
                if (this.state.typeContractSign === 'simulate'){typeContractSignX = 'Simulation'}
                if (this.state.typeContractSign === 'uploaded'){typeContractSignX = 'Télécharger le Document'}
                if (this.state.typeContractSign === 'spreadsheet'){typeContractSignX = 'Feuille de Calcul'}
                if (this.state.typeContractSign === 'workorder'){typeContractSignX = 'Demande de Service'}
              }
              if (this.state.language === 'Spanish'){
                if (this.state.typeContractSign === 'blank'){typeContractSignX = 'Documento en Blanco'}
                if (this.state.typeContractSign === 'delivery'){typeContractSignX = 'Logística, Transporte y Entrega'}
                if (this.state.typeContractSign === 'proforma'){typeContractSignX = 'Proforma'}
                if (this.state.typeContractSign === 'maintenance'){typeContractSignX = 'Mantenimiento Industrial'}
                if (this.state.typeContractSign === 'simulate'){typeContractSignX = 'Simulación'}
                if (this.state.typeContractSign === 'uploaded'){typeContractSignX = 'Subir Documento'}
                if (this.state.typeContractSign === 'spreadsheet'){typeContractSignX = 'Hoja de Cálculo'}
                if (this.state.typeContractSign === 'workorder'){typeContractSignX = 'Orden de Trabajo'}
              }
              if (this.state.language === 'Portuguese'){
                if (this.state.typeContractSign === 'blank'){typeContractSignX = 'Documento em Branco'}
                if (this.state.typeContractSign === 'delivery'){typeContractSignX = 'Logística, Transporte e Entrega'}
                if (this.state.typeContractSign === 'proforma'){typeContractSignX = 'Proforma'}
                if (this.state.typeContractSign === 'maintenance'){typeContractSignX = 'Manutenção Industrial'}
                if (this.state.typeContractSign === 'simulate'){typeContractSignX = 'Simulação'}
                if (this.state.typeContractSign === 'uploaded'){typeContractSignX = 'Carregar Documento'}
                if (this.state.typeContractSign === 'spreadsheet'){typeContractSignX = 'Planilha'}
                if (this.state.typeContractSign === 'workorder'){typeContractSignX = 'Ordem de Serviço'}
              }
              if (this.state.language === 'Swedish'){
                if (this.state.typeContractSign === 'blank'){typeContractSignX = 'Tomt Dokument'}
                if (this.state.typeContractSign === 'delivery'){typeContractSignX = 'Logistik, Transport och Leverans'}
                if (this.state.typeContractSign === 'proforma'){typeContractSignX = 'Proforma'}
                if (this.state.typeContractSign === 'maintenance'){typeContractSignX = 'Industriellt Underhåll'}
                if (this.state.typeContractSign === 'simulate'){typeContractSignX = 'Simulering'}
                if (this.state.typeContractSign === 'uploaded'){typeContractSignX = 'Ladda upp Dokument'}
                if (this.state.typeContractSign === 'spreadsheet'){typeContractSignX = 'Kalkylblad'}
                if (this.state.typeContractSign === 'workorder'){typeContractSignX = 'Arbetsorder'}
              }
              if (this.state.language === 'Netherlands'){
                if (this.state.typeContractSign === 'blank'){typeContractSignX = 'Leeg Document'}
                if (this.state.typeContractSign === 'delivery'){typeContractSignX = 'Logistiek, Transport en Levering'}
                if (this.state.typeContractSign === 'proforma'){typeContractSignX = 'Proforma'}
                if (this.state.typeContractSign === 'maintenance'){typeContractSignX = 'Industrieel Onderhoud'}
                if (this.state.typeContractSign === 'simulate'){typeContractSignX = 'Simulatie'}
                if (this.state.typeContractSign === 'uploaded'){typeContractSignX = 'Document Uploaden'}
                if (this.state.typeContractSign === 'spreadsheet'){typeContractSignX = 'Spreadsheet'}
                if (this.state.typeContractSign === 'workorder'){typeContractSignX = 'Werkorder'}
              }
              if (this.state.language === 'Russian'){
                if (this.state.typeContractSign === 'blank'){typeContractSignX = 'Пустой документ'}
                if (this.state.typeContractSign === 'delivery'){typeContractSignX = 'Логистика, Транспорт и Доставка'}
                if (this.state.typeContractSign === 'proforma'){typeContractSignX = 'Proforma'}
                if (this.state.typeContractSign === 'maintenance'){typeContractSignX = 'Промышленное обслуживание'}
                if (this.state.typeContractSign === 'simulate'){typeContractSignX = 'моделирование'}
                if (this.state.typeContractSign === 'uploaded'){typeContractSignX = 'Загрузить документ'}
                if (this.state.typeContractSign === 'spreadsheet'){typeContractSignX = 'таблица'}
                if (this.state.typeContractSign === 'workorder'){typeContractSignX = 'Заказ на работу'}
              }
              if (this.state.language === 'Japanese'){
                if (this.state.typeContractSign === 'blank'){typeContractSignX = '白紙'}
                if (this.state.typeContractSign === 'delivery'){typeContractSignX = '物流、輸送、配送'}
                if (this.state.typeContractSign === 'proforma'){typeContractSignX = 'プロフォーマ'}
                if (this.state.typeContractSign === 'maintenance'){typeContractSignX = '産業用メンテナンス'}
                if (this.state.typeContractSign === 'simulate'){typeContractSignX = 'シミュレーション'}
                if (this.state.typeContractSign === 'uploaded'){typeContractSignX = 'ドキュメントをアップロード'}
                if (this.state.typeContractSign === 'spreadsheet'){typeContractSignX = 'スプレッドシート'}
                if (this.state.typeContractSign === 'workorder'){typeContractSignX = '作業命令'}
              }
              if (this.state.language === 'Chinese'){
                if (this.state.typeContractSign === 'blank'){typeContractSignX = '空白文件'}
                if (this.state.typeContractSign === 'delivery'){typeContractSignX = '物流，运输与交付'}
                if (this.state.typeContractSign === 'proforma'){typeContractSignX = '形式'}
                if (this.state.typeContractSign === 'maintenance'){typeContractSignX = '工业维修'}
                if (this.state.typeContractSign === 'simulate'){typeContractSignX = '模拟'}
                if (this.state.typeContractSign === 'uploaded'){typeContractSignX = '上传文件'}
                if (this.state.typeContractSign === 'spreadsheet'){typeContractSignX = '试算表'}
                if (this.state.typeContractSign === 'workorder'){typeContractSignX = '工作指示'}
              }
              if (this.state.language === 'German'){
                if (this.state.typeContractSign === 'blank'){typeContractSignX = 'Leeres Dokument'}
                if (this.state.typeContractSign === 'delivery'){typeContractSignX = 'Logistik, Transport & Lieferung'}
                if (this.state.typeContractSign === 'proforma'){typeContractSignX = 'Proforma'}
                if (this.state.typeContractSign === 'maintenance'){typeContractSignX = 'Industrielle Instandhaltung'}
                if (this.state.typeContractSign === 'simulate'){typeContractSignX = 'Simulation'}
                if (this.state.typeContractSign === 'uploaded'){typeContractSignX = 'Dokument Hochladen'}
                if (this.state.typeContractSign === 'spreadsheet'){typeContractSignX = 'Tabellenkalkulation'}
                if (this.state.typeContractSign === 'workorder'){typeContractSignX = 'Arbeitsauftrag'}
              }
              if (this.state.language === 'Italian'){
                if (this.state.typeContractSign === 'blank'){typeContractSignX = 'Documento in Bianco'}
                if (this.state.typeContractSign === 'delivery'){typeContractSignX = 'Logistica, Trasporto e Consegna'}
                if (this.state.typeContractSign === 'proforma'){typeContractSignX = 'Proforma'}
                if (this.state.typeContractSign === 'maintenance'){typeContractSignX = 'Manutenzione Industriale'}
                if (this.state.typeContractSign === 'simulate'){typeContractSignX = 'Simulazione'}
                if (this.state.typeContractSign === 'uploaded'){typeContractSignX = 'Carica Documento'}
                if (this.state.typeContractSign === 'spreadsheet'){typeContractSignX = 'Foglio Elettronico'}
                if (this.state.typeContractSign === 'workorder'){typeContractSignX = 'Ordine di Lavoro'}
              }
              if (this.state.configurationContractNumberSign.length > 0){
                 tittleXX3 = `${typeContractSignX}`
                 messageSubtittleXX2 = `${this.state.icondisplaySubjectX} / ${this.state.displayLifeCycleX} / ${this.state.whatUserRole}`
                 messageSubtittleXX3 = `${this.state.configurationContractNumberSign}`
              }else{
                 tittleXX2 = `${typeContractSignX}`
                 tittleXX3 = `${typeContractSignX}`
                 messageSubtittleXX2 = ''
                 messageSubtittleXX3 = ''
              }
          }
          const displayReportX9 = this.state.icondisplayReportX
          const displayDeliverableX9 = this.state.icondisplayDeliverableX
          const displayFormsDeliverableX9 = this.state.icondisplayFormsDeliverableX
          const displayAuthorizersDeliverableX9 = this.state.icondisplayAuthorizersDeliverableX
          const displayRolDeliverableX9 = this.state.icondisplayRolDeliverableX
          const displayTagDeliverableX9 = this.state.icondisplayTagDeliverableX
          const displayReporteTurnoDeliverableX9 = this.state.icondisplayReporteTurnoDeliverableX
          const displayUserX9 = this.state.icondisplayUserX
          const displaySignatureX9 = this.state.icondisplaySignatureX
          const displayRegisterX9 = this.state.icondisplayRegisterX
          const displayLinkX9 = this.state.icondisplayLinkX
          const displayEyeX9 = this.state.icondisplayEyeX
          const displayChatX9 = this.state.icondisplayChatX
          const displayTagX9 = this.state.icondisplayTagX
          const typeContract9 = this.state.icontypeContract
          const configurationContractNumber9 = this.state.iconconfigurationContractNumber
          const displayRoleX9 = this.state.icondisplayRoleX
          const displayOriginX9 = this.state.icondisplayOriginX
          const displaySubjectX9 = this.state.icondisplaySubjectX
          const displayCryptoCurrencyX9 = this.state.icondisplayCryptoCurrencyX
          const displayBlockchainX9 = this.state.icondisplayBlockchainX
          const displayAssociatedX9 = this.state.icondisplayAssociatedX
          const displayRulesX9 = this.state.icondisplayRulesX
          const displayDocumentX9 = this.state.icondisplayDocumentX
          const displayShareX9 = this.state.icondisplayShareX
          const displayActiveParticipantsX9 = this.state.icondisplayActiveParticipantsX
          const displayIconsRedX9 = this.state.displayIconsRed
          const displayLifeCycleX9 = this.state.displayLifeCycleX
          const displaySimulatorX = this.state.displaySimulator
          if (displayLinkX && this.state.whatUserRole === 'Support'){
             localStorage.removeItem('jsonBlockstack2')
             localStorage.removeItem('idsmartcontract')
             localStorage.removeItem('searchContract')
             //---------------------------------------------------
             displayLinkX = false
             //---------------------------------------------------
          }
          let disabled2X = disabledX
          let disabled3X = disabledX
          if (this.state.displayLifeCycleX==="Published" || displayDataPaymentX === false || selectedSignaturePaymentX === false){
             disabled2X = true
          }
          if (this.state.displayLifeCycleX==="Published"){
             disabled3X = true
          }

          let carpetListInboxX = false
          let carpetListArchiveX = false
          let carpetListTrashX = false
          if (this.state.carpetListX === 'inbox'){carpetListInboxX = true}
          if (this.state.carpetListX === 'archive'){carpetListArchiveX = true}
          if (this.state.carpetListX === 'trash'){carpetListTrashX = true}

          let activeInactiveAllX = this.state.activeInactiveAllX

          let inboxX = ''
          let archiveX = ''
          let trashX = ''
          let activeX = ''
          let inactiveX = ''
          let allX = ''
          if (this.state.language === 'English'){inboxX='Execution Documents'; archiveX='Archived Documents'; trashX='Trash'; activeX='Active'; inactiveX='Inactive'; allX='All'}
          if (this.state.language === 'French'){inboxX=`Documents d'exécution`; archiveX='Documents archivés'; trashX='Corbeille'; activeX='Active'; inactiveX='Inactive'; allX='All'}
          if (this.state.language === 'Spanish'){inboxX='Documentos en ejecución'; archiveX='Documentos Archivados'; trashX='Papelera'; activeX='Activo'; inactiveX='Inactivo'; allX='Todo'}
          if (this.state.language === 'Portuguese'){inboxX='Documentos de execução'; archiveX='Documentos Arquivados'; trashX='Reciclagem'; activeX='Active'; inactiveX='Inactive'; allX='All'}
          if (this.state.language === 'Swedish'){inboxX='Utförande dokument'; archiveX='Arkiverade dokument'; trashX='Papperskorg'; activeX='Active'; inactiveX='Inactive'; allX='All'}
          if (this.state.language === 'Netherlands'){inboxX='Uitvoeringsdocumenten'; archiveX='Gearchiveerde documenten'; trashX='Prullenbak'; activeX='Active'; inactiveX='Inactive'; allX='All'}
          if (this.state.language === 'Russian'){inboxX='Оформление документов'; archiveX='Архивные документы'; trashX='Kорзина'; activeX='Active'; inactiveX='Inactive'; allX='All'}
          if (this.state.language === 'Japanese'){inboxX='実行文書'; archiveX='アーカイブされたドキュメント'; trashX='バスケット'; activeX='Active'; inactiveX='Inactive'; allX='All'}
          if (this.state.language === 'Chinese'){inboxX='執行文件'; archiveX='存檔文件'; trashX='垃圾'; activeX='Active'; inactiveX='Inactive'; allX='All'}
          if (this.state.language === 'German'){inboxX='Ausführungsdokumente'; archiveX='Archivierte Dokumente'; trashX='Gelöscht'; activeX='Active'; inactiveX='Inactive'; allX='All'}
          if (this.state.language === 'Italian'){inboxX='Documenti di esecuzione'; archiveX='Documenti archiviati'; trashX='Cestino'; activeX='Active'; inactiveX='Inactive'; allX='All'}

          const displayGeneratePdfX = this.state.generatePdfX

          let buttonModifyWorkOrder = false
          if (this.state.whatUserRole==="Creator"){
            if (this.state.statusActive2){
              if (this.state.existContract){
                if (this.state.jsonStatusBlockchain === 'Blockchain'){
                   buttonModifyWorkOrder = true
                }
              }
            }
          }

          return (
            <>
              { !this.props.colorDark ?
                <DatosCryptoCurrency colorDark={this.props.colorDark}/>
              : null
              }
              <Container fluid className="main-content-container px-4" style={ this.props.colorDark ? { backgroundColor:'#0b151d'} : {}}>
                {/* Page Header */}
                <Row form>&nbsp;</Row>
                { modeDisplayCollapsedX ?
                  <React.Fragment>
                    <Card style={ this.props.colorDark ? { backgroundColor:'#0b151d'} : {}}  small>
                      <React.Fragment>
                        <Row form>
                          <Col md="1"></Col>
                          <Col md="11" style={{fontSize:9}}>
                             {this.displayArrowCollapsed(tittleXX2, messageSubtittleXX2, tittleXX3, messageSubtittleXX3)}
                          </Col>
                        </Row>
                      </React.Fragment>
                    </Card>
                    <Card style={ this.props.colorDark ? { backgroundColor:'#0b151d'} : {}}small>
                      { pathnameNew ?
                        <React.Fragment>
                          <Row form>
                            <Col md="1"></Col>
                               {modeMenuContractX ?
                                 <React.Fragment>
                                   <Col md="10">
                                     {this.displayButtonsTabRed()}
                                   </Col>
                                 </React.Fragment>
                               :
                                 <React.Fragment>
                                   <Col md="10">
                                      {this.displayButtonsRed()}
                                   </Col>
                                 </React.Fragment>
                               }
                            <Col md="1"></Col>
                          </Row>
                        </React.Fragment>
                      :
                        <React.Fragment>
                          <Row form>
                            <Col md="1"></Col>
                            {modeMenuContractX ?
                                <React.Fragment>
                                  { displayIconsRedX9 ?
                                    <Col md="10">
                                       {this.displayButtonsTabRed()}
                                    </Col>
                                  :
                                    <Col md="10">
                                       {this.displayButtonsTab(typeContract9, configurationContractNumber9, displayRoleX9, displayOriginX9, displaySubjectX9, displayCryptoCurrencyX9, displayBlockchainX9, displayReportX9, displayUserX9, displaySignatureX9, displayLinkX9, displayEyeX9, displayChatX9, displayTagX9, displayAssociatedX9, displayRulesX9, displayDocumentX9, displayShareX9, displayActiveParticipantsX9, displayDeliverableX9,displayFormsDeliverableX9,displayAuthorizersDeliverableX9,displayRolDeliverableX9,displayTagDeliverableX9,displayReporteTurnoDeliverableX9,displayLifeCycleX9,displayRegisterX9)}
                                    </Col>
                                  }
                                </React.Fragment>

                            :
                                <React.Fragment>
                                  { displayIconsRedX9 ?
                                    <Col md="10">
                                       {this.displayButtonsRed()}
                                    </Col>
                                  :
                                    <Col md="10">
                                       {this.displayButtons(typeContract9, configurationContractNumber9, displayRoleX9, displayOriginX9, displaySubjectX9, displayCryptoCurrencyX9, displayBlockchainX9, displayReportX9, displayUserX9, displaySignatureX9, displayLinkX9, displayEyeX9, displayChatX9, displayTagX9, displayAssociatedX9, displayRulesX9, displayDocumentX9, displayShareX9, displayDeliverableX9,displayFormsDeliverableX9,displayAuthorizersDeliverableX9,displayRolDeliverableX9,displayTagDeliverableX9,displayReporteTurnoDeliverableX9,displayRegisterX9)}
                                    </Col>
                                  }
                                </React.Fragment>
                            }
                            <Col md="1"></Col>
                          </Row>
                        </React.Fragment>
                      }
                    </Card>
                  </React.Fragment>
                :
                  <Card style={ this.props.colorDark ? { backgroundColor:'#0b151d'} : {}}small>
                     { pathnameStart ?
                       <React.Fragment>
                         {carpetListInboxX
                           ?
                             <React.Fragment>
                               <Row form>
                                 <Col md="0"></Col>
                                 <Col md="12" style={{fontSize:11}}>
                                      {this.displayListContractEditorNew2(pathname)}
                                 </Col>
                               </Row>
                               <Row form>
                                 <Col md="3"></Col>
                                 <Col md="9" style={{fontSize:9}}>
                                     {this.displayConfigContract(pathname)}
                                 </Col>
                               </Row>
                               <Row form>
                                 <Col md="0"></Col>
                                 <Col md="12" style= {{fontSize:11}}>
                                      {this.displayListContract(pathname,modeDisplay)}
                                 </Col>
                               </Row>
                               <Row form>
                                 <Col md="9"></Col>
                                 <Col md="3" style={{fontSize:10}}>
                                     {this.displayPaginacion(pathname)}
                                 </Col>
                               </Row>
                             </React.Fragment>
                           : null }
                         {carpetListArchiveX
                           ?
                             <React.Fragment>
                               <Row form>&nbsp;</Row>
                               <Row form>
                                 <Col md="9"></Col>
                                 <Col md="3" style={{fontSize:9}}>
                                     {this.displayConfigContractArchive(pathname)}
                                 </Col>
                               </Row>
                               <Row form>
                                 <Col md="0"></Col>
                                 <Col md="12" style= {{fontSize:11}}>
                                      {this.displayListContractArchive(pathname,modeDisplay)}
                                 </Col>
                               </Row>
                             </React.Fragment>
                           : null }
                       </React.Fragment>
                     : null }
                     { pathnameNew ?
                       <React.Fragment>
                         <Row form>
                           <Col md="0"></Col>
                           <Col md="12" style={{fontSize:11}}>
                                {this.displayListContractEditorNew(pathname)}
                           </Col>
                         </Row>
                       </React.Fragment>
                     : null }
                     { pathnameOpen ?
                       <React.Fragment>
                         <Row form>
                           <Col md="0"></Col>
                           <Col md="12" style={{fontSize:11}}>
                                {this.displayListContractEditorNew2(pathname)}
                           </Col>
                         </Row>
                         <Row form>
                           <Col md="3"></Col>
                           <Col md="9" style={{fontSize:9}}>
                               {this.displayConfigContract(pathname)}
                           </Col>
                         </Row>
                         <Row form>
                           <Col md="0"></Col>
                           <Col md="12" style={{fontSize:11}}>
                               {this.displayListContract(pathname,modeDisplay)}
                           </Col>
                         </Row>
                         <Row form>
                           <Col md="9"></Col>
                           <Col md="3" style={{fontSize:10}}>
                               {this.displayPaginacion(pathname)}
                           </Col>
                         </Row>
                       </React.Fragment>
                     : null }
                  </Card>
                }
                <Row form>&nbsp;</Row>
                {/*----------------------------------------------------------------------------------------*/}
                { displayLinkX ? <ContractIoTDevice typeContract={this.state.typeContractTable} numberContract={this.state.numberContractTable} subjectContract={this.state.subjectContractTable} returnProps={this.returnProps} jsonEnrollment={this.state.jsonEnrollmentChange} colorDark={this.props.colorDark} storageSX={this.props.storageSX} /> : null }

                { displayAttachX ? <ContractAttachFile typeContract={this.state.typeContractTable} numberContract={this.state.numberContractTable} subjectContract={this.state.subjectContractTable} returnProps={this.returnProps} jsonAttachFile={this.state.jsonAttachFile} jsonAttachFile1={this.state.jsonAttachFile1} jsonAttachFile2={this.state.jsonAttachFile2} colorDark={this.props.colorDark} storageSX={this.props.storageSX} /> : null }

                { displayDeliverableX ? <ContractDeliverable typeContract={this.state.typeContractTable} numberContract={this.state.numberContractTable} subjectContract={this.state.subjectContractTable} returnProps={this.returnProps} userRole={this.state.whatUserRole} userOrigin={this.state.whatUserOrigin} confirmSignX={this.state.confirmSignX} FIACurrency={this.state.FIACurrency} cryptoPactClarityEthereum={this.state.cryptoPactClarityEthereum} myUserConfig={this.state.myUserConfig} colorDark={this.props.colorDark} selectedSignaturePayment={this.state.selectedSignaturePayment} CurrencyType={this.state.CurrencyType} FIACurrency={this.state.FIACurrency} cryptoCurrencyOrigin={this.state.cryptoCurrencyOrigin} amountPayment={this.state.amountPayment} cryptoCurrencyPayment={this.state.cryptoCurrencyPayment} trimmedDataURL={this.state.trimmedDataURL} storageSX={this.props.storageSX} /> : null }

                { displayFormsDeliverableX ? <FormsDeliverable typeContract={this.state.typeContractTable} numberContract={this.state.numberContractTable} subjectContract={this.state.subjectContractTable} returnProps={this.returnProps} userRole={this.state.whatUserRole} userOrigin={this.state.whatUserOrigin} confirmSignX={this.state.confirmSignX} FIACurrency={this.state.FIACurrency} cryptoPactClarityEthereum={this.state.cryptoPactClarityEthereum} myUserConfig={this.state.myUserConfig} colorDark={this.props.colorDark} selectedSignaturePayment={this.state.selectedSignaturePayment} jsonStatusLifeCycle={this.state.displayLifeCycleX} whatUserRole={this.state.whatUserRole} username={this.state.username} storageSX={this.props.storageSX} /> : null }

                { displayAuthorizersDeliverableX ? <AuthorizersDeliverable typeContract={this.state.typeContractTable} numberContract={this.state.numberContractTable} subjectContract={this.state.subjectContractTable} returnProps={this.returnProps} jsonUserGroup={this.state.jsonUserGroup} jsonRole={this.state.jsonBlockstackZ} userRole={this.state.whatUserRole} activeUserGroupX={this.state.activeUserGroupX} FIACurrency={this.state.FIACurrency} cryptoPactClarityEthereum={this.state.cryptoPactClarityEthereum} myUserConfig={this.state.myUserConfig} confirmSignX={this.state.confirmSignX} colorDark={this.props.colorDark} jsonStatusLifeCycle={this.state.displayLifeCycleX} whatUserRole={this.state.whatUserRole} userOrigin={this.state.whatUserOrigin} username={this.state.username} storageSX={this.props.storageSX} /> : null }

                { displayRolDeliverableX ? <MasterFileDeliverable typeContract={this.state.typeContractTable} numberContract={this.state.numberContractTable} subjectContract={this.state.subjectContractTable} typeMasterFile={'role'} whatUserRole={this.state.whatUserRole} colorDark={this.props.colorDark} userOrigin={this.state.whatUserOrigin} username={this.state.username} myUserConfig={this.state.myUserConfig} storageSX={this.props.storageSX} /> : null }

                { displayTagDeliverableX ? <MasterFileDeliverable typeContract={this.state.typeContractTable} numberContract={this.state.numberContractTable} subjectContract={this.state.subjectContractTable} typeMasterFile={'tag'} whatUserRole={this.state.whatUserRole} colorDark={this.props.colorDark} userOrigin={this.state.whatUserOrigin} username={this.state.username} myUserConfig={this.state.myUserConfig} storageSX={this.props.storageSX} /> : null }

                { displayReporteTurnoDeliverableX ? <ReporteTurnoDeliverable typeContract={this.state.typeContractTable} numberContract={this.state.numberContractTable} whatUserRole={this.state.whatUserRole} colorDark={this.props.colorDark} userOrigin={this.state.whatUserOrigin} username={this.state.username} myUserConfig={this.state.myUserConfig} displayCompanyLogoDataX={displayCompanyLogoDataX} logoCompanyX={logoCompanyX} dataCompany2X={dataCompany2X} logoCompany={this.state.logoCompany} dataCompany2={this.state.dataCompany2} colorDark={this.props.colorDark}  workorderclienteX={this.state.workordercliente} workordercampañaX={this.state.workordercampaña} workordersondajeX= {this.state.workordersondaje} workordertipoperforacionX={this.state.workordertipoperforacion} workorderfaseX={this.state.workorderfase} workorderrecomendadoX={this.state.workorderrecomendado} workordernumerocontratoX={this.state.workordernumerocontrato} workorderfecharealinicio={this.state.workorderfecharealinicio} workordermetaturnodia={this.state.workordermetaturnodia} workordermetaturnonoche={this.state.workordermetaturnonoche} workorderdeclinacionX={this.state.workorderdeclinacion} active_after_publishedX={this.state.active_after_publishedX} storageSX={this.props.storageSX} /> : null }

                { displayInformeDeliverableX ? <InformeDeliverable typeContract={this.state.typeContractTable} numberContract={this.state.numberContractTable} subjectContract={this.state.subjectContractTable} whatUserRole={this.state.whatUserRole} colorDark={this.props.colorDark} userOrigin={this.state.whatUserOrigin} username={this.state.username} myUserConfig={this.state.myUserConfig} displayCompanyLogoDataX={displayCompanyLogoDataX} logoCompanyX={logoCompanyX} dataCompany2X={dataCompany2X} logoCompany={this.state.logoCompany} dataCompany2={this.state.dataCompany2} colorDark={this.props.colorDark} active_after_publishedX={this.state.active_after_publishedX} language={this.state.language} returnProps={this.returnProps} userOrigin={this.state.whatUserOrigin} storageSX={this.props.storageSX}  /> : null }

                { displayDashboardX ? <ContractDashboard typeContract={this.state.typeContractTable} numberContract={this.state.numberContractTable} subjectContract={this.state.subjectContractTable} returnProps={this.returnProps} jsonEnrollment={this.state.jsonEnrollmentChange} userRole={this.state.whatUserRole} userOrigin={this.state.whatUserOrigin} activeDataDashboardX={this.state.activeDataDashboardX} FIACurrency={this.state.FIACurrency} cryptoPactClarityEthereum={this.state.cryptoPactClarityEthereum} myUserConfig={this.state.myUserConfig} colorDark={this.props.colorDark} storageSX={this.props.storageSX} /> : null }

                { displayChatX ? <ContractChat typeContract={this.state.typeContractTable} numberContract={this.state.numberContractTable} subjectContract={this.state.subjectContractTable} returnProps={this.returnProps} userRole={this.state.whatUserRole} userOrigin={this.state.whatUserOrigin} colorDark={this.props.colorDark} storageSX={this.props.storageSX} /> : null }

                { displayTagX ? <ContractTag typeContract={this.state.typeContractTable} numberContract={this.state.numberContractTable} subjectContract={this.state.subjectContractTable} returnProps={this.returnProps} tagList={this.state.tagList} userOrigin={this.state.whatUserOrigin} displayStringTagX={this.state.displayStringTagX} displayColourTagX={this.state.displayColourTagX} displayColourLetterTagX={this.state.displayColourLetterTagX} jsonContractTag={this.state.jsonContractTag} colorDark={this.props.colorDark} storageSX={this.props.storageSX} /> : null }

                { displaySignX ? <ContractSign typeContract={this.state.typeContractTable} numberContract={this.state.numberContractTable} subjectContract={this.state.subjectContractTable} returnProps={this.returnProps} jsonBlockstackY={this.state.jsonBlockstackY} jsonBlockstackZ={this.state.jsonBlockstackZ} userRole={this.state.whatUserRole} userOrigin={this.state.whatUserOrigin} whatUserRole={this.state.whatUserRole} statusActive2={this.state.statusActive2} existContract={this.state.existContract} jsonStatusIdPact={this.state.jsonStatusIdPact} jsonStatusBlockchain={this.state.jsonStatusBlockchain} jsonStatusLifeCycle={this.state.jsonStatusLifeCycle} signTrue={this.state.signTrue} signContract={this.signContract} unsignContract={this.unsignContract} todosSign={this.state.todosSign} confirmSignX={this.state.confirmSignX} FIACurrency={this.state.FIACurrency} cryptoPactClarityEthereum={this.state.cryptoPactClarityEthereum} myUserConfig={this.state.myUserConfig} colorDark={this.props.colorDark} selectedSignaturePayment={this.state.selectedSignaturePayment} trimmedDataURL={this.state.trimmedDataURL} username={this.state.username} storageSX={this.props.storageSX} /> : null }

                { displayUserX ? <ContractUserGroup typeContract={this.state.typeContractTable} numberContract={this.state.numberContractTable} subjectContract={this.state.subjectContractTable} returnProps={this.returnProps} jsonUserGroup={this.state.jsonUserGroup} jsonRole={this.state.jsonBlockstackZ} userRole={this.state.whatUserRole} activeUserGroupX={this.state.activeUserGroupX} FIACurrency={this.state.FIACurrency} cryptoPactClarityEthereum={this.state.cryptoPactClarityEthereum} myUserConfig={this.state.myUserConfig} confirmSignX={this.state.confirmSignX} colorDark={this.props.colorDark} storageSX={this.props.storageSX} /> : null }

                { displayAssociatedX ? <ContractAssociated typeContract={this.state.typeContractTable} numberContract={this.state.numberContractTable} subjectContract={this.state.subjectContractTable} returnProps={this.returnProps} jsonEnrollment={this.state.jsonEnrollment} templateName={templateName} noEnrollmentX={noEnrollmentX} templateNameMaintenance={templateNameMaintenance} templateNameDelivery={templateNameDelivery} displayRoleX={displayRoleX} c04FieldContractX={''} JSONTemplateName={this.state.JSONTemplateName} codeAssociatedToMaintenance={this.state.codeAssociatedToMaintenance} colorDark={this.props.colorDark} storageSX={this.props.storageSX} /> : null }

                { displayRulesX ? <ContractRules typeContract={this.state.typeContractTable} numberContract={this.state.numberContractTable} subjectContract={this.state.subjectContractTable} returnProps={this.returnProps} jsonEnrollment={this.state.jsonEnrollment} templateName={templateName} templateNameMaintenance={templateNameMaintenance} templateNameDelivery={templateNameDelivery} templateNameProforma={templateNameProforma} templateNameBlank={templateNameBlank} displayRoleX={displayRoleX} rules2X={rules2X} rules3X={rules3X} temperature2X={temperature2X} humidity2X={humidity2X} gascontrol2X={gascontrol2X} gps2X={gps2X} fire2X={fire2X} flood2X={flood2X} sealintegrity2X={sealintegrity2X} motion2X={motion2X} smoke2X={smoke2X} displaySaveRulesX={displaySaveRulesX} todosSignX={todosSignX} ningunoSignX={ningunoSignX} indiceRules={indiceRules} algunosSignX={algunosSignX} JSONTemplateName={this.state.JSONTemplateName} c01SensorContract={this.state.c01SensorContract} c02SensorContract={this.state.c02SensorContract} c03SensorContract={this.state.c03SensorContract} c04SensorContract={this.state.c04SensorContract} c05SensorContract={this.state.c05SensorContract} c06SensorContract={this.state.c06SensorContract} c07SensorContract={this.state.c07SensorContract} c08SensorContract={this.state.c08SensorContract} c09SensorContract={this.state.c09SensorContract} c10SensorContract={this.state.c10SensorContract} c11SensorContract={this.state.c11SensorContract} c12SensorContract={this.state.c12SensorContract} c13SensorContract={this.state.c01SensorContract} colorDark={this.props.colorDark} storageSX={this.props.storageSX} /> : null }

                { displayActiveParticipantsX ? <ActiveParticipants typeContract={this.state.typeContractTable} numberContract={this.state.numberContractTable} subjectContract={this.state.subjectContractTable} returnProps={this.returnProps} jsonEnrollment={this.state.jsonEnrollmentChange} colorDark={this.props.colorDark} storageSX={this.props.storageSX} /> : null }

                { displayPaymentFormX ? <ContractPaymentForm typeContract={this.state.typeContractTable} numberContract={this.state.numberContractTable} subjectContract={this.state.subjectContractTable} returnProps={this.returnProps} jsonPaymentForm={this.state.jsonPaymentForm} jsonStatusLifeCycle={this.state.displayLifeCycleX} colorDark={this.props.colorDark} CurrencyType={this.state.CurrencyType} FIACurrency={this.state.FIACurrency} cryptoCurrencyOrigin={this.state.cryptoCurrencyOrigin} amountPayment={this.state.amountPayment} cryptoCurrencyPayment={this.state.cryptoCurrencyPayment} storageSX={this.props.storageSX} /> : null }

                { displayPayX ? <ContractPay typeContract={this.state.typeContractTable} numberContract={this.state.numberContractTable} subjectContract={this.state.subjectContractTable} returnProps={this.returnProps} jsonStatusLifeCycle={this.state.displayLifeCycleX}  jsonUserGroup={this.state.jsonUserGroup} jsonRole={this.state.jsonBlockstackZ} userRole={this.state.whatUserRole} activeUserGroupX={this.state.activeUserGroupX} userOrigin={this.state.whatUserOrigin} whatUserRole={this.state.whatUserRole} colorDark={this.props.colorDark} userOrigin={this.state.whatUserOrigin} userRole={this.state.whatUserRole} storageSX={this.props.storageSX} /> : null }

                { displayRegisterX ? <ContractRegister typeContract={this.state.typeContractTable} numberContract={this.state.numberContractTable} subjectContract={this.state.subjectContractTable} returnProps={this.returnProps} jsonBlockstackY={this.state.jsonBlockstackY} jsonBlockstackZ={this.state.jsonBlockstackZ} userRole={this.state.whatUserRole} userOrigin={this.state.whatUserOrigin} whatUserRole={this.state.whatUserRole} statusActive2={this.state.statusActive2} existContract={this.state.existContract} jsonStatusIdPact={this.state.jsonStatusIdPact} jsonStatusBlockchain={this.state.jsonStatusBlockchain} jsonStatusLifeCycle={this.state.jsonStatusLifeCycle} signTrue={this.state.signTrue} signContract={this.signContract} unsignContract={this.unsignContract} todosSign={this.state.todosSign} confirmSignX={this.state.confirmSignX} FIACurrency={this.state.FIACurrency} cryptoPactClarityEthereum={this.state.cryptoPactClarityEthereum} myUserConfig={this.state.myUserConfig} jsonStatusLifeCycle={this.state.displayLifeCycleX} colorDark={this.props.colorDark} storageSX={this.props.storageSX} /> : null }

                { displayCertificatePaymentsMadeX ? <ViewerPdf contentState={this.state.contentStateRaw} typeContract={this.state.typeContractSign} numberContract={this.state.configurationContractNumberSign} userRole={this.state.whatUserRole} userOrigin={this.state.whatUserOrigin} whatUserRole={this.state.whatUserRole} description={this.state.subject} startDate={this.state.startDate} endDate={this.state.endDate} filedecodeAttachX={filedecodeAttachX} colorDark={this.props.colorDark} displayCertificatePaymentsMade={this.state.displayCertificatePaymentsMade} displayCertificateContract={this.state.displayCertificateContract} storageSX={this.props.storageSX} /> : null }

                {/*----------------------------------------------------------------------------------------*/}

                <Confirmacion
                    handleDialog={this.handleDialog}
                    dialogMessage={this.state.dialogMessage}
                    dialogOpen={this.state.dialogOpen}
                    dialogTitle={this.state.dialogTitle}
                />
                <ConfirmacionWriteBlockchain
                    handleDialog={this.handleDialog}
                    dialogMessage={this.state.dialogMessage}
                    dialogOpen={this.state.dialogOpenWriteBlockchain}
                    dialogTitle={this.state.dialogTitle}
                />
                <ConfirmacionWalletSinSaldo
                    handleDialog={this.handleDialog}
                    dialogMessage={this.state.dialogMessage}
                    dialogOpen={this.state.dialogOpenWalletSinSaldo}
                    dialogTitle={this.state.dialogTitle}
                />
                <ConfirmacionSign
                    handleDialog={this.handleDialog}
                    dialogMessage={this.state.dialogMessage}
                    dialogOpen={this.state.dialogOpenSign}
                    dialogTitle={this.state.dialogTitle}
                />
                <ConfirmacionUnSign
                    handleDialog={this.handleDialog}
                    dialogMessage={this.state.dialogMessage}
                    dialogOpen={this.state.dialogOpenUnSign}
                    dialogTitle={this.state.dialogTitle}
                />
                <ConfirmacionContractExist
                    handleDialog={this.handleDialog}
                    dialogMessage={this.state.dialogMessage}
                    dialogOpen={this.state.dialogOpenContractExist}
                    dialogTitle={this.state.dialogTitle}
                />
                <ConfirmacionDeactivate
                    handleDialog={this.handleDialog}
                    dialogMessage={this.state.dialogMessage}
                    dialogOpen={this.state.dialogOpenDeactivate}
                    dialogTitle={this.state.dialogTitle}
                />
                <ConfirmacionSaveDraft
                    handleDialog={this.handleDialog}
                    dialogMessage={this.state.dialogMessage}
                    dialogOpen={this.state.dialogOpenSaveDraft}
                    dialogTitle={this.state.dialogTitle}
                />
                <ConfirmacionSaveDraftAgree
                    handleDialog={this.handleDialog}
                    dialogMessage={this.state.dialogMessage}
                    dialogOpen={this.state.dialogOpenSaveDraftAgree}
                    dialogTitle={this.state.dialogTitle}
                />
                <ConfirmacionPaymentForm
                    handleDialog={this.handleDialog}
                    dialogMessage={this.state.dialogMessage}
                    dialogOpen={this.state.dialogOpenPaymentForm}
                    dialogTitle={this.state.dialogTitle}
                />

                {displaySimulatorX ?
                    <ContenedorSimulador />
                : null }

                {displayTemplateDetailX ?
                  <div>
                    { displayTemplateAutomatic
                      ?
                        {JSONTemplateDetail}
                      :
                        <React.Fragment>
                            <Card small style={ this.props.colorDark ? { backgroundColor:'#0b151d'} : {}}>
                              <ListGroup flush>
                                <ListGroupItem className="p-3" style={ this.props.colorDark ? { backgroundColor:'#0b151d'} : {}}>
                                <h5 style={{ color: 'red' }}>{detail2X}</h5>
                                 <Card style={ this.props.colorDark ? { backgroundColor:'#0b151d'} : {}}>
                                    { templateNameWorkOrder
                                     ?
                                       <React.Fragment>
                                           <Form style={{backgroundColor:"#F2EACE"}}>
                                             { displayCompanyLogoDataX ?
                                               <React.Fragment>
                                                 <Row></Row>
                                                 <Row form>
                                                     <Table size="sm" borderless responsive>
                                                         <tbody>
                                                             <tr>
                                                                 {logoCompanyX ?
                                                                   <>
                                                                     <td style={{ width: "120px", textAlign:"left" }}>
                                                                        <img src={`${this.state.logoCompany}`} style={{maxWidth: "300px"}} />
                                                                     </td>
                                                                     {dataCompany2X ?
                                                                       <td style={{ width: "220px", textAlign:"right"}}>
                                                                          <div dangerouslySetInnerHTML={{__html: this.state.dataCompany2}} />
                                                                       </td>
                                                                     :
                                                                       null
                                                                     }
                                                                   </>
                                                                 :
                                                                   <>
                                                                     {dataCompany2X ?
                                                                       <td style={{ width: "220px", textAlign:"right" }}>
                                                                          <div dangerouslySetInnerHTML={{__html: this.state.dataCompany2}} />
                                                                       </td>
                                                                     :
                                                                       <>
                                                                         <td style={{ width: "220px", textAlign:"left" }}>
                                                                           <div className="fa fa-info-circle mx-2" style={{fontSize:10, color:'red'}}>
                                                                             &nbsp;
                                                                             <FormattedMessage id="contract.workorderlogodata" />
                                                                           </div>
                                                                         </td>
                                                                       </>
                                                                     }
                                                                   </>
                                                                 }
                                                             </tr>
                                                         </tbody>
                                                     </Table>
                                                  </Row>
                                                </React.Fragment>
                                             :
                                               <React.Fragment>
                                                 <Row></Row>
                                                 <Row form>
                                                     <Col md="1"></Col>
                                                     <Col md="10">
                                                         <div className="fa fa-info-circle mx-2" style={{fontSize:10, color:'red'}}>
                                                           &nbsp;
                                                         </div>
                                                     </Col>
                                                  </Row>
                                                </React.Fragment>
                                              }
                                           </Form>

                                           <Form style={{fontSize:13, backgroundColor:"#F2EACE"}}>
                                             <Row>&nbsp;</Row>
                                             <Row form>
                                               <Col md="1"></Col>
                                               <Col md="5">
                                                 <Card style={{ maxWidth: "600px", backgroundColor:"#F2EACE" }}>
                                                    <CardHeader className="text-center" style={{fontSize:17, backgroundColor:"#F2EACE"}}><FormattedMessage id="contract.workorderdatosot" /></CardHeader>
                                                    <CardImg src="/images/lines-divider2.png" />
                                                    <CardBody>
                                                        <label style={{ color: 'Black', fontSize:10 }}><FormattedMessage id="contract.workordercliente" /></label>
                                                        <FormSelect
                                                            id="workordercliente"
                                                            innerRef={this.c06FieldContract}
                                                            placeholder="Select Client"
                                                            disabled={disabledX}
                                                          >
                                                          {this.state.clientWorkOrder.map((todo, i) => {
                                                            return (
                                                              <option style={this.props.colorDark ? {color:'orange'} : {color:'darkblue'}} key={i} value={`${todo.description}`}>{`${todo.description}`}</option>
                                                            )
                                                          })}
                                                        </FormSelect>
                                                        <label style={{ color: 'Black', fontSize:10 }}><FormattedMessage id="contract.workordercampaña" /></label>
                                                        <FormInput
                                                          size="sm"
                                                          id="workordercampaña"
                                                          innerRef={this.c07FieldContract}
                                                          placeholder=""
                                                          disabled={disabledX}
                                                        />
                                                        <label style={{ color: 'Black', fontSize:10 }}><FormattedMessage id="contract.workordersondaje" /></label>
                                                        <FormInput
                                                          size="sm"
                                                          id="workordersondaje"
                                                          innerRef={this.c08FieldContract}
                                                          placeholder=""
                                                          disabled={disabledX}
                                                        />
                                                        <label style={{ color: 'Black', fontSize:10 }}><FormattedMessage id="contract.workorderrecomendado" /></label>
                                                        <FormInput
                                                          size="sm"
                                                          id="workorderrecomendado"
                                                          innerRef={this.c09FieldContract}
                                                          placeholder=""
                                                          disabled={disabledX}
                                                        />
                                                        <label style={{ color: 'Black', fontSize:10 }}><FormattedMessage id="contract.workordertipoperforacion" /></label>
                                                        <FormInput
                                                          size="sm"
                                                          id="workordertipoperforacion"
                                                          innerRef={this.c10FieldContract}
                                                          placeholder=""
                                                          disabled={disabledX}
                                                        />
                                                        <label style={{ color: 'Black', fontSize:10 }}><FormattedMessage id="contract.workorderfase" /></label>
                                                        <FormInput
                                                          size="sm"
                                                          id="workorderfase"
                                                          innerRef={this.c11FieldContract}
                                                          placeholder=""
                                                          disabled={disabledX}
                                                        />
                                                        <label style={{ color: 'Black', fontSize:10 }}><FormattedMessage id="contract.workordernumerocontrato" /></label>
                                                        <FormInput
                                                          size="sm"
                                                          id="workordernumerocontrato"
                                                          innerRef={this.c12FieldContract}
                                                          placeholder=""
                                                          disabled={disabledX}
                                                        />
                                                    </CardBody>
                                                  </Card>
                                                  <Card style={{ maxWidth: "600px", backgroundColor:"#F2EACE" }}>
                                                     <CardBody>
                                                         <Table size="sm" borderless responsive>
                                                             <thead>
                                                               <tr>
                                                                 <th style={{ width: "33%" }}></th>
                                                                 <th style={{ width: "33%" }}><FormattedMessage id="contract.workorderprimerobjetivo" /></th>
                                                                 <th style={{ width: "33%" }}><FormattedMessage id="contract.workordersegundoobjetivo" /></th>
                                                               </tr>
                                                             </thead>
                                                             <tbody>
                                                                 <tr>
                                                                   <td>
                                                                     <span><FormattedMessage id="contract.workorderdobleobjetivo" /></span>
                                                                   </td>
                                                                   <td>
                                                                     <FormInput
                                                                       size="sm"
                                                                       id="workorderprimerobjetivo"
                                                                       innerRef={this.c13FieldContract}
                                                                       placeholder=""
                                                                       disabled={disabledX}
                                                                     />
                                                                   </td>
                                                                   <td>
                                                                     <FormInput
                                                                       size="sm"
                                                                       id="workordersegundoobjetivo"
                                                                       innerRef={this.c14FieldContract}
                                                                       placeholder=""
                                                                       disabled={disabledX}
                                                                     />
                                                                   </td>
                                                                </tr>
                                                             </tbody>
                                                         </Table>
                                                     </CardBody>
                                                  </Card>
                                               </Col>
                                               <Col md="5">
                                                 <Card style={{ maxWidth: "600px", backgroundColor:"#F2EACE" }}>
                                                    <CardHeader className="text-center" style={{fontSize:17, backgroundColor:"#F2EACE"}}><FormattedMessage id="contract.workordercoordenadasprograma" /></CardHeader>
                                                    <CardImg src="/images/lines-divider2.png" />
                                                    <CardBody>
                                                        <label style={{ color: 'Black', fontSize:10 }}><FormattedMessage id="contract.workordereste" /></label>
                                                        <FormInput
                                                          size="sm"
                                                          id="workordereste"
                                                          innerRef={this.c15FieldContract}
                                                          placeholder=""
                                                          disabled={disabledX}
                                                        />
                                                        <label style={{ color: 'Black', fontSize:10 }}><FormattedMessage id="contract.workordernorte" /></label>
                                                        <FormInput
                                                          size="sm"
                                                          id="workordernorte"
                                                          innerRef={this.c17FieldContract}
                                                          placeholder=""
                                                          disabled={disabledX}
                                                        />
                                                        <label style={{ color: 'Black', fontSize:10 }}><FormattedMessage id="contract.workordercotainicio" /></label>
                                                        <FormInput
                                                          size="sm"
                                                          id="workordercotainicio"
                                                          innerRef={this.c18FieldContract}
                                                          placeholder=""
                                                          disabled={disabledX}
                                                        />
                                                        <label style={{ color: 'Black', fontSize:10 }}><FormattedMessage id="contract.workordercotfinal" /></label>
                                                        <FormInput
                                                          size="sm"
                                                          id="workordercotfinal"
                                                          innerRef={this.c19FieldContract}
                                                          placeholder=""
                                                          disabled={disabledX}
                                                        />
                                                        <label style={{ color: 'Black', fontSize:10 }}><FormattedMessage id="contract.workorderlargo" /></label>
                                                        <FormInput
                                                          size="sm"
                                                          id="workorderlargo"
                                                          innerRef={this.c21FieldContract}
                                                          placeholder=""
                                                          disabled={disabledX}
                                                        />
                                                        <label style={{ color: 'Black', fontSize:10 }}><FormattedMessage id="contract.workorderantepozo" /></label>
                                                        <FormInput
                                                          size="sm"
                                                          id="workorderantepozo"
                                                          innerRef={this.c22FieldContract}
                                                          placeholder=""
                                                          disabled={disabledX}
                                                        />
                                                        <label style={{ color:'darkorange', fontWeight:'bold', fontSize:10 }}><FormattedMessage id="contract.workorderfechainiciopozo" /></label>
                                                        <br></br>
                                                        <DatePicker
                                                          id="workorderfechainiciopozo"
                                                          style={ this.props.colorDark ? { backgroundColor:'#468C77', color:'white'} : {backgroundColor:'#468C77', color:'white'}}
                                                          dateFormat={this.state.dateFormatX}
                                                          placeholder=""
                                                          locale={es} utils={DateFnsUtils}
                                                          disabled={false}
                                                          //size="sm"
                                                          selected={this.state.workorderfechainiciopozo}
                                                          onChange={val=>this.handleDate(val,'workorderfechainiciopozo')}
                                                          onBlur={e=>this.modifyWorkOrderDatoExtra(e)}
                                                          dropdownMode="select"
                                                        />
                                                        <br></br>
                                                        <label style={{ color: 'darkorange', fontWeight:'bold', fontSize:10 }}><FormattedMessage id="contract.workorderfechaterminoperforacion" /></label>
                                                        <br></br>
                                                        <DatePicker
                                                          id="workorderfechaterminoperforacion"
                                                          style={ this.props.colorDark ? { backgroundColor:'#468C77', color:'white'} : {backgroundColor:'#468C77', color:'white'}}
                                                          dateFormat={this.state.dateFormatX}
                                                          placeholder=""
                                                          locale={es} utils={DateFnsUtils}
                                                          disabled={false}
                                                          //size="sm"
                                                          selected={this.state.workorderfechaterminoperforacion}
                                                          onChange={val=>this.handleDate(val,'workorderfechaterminoperforacion')}
                                                          onBlur={e=>this.modifyWorkOrderDatoExtra(e)}
                                                          dropdownMode="select"
                                                        />
                                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                        {buttonModifyWorkOrder ?
                                                          <Button outline pill theme="warning" size="sm" className="mb-2" onClick={e=>this.modifyWorkOrderDatoExtra(e)}>
                                                              Actualizar
                                                          </Button>
                                                        : null }
                                                        <br></br>
                                                        <label style={{ color: 'darkorange', fontWeight:'bold', fontSize:10 }}><FormattedMessage id="contract.workorderfechaterminosondaje" /></label>
                                                        <br></br>
                                                        <DatePicker
                                                          id="workorderfechaterminosondaje"
                                                          style={ this.props.colorDark ? { backgroundColor:'#468C77', color:'white'} : {backgroundColor:'#468C77', color:'white'}}
                                                          dateFormat={this.state.dateFormatX}
                                                          placeholder=""
                                                          disabled={false}
                                                          locale={es} utils={DateFnsUtils}
                                                          //size="sm"
                                                          selected={this.state.workorderfechaterminosondaje}
                                                          onChange={val=>this.handleDate(val,'workorderfechaterminosondaje')}
                                                          onBlur={e=>this.modifyWorkOrderDatoExtra(e)}
                                                          dropdownMode="select"
                                                        />
                                                    </CardBody>
                                                  </Card>
                                               </Col>
                                               <Col md="1"></Col>
                                             </Row>

                                             <Row form>
                                               <Col md="1">&nbsp;</Col>
                                               <Col md="6">
                                                 <Card style={{ backgroundColor:"#F2EACE" }}>
                                                    <CardBody>
                                                     <Table size="sm" borderless responsive>
                                                         <thead>
                                                           <tr>
                                                             <th style={{ width: "25%" }}><FormattedMessage id="contract.workorderdesde" /></th>
                                                             <th style={{ width: "25%" }}><FormattedMessage id="contract.workorderhasta" /></th>
                                                             <th style={{ width: "25%" }}><FormattedMessage id="contract.workorderazimut" /></th>
                                                             <th style={{ width: "25%" }}><FormattedMessage id="contract.workorderdeclinacion" /></th>
                                                           </tr>
                                                         </thead>
                                                         <tbody>
                                                             <tr>
                                                               <td>
                                                                 <FormInput
                                                                   size="sm"
                                                                   id="workorderdesde"
                                                                   innerRef={this.c27FieldContract}
                                                                   placeholder=""
                                                                   disabled={disabledX}
                                                                 />
                                                               </td>
                                                               <td>
                                                                 <FormInput
                                                                   size="sm"
                                                                   id="workorderhasta"
                                                                   innerRef={this.c28FieldContract}
                                                                   placeholder=""
                                                                   disabled={disabledX}
                                                                 />
                                                               </td>
                                                               <td>
                                                                 <FormInput
                                                                   size="sm"
                                                                   id="workorderazimut"
                                                                   innerRef={this.c29FieldContract}
                                                                   placeholder=""
                                                                   disabled={disabledX}
                                                                 />
                                                               </td>
                                                               <td>
                                                                 <FormInput
                                                                   size="sm"
                                                                   id="workorderdeclinacion"
                                                                   innerRef={this.c30FieldContract}
                                                                   placeholder=""
                                                                   disabled={disabledX}
                                                                 />
                                                               </td>
                                                             </tr>
                                                         </tbody>
                                                     </Table>
                                                   </CardBody>
                                                 </Card>
                                               </Col>
                                               <Col md="4">
                                                 <Card style={{ backgroundColor:"#F2EACE" }}>
                                                    <CardBody>
                                                     <Table size="sm" borderless responsive>
                                                         <thead>
                                                           <tr>
                                                             <th style={{ width: "33%", color:'darkorange', fontWeight:'bold' }}>Fecha Real Inicio</th>
                                                             <th style={{ width: "33%", color:'darkorange', fontWeight:'bold' }}>Meta T.Día</th>
                                                             <th style={{ width: "33%", color:'darkorange', fontWeight:'bold' }}>Meta T.Noche</th>
                                                           </tr>
                                                         </thead>
                                                         <tbody>
                                                             <tr>
                                                               <td>
                                                                 <DatePicker
                                                                   id="workorderfecharealinicio"
                                                                   dateFormat={this.state.dateFormatX}
                                                                   placeholder=""
                                                                   locale={es} utils={DateFnsUtils}
                                                                   disabled={false}
                                                                   //size="sm"
                                                                   selected={this.state.workorderfecharealinicio}
                                                                   onChange={val=>this.handleDate(val,'workorderfecharealinicio')}
                                                                   onBlur={e=>this.modifyWorkOrderDatoExtra(e)}
                                                                   dropdownMode="select"
                                                                 />
                                                               </td>
                                                               <td>
                                                                 <FormInput
                                                                   type="number"
                                                                   size="sm"
                                                                   id="workordermetaturnodia"
                                                                   innerRef={this.c48FieldContract}
                                                                   onInput={e=>this.handleInputNumber(e, "MetaDia")}
                                                                   onBlur={e=>this.modifyWorkOrderDatoExtra(e)}
                                                                   placeholder=""
                                                                   disabled={false}
                                                                 />
                                                               </td>
                                                               <td>
                                                                 <FormInput
                                                                   type="number"
                                                                   size="sm"
                                                                   id="workordermetaturnonoche"
                                                                   innerRef={this.c49FieldContract}
                                                                   onInput={e=>this.handleInputNumber(e, "MetaNoche")}
                                                                   onBlur={e=>this.modifyWorkOrderDatoExtra(e)}
                                                                   placeholder=""
                                                                   disabled={false}
                                                                 />
                                                               </td>
                                                               <td>
                                                                 {buttonModifyWorkOrder ?
                                                                   <Button outline pill theme="warning" size="sm" className="mb-2" onClick={e=>this.modifyWorkOrderDatoExtra(e)}>
                                                                       Actualizar
                                                                   </Button>
                                                                 : null }
                                                               </td>
                                                             </tr>
                                                         </tbody>
                                                     </Table>
                                                   </CardBody>
                                                 </Card>
                                               </Col>
                                               <Col md="1">&nbsp;</Col>
                                             </Row>


                                             <Row form>
                                               <Col md="1"></Col>
                                               <Col md="5">
                                                 <Card style={{ maxWidth: "600px", backgroundColor:"#F2EACE" }}>
                                                    <CardHeader className="text-center" style={{fontSize:17, backgroundColor:"#F2EACE"}}><FormattedMessage id="contract.workordertipoperforacionrecomendada" /></CardHeader>
                                                    <CardImg src="/images/lines-divider2.png" />
                                                    <CardBody>
                                                         <Table size="sm" borderless responsive>
                                                             <thead>
                                                               <tr>
                                                                 <th style={{ width: "33%" }}></th>
                                                                 <th style={{ width: "33%" }}><FormattedMessage id="contract.workorderdesde" /></th>
                                                                 <th style={{ width: "33%" }}><FormattedMessage id="contract.workorderhasta" /></th>
                                                               </tr>
                                                             </thead>
                                                             <tbody>
                                                                 <tr>
                                                                   <td>
                                                                     <span><FormattedMessage id="contract.workordersobrecarga" /></span>
                                                                   </td>
                                                                   <td>
                                                                     <FormInput
                                                                       size="sm"
                                                                       id="workordersobrecarga"
                                                                       innerRef={this.c31FieldContract}
                                                                       placeholder=""
                                                                       disabled={disabledX}
                                                                     />
                                                                   </td>
                                                                   <td>
                                                                     <FormInput
                                                                       size="sm"
                                                                       id="workordersobrecarga"
                                                                       innerRef={this.c32FieldContract}
                                                                       placeholder=""
                                                                       disabled={disabledX}
                                                                     />
                                                                   </td>
                                                                </tr>
                                                                <tr>
                                                                  <td>
                                                                    <span><FormattedMessage id="contract.workorderantepozo" /></span>
                                                                  </td>
                                                                  <td>
                                                                    <FormInput
                                                                      size="sm"
                                                                      id="workorderantepozo"
                                                                      innerRef={this.c33FieldContract}
                                                                      placeholder=""
                                                                      disabled={disabledX}
                                                                    />
                                                                  </td>
                                                                  <td>
                                                                    <FormInput
                                                                      size="sm"
                                                                      id="workorderantepozo"
                                                                      innerRef={this.c34FieldContract}
                                                                      placeholder=""
                                                                      disabled={disabledX}
                                                                    />
                                                                  </td>
                                                               </tr>
                                                               <tr>
                                                                 <td>
                                                                   <span><FormattedMessage id="contract.workorderpolvo" /></span>
                                                                 </td>
                                                                 <td>
                                                                   <FormInput
                                                                     size="sm"
                                                                     id="workorderpolvo"
                                                                     innerRef={this.c35FieldContract}
                                                                     placeholder=""
                                                                     disabled={disabledX}
                                                                   />
                                                                 </td>
                                                                 <td>
                                                                   <FormInput
                                                                     size="sm"
                                                                     id="workorderpolvo"
                                                                     innerRef={this.c36FieldContract}
                                                                     placeholder=""
                                                                     disabled={disabledX}
                                                                   />
                                                                 </td>
                                                              </tr>
                                                              <tr>
                                                                <td>
                                                                  <span><FormattedMessage id="contract.workorderdiamantino" /></span>
                                                                </td>
                                                                <td>
                                                                  <FormInput
                                                                    size="sm"
                                                                    id="workorderdiamantino"
                                                                    innerRef={this.c37FieldContract}
                                                                    placeholder=""
                                                                    disabled={disabledX}
                                                                  />
                                                                </td>
                                                                <td>
                                                                  <FormInput
                                                                    size="sm"
                                                                    id="workorderdiamantino"
                                                                    innerRef={this.c38FieldContract}
                                                                    placeholder=""
                                                                    disabled={disabledX}
                                                                  />
                                                                </td>
                                                              </tr>
                                                             </tbody>
                                                         </Table>
                                                    </CardBody>
                                                  </Card>
                                               </Col>
                                               <Col md="5">
                                                  <Card style={{ maxWidth: "600px", backgroundColor:"#F2EACE" }}>
                                                     <CardHeader className="text-center" style={{fontSize:17, backgroundColor:"#F2EACE"}}><FormattedMessage id="contract.workordertipoperforacionreal" /></CardHeader>
                                                     <CardImg src="/images/lines-divider2.png" />
                                                     <CardBody>
                                                       <Table size="sm" borderless responsive>
                                                           <thead>
                                                             <tr>
                                                               <th style={{ width: "33%", color:'darkorange', fontWeight:'bold' }}></th>
                                                               <th style={{ width: "33%", color:'darkorange', fontWeight:'bold' }}><FormattedMessage id="contract.workorderdesde" /></th>
                                                               <th style={{ width: "33%", color:'darkorange', fontWeight:'bold' }}><FormattedMessage id="contract.workorderhasta" /></th>
                                                             </tr>
                                                           </thead>
                                                           <tbody>
                                                               <tr>
                                                                 <td>
                                                                   <span style={{ color:'darkorange', fontWeight:'bold' }}><FormattedMessage id="contract.workordersobrecarga" /></span>
                                                                 </td>
                                                                 <td>
                                                                   <FormInput
                                                                     size="sm"
                                                                     id="workordersobrecarga"
                                                                     innerRef={this.c39FieldContract}
                                                                     placeholder=""
                                                                     onBlur={e=>this.modifyWorkOrderDatoExtra(e)}
                                                                     disabled={false}
                                                                   />
                                                                 </td>
                                                                 <td>
                                                                   <FormInput
                                                                     size="sm"
                                                                     id="workordersobrecarga"
                                                                     innerRef={this.c40FieldContract}
                                                                     onBlur={e=>this.modifyWorkOrderDatoExtra(e)}
                                                                     placeholder=""
                                                                     disabled={false}
                                                                   />
                                                                 </td>
                                                              </tr>
                                                              <tr>
                                                                <td>
                                                                  <span style={{ color:'darkorange', fontWeight:'bold' }}><FormattedMessage id="contract.workorderantepozo" /></span>
                                                                </td>
                                                                <td>
                                                                  <FormInput
                                                                    size="sm"
                                                                    id="workorderantepozo"
                                                                    innerRef={this.c41FieldContract}
                                                                    onBlur={e=>this.modifyWorkOrderDatoExtra(e)}
                                                                    placeholder=""
                                                                    disabled={false}
                                                                  />
                                                                </td>
                                                                <td>
                                                                  <FormInput
                                                                    size="sm"
                                                                    id="workorderantepozo"
                                                                    innerRef={this.c42FieldContract}
                                                                    onBlur={e=>this.modifyWorkOrderDatoExtra(e)}
                                                                    placeholder=""
                                                                    disabled={false}
                                                                  />
                                                                </td>
                                                             </tr>
                                                             <tr>
                                                               <td>
                                                                 <span style={{ color:'darkorange', fontWeight:'bold' }}><FormattedMessage id="contract.workorderpolvo" /></span>
                                                               </td>
                                                               <td>
                                                                 <FormInput
                                                                   size="sm"
                                                                   id="workorderpolvo"
                                                                   innerRef={this.c43FieldContract}
                                                                   placeholder=""
                                                                   onBlur={e=>this.modifyWorkOrderDatoExtra(e)}
                                                                   disabled={false}
                                                                 />
                                                               </td>
                                                               <td>
                                                                 <FormInput
                                                                   size="sm"
                                                                   id="workorderpolvo"
                                                                   innerRef={this.c44FieldContract}
                                                                   onBlur={e=>this.modifyWorkOrderDatoExtra(e)}
                                                                   placeholder=""
                                                                   disabled={false}
                                                                 />
                                                               </td>
                                                            </tr>
                                                            <tr>
                                                              <td>
                                                                <span style={{ color:'darkorange', fontWeight:'bold' }}><FormattedMessage id="contract.workorderdiamantino" /></span>
                                                              </td>
                                                              <td>
                                                                <FormInput
                                                                  size="sm"
                                                                  id="workorderdiamantino"
                                                                  innerRef={this.c45FieldContract}
                                                                  onBlur={e=>this.modifyWorkOrderDatoExtra(e)}
                                                                  placeholder=""
                                                                  disabled={false}
                                                                />
                                                              </td>
                                                              <td>
                                                                <FormInput
                                                                  size="sm"
                                                                  id="workorderdiamantino"
                                                                  innerRef={this.c46FieldContract}
                                                                  onBlur={e=>this.modifyWorkOrderDatoExtra(e)}
                                                                  placeholder=""
                                                                  disabled={false}
                                                                />
                                                              </td>
                                                            </tr>
                                                           </tbody>
                                                       </Table>
                                                     </CardBody>
                                                  </Card>
                                               </Col>
                                               <Col md="1"></Col>
                                             </Row>

                                             <Row form>
                                               <Col md="1"></Col>
                                               <Col md="5">
                                                 <label style={{ color:'darkorange', fontWeight:'bold' }} htmlFor="workorderobservacion"><FormattedMessage id="contract.workorderobservacion" /></label>
                                                 <FormTextarea
                                                   id="workorderobservacion"
                                                   innerRef={this.c47FieldContract}
                                                   onChange={e=>this.handleCaracteresEspeciales(e)}
                                                   onBlur={e=>this.modifyWorkOrderDatoExtra(e)}
                                                   placeholder=""
                                                   disabled={false}
                                                 />
                                               </Col>
                                               <Col md="5">
                                                 <label htmlFor="Signed" style={{ color: 'red' }}><FormattedMessage id="contract.signed" /></label>
                                                 { trimmedDataURLX
                                                   ?
                                                     <div>
                                                       <img src={this.state.trimmedDataURL} style={{ minWidth:100, maxWidth:350, minHeight:30, maxHeight:150, width:350, height:150}} />
                                                       <input type="hidden" ref={this.c26FieldContract} />
                                                     </div>
                                                   :
                                                     <FormTextarea
                                                       style={{fontSize:16}}
                                                       id="Signed"
                                                       innerRef={this.c26FieldContract}
                                                       placeholder=""
                                                       disabled={true}
                                                     />
                                                   }
                                               </Col>
                                               <Col md="1">&nbsp;</Col>
                                             </Row>
                                             <br></br>
                                           </Form>
                                       </React.Fragment>
                                     : null
                                    }
                                    { templateNameDelivery
                                    ?
                                      <React.Fragment>
                                          <Form style={{backgroundColor:"#F2EACE"}}>
                                            { displayCompanyLogoDataX ?
                                              <React.Fragment>
                                                <Row></Row>
                                                <Row form>
                                                    <Table size="sm" borderless responsive>
                                                        <tbody>
                                                            <tr>
                                                                {logoCompanyX ?
                                                                  <>
                                                                    <td style={{ width: "120px", textAlign:"left" }}>
                                                                       <img src={`${this.state.logoCompany}`} style={{maxWidth: "300px"}} />
                                                                    </td>
                                                                    {dataCompany2X ?
                                                                      <td style={{ width: "220px", textAlign:"right"}}>
                                                                         <div dangerouslySetInnerHTML={{__html: this.state.dataCompany2}} />
                                                                      </td>
                                                                    :
                                                                      null
                                                                    }
                                                                  </>
                                                                :
                                                                  <>
                                                                    {dataCompany2X ?
                                                                      <td style={{ width: "220px", textAlign:"right" }}>
                                                                         <div dangerouslySetInnerHTML={{__html: this.state.dataCompany2}} />
                                                                      </td>
                                                                    :
                                                                      <>
                                                                        <td style={{ width: "220px", textAlign:"left" }}>
                                                                          <div className="fa fa-info-circle mx-2" style={{fontSize:10, color:'red'}}>
                                                                            &nbsp;
                                                                            <FormattedMessage id="contract.deliverylogodata" />
                                                                          </div>
                                                                        </td>
                                                                      </>
                                                                    }
                                                                  </>
                                                                }
                                                            </tr>
                                                        </tbody>
                                                    </Table>
                                                 </Row>
                                               </React.Fragment>
                                            :
                                              <React.Fragment>
                                                <Row></Row>
                                                <Row form>
                                                    <Col md="1"></Col>
                                                    <Col md="10">
                                                        <div className="fa fa-info-circle mx-2" style={{fontSize:10, color:'red'}}>
                                                          &nbsp;
                                                        </div>
                                                    </Col>
                                                 </Row>
                                               </React.Fragment>
                                             }
                                          </Form>

                                          <Form style={{fontSize:13, backgroundColor:"#F2EACE"}}>
                                            <Row>&nbsp;</Row>
                                            <Row form>
                                              <Col md="1">&nbsp;</Col>
                                              <Col md="3">
                                                <label htmlFor="Shipper"><FormattedMessage id="contract.shipper" /></label>
                                                <FormTextarea
                                                  id="Shipper"
                                                  innerRef={this.c06FieldContract}
                                                  placeholder=""
                                                />
                                              </Col>
                                              <Col md="2">
                                                <label htmlFor="Consignee"><FormattedMessage id="contract.consignee" /></label>
                                                <FormTextarea
                                                  id="Consignee"
                                                  innerRef={this.c07FieldContract}
                                                  placeholder=""
                                                />
                                              </Col>
                                              <Col md="2">
                                                <label htmlFor="NotifyParty"><FormattedMessage id="contract.notifyparty" /></label>
                                                <FormTextarea
                                                  id="NotifyParty"
                                                  innerRef={this.c08FieldContract}
                                                  placeholder=""
                                                />
                                              </Col>
                                              <Col md="3">
                                                <label htmlFor="Carrier"><FormattedMessage id="contract.carrier" /></label>
                                                <FormTextarea
                                                  id="Carrier"
                                                  innerRef={this.c09FieldContract}
                                                  placeholder=""
                                                />
                                              </Col>
                                              <Col md="1">&nbsp;</Col>
                                            </Row>
                                            <Row>&nbsp;</Row>
                                            <Row form>
                                              <Col md="1">&nbsp;</Col>
                                              <Col md="2">
                                                <label htmlFor="PlaceAcceptance"><FormattedMessage id="contract.placeofacceptance" /></label>
                                                <FormInput
                                                  id="PlaceAcceptance"
                                                  innerRef={this.c10FieldContract}
                                                  placeholder=""
                                                />
                                              </Col>
                                              <Col md="2">
                                                <label htmlFor="PortLading"><FormattedMessage id="contract.portoflading" /></label>
                                                <FormInput
                                                  id="PortLading"
                                                  innerRef={this.c11FieldContract}
                                                  placeholder=""
                                                />
                                              </Col>
                                              <Col md="2">
                                                <label htmlFor="Vessel"><FormattedMessage id="contract.vessel" /></label>
                                                <FormInput
                                                  id="Vessel"
                                                  innerRef={this.c12FieldContract}
                                                  placeholder=""
                                                />
                                              </Col>
                                              <Col md="2">
                                                <label htmlFor="PortDischarge"><FormattedMessage id="contract.portofdischarge" /></label>
                                                <FormInput
                                                  id="PortDischarge"
                                                  innerRef={this.c13FieldContract}
                                                  placeholder=""
                                                />
                                              </Col>
                                              <Col md="2">
                                                <label htmlFor="PlaceDelivery"><FormattedMessage id="contract.placeofdelivery" /></label>
                                                <FormInput
                                                  id="PlaceDelivery"
                                                  innerRef={this.c14FieldContract}
                                                  placeholder=""
                                                />
                                              </Col>
                                              <Col md="1">&nbsp;</Col>
                                            </Row>
                                            <Row>&nbsp;</Row>
                                            <Row form>
                                              <Col md="1">&nbsp;</Col>
                                              <Col md="2">
                                                <label htmlFor="FinalDestination"><FormattedMessage id="contract.finaldestination" /></label>
                                                <FormInput
                                                  id="FinalDestination"
                                                  innerRef={this.c15FieldContract}
                                                  placeholder=""
                                                />
                                              </Col>
                                              <Col md="2">
                                                <label htmlFor="Amount"><FormattedMessage id="contract.amount" /></label>
                                                <FormInput
                                                  id="Amount"
                                                  type="number"
                                                  innerRef={this.c20FieldContract}
                                                  placeholder=""
                                                  onChange={e=>this.handleChangeNumber(e, "Amount")}
                                                  onBlur={e=>this.handleBlurNumber(e, "Amount")}
                                                  onInput={e=>this.handleInputNumber(e, "Amount")}
                                                />
                                              </Col>
                                              <Col md="2">
                                                <label htmlFor="Currency"><FormattedMessage id="contract.currency" /></label>
                                                <FormSelect
                                                    id="Currency"
                                                    innerRef={this.c16FieldContract}
                                                    placeholder="Select Currency"
                                                  >
                                                  {currencyFiatX.map((todo, i) => {
                                                    return (
                                                      <option style={this.props.colorDark ? {color:'orange'} : {color:'darkblue'}} key={i} value={`${todo.Ccy} - ${todo.CcyNm}`}>{`${todo.Ccy} - ${todo.CcyNm}`}</option>
                                                    )
                                                  })}
                                                </FormSelect>
                                              </Col>
                                              <Col md="4">
                                                <label htmlFor="Signed" style={{ color: 'red' }}><FormattedMessage id="contract.signed" /></label>

                                                      { trimmedDataURLX
                                                        ?
                                                          <div>
                                                            <img src={this.state.trimmedDataURL} style={{ minWidth:100, maxWidth:350, minHeight:30, maxHeight:150, width:350, height:150}} />
                                                            <input type="hidden" ref={this.c26FieldContract} />
                                                          </div>
                                                        :
                                                          <FormTextarea
                                                            style={{fontSize:16}}
                                                            id="Signed"
                                                            innerRef={this.c26FieldContract}
                                                            placeholder=""
                                                            disabled={true}
                                                          />
                                                        }

                                              </Col>
                                              <Col md="1">&nbsp;</Col>
                                            </Row>
                                            <br></br>
                                          </Form>
                                      </React.Fragment>
                                    : null
                                    }
                                    { templateNameMaintenance
                                    ?
                                      <Container style={ this.props.colorDark ? { backgroundColor:'#0b151d'} : {}}>
                                        <Form style={{fontSize:13}}>
                                          { displayCompanyLogoDataX ?
                                            <React.Fragment>
                                              <Row></Row>
                                              <Row form>
                                                  <Col md="1"></Col>
                                                  <Col md="10">
                                                    <Card style={{ maxWidth: "1200px", backgroundColor:"#F2EACE" }}>
                                                        <Table size="sm" borderless responsive>
                                                            <tbody>
                                                                <tr>
                                                                    {logoCompanyX ?
                                                                      <>
                                                                        <td style={{ width: "120px", textAlign:"left" }}>
                                                                           <img src={`${this.state.logoCompany}`} style={{maxWidth: "300px"}} />
                                                                        </td>
                                                                        {dataCompany2X ?
                                                                          <td style={{ width: "220px", textAlign:"right"}}>
                                                                             <div dangerouslySetInnerHTML={{__html: this.state.dataCompany2}} />
                                                                          </td>
                                                                        :
                                                                          null
                                                                        }
                                                                      </>
                                                                    :
                                                                      <>
                                                                        {dataCompany2X ?
                                                                          <td style={{ width: "220px", textAlign:"right" }}>
                                                                             <div dangerouslySetInnerHTML={{__html: this.state.dataCompany2}} />
                                                                          </td>
                                                                        :
                                                                          <>
                                                                            <td style={{ width: "220px", textAlign:"left" }}>
                                                                              <div className="fa fa-info-circle mx-2" style={{fontSize:10, color:'red'}}>
                                                                                &nbsp;
                                                                                <FormattedMessage id="contract.proformalogodata" />
                                                                              </div>
                                                                            </td>
                                                                          </>
                                                                        }
                                                                      </>
                                                                    }
                                                                </tr>
                                                            </tbody>
                                                        </Table>

                                                     </Card>
                                                  </Col>
                                                  <Col md="1"></Col>
                                               </Row>
                                             </React.Fragment>
                                          :
                                            <React.Fragment>
                                              <Row></Row>
                                              <Row form>
                                                  <Col md="1"></Col>
                                                  <Col md="10">
                                                    <Card style={{ maxWidth: "1200px", backgroundColor:"#F2EACE" }}>
                                                      <div className="fa fa-info-circle mx-2" style={{fontSize:10, color:'red'}}>
                                                        &nbsp;
                                                      </div>
                                                    </Card>
                                                  </Col>
                                              </Row>
                                            </React.Fragment>
                                          }
                                          <Row form>
                                              <Col md="1"></Col>
                                              <Col md="5">
                                                <Card style={{ maxWidth: "600px", backgroundColor:"#F2EACE" }}>
                                                   <CardHeader className="text-center" style={{fontSize:17, backgroundColor:"#F2EACE"}}><FormattedMessage id="contract.maintenanceproviderdata" /></CardHeader>
                                                   <CardImg src="/images/lines-divider2.png" />
                                                   <CardBody>
                                                     <Row>&nbsp;</Row>
                                                     <Row form>
                                                       <Col md="1">&nbsp;</Col>
                                                       <Col md="10">
                                                         <label htmlFor="YourNameCompany"><FormattedMessage id="contract.yournamecompany" /></label>
                                                         <FormTextarea
                                                           id="YourNameCompany"
                                                           innerRef={this.c06FieldContract}
                                                           placeholder=""
                                                           disabled={disabledX}
                                                         />
                                                       </Col>
                                                     </Row>
                                                     <Row>&nbsp;</Row>
                                                     <Row form>
                                                       <Col md="1">&nbsp;</Col>
                                                       <Col md="10">
                                                         <label htmlFor="YourCompleteAddress"><FormattedMessage id="contract.yourcompleteaddress" /></label>
                                                         <FormTextarea
                                                           id="ClientCompleteAddress"
                                                           innerRef={this.c07FieldContract}
                                                           placeholder=""
                                                           disabled={disabledX}
                                                         />
                                                       </Col>
                                                     </Row>
                                                     <Row>&nbsp;</Row>
                                                   </CardBody>
                                                 </Card>
                                              </Col>

                                              <Col md="5">
                                                <Card style={{ maxWidth: "600px", backgroundColor:"#F2EACE" }}>
                                                   <CardHeader className="text-center" style={{fontSize:17, backgroundColor:"#F2EACE"}}><FormattedMessage id="contract.maintenanceclientdata" /></CardHeader>
                                                   <CardImg src="/images/lines-divider2.png" />
                                                   <CardBody>
                                                     <Row>&nbsp;</Row>
                                                     <Row form>
                                                       <Col md="1">&nbsp;</Col>
                                                       <Col md="10">
                                                         <label htmlFor="ClientNameDirection"><FormattedMessage id="contract.clientnamecompany" /></label>
                                                         <FormTextarea
                                                           id="ClientNameDirection"
                                                           innerRef={this.c10FieldContract}
                                                           placeholder=""
                                                           disabled={disabledX}
                                                         />
                                                       </Col>
                                                     </Row>
                                                     <Row>&nbsp;</Row>
                                                     <Row form>
                                                       <Col md="1">&nbsp;</Col>
                                                       <Col md="10">
                                                         <label htmlFor="ClientompleteAddress"><FormattedMessage id="contract.clientcompleteaddress" /></label>
                                                         <FormTextarea
                                                           id="ClientDirection"
                                                           innerRef={this.c11FieldContract}
                                                           placeholder=""
                                                           disabled={disabledX}
                                                         />
                                                       </Col>
                                                       <Col md="1">&nbsp;</Col>
                                                     </Row>
                                                     <Row>&nbsp;</Row>
                                                   </CardBody>
                                                 </Card>
                                              </Col>
                                              <Col md="1"></Col>
                                          </Row>
                                          <Row form>
                                              <Col md="1"></Col>
                                              <Col md="10">
                                                <Card style={{ maxWidth: "1200px", backgroundColor:"#F2EACE" }}>
                                                   <CardBody>
                                                      <Row>&nbsp;</Row>
                                                      <Row form>
                                                        <Col md="1">&nbsp;</Col>
                                                        <Col md="10">
                                                          <label htmlFor="Observations"><FormattedMessage id="contract.observations" /></label>
                                                          <FormTextarea
                                                            id="Observation"
                                                            innerRef={this.c30FieldContract}
                                                            placeholder=""
                                                            disabled={disabledX}
                                                          />
                                                        </Col>
                                                      </Row>
                                                    </CardBody>
                                                </Card>
                                              </Col>
                                          </Row>
                                          <Row form>
                                              <Col md="1"></Col>
                                              <Col md="10">
                                                <Card style={{ maxWidth: "1200px", backgroundColor:"#F2EACE" }}>
                                                   <CardBody>
                                                      <Row>&nbsp;</Row>
                                                      <Row form>
                                                        <Col md="1">&nbsp;</Col>
                                                        <Col md="6">
                                                            <label htmlFor="Proyect"><FormattedMessage id="contract.proyect" /></label>
                                                            <FormTextarea
                                                              id="Proyect"
                                                              innerRef={this.c33FieldContract}
                                                              placeholder=""
                                                              disabled={disabledX}
                                                            />
                                                        </Col>
                                                        <Col md="4">
                                                          <label htmlFor="Responsible Task"><FormattedMessage id="contract.responsible" /></label>
                                                          <FormInput
                                                            id="Responsible Task"
                                                            innerRef={this.c31FieldContract}
                                                            placeholder=""
                                                            disabled={disabledX}
                                                          />
                                                        </Col>
                                                      </Row>
                                                      <Row>&nbsp;</Row>
                                                      <Row form>
                                                        <Col md="1">&nbsp;</Col>
                                                        <Col md="4">
                                                            <label htmlFor="Responsible Task"><FormattedMessage id="contract.typemaintenance" /></label>
                                                            <InputGroupAddon type="prepend">
                                                              <InputGroupText>
                                                                <FormRadio
                                                                  name="optSearch"
                                                                  checked={this.state.selectedTypeMaintenance === "switchPreventive"}
                                                                  disabled={disabledX}
                                                                  onChange={() => {
                                                                    this.handleChangeOption("switchPreventive",disabledX);
                                                                  }}
                                                                >
                                                                  <FormattedMessage id="contract.preventive" />
                                                                </FormRadio>
                                                                &nbsp;&nbsp;
                                                                <FormRadio
                                                                  name="optSearch"
                                                                  checked={this.state.selectedTypeMaintenance === "switchCorrective"}
                                                                  disabled={disabledX}
                                                                  onChange={() => {
                                                                    this.handleChangeOption("switchCorrective",disabledX);
                                                                  }}
                                                                >
                                                                  <FormattedMessage id="contract.corrective" />
                                                                </FormRadio>
                                                              </InputGroupText>
                                                            </InputGroupAddon>
                                                        </Col>
                                                        <Col md="3">
                                                          <label htmlFor="Task Frequency"><FormattedMessage id="contract.taskfrequency" /></label>
                                                          <FormInput
                                                            id="Task Frequency"
                                                            innerRef={this.c32FieldContract}
                                                            placeholder=""
                                                            disabled={disabledX}
                                                          />
                                                        </Col>
                                                      </Row>
                                                      <Row>&nbsp;</Row>
                                                      <Row form>
                                                        <Col md="1">&nbsp;</Col>
                                                        <Col md="2">
                                                          <label htmlFor="Amount"><FormattedMessage id="contract.amountmaintenance" /></label>
                                                          <FormInput
                                                            id="Amount"
                                                            type="number"
                                                            innerRef={this.c20FieldContract}
                                                            placeholder=""
                                                            onChange={e=>this.handleChangeNumber(e, "Amount")}
                                                            onBlur={e=>this.handleBlurNumber(e, "Amount")}
                                                            onInput={e=>this.handleInputNumber(e, "Amount")}
                                                            disabled={disabledX}
                                                          />
                                                        </Col>
                                                        <Col md="2">
                                                          <label htmlFor="Currency"><FormattedMessage id="contract.currency" /></label>
                                                          <FormSelect
                                                              id="Currency"
                                                              innerRef={this.c16FieldContract}
                                                              placeholder="Select Currency"
                                                              disabled={disabledX}
                                                            >
                                                            {currencyFiatX.map((todo, i) => {
                                                              let booleanFIACurrency = false
                                                              if (this.state.existContract === false && this.state.FIACurrency === `${todo.Ccy} - ${todo.CcyNm}`){
                                                                 booleanFIACurrency = true
                                                              }
                                                              return (
                                                                <option style={ this.props.colorDark ? {color:'orange'} : {color:'darkblue'}} key={i} value={`${todo.Ccy} - ${todo.CcyNm}`} selected={booleanFIACurrency}>{`${todo.Ccy} - ${todo.CcyNm}`}</option>
                                                              )
                                                            })}
                                                          </FormSelect>
                                                        </Col>

                                                        <Col md="6">
                                                          <label htmlFor="Signed" style={{ color: 'red' }}><FormattedMessage id="contract.signed" /></label>
                                                          { trimmedDataURLX
                                                            ?
                                                              <div>
                                                                <img src={this.state.trimmedDataURL} style={{ minWidth:100, maxWidth:350, minHeight:30, maxHeight:150, width:350, height:150}} />
                                                                <input type="hidden" ref={this.c26FieldContract} />
                                                              </div>
                                                            :
                                                              <FormTextarea
                                                                style={{fontSize:16}}
                                                                id="Signed"
                                                                innerRef={this.c26FieldContract}
                                                                placeholder=""
                                                                disabled={true}
                                                              />
                                                            }
                                                        </Col>
                                                        <Col md="1">&nbsp;</Col>
                                                      </Row>
                                                    </CardBody>
                                                </Card>
                                              </Col>
                                          </Row>
                                          <br></br>
                                        </Form>
                                      </Container>
                                    : null
                                    }
                                    { templateNameBlank
                                    ?
                                      <React.Fragment>
                                        <Form style={ this.props.colorDark ? { backgroundColor:'#0b151d', fontSize:12, color: 'black'} : {fontSize:12, backgroundColor:"#F2EACE"}}>
                                          <Row>&nbsp;</Row>
                                          <Row form>
                                              <Col md="1"></Col>
                                              <Col md="10">
                                                <Card style={{ backgroundColor:"#F2EACE" }}>
                                                    <Editor
                                                      editorState={editorState}
                                                      wrapperClassName="wrapper-class"
                                                      editorClassName="editor-class"
                                                      toolbarClassName="toolbar-class"
                                                      onContentStateChange={this.onContentStateChange}
                                                      onEditorStateChange={this.onEditorStateChange}
                                                      onChange={this.handleChangeEditor}
                                                      toolbar={{
                                                        history: { inDropdown: true },
                                                        image: {
                                                              uploadCallback: uploadImageCallBack,
                                                              previewImage: true,
                                                              alt: { present: true, mandatory: false },
                                                              inputAccept: 'image/gif,image/jpeg,image/jpg,image/png,image/svg',
                                                               },
                                                      }}
                                                    />
                                                    {displayWriteUp ?
                                                        <label htmlFor="Signed" style={{ color: 'red' }}><FormattedMessage id="contract.writeup" /></label>
                                                    : null }
                                                </Card>
                                              </Col>
                                              <Col md="1"></Col>

                                          </Row>
                                        </Form>
                                      </React.Fragment>
                                    :
                                      null
                                    }
                                    { templateNameSpreadsheet
                                    ?
                                      <React.Fragment>
                                        <Form style={ this.props.colorDark ? { backgroundColor:'#0b151d', fontSize:12, color: 'white'} : {fontSize:12, backgroundColor:"#F2EACE"}}>
                                          <Row>&nbsp;</Row>
                                          <Row form>
                                              <Col md="12">
                                                <Spreadsheet />
                                              </Col>
                                          </Row>
                                          <br></br>
                                        </Form>
                                      </React.Fragment>
                                    :
                                      null
                                    }
                                    { templateNameUploaded
                                    ?
                                      <React.Fragment>
                                       <Form style={ this.props.colorDark ? { backgroundColor:'#F2EACE', fontSize:12, color: 'white'} : {fontSize:12, backgroundColor:"#F2EACE"}}>
                                          <Row>&nbsp;</Row>
                                          {newUploadedX ?
                                            <Row form>
                                                <Col md="4">
                                                   <ContractUpload returnUploadContract={this.returnUploadContract}/>
                                                </Col>
                                                <Col md="8">
                                                  {this.state.seeAttachX ?
                                                    <Card small text-center>
                                                      <Col md="12">
                                                          <MyViewerPdf filedecodeAttachX={filedecodeAttachX} scale={scale} origen={'uploaded document'} />
                                                      </Col>
                                                      <br></br>
                                                    </Card>
                                                  :
                                                    <ContractLoader colorDark={this.props.colorDark}/>
                                                 }
                                                </Col>
                                            </Row>
                                          :
                                            <Row form>
                                              <Col md="12">
                                                {this.state.seeAttachX ?
                                                  <Card small text-center>
                                                    <Col md="12">
                                                        <MyViewerPdf filedecodeAttachX={filedecodeAttachX} scale={scale} />
                                                    </Col>
                                                    <br></br>
                                                  </Card>
                                                :
                                                  <ContractLoader colorDark={this.props.colorDark}/>
                                                }
                                              </Col>
                                            </Row>
                                          }
                                        </Form>
                                      </React.Fragment>
                                    :
                                      null
                                    }
                                    { templateNameProforma
                                    ?
                                      <Container style={ this.props.colorDark ? { backgroundColor:'#0b151d'} : {}}>
                                        <Form style={{fontSize:13}}>
                                          { displayCompanyLogoDataX ?
                                            <React.Fragment>
                                              <Row></Row>
                                              <Row form>
                                                  <Col md="1"></Col>
                                                  <Col md="10">
                                                    <Card style={{ maxWidth: "1200px", backgroundColor:"#F2EACE" }}>
                                                        <Table size="sm" borderless responsive>
                                                            <tbody>
                                                                <tr>
                                                                    {logoCompanyX ?
                                                                      <>
                                                                        <td style={{ width: "120px", textAlign:"left" }}>
                                                                           <img src={`${this.state.logoCompany}`} style={{maxWidth: "300px"}} />
                                                                        </td>
                                                                        {dataCompany2X ?
                                                                          <td style={{ width: "220px", textAlign:"right"}}>
                                                                             <div dangerouslySetInnerHTML={{__html: this.state.dataCompany2}} />
                                                                          </td>
                                                                        :
                                                                          null
                                                                        }
                                                                      </>
                                                                    :
                                                                      <>
                                                                        {dataCompany2X ?
                                                                          <td style={{ width: "220px", textAlign:"right" }}>
                                                                             <div dangerouslySetInnerHTML={{__html: this.state.dataCompany2}} />
                                                                          </td>
                                                                        :
                                                                          <>
                                                                            <td style={{ width: "220px", textAlign:"left" }}>
                                                                              <div className="fa fa-info-circle mx-2" style={{fontSize:10, color:'red'}}>
                                                                                &nbsp;
                                                                                <FormattedMessage id="contract.proformalogodata" />
                                                                              </div>
                                                                            </td>
                                                                          </>
                                                                        }
                                                                      </>
                                                                    }
                                                                </tr>
                                                            </tbody>
                                                        </Table>

                                                     </Card>
                                                  </Col>
                                                  <Col md="1"></Col>
                                               </Row>
                                             </React.Fragment>
                                          :
                                            <React.Fragment>
                                              <Row></Row>
                                              <Row form>
                                                  <Col md="1"></Col>
                                                  <Col md="10">
                                                    <Card style={{ maxWidth: "1200px", backgroundColor:"#F2EACE" }}>
                                                      <div className="fa fa-info-circle mx-2" style={{fontSize:10, color:'red'}}>
                                                        &nbsp;
                                                      </div>
                                                    </Card>
                                                  </Col>
                                              </Row>
                                            </React.Fragment>
                                          }
                                          <Row form>
                                              <Col md="1"></Col>
                                              <Col md="5">
                                                <Card style={{ maxWidth: "600px", backgroundColor:"#F2EACE" }}>
                                                   <CardHeader className="text-center" style={{fontSize:17, backgroundColor:"#F2EACE"}}><FormattedMessage id="contract.proformaSHIPPER" /></CardHeader>
                                                   <CardImg src="/images/lines-divider2.png" />
                                                   <CardBody>
                                                       <label style={{ color: 'Black', fontSize:9 }}><FormattedMessage id="contract.proformaname" /></label>
                                                       <InputGroup className="mb-2">
                                                         <FormInput
                                                             size="sm"
                                                             id="Name"
                                                             innerRef={this.c06FieldContract}
                                                             placeholder=""
                                                             disabled={disabledX}
                                                         />
                                                         <InputGroupAddon type="append">
                                                           <InputGroupText>
                                                             <strong style={{cursor: 'pointer'}} onClick={e=>this.proformaDeleteSender(e,disabledX)}><img src="images/deletex.png" weight="20" height="20" alt=""/></strong>
                                                           </InputGroupText>
                                                           <InputGroupText>
                                                             <strong style={{cursor: 'pointer'}} onClick={e=>this.proformaSearchSender(e)}><img src="images/searchUser.png" weight="20" height="20" alt=""/></strong>
                                                           </InputGroupText>
                                                         </InputGroupAddon>
                                                       </InputGroup>
                                                       {displayProformaSearchSenderX ?
                                                         <FormSelect
                                                             id="Description"
                                                             placeholder="Select an Option"
                                                             innerRef={this.c06FieldContractSearch}
                                                             onChange={this.handleChangeProformaSender}
                                                             disabled={disabledX}
                                                           >
                                                           <option value={`select`}>{placeholderX3}</option>
                                                           {jsonProformaSenderX.map((todo, key) => {
                                                               return (
                                                                <option style={this.props.colorDark ? {color:'orange'} : {color:'darkblue'}} key={key} value={`${todo.value}`}>{todo.value}</option>
                                                           )})}
                                                         </FormSelect>
                                                       : null }
                                                       <label style={{ color: 'Black', fontSize:9 }}><FormattedMessage id="contract.proformaCompanyName" /></label>
                                                       <FormInput
                                                         size="sm"
                                                         id="CompanyName"
                                                         innerRef={this.c07FieldContract}
                                                         placeholder=""
                                                         disabled={disabledX}
                                                       />
                                                       <label style={{ color: 'Black', fontSize:9 }}><FormattedMessage id="contract.proformaContactPerson" /></label>
                                                       <FormInput
                                                         size="sm"
                                                         id="ContactPerson"
                                                         innerRef={this.c08FieldContract}
                                                         placeholder=""
                                                         disabled={disabledX}
                                                       />
                                                       <label style={{ color: 'Black', fontSize:9 }}><FormattedMessage id="contract.proformaStreetAddress" /></label>
                                                       <FormInput
                                                         size="sm"
                                                         id="StreetAddress"
                                                         innerRef={this.c09FieldContract}
                                                         placeholder=""
                                                         disabled={disabledX}
                                                       />
                                                       <label style={{ color: 'Black', fontSize:9 }}><FormattedMessage id="contract.proformaCitySTZipCode" /></label>
                                                       <FormInput
                                                         size="sm"
                                                         id="CitySTZipCode"
                                                         innerRef={this.c10FieldContract}
                                                         placeholder=""
                                                         disabled={disabledX}
                                                       />
                                                       <label style={{ color: 'Black', fontSize:9 }}><FormattedMessage id="contract.proformaPhone" /></label>
                                                       <FormInput
                                                         size="sm"
                                                         id="Phone"
                                                         innerRef={this.c11FieldContract}
                                                         placeholder=""
                                                         disabled={disabledX}
                                                       />
                                                       <label style={{ color: 'Black', fontSize:9 }}><FormattedMessage id="contract.proformaeMail" /></label>
                                                       <FormInput
                                                         size="sm"
                                                         id="eMail"
                                                         innerRef={this.c12FieldContract}
                                                         placeholder=""
                                                         disabled={disabledX}
                                                       />
                                                   </CardBody>
                                                 </Card>
                                              </Col>
                                              <Col md="5">
                                                <Card style={{ maxWidth: "600px", backgroundColor:"#F2EACE" }}>
                                                   <CardHeader className="text-center" style={{fontSize:17, backgroundColor:"#F2EACE"}}><FormattedMessage id="contract.proformaRECEIVER" /></CardHeader>
                                                   <CardImg src="/images/lines-divider2.png" />
                                                   <CardBody>
                                                       <label style={{ color: 'Black', fontSize:9 }}><FormattedMessage id="contract.proformaname" /></label>
                                                       <InputGroup className="mb-2">
                                                         <FormInput
                                                             size="sm"
                                                             id="Name"
                                                             innerRef={this.c13FieldContract}
                                                             placeholder=""
                                                             disabled={disabledX}
                                                         />
                                                         <InputGroupAddon type="append">
                                                           <InputGroupText>
                                                             <strong style={{cursor: 'pointer'}} onClick={e=>this.proformaDeleteReceiver(e,disabledX)}><img src="images/deletex.png" weight="20" height="20" alt=""/></strong>
                                                           </InputGroupText>
                                                           <InputGroupText>
                                                             <strong style={{cursor: 'pointer'}} onClick={e=>this.proformaSearchReceiver(e)}><img src="images/searchUser.png" weight="20" height="20" alt=""/></strong>
                                                           </InputGroupText>
                                                         </InputGroupAddon>
                                                       </InputGroup>
                                                       {displayProformaSearchReceiverX ?
                                                         <FormSelect
                                                             id="Description"
                                                             placeholder="Select an Option"
                                                             innerRef={this.c13FieldContractSearch}
                                                             onChange={this.handleChangeProformaReceiver}
                                                             disabled={disabledX}
                                                           >
                                                           <option value={`select`}>{placeholderX3}</option>
                                                           {jsonProformaReceiverX.map((todo, key) => {
                                                               return (
                                                                <option style={this.props.colorDark ? {color:'orange'} : {color:'darkblue'}} key={key} value={`${todo.value}`}>{todo.value}</option>
                                                           )})}
                                                         </FormSelect>
                                                       : null }
                                                       <label style={{ color: 'Black', fontSize:9 }}><FormattedMessage id="contract.proformaCompanyName" /></label>
                                                       <FormInput
                                                         size="sm"
                                                         id="CompanyName"
                                                         innerRef={this.c14FieldContract}
                                                         placeholder=""
                                                         disabled={disabledX}
                                                       />
                                                       <label style={{ color: 'Black', fontSize:9 }}><FormattedMessage id="contract.proformaContactPerson" /></label>
                                                       <FormInput
                                                         size="sm"
                                                         id="ContactPerson"
                                                         innerRef={this.c15FieldContract}
                                                         placeholder=""
                                                         disabled={disabledX}
                                                       />
                                                       <label style={{ color: 'Black', fontSize:9 }}><FormattedMessage id="contract.proformaStreetAddress" /></label>
                                                       <FormInput
                                                         size="sm"
                                                         id="StreetAddress"
                                                         innerRef={this.c17FieldContract}
                                                         placeholder=""
                                                         disabled={disabledX}
                                                       />
                                                       <label style={{ color: 'Black', fontSize:9 }}><FormattedMessage id="contract.proformaCitySTZipCode" /></label>
                                                       <FormInput
                                                         size="sm"
                                                         id="CitySTZipCode"
                                                         innerRef={this.c18FieldContract}
                                                         placeholder=""
                                                         disabled={disabledX}
                                                       />
                                                       <label style={{ color: 'Black', fontSize:9 }}><FormattedMessage id="contract.proformaPhone" /></label>
                                                       <FormInput
                                                         size="sm"
                                                         id="Phone"
                                                         innerRef={this.c19FieldContract}
                                                         placeholder=""
                                                         disabled={disabledX}
                                                       />
                                                       <label style={{ color: 'Black', fontSize:9 }}><FormattedMessage id="contract.proformaeMail" /></label>
                                                       <FormInput
                                                         size="sm"
                                                         id="eMail"
                                                         innerRef={this.c20FieldContract}
                                                         placeholder=""
                                                         disabled={disabledX}
                                                       />
                                                   </CardBody>
                                                 </Card>
                                              </Col>
                                              <Col md="1"></Col>
                                          </Row>
                                          <Row form>
                                              <Col md="1"></Col>
                                              <Col md="10">
                                                <Card style={{ maxWidth: "1200px", backgroundColor:"#F2EACE" }}>
                                                   <CardBody>
                                                       <label style={{ color: 'Black', fontSize:9 }}><FormattedMessage id="contract.proformaReference" /></label>
                                                       <FormTextarea
                                                         size="sm"
                                                         id="Reference"
                                                         innerRef={this.c21FieldContract}
                                                         placeholder=""
                                                         disabled={disabledX}
                                                       />
                                                   </CardBody>
                                                 </Card>
                                              </Col>
                                              <Col md="1"></Col>
                                          </Row>
                                          <Row form>
                                              <Col md="1"></Col>
                                              <Col md="3">
                                                <Card style={{ maxWidth: "400px", backgroundColor:"#F2EACE" }}>
                                                   <CardBody>
                                                       <label style={{ color: 'Black', fontSize:9 }}><FormattedMessage id="contract.proformaModeofTransport" /></label>
                                                       <FormInput
                                                         size="sm"
                                                         id="ModeofTransport"
                                                         innerRef={this.c22FieldContract}
                                                         placeholder=""
                                                         disabled={disabledX}
                                                       />
                                                   </CardBody>
                                                 </Card>
                                              </Col>
                                              <Col md="4">
                                                <Card style={{ maxWidth: "500px", backgroundColor:"#F2EACE" }}>
                                                   <CardBody>
                                                       <label style={{ color: 'Black', fontSize:9 }}><FormattedMessage id="contract.proformaTotalNumberofPackages" /></label>
                                                       <FormInput
                                                         size="sm"
                                                         id="TotalNumberofPackages"
                                                         innerRef={this.c23FieldContract}
                                                         placeholder=""
                                                         disabled={disabledX}
                                                       />
                                                   </CardBody>
                                                 </Card>
                                              </Col>
                                              <Col md="3">
                                                <Card style={{ maxWidth: "400px", backgroundColor:"#F2EACE" }}>
                                                   <CardBody>
                                                       <label style={{ color: 'Black', fontSize:9 }}><FormattedMessage id="contract.proformaTotalGrossWeight" /></label>
                                                       <FormInput
                                                         size="sm"
                                                         id="TotalGrossWeight"
                                                         innerRef={this.c24FieldContract}
                                                         placeholder=""
                                                         disabled={disabledX}
                                                       />
                                                   </CardBody>
                                                 </Card>
                                              </Col>
                                              <Col md="1"></Col>
                                          </Row>
                                          <Row form>
                                              <Col md="1"></Col>
                                              <Col md="10">
                                                <Card style={{ maxWidth: "1200px", backgroundColor:"#F2EACE" }}>
                                                   <CardBody>
                                                     {displayRoleX ?
                                                         <Table size="sm" borderless responsive>
                                                             <tbody>
                                                                 <tr>
                                                                     <td style={{ width: "20px" }}>
                                                                        <label style={{ color: 'Black', fontSize:9 }}><FormattedMessage id="contract.proformaProductId" /></label>
                                                                         <FormInput
                                                                           size="sm"
                                                                           id="ProductID"
                                                                           innerRef={this.c25FieldContract}
                                                                           placeholder=""
                                                                           disabled={disabledX}
                                                                         />
                                                                     </td>
                                                                     <td style={{ width: "120px" }}>
                                                                         <label style={{ color: 'Black', fontSize:9 }}><FormattedMessage id="contract.proformaDescription" /></label>
                                                                         <FormInput
                                                                           size="sm"
                                                                           id="Description"
                                                                           innerRef={this.c40FieldContract}
                                                                           placeholder=""
                                                                           disabled={disabledX}
                                                                         />
                                                                     </td>
                                                                     <td style={{ width: "20px" }}>
                                                                         <label style={{ color: 'Black', fontSize:9 }}><FormattedMessage id="contract.proformaQuantity" /></label>
                                                                         <FormInput
                                                                           size="sm"
                                                                           type="text"
                                                                           id="Quantity"
                                                                           innerRef={this.c27FieldContract}
                                                                           onChange={e=>this.handleChange(e, "Quantity")}
                                                                           placeholder=""
                                                                           disabled={disabledX}
                                                                         />
                                                                     </td>
                                                                     <td style={{ width: "20px" }}>
                                                                         <label style={{ color: 'Black', fontSize:9 }}><FormattedMessage id="contract.proformaUnitPrice" /></label>
                                                                         <FormInput
                                                                           size="sm"
                                                                           type="text"
                                                                           id="UnitPrice"
                                                                           innerRef={this.c28FieldContract}
                                                                           onChange={e=>this.handleChange(e, "UnitPrice")}
                                                                           placeholder=""
                                                                           disabled={disabledX}
                                                                         />
                                                                     </td>
                                                                     {this.state.ningunoSign ?
                                                                      <React.Fragment>
                                                                        <td style={{ width: "20px" }}>
                                                                            <label style={{ color: 'Black', fontSize:9 }}>&nbsp;</label>
                                                                            <br></br>
                                                                            {this.state.modifyItemProformaDetail ?
                                                                              <Button pill theme="warning" onClick={e=>this.modifyDetail(e,templateName)}>---<FormattedMessage id="configuration.update" />---</Button>
                                                                            :
                                                                              <Button pill theme="warning" onClick={e=>this.newDetail(e,templateName)}>---<FormattedMessage id="contract.add" />---</Button>
                                                                            }
                                                                        </td>
                                                                      </React.Fragment>
                                                                     :
                                                                      <td style={{ width: "20px" }}></td>
                                                                     }
                                                                 </tr>
                                                             </tbody>
                                                         </Table>
                                                     : null }
                                                     <Table size="sm" className="text-center" responsive hover striped style={{ color: 'black', fontSize:11 }}>
                                                         <thead>
                                                           <tr>
                                                             {displayRoleX ?
                                                               <>
                                                                 {this.state.ningunoSign ?
                                                                   <>
                                                                      <th style={{ width: "20px" }}><FormattedMessage id="contract.proformaEdit" /></th>
                                                                      <th style={{ width: "20px" }}><FormattedMessage id="contract.proformaDelete" /></th>
                                                                   </>
                                                                 : null }
                                                               </>
                                                             : null }
                                                             <th style={{ width: "30px" }}>#</th>
                                                             <th style={{ width: "30px" }}><FormattedMessage id="contract.proformaPRODUCTID" /></th>
                                                             <th style={{ width: "120px" }}><FormattedMessage id="contract.proformaDESCRIPTION" /></th>
                                                             <th style={{ width: "20px" }}><FormattedMessage id="contract.proformaQUANTITY" /></th>
                                                             <th style={{ width: "20px" }}><FormattedMessage id="contract.proformaUNITPRICE" /></th>
                                                             <th style={{ width: "20px" }}><FormattedMessage id="contract.proformaTOTAL" /></th>
                                                           </tr>
                                                         </thead>
                                                         <tbody>
                                                           {jsonProformaDetail.map((todo, i) => {
                                                             correlativo = i
                                                             let totalProformaDetail = parseFloat(todo.quantity) * parseFloat(todo.unitprice)
                                                             totalProformaDetail = totalProformaDetail.toFixed(2)
                                                             return (
                                                                 <tr key={i}>
                                                                   {displayRoleX ?
                                                                     <>
                                                                       {this.state.ningunoSign ?
                                                                         <>
                                                                           <td><Button pill theme="success" onClick={e=>this.editProformaDetailConfirm(e,i)}><FontAwesomeIcon icon={faEdit} style={{color:"yellow"}} /></Button></td>
                                                                           <td><Button pill theme="danger" onClick={e=>this.deleteProformaDetailConfirm(e,i)}><FontAwesomeIcon icon={faTimes} /></Button></td>
                                                                         </>
                                                                       :
                                                                         null
                                                                       }
                                                                     </>
                                                                   :
                                                                     null
                                                                   }
                                                                   <td>{++correlativo}</td>
                                                                   <td>{todo.productid}</td>
                                                                   <td>{todo.description}</td>
                                                                   <td>{todo.quantity}</td>
                                                                   <td>{todo.unitprice}</td>
                                                                   <td style={{textAlign: 'right'}}>{totalProformaDetail}</td>
                                                                 </tr>
                                                              )})}
                                                         </tbody>
                                                     </Table>
                                                     <Table size="sm" borderless responsive style={{ color: 'Black', fontSize:10 }}>
                                                         <thead>
                                                           <tr>
                                                             <th style={{ width: "20px" }}></th>
                                                             <th style={{ width: "20px" }}></th>
                                                             <th style={{ width: "30px" }}></th>
                                                             <th style={{ width: "30px" }}></th>
                                                             <th style={{ width: "120px"}}></th>
                                                             <th style={{ width: "20px" }}></th>
                                                             <th style={{ width: "20px" }}></th>
                                                             <th style={{ width: "40px" }}></th>
                                                           </tr>
                                                         </thead>
                                                         <tbody>
                                                             <tr>
                                                                 <td></td>
                                                                 <td></td>
                                                                 <td></td>
                                                                 <td></td>
                                                                 <td></td>
                                                                 <td></td>
                                                                 <td><FormattedMessage id="contract.proformaSUBTOTAL" /></td>
                                                                 <td>
                                                                     <FormInput
                                                                       size="sm"
                                                                       type="text"
                                                                       id="Subtotal"
                                                                       innerRef={this.c29FieldContract}
                                                                       placeholder=""
                                                                       disabled={true}
                                                                       style={{textAlign: 'right'}}
                                                                     />
                                                                 </td>
                                                             </tr>
                                                             <tr>
                                                                 <td></td>
                                                                 <td></td>
                                                                 <td></td>
                                                                 <td></td>
                                                                 <td></td>
                                                                 <td></td>
                                                                 <td><FormattedMessage id="contract.proformaDISCOUNT" /></td>
                                                                 <td>
                                                                     <FormInput
                                                                       size="sm"
                                                                       type="text"
                                                                       id="Discount"
                                                                       innerRef={this.c30FieldContract}
                                                                       placeholder=""
                                                                       disabled={disabledX}
                                                                       onChange={e=>this.handleChange(e, "Discount")}
                                                                       style={{textAlign: 'right'}}
                                                                     />
                                                                 </td>
                                                             </tr>
                                                             <tr>
                                                                 <td></td>
                                                                 <td></td>
                                                                 <td></td>
                                                                 <td></td>
                                                                 <td></td>
                                                                 <td></td>
                                                                 <td><FormattedMessage id="contract.proformaTAXRATE" /></td>
                                                                 <td>
                                                                     <FormInput
                                                                       size="sm"
                                                                       type="text"
                                                                       id="TaxRate"
                                                                       innerRef={this.c31FieldContract}
                                                                       placeholder=""
                                                                       disabled={true}
                                                                       style={{textAlign: 'right'}}
                                                                     />
                                                                 </td>
                                                             </tr>
                                                             <tr>
                                                                 <td></td>
                                                                 <td></td>
                                                                 <td></td>
                                                                 <td></td>
                                                                 <td></td>
                                                                 <td></td>
                                                                 <td><FormattedMessage id="contract.proformaSALESRATE" /></td>
                                                                 <td>
                                                                     <FormInput
                                                                       size="sm"
                                                                       type="text"
                                                                       id="SalesRate"
                                                                       innerRef={this.c32FieldContract}
                                                                       placeholder=""
                                                                       disabled={true}
                                                                       style={{textAlign: 'right'}}
                                                                     />
                                                                 </td>
                                                             </tr>
                                                             <tr>
                                                                 <td></td>
                                                                 <td></td>
                                                                 <td></td>
                                                                 <td></td>
                                                                 <td></td>
                                                                 <td></td>
                                                                 <td><FormattedMessage id="contract.proformaSHIPPINGANDHANDLING" /></td>
                                                                 <td>
                                                                     <FormInput
                                                                       size="sm"
                                                                       type="text"
                                                                       id="Shipping"
                                                                       innerRef={this.c33FieldContract}
                                                                       placeholder=""
                                                                       disabled={disabledX}
                                                                       onChange={e=>this.handleChange(e, "Shipping")}
                                                                       style={{textAlign: 'right'}}
                                                                     />
                                                                 </td>
                                                             </tr>
                                                             <tr>
                                                                 <td></td>
                                                                 <td></td>
                                                                 <td></td>
                                                                 <td></td>
                                                                 <td>
                                                                    <FormSelect
                                                                         id="Currency"
                                                                         style={ this.props.colorDark ? { backgroundColor:'#F2EACE', color:'darkblue'} : {}}
                                                                         innerRef={this.c16FieldContract}
                                                                         placeholder="Select Currency"
                                                                         disabled={disabledX}
                                                                       >
                                                                       {currencyFiatX.map((todo, i) => {
                                                                         return (
                                                                           <option style={this.props.colorDark ? {color:'darkblue'} : {color:'darkblue'}} key={i} value={`${todo.Ccy} - ${todo.CcyNm}`}>{`${todo.Ccy} - ${todo.CcyNm}`}</option>
                                                                         )
                                                                       })}
                                                                     </FormSelect>
                                                                 </td>
                                                                 <td></td>
                                                                 <td><FormattedMessage id="contract.proformaTOTAL" /></td>
                                                                 <td>
                                                                     <FormInput
                                                                       size="sm"
                                                                       type="text"
                                                                       id="Total"
                                                                       innerRef={this.c34FieldContract}
                                                                       placeholder=""
                                                                       disabled={true}
                                                                       style={{textAlign: 'right'}}
                                                                     />
                                                                 </td>
                                                             </tr>
                                                         </tbody>
                                                     </Table>
                                                   </CardBody>
                                                 </Card>
                                              </Col>
                                              <Col md="1"></Col>
                                          </Row>
                                          <Row form>
                                              <Col md="1"></Col>
                                              <Col md="5">
                                                <Card style={{ maxWidth: "600px", backgroundColor:"#F2EACE" }}>
                                                   <CardHeader className="text-center" style={{fontSize:17, backgroundColor:"#F2EACE"}}><FormattedMessage id="contract.proformaADDITIONALDETAILS" /></CardHeader>
                                                   <CardImg src="/images/lines-divider2.png" />
                                                   <CardBody>
                                                       <label style={{ color: 'Black', fontSize:9 }}><FormattedMessage id="contract.proformaCountryofOrigin" /></label>
                                                       <FormInput
                                                         size="sm"
                                                         id="Country"
                                                         innerRef={this.c35FieldContract}
                                                         placeholder=""
                                                         disabled={disabledX}
                                                       />
                                                       <label style={{ color: 'Black', fontSize:9 }}><FormattedMessage id="contract.proformaPortofEmbarcation" /></label>
                                                       <FormInput
                                                         size="sm"
                                                         id="Embarcation"
                                                         innerRef={this.c36FieldContract}
                                                         placeholder=""
                                                         disabled={disabledX}
                                                       />
                                                       <label style={{ color: 'Black', fontSize:9 }}><FormattedMessage id="contract.proformaPortofDischarge" /></label>
                                                       <FormInput
                                                         size="sm"
                                                         id="Discharge"
                                                         innerRef={this.c37FieldContract}
                                                         placeholder=""
                                                         disabled={disabledX}
                                                       />
                                                       <label style={{ color: 'Black', fontSize:9 }}><FormattedMessage id="contract.proformaReasonforExport" /></label>
                                                       <FormInput
                                                         size="sm"
                                                         id="Export"
                                                         innerRef={this.c38FieldContract}
                                                         placeholder=""
                                                         disabled={disabledX}
                                                       />
                                                   </CardBody>
                                                 </Card>
                                              </Col>
                                              <Col md="5">
                                                <Card style={{ maxWidth: "600px", backgroundColor:"#F2EACE" }}>
                                                   <CardHeader className="text-center" style={{fontSize:17, backgroundColor:"#F2EACE"}}><FormattedMessage id="contract.proformaTERMSALEOTHERCOMMENTS" /></CardHeader>
                                                   <CardImg src="/images/lines-divider2.png" />
                                                   <CardBody>
                                                       <label style={{ color: 'Black', fontSize:9 }}><FormattedMessage id="contract.proformaTermSaleOtherComments" /></label>
                                                       <FormTextarea
                                                         size="sm"
                                                         id="TermofSale"
                                                         innerRef={this.c39FieldContract}
                                                         placeholder=""
                                                         disabled={disabledX}
                                                       />
                                                       <br></br>
                                                       <label htmlFor="Signed" style={{ color: 'red' }}><FormattedMessage id="contract.signed" /></label>
                                                       { trimmedDataURLX
                                                         ?
                                                           <div>
                                                             <img src={this.state.trimmedDataURL} style={{ minWidth:100, maxWidth:350, minHeight:30, maxHeight:150, width:350, height:150}} />
                                                             <input type="hidden" ref={this.c26FieldContract} />
                                                           </div>
                                                         :
                                                           <FormTextarea
                                                             style={{fontSize:16}}
                                                             id="Signed"
                                                             innerRef={this.c26FieldContract}
                                                             placeholder=""
                                                             disabled={true}
                                                           />
                                                         }
                                                       <br></br>
                                                   </CardBody>

                                                 </Card>
                                              </Col>
                                              <Col md="1"></Col>
                                          </Row>
                                        </Form>
                                      </Container>

                                    : null
                                    }
                                  </Card>

                                  <Card small style={ this.props.colorDark ? { backgroundColor:'#111f2c', color:'white'} : {}}>
                                    <ListGroup style={{'color': 'black'}} flush>
                                      <ListGroupItem className="p-3" style={ this.props.colorDark ? { backgroundColor:'#111f2c', color:'white'} : {'color': 'black'}}>
                                      <h5 style={{ color: 'red' }}>{configuration2X}</h5>
                                      <Form style={{fontSize:13}}>
                                        <Row>
                                          {/*}<Col md="3">
                                            <label htmlFor="ConfigurationContracType"><FormattedMessage id="contract.contracttype" /></label>
                                            <FormInput
                                              style={{fontSize:20}}
                                              id="ConfigurationContracType"
                                              innerRef={this.c10ConfigurationContract}
                                              alt={templateName}
                                              disabled={true}
                                            />
                                          </Col>
                                          <Col md="1"></Col>*/}
                                          <Col md="3">
                                            {this.messageExistContract()}
                                            {!this.state.statusActive2
                                              ?
                                                <Card theme="danger" style={{ color: "white" }}>
                                                  <table>
                                                    <tbody>
                                                      <tr>
                                                        <td>
                                                          <div className="fa fa-info-circle mx-2"></div>
                                                        </td>
                                                        <td>
                                                          <FormattedMessage id="contract.deletedordeactivated" />
                                                        </td>
                                                      </tr>
                                                    </tbody>
                                                  </table>
                                                </Card>
                                              :
                                                <label htmlFor="ConfigurationContractNumber" style={{color:"red"}}><FormattedMessage id="contract.contractnumberrequired" /></label>
                                            }

                                            <FormInput
                                              id="ConfigurationContractNumber"
                                              style={ this.props.colorDark ? { backgroundColor:'#111f2c', fontSize:20, color:'white'} : {fontSize:20}}
                                              innerRef={this.c02ConfigurationContract}
                                              placeholder=""
                                              disabled={this.state.existContract}
                                              onChange={e=>this.handleContractNumber(e)}
                                            />

                                          </Col>
                                          <Col md="1"></Col>
                                          <Col md="3">
                                            <label htmlFor="StartDate" style={{color:"red"}}><FormattedMessage id="contract.startdaterequired" /></label>
                                            <br></br>
                                            <DatePicker
                                              id="StartDate"
                                              style={ this.props.colorDark ? { backgroundColor:'#111f2c', color:'white'} : {}}
                                              dateFormat={this.state.dateFormatX}
                                              innerRef={this.startDate}
                                              placeholder=""
                                              disabled={disabledX}
                                              //size="sm"
                                              selected={this.state.startDate}
                                              onChange={val=>this.handleDate(val,'startDateX')}
                                              dropdownMode="select"
                                            />
                                          </Col>
                                          <Col md="1"></Col>
                                          <Col md="3">
                                            <label htmlFor="EndDate" style={{color:"red"}}><FormattedMessage id="contract.enddaterequired" /></label>
                                            <br></br>
                                            <DatePicker
                                              id="EndDate"
                                              style={ this.props.colorDark ? { backgroundColor:'#111f2c', color:'white'} : {}}
                                              dateFormat={this.state.dateFormatX}
                                              innerRef={this.endDate}
                                              disabled={disabledX}
                                              placeholder=""
                                              //size="sm"
                                              selected={this.state.endDate}
                                              onChange={val=>this.handleDate(val,'endDateX')}
                                              dropdownMode="select"
                                            />
                                          </Col>
                                          <Col md="1"></Col>
                                        </Row>
                                        <br></br>

                                        <Row form>
                                          <Col md="6">
                                            <label htmlFor="Subject" style={{ color: 'red' }}><FormattedMessage id="contract.listcol5" /></label>
                                            <FormTextarea
                                              id="Subject"
                                              style={ this.props.colorDark ? { backgroundColor:'#111f2c', color:'white'} : {}}
                                              innerRef={this.c09ConfigurationContract}
                                              onChange={e=>this.handleCaracteresEspeciales(e)}
                                              placeholder=""
                                              disabled={disabledX}
                                            />
                                          </Col>
                                          <Col md="1"></Col>
                                          { templateNameDelivery ?
                                            <Col md="3">
                                              <label htmlFor="TypeBillLading" style={{color:"red"}}><FormattedMessage id="contract.associatedtorequired" /></label>
                                              <FormSelect
                                                  id="TypeBillLading"
                                                  style={ this.props.colorDark ? { backgroundColor:'#111f2c', color:'white'} : {}}
                                                  innerRef={this.c04FieldContract}
                                                  placeholder="Select an Option"
                                                  disabled={disabledX}
                                                >
                                               <option style={this.props.colorDark ? {color:'orange'} : {color:'darkblue'}} value="Container" defaultValue>{associatedToX}</option>
                                              </FormSelect>
                                            </Col>
                                          : null
                                          }
                                          { templateNameMaintenance ?
                                            <Col md="3">
                                              <label htmlFor="TypeBillLading" style={{color:"red"}}><FormattedMessage id="contract.associatedtorequired" /></label>
                                              {disabledX
                                              ?
                                                <FormInput
                                                    id="TypeBillLading"
                                                    style={ this.props.colorDark ? { backgroundColor:'#111f2c', color:'white'} : {}}
                                                    innerRef={this.c04FieldContract}
                                                    disabled={disabledX}
                                                />
                                              :
                                                <FormSelect
                                                    id="TypeBillLading"
                                                    style={ this.props.colorDark ? { backgroundColor:'#111f2c', color:'white'} : {}}
                                                    innerRef={this.c04FieldContract}
                                                    placeholder="Select an Option"
                                                    disabled={disabledX}
                                                >
                                                    {jsonAssociatedToMaintenanceX.map((todo,t)=>{
                                                      if (this.state.codeAssociatedToMaintenance === todo.code) {
                                                        return (
                                                           <option style={this.props.colorDark ? {color:'orange'} : {color:'darkblue'}} key={t} value={`${todo.code}#$%${todo.description}`} selected>{todo.description}</option>
                                                        )
                                                      }else{
                                                        return (
                                                           <option style={this.props.colorDark ? {color:'orange'} : {color:'darkblue'}} key={t} value={`${todo.code}#$%${todo.description}`}>{todo.description}</option>
                                                        )
                                                      }
                                                    })}
                                                </FormSelect>
                                              }
                                            </Col>
                                          : null
                                          }
                                          <Col md="1"></Col>
                                        </Row>
                                        <br></br>
                                        <Row form>
                                        { displayDataPaymentX ?
                                          <>
                                          <Col md="3">
                                            <label htmlFor="ScopeContract" style={{color:"red"}}><FormattedMessage id="contract.scopecontract" /></label>
                                            <InputGroupAddon style={ this.props.colorDark ? { backgroundColor:'#F2EACE', color: 'Black'} : {color: 'Black'  }}>
                                              <InputGroupText style={ this.props.colorDark ? { backgroundColor:'#F2EACE', color: 'Black'} : {color: 'Black'  }}>
                                                <FormRadio
                                                  name="SignatureOnly"
                                                  checked={this.state.selectedSignaturePayment === "SignatureOnly"}
                                                  disabled={disabled3X}
                                                  onChange={() => {
                                                    this.handleChangeOption("SignatureOnly",disabled3X);
                                                  }}
                                                >
                                                  <FormattedMessage id="contract.onlysign" />
                                                </FormRadio>
                                                &nbsp;&nbsp;
                                                <FormRadio
                                                  name="SignatureAndPayment"
                                                  checked={this.state.selectedSignaturePayment === "SignatureAndPayment"}
                                                  disabled={disabled3X}
                                                  onChange={() => {
                                                    this.handleChangeOption("SignatureAndPayment",disabled3X);
                                                  }}
                                                >
                                                  <FormattedMessage id="contract.signandpay" />
                                                </FormRadio>

                                              </InputGroupText>
                                            </InputGroupAddon>
                                          </Col>
                                          <Col md="1"></Col>
                                              <Col md="2">
                                                <label htmlFor="Amount" style={{color:"red"}}><FormattedMessage id="contract.amount" /></label>
                                                <FormInput
                                                  id="Amount"
                                                  type="number"
                                                  style={ this.props.colorDark ? { backgroundColor:'#111f2c', color:'white'} : {}}
                                                  innerRef={this.c20FieldContract}
                                                  placeholder=""
                                                  onChange={e=>this.handleChangeNumber(e, "Amount")}
                                                  onBlur={e=>this.handleBlurNumber(e, "Amount")}
                                                  onInput={e=>this.handleInputNumber(e, "Amount")}
                                                  disabled={disabled2X}
                                                />
                                              </Col>
                                              <Col md="1"></Col>
                                              <Col md="2">
                                                <label htmlFor="CryptoFiat" style={{color:"red"}}><FormattedMessage id="contract.currencytype" /></label>
                                                <FormSelect
                                                    id="CryptoFiat"
                                                    style={ this.props.colorDark ? { backgroundColor:'#111f2c', color:'white'} : {}}
                                                    innerRef={this.c60FieldContract}
                                                    placeholder="Currency Type"
                                                    disabled={disabled2X}
                                                    onChange={e=>this.handleChangeCriptoFIAT(e)}
                                                  >
                                                    <option style={this.props.colorDark ? {color:'orange'} : {color:'darkblue'}} value={`FIAT Money`}>{`FIAT Money`}</option>
                                                    <option style={this.props.colorDark ? {color:'orange'} : {color:'darkblue'}} value={`CryptoCurrency`}>{`Crypto Currency`}</option>
                                                </FormSelect>
                                              </Col>
                                              <Col md="1"></Col>
                                              <Col md="2">
                                                {currencyTypeX ?
                                                  <>
                                                    <label htmlFor="Currency" style={{color:"red"}}><FormattedMessage id="contract.currency" /></label>
                                                    <FormSelect
                                                        id="Currency"
                                                        style={ this.props.colorDark ? { backgroundColor:'#111f2c', color:'white'} : {}}
                                                        innerRef={this.c16FieldContract}
                                                        placeholder="Preferred Currency"
                                                        disabled={disabled2X}
                                                      >
                                                      {currencyFiatX.map((todo, i) => {
                                                        if (this.state.FIACurrency === `${todo.Ccy} - ${todo.CcyNm}`){
                                                          return (
                                                             <option selected style={this.props.colorDark ? {color:'orange'} : {color:'darkblue'}} key={i} value={`${todo.Ccy} - ${todo.CcyNm}`}>{`${todo.Ccy} - ${todo.CcyNm}`}</option>
                                                          )
                                                        }else{
                                                          return (
                                                             <option style={this.props.colorDark ? {color:'orange'} : {color:'darkblue'}} key={i} value={`${todo.Ccy} - ${todo.CcyNm}`}>{`${todo.Ccy} - ${todo.CcyNm}`}</option>
                                                          )
                                                        }
                                                      })}
                                                    </FormSelect>
                                                  </>
                                                :
                                                  <>
                                                    <label htmlFor="Currency" style={{color:"red"}}><FormattedMessage id="contract.currency" /></label>
                                                    <FormSelect
                                                        id="Currency"
                                                        style={ this.props.colorDark ? { backgroundColor:'#111f2c', color:'white'} : {}}
                                                        innerRef={this.c16FieldContract}
                                                        placeholder="Preferred Currency"
                                                        disabled={disabled2X}
                                                      >
                                                      {currencyCryptoX.map((todo, i) => {
                                                        if (this.state.cryptoCurrencyOrigin === `${todo.Ccy} - ${todo.CcyNm}`){
                                                          return (
                                                             <option selected style={this.props.colorDark ? {color:'orange'} : {color:'darkblue'}} key={i} value={`${todo.Ccy} - ${todo.CcyNm}`}>{`${todo.Ccy} - ${todo.CcyNm}`}</option>
                                                          )
                                                        }else{
                                                          return (
                                                             <option style={this.props.colorDark ? {color:'orange'} : {color:'darkblue'}} key={i} value={`${todo.Ccy} - ${todo.CcyNm}`}>{`${todo.Ccy} - ${todo.CcyNm}`}</option>
                                                          )
                                                        }
                                                      })}
                                                    </FormSelect>
                                                  </>
                                                }
                                              </Col>
                                            </>
                                          : null }
                                        </Row>
                                        <br></br>

                                        <Row form>
                                          { templateNameBlank ?
                                            <Col md="4">
                                              <label htmlFor="Signed" style={{ color: 'red' }}><FormattedMessage id="contract.signed" /></label>
                                              { trimmedDataURLX
                                                ?
                                                  <div>
                                                    <img src={this.state.trimmedDataURL} style={{ minWidth:100, maxWidth:350, minHeight:30, maxHeight:150, width:350, height:150}} />
                                                    <input type="hidden" ref={this.c26FieldContract} />
                                                  </div>
                                                :
                                                  <FormTextarea
                                                    style={ this.props.colorDark ? { backgroundColor:'#111f2c', color:'white', fontSize:16} : {fontSize:16}}
                                                    id="Signed"
                                                    innerRef={this.c26FieldContract}
                                                    placeholder=""
                                                    disabled={true}
                                                  />
                                                }
                                            </Col>
                                          : null
                                          }
                                          { templateNameSpreadsheet ?
                                            <Col md="4">
                                              <label htmlFor="Signed" style={{ color: 'red' }}><FormattedMessage id="contract.signed" /></label>
                                              { trimmedDataURLX
                                                ?
                                                  <div>
                                                    <img src={this.state.trimmedDataURL} style={{ minWidth:100, maxWidth:350, minHeight:30, maxHeight:150, width:350, height:150}} />
                                                    <input type="hidden" ref={this.c26FieldContract} />
                                                  </div>
                                                :
                                                  <FormTextarea
                                                    style={ this.props.colorDark ? { backgroundColor:'#111f2c', color:'white', fontSize:16} : {fontSize:16}}
                                                    id="Signed"
                                                    innerRef={this.c26FieldContract}
                                                    placeholder=""
                                                    disabled={true}
                                                  />
                                                }
                                            </Col>
                                          : null
                                          }
                                          { templateNameUploaded ?
                                            <Col md="4">
                                              <label htmlFor="Signed" style={{ color: 'red' }}><FormattedMessage id="contract.signed" /></label>
                                              { trimmedDataURLX
                                                ?
                                                  <div>
                                                    <img src={this.state.trimmedDataURL} style={{ minWidth:100, maxWidth:350, minHeight:30, maxHeight:150, width:350, height:150}} />
                                                    <input type="hidden" ref={this.c26FieldContract} />
                                                  </div>
                                                :
                                                  <FormTextarea
                                                    style={ this.props.colorDark ? { backgroundColor:'#111f2c', fontSize:16} : {fontSize:16}}
                                                    id="Signed"
                                                    innerRef={this.c26FieldContract}
                                                    placeholder=""
                                                    disabled={true}
                                                  />
                                                }
                                            </Col>
                                          : null
                                          }
                                        </Row>
                                        <br></br>

                                        <Row form>
                                          <Col>
                                            <Row form style={{fontSize:9}}>
                                              <Col md="3">
                                                <label htmlFor="ConfigurationContractPactId" style={ this.props.colorDark ? { color:'orange'} : {}}>(Smart Contract Address)</label>
                                                <FormInput
                                                  id="ConfigurationContractPactId"
                                                  style={ this.props.colorDark ? { backgroundColor:'#111f2c', fontSize:9, color:'grey'} : {fontSize:9, color:'blue'}}
                                                  innerRef={this.c06ConfigurationContract}
                                                  placeholder=""
                                                  disabled={true}
                                                />
                                              </Col>
                                              <Col md="1"></Col>
                                              <Col md="3">
                                                <label htmlFor="ConfigurationPublishStatus" style={ this.props.colorDark ? { color:'orange'} : {}}><FormattedMessage id="contract.listcol26" /></label>
                                                <FormInput
                                                  id="ConfigurationPublishStatus"
                                                  style={ this.props.colorDark ? { backgroundColor:'#111f2c', fontSize:9, color:'grey'} : {fontSize:9, color:'blue'}}
                                                  innerRef={this.c07ConfigurationContract}
                                                  placeholder=""
                                                  disabled={true}
                                                />
                                              </Col>
                                              <Col md="1"></Col>
                                              <Col md="4">
                                                <label htmlFor="ConfigurationLifeCycleStatus" style={ this.props.colorDark ? { color:'orange'} : {}}><FormattedMessage id="contract.listcol8" /></label>
                                                <FormInput
                                                  id="ConfigurationLifeCycleStatus"
                                                  style={ this.props.colorDark ? { backgroundColor:'#111f2c', fontSize:9, color:'grey'} : {fontSize:9, color:'blue'}}
                                                  innerRef={this.c08ConfigurationContract}
                                                  placeholder=""
                                                  disabled={true}
                                                />
                                              </Col>
                                            </Row>
                                            <br></br>
                                            { templateNameDelivery ?
                                              <Row form>
                                                <Col md="3">
                                                   <FormCheckbox
                                                        inline
                                                        checked={this.state.c03ConfigurationContract}
                                                        onChange={e=>this.handleChange(e, "c03ConfigurationContract")}
                                                        disabled={this.state.existContract}
                                                        placeholder="Enable GPS"
                                                    >
                                                        <FormattedMessage id="contract.transportorigindestination" />
                                                    </FormCheckbox>
                                                </Col>
                                                <Col md="3">
                                                    <FormCheckbox
                                                        inline
                                                        checked={this.state.c04ConfigurationContract}
                                                        onChange={e=>this.handleChange(e, "c04ConfigurationContract")}
                                                        disabled={this.state.existContract}
                                                        placeholder="Enable Other Sensors (example: Temperature, Humidity)"
                                                    >
                                                        <FormattedMessage id="contract.conditionsintegritymaterials" />
                                                    </FormCheckbox>
                                                </Col>
                                                <Col md="3">
                                                    <FormCheckbox
                                                        inline
                                                        checked={this.state.c05ConfigurationContract}
                                                        onChange={e=>this.handleChange(e, "c05ConfigurationContract")}
                                                        disabled={this.state.existContract}
                                                    >
                                                        <FormattedMessage id="contract.useofassets" />
                                                    </FormCheckbox>
                                                </Col>
                                              </Row>
                                            :
                                              null
                                            }
                                          </Col>
                                          </Row>
                                        <Row>
                                        <FormInput
                                          type="hidden"
                                          style={ this.props.colorDark ? { backgroundColor:'#111f2c'} : {}}
                                          style={{fontSize:20}}
                                          id="ConfigurationContracType"
                                          innerRef={this.c10ConfigurationContract}
                                          alt={templateName}
                                          disabled={true}
                                        />
                                        </Row>
                                      </Form>
                                    </ListGroupItem>
                                    </ListGroup>
                                  </Card>

                                  {displayActions ?
                                      <Card small style={ this.props.colorDark ? { backgroundColor:'#111f2c'} : {}}>
                                        <ListGroup flush>
                                          <ListGroupItem className="p-3" style={ this.props.colorDark ? { backgroundColor:'#111f2c'} : {}}>
                                            {this.state.sExistContract ?
                                               <h5 style={{ color: 'red' }}>{actionsX}</h5>
                                             : <h5 style={{ color: 'red' }}>{actionsX}</h5> }
                                               <Card small className="mb-12 pt-3" style={ this.props.colorDark ? { backgroundColor:'#111f2c'} : {}}>
                                                 <Form style={{fontSize:15}}>
                                                    <Row form>
                                                       <Col md="1"></Col>
                                                       <Col md="11" >
                                                         <FormCheckbox
                                                            checked={this.state.cContractPolicy}
                                                            style={ this.props.colorDark ? { backgroundColor:'#111f2c'} : {}}
                                                            onChange={e=>this.handleChange(e, "cContractPolicy")}
                                                            disabled={!this.state.statusActive2}
                                                         >
                                                           {/* eslint-disable-next-line */}<FormattedMessage id="contract.iagreewithyour" />{" "}
                                                           <strong style={this.props.colorDark ? {color: "orange", cursor: 'pointer'} : {color: "blue", cursor: 'pointer'}}><FormattedMessage id="contract.contractpolicy" /></strong>
                                                         </FormCheckbox>
                                                       </Col>
                                                    </Row>
                                                    <br></br>
                                                    <Row form>
                                                       <Col md="1"></Col>
                                                       <Col md="11">
                                                          <br></br>
                                                          {this.mostrarBotonesAbajo()}
                                                          {this.messageErrorWrite()}
                                                          {this.messageErrorNumber()}
                                                          {this.messageExistContract()}
                                                          <br></br>
                                                       </Col>
                                                     </Row>
                                                     <Row>&nbsp;</Row>
                                                   </Form>
                                               </Card>
                                             </ListGroupItem>
                                          </ListGroup>
                                          {/*<Launcher
                                              agentProfile={{
                                                  teamName: 'Crosscheck Chat',
                                                  imageUrl: 'https://xck.app/images/chatGreen30x30.png'
                                              }}
                                              onMessageWasSent={this._onMessageWasSent.bind(this)}
                                              messageList={this.state.messageList}
                                              showEmoji
                                              newMessagesCount={countMessages}
                                          />*/}
                                      </Card>
                                  :
                                     null
                                  }
                            </ListGroupItem>
                            </ListGroup>
                          </Card>
                          <input type="hidden" ref={this.c01FieldContract} />
                          <input type="hidden" ref={this.c03FieldContract} />
                          <input type="hidden" ref={this.c02FieldContract} />
                          { templateNameWorkOrder ?
                            <React.Fragment>
                              <input type="hidden" ref={this.c04FieldContract} />
                              <input type="hidden" ref={this.c16FieldContract} />
                              <input type="hidden" ref={this.c20FieldContract} />
                              <input type="hidden" ref={this.c23FieldContract} />
                              <input type="hidden" ref={this.c24FieldContract} />
                              <input type="hidden" ref={this.c25FieldContract} />
                              <input type="hidden" ref={this.c26FieldContract} />
                              <input type="hidden" ref={this.c50FieldContract} />
                              <input type="hidden" ref={this.c51FieldContract} />
                              <input type="hidden" ref={this.c52FieldContract} />
                              <input type="hidden" ref={this.c53FieldContract} />
                              <input type="hidden" ref={this.c54FieldContract} />
                              <input type="hidden" ref={this.c55FieldContract} />
                              <input type="hidden" ref={this.c56FieldContract} />
                              <input type="hidden" ref={this.c57FieldContract} />
                              <input type="hidden" ref={this.c58FieldContract} />
                              <input type="hidden" ref={this.c59FieldContract} />
                              <input type="hidden" ref={this.c60FieldContract} />
                            </React.Fragment>
                          : null
                          }
                          { templateNameDelivery ?
                            <React.Fragment>
                              <input type="hidden" ref={this.c17FieldContract} />
                              <input type="hidden" ref={this.c18FieldContract} />
                              <input type="hidden" ref={this.c19FieldContract} />
                              <input type="hidden" ref={this.c21FieldContract} />
                              <input type="hidden" ref={this.c22FieldContract} />
                              <input type="hidden" ref={this.c23FieldContract} />
                              <input type="hidden" ref={this.c24FieldContract} />
                              <input type="hidden" ref={this.c25FieldContract} />
                              <input type="hidden" ref={this.c27FieldContract} />
                              <input type="hidden" ref={this.c28FieldContract} />
                              <input type="hidden" ref={this.c29FieldContract} />
                              <input type="hidden" ref={this.c30FieldContract} />
                              <input type="hidden" ref={this.c31FieldContract} />
                              <input type="hidden" ref={this.c32FieldContract} />
                              <input type="hidden" ref={this.c33FieldContract} />
                              <input type="hidden" ref={this.c34FieldContract} />
                              <input type="hidden" ref={this.c35FieldContract} />
                              <input type="hidden" ref={this.c36FieldContract} />
                              <input type="hidden" ref={this.c37FieldContract} />
                              <input type="hidden" ref={this.c38FieldContract} />
                              <input type="hidden" ref={this.c39FieldContract} />
                              <input type="hidden" ref={this.c40FieldContract} />
                              <input type="hidden" ref={this.c41FieldContract} />
                              <input type="hidden" ref={this.c42FieldContract} />
                              <input type="hidden" ref={this.c43FieldContract} />
                              <input type="hidden" ref={this.c44FieldContract} />
                              <input type="hidden" ref={this.c45FieldContract} />
                              <input type="hidden" ref={this.c46FieldContract} />
                              <input type="hidden" ref={this.c47FieldContract} />
                              <input type="hidden" ref={this.c48FieldContract} />
                              <input type="hidden" ref={this.c49FieldContract} />
                              <input type="hidden" ref={this.c50FieldContract} />
                              <input type="hidden" ref={this.c51FieldContract} />
                              <input type="hidden" ref={this.c52FieldContract} />
                              <input type="hidden" ref={this.c53FieldContract} />
                              <input type="hidden" ref={this.c54FieldContract} />
                              <input type="hidden" ref={this.c55FieldContract} />
                              <input type="hidden" ref={this.c56FieldContract} />
                              <input type="hidden" ref={this.c57FieldContract} />
                              <input type="hidden" ref={this.c58FieldContract} />
                              <input type="hidden" ref={this.c59FieldContract} />
                              <input type="hidden" ref={this.c60FieldContract} />
                            </React.Fragment>
                          : null
                          }

                          { templateNameMaintenance ?
                            <React.Fragment>
                              <input type="hidden" ref={this.c08FieldContract} />
                              <input type="hidden" ref={this.c09FieldContract} />
                              <input type="hidden" ref={this.c12FieldContract} />
                              <input type="hidden" ref={this.c13FieldContract} />
                              <input type="hidden" ref={this.c14FieldContract} />
                              <input type="hidden" ref={this.c15FieldContract} />
                              <input type="hidden" ref={this.c17FieldContract} />
                              <input type="hidden" ref={this.c18FieldContract} />
                              <input type="hidden" ref={this.c19FieldContract} />
                              <input type="hidden" ref={this.c21FieldContract} />
                              <input type="hidden" ref={this.c22FieldContract} />
                              <input type="hidden" ref={this.c23FieldContract} />
                              <input type="hidden" ref={this.c24FieldContract} />
                              <input type="hidden" ref={this.c25FieldContract} />
                              <input type="hidden" ref={this.c27FieldContract} />
                              <input type="hidden" ref={this.c28FieldContract} />
                              <input type="hidden" ref={this.c29FieldContract} />
                              <input type="hidden" ref={this.c34FieldContract} />
                              <input type="hidden" ref={this.c35FieldContract} />
                              <input type="hidden" ref={this.c36FieldContract} />
                              <input type="hidden" ref={this.c37FieldContract} />
                              <input type="hidden" ref={this.c38FieldContract} />
                              <input type="hidden" ref={this.c39FieldContract} />
                              <input type="hidden" ref={this.c40FieldContract} />
                              <input type="hidden" ref={this.c41FieldContract} />
                              <input type="hidden" ref={this.c42FieldContract} />
                              <input type="hidden" ref={this.c43FieldContract} />
                              <input type="hidden" ref={this.c44FieldContract} />
                              <input type="hidden" ref={this.c45FieldContract} />
                              <input type="hidden" ref={this.c46FieldContract} />
                              <input type="hidden" ref={this.c47FieldContract} />
                              <input type="hidden" ref={this.c48FieldContract} />
                              <input type="hidden" ref={this.c49FieldContract} />
                              <input type="hidden" ref={this.c50FieldContract} />
                              <input type="hidden" ref={this.c51FieldContract} />
                              <input type="hidden" ref={this.c52FieldContract} />
                              <input type="hidden" ref={this.c53FieldContract} />
                              <input type="hidden" ref={this.c54FieldContract} />
                              <input type="hidden" ref={this.c55FieldContract} />
                              <input type="hidden" ref={this.c56FieldContract} />
                              <input type="hidden" ref={this.c57FieldContract} />
                              <input type="hidden" ref={this.c58FieldContract} />
                              <input type="hidden" ref={this.c59FieldContract} />
                              <input type="hidden" ref={this.c60FieldContract} />
                            </React.Fragment>
                          : null
                          }
                          { templateNameProforma ?
                            <React.Fragment>
                              <input type="hidden" ref={this.c04FieldContract} />
                              <input type="hidden" ref={this.c41FieldContract} />
                              <input type="hidden" ref={this.c42FieldContract} />
                              <input type="hidden" ref={this.c43FieldContract} />
                              <input type="hidden" ref={this.c44FieldContract} />
                              <input type="hidden" ref={this.c45FieldContract} />
                              <input type="hidden" ref={this.c46FieldContract} />
                              <input type="hidden" ref={this.c47FieldContract} />
                              <input type="hidden" ref={this.c48FieldContract} />
                              <input type="hidden" ref={this.c49FieldContract} />
                              <input type="hidden" ref={this.c50FieldContract} />
                              <input type="hidden" ref={this.c51FieldContract} />
                              <input type="hidden" ref={this.c52FieldContract} />
                              <input type="hidden" ref={this.c53FieldContract} />
                              <input type="hidden" ref={this.c54FieldContract} />
                              <input type="hidden" ref={this.c55FieldContract} />
                              <input type="hidden" ref={this.c56FieldContract} />
                              <input type="hidden" ref={this.c57FieldContract} />
                              <input type="hidden" ref={this.c58FieldContract} />
                              <input type="hidden" ref={this.c59FieldContract} />
                              <input type="hidden" ref={this.c60FieldContract} />
                            </React.Fragment>
                          : null
                          }
                          { templateNameBlank ?
                            <React.Fragment>
                              <input type="hidden" ref={this.c04FieldContract} />
                              <input type="hidden" ref={this.c08FieldContract} />
                              <input type="hidden" ref={this.c09FieldContract} />
                              <input type="hidden" ref={this.c12FieldContract} />
                              <input type="hidden" ref={this.c13FieldContract} />
                              <input type="hidden" ref={this.c14FieldContract} />
                              <input type="hidden" ref={this.c15FieldContract} />
                              <input type="hidden" ref={this.c17FieldContract} />
                              <input type="hidden" ref={this.c18FieldContract} />
                              <input type="hidden" ref={this.c19FieldContract} />
                              <input type="hidden" ref={this.c21FieldContract} />
                              <input type="hidden" ref={this.c22FieldContract} />
                              <input type="hidden" ref={this.c23FieldContract} />
                              <input type="hidden" ref={this.c24FieldContract} />
                              <input type="hidden" ref={this.c25FieldContract} />
                              <input type="hidden" ref={this.c27FieldContract} />
                              <input type="hidden" ref={this.c28FieldContract} />
                              <input type="hidden" ref={this.c29FieldContract} />
                              <input type="hidden" ref={this.c30FieldContract} />
                              <input type="hidden" ref={this.c31FieldContract} />
                              <input type="hidden" ref={this.c32FieldContract} />
                              <input type="hidden" ref={this.c33FieldContract} />
                              <input type="hidden" ref={this.c34FieldContract} />
                              <input type="hidden" ref={this.c35FieldContract} />
                              <input type="hidden" ref={this.c36FieldContract} />
                              <input type="hidden" ref={this.c37FieldContract} />
                              <input type="hidden" ref={this.c38FieldContract} />
                              <input type="hidden" ref={this.c39FieldContract} />
                              <input type="hidden" ref={this.c40FieldContract} />
                              <input type="hidden" ref={this.c41FieldContract} />
                              <input type="hidden" ref={this.c42FieldContract} />
                              <input type="hidden" ref={this.c43FieldContract} />
                              <input type="hidden" ref={this.c44FieldContract} />
                              <input type="hidden" ref={this.c45FieldContract} />
                              <input type="hidden" ref={this.c46FieldContract} />
                              <input type="hidden" ref={this.c47FieldContract} />
                              <input type="hidden" ref={this.c48FieldContract} />
                              <input type="hidden" ref={this.c49FieldContract} />
                              <input type="hidden" ref={this.c50FieldContract} />
                              <input type="hidden" ref={this.c51FieldContract} />
                              <input type="hidden" ref={this.c52FieldContract} />
                              <input type="hidden" ref={this.c53FieldContract} />
                              <input type="hidden" ref={this.c54FieldContract} />
                              <input type="hidden" ref={this.c55FieldContract} />
                              <input type="hidden" ref={this.c56FieldContract} />
                              <input type="hidden" ref={this.c57FieldContract} />
                              <input type="hidden" ref={this.c58FieldContract} />
                              <input type="hidden" ref={this.c59FieldContract} />
                            </React.Fragment>
                          : null
                          }
                          { templateNameSpreadsheet ?
                            <React.Fragment>
                              <input type="hidden" ref={this.c04FieldContract} />
                              <input type="hidden" ref={this.c08FieldContract} />
                              <input type="hidden" ref={this.c09FieldContract} />
                              <input type="hidden" ref={this.c12FieldContract} />
                              <input type="hidden" ref={this.c13FieldContract} />
                              <input type="hidden" ref={this.c14FieldContract} />
                              <input type="hidden" ref={this.c15FieldContract} />
                              <input type="hidden" ref={this.c17FieldContract} />
                              <input type="hidden" ref={this.c18FieldContract} />
                              <input type="hidden" ref={this.c19FieldContract} />
                              <input type="hidden" ref={this.c21FieldContract} />
                              <input type="hidden" ref={this.c22FieldContract} />
                              <input type="hidden" ref={this.c23FieldContract} />
                              <input type="hidden" ref={this.c24FieldContract} />
                              <input type="hidden" ref={this.c25FieldContract} />
                              <input type="hidden" ref={this.c27FieldContract} />
                              <input type="hidden" ref={this.c28FieldContract} />
                              <input type="hidden" ref={this.c29FieldContract} />
                              <input type="hidden" ref={this.c30FieldContract} />
                              <input type="hidden" ref={this.c31FieldContract} />
                              <input type="hidden" ref={this.c32FieldContract} />
                              <input type="hidden" ref={this.c33FieldContract} />
                              <input type="hidden" ref={this.c34FieldContract} />
                              <input type="hidden" ref={this.c35FieldContract} />
                              <input type="hidden" ref={this.c36FieldContract} />
                              <input type="hidden" ref={this.c37FieldContract} />
                              <input type="hidden" ref={this.c38FieldContract} />
                              <input type="hidden" ref={this.c39FieldContract} />
                              <input type="hidden" ref={this.c40FieldContract} />
                              <input type="hidden" ref={this.c41FieldContract} />
                              <input type="hidden" ref={this.c42FieldContract} />
                              <input type="hidden" ref={this.c43FieldContract} />
                              <input type="hidden" ref={this.c44FieldContract} />
                              <input type="hidden" ref={this.c45FieldContract} />
                              <input type="hidden" ref={this.c46FieldContract} />
                              <input type="hidden" ref={this.c47FieldContract} />
                              <input type="hidden" ref={this.c48FieldContract} />
                              <input type="hidden" ref={this.c49FieldContract} />
                              <input type="hidden" ref={this.c50FieldContract} />
                              <input type="hidden" ref={this.c51FieldContract} />
                              <input type="hidden" ref={this.c52FieldContract} />
                              <input type="hidden" ref={this.c53FieldContract} />
                              <input type="hidden" ref={this.c54FieldContract} />
                              <input type="hidden" ref={this.c55FieldContract} />
                              <input type="hidden" ref={this.c56FieldContract} />
                              <input type="hidden" ref={this.c57FieldContract} />
                              <input type="hidden" ref={this.c58FieldContract} />
                              <input type="hidden" ref={this.c59FieldContract} />
                            </React.Fragment>
                          : null
                          }
                          { templateNameUploaded ?
                            <React.Fragment>
                              <input type="hidden" ref={this.c04FieldContract} />
                              <input type="hidden" ref={this.c08FieldContract} />
                              <input type="hidden" ref={this.c09FieldContract} />
                              <input type="hidden" ref={this.c12FieldContract} />
                              <input type="hidden" ref={this.c13FieldContract} />
                              <input type="hidden" ref={this.c14FieldContract} />
                              <input type="hidden" ref={this.c15FieldContract} />
                              <input type="hidden" ref={this.c17FieldContract} />
                              <input type="hidden" ref={this.c18FieldContract} />
                              <input type="hidden" ref={this.c19FieldContract} />
                              <input type="hidden" ref={this.c21FieldContract} />
                              <input type="hidden" ref={this.c22FieldContract} />
                              <input type="hidden" ref={this.c23FieldContract} />
                              <input type="hidden" ref={this.c24FieldContract} />
                              <input type="hidden" ref={this.c25FieldContract} />
                              <input type="hidden" ref={this.c27FieldContract} />
                              <input type="hidden" ref={this.c28FieldContract} />
                              <input type="hidden" ref={this.c29FieldContract} />
                              <input type="hidden" ref={this.c30FieldContract} />
                              <input type="hidden" ref={this.c31FieldContract} />
                              <input type="hidden" ref={this.c32FieldContract} />
                              <input type="hidden" ref={this.c33FieldContract} />
                              <input type="hidden" ref={this.c34FieldContract} />
                              <input type="hidden" ref={this.c35FieldContract} />
                              <input type="hidden" ref={this.c36FieldContract} />
                              <input type="hidden" ref={this.c37FieldContract} />
                              <input type="hidden" ref={this.c38FieldContract} />
                              <input type="hidden" ref={this.c39FieldContract} />
                              <input type="hidden" ref={this.c40FieldContract} />
                              <input type="hidden" ref={this.c41FieldContract} />
                              <input type="hidden" ref={this.c42FieldContract} />
                              <input type="hidden" ref={this.c43FieldContract} />
                              <input type="hidden" ref={this.c44FieldContract} />
                              <input type="hidden" ref={this.c45FieldContract} />
                              <input type="hidden" ref={this.c46FieldContract} />
                              <input type="hidden" ref={this.c47FieldContract} />
                              <input type="hidden" ref={this.c48FieldContract} />
                              <input type="hidden" ref={this.c49FieldContract} />
                              <input type="hidden" ref={this.c50FieldContract} />
                              <input type="hidden" ref={this.c51FieldContract} />
                              <input type="hidden" ref={this.c52FieldContract} />
                              <input type="hidden" ref={this.c53FieldContract} />
                              <input type="hidden" ref={this.c54FieldContract} />
                              <input type="hidden" ref={this.c55FieldContract} />
                              <input type="hidden" ref={this.c56FieldContract} />
                              <input type="hidden" ref={this.c57FieldContract} />
                              <input type="hidden" ref={this.c58FieldContract} />
                              <input type="hidden" ref={this.c59FieldContract} />
                            </React.Fragment>
                          : null
                          }
                        </React.Fragment>
                    }

                  </div>
                :
                  <React.Fragment>
                    <input type="hidden" ref={this.c02ConfigurationContract} />
                    <input type="hidden" ref={this.c06ConfigurationContract} />
                    <input type="hidden" ref={this.c07ConfigurationContract} />
                    <input type="hidden" ref={this.c08ConfigurationContract} />
                    <input type="hidden" ref={this.c09ConfigurationContract} />
                    <input type="hidden" ref={this.c10ConfigurationContract} />
                  </React.Fragment>
               }
               <Card style={ this.props.colorDark ? { backgroundColor:'#0b151d'} : {}}  small>
                 { displayGeneratePdfX ? <ViewerPdf contentState={this.state.contentStateRaw}
                                                    typeContract={this.state.typeContractSign}
                                                    numberContract={this.state.configurationContractNumberSign}
                                                    userRole={this.state.whatUserRole}
                                                    userOrigin={this.state.whatUserOrigin}
                                                    whatUserRole={this.state.whatUserRole}
                                                    description={this.state.subject}
                                                    startDate={this.state.startDate}
                                                    endDate={this.state.endDate}
                                                    filedecodeAttachX={filedecodeAttachX}
                                                    colorDark={this.props.colorDark}
                                                    displayCertificatePaymentsMade={this.state.displayCertificatePaymentsMade}
                                                    displayCertificateContract={this.state.displayCertificateContract} />
                 : null }

               </Card>

              </Container>
            </>
          );
     }
}

Contract.propTypes = {
    agregarContract : PropTypes.func.isRequired,
    validarFormulario : PropTypes.func.isRequired,
    tokenTemplate : PropTypes.func.isRequired,
    mostrarTemplateAll : PropTypes.func.isRequired,
    mostrarTemplate : PropTypes.func.isRequired,
}
Confirmacion.propTypes = {
    dialogOpen: PropTypes.bool.isRequired,
    dialogTitle: PropTypes.string.isRequired,
    dialogMessage: PropTypes.string.isRequired,
    handleDialog: PropTypes.func.isRequired,
}
ConfirmacionWriteBlockchain.propTypes = {
    dialogOpen: PropTypes.bool.isRequired,
    dialogTitle: PropTypes.string.isRequired,
    dialogMessage: PropTypes.string.isRequired,
    handleDialog: PropTypes.func.isRequired,
}

const mapStateToProps = state => ({
    contracts: state.contracts.contracts,
    smartcontract: state.smartcontract.smartcontract,
    templates: state.templates.templates,
    templatesAll: state.templates.templatesAll,
    templatesToken: state.templates.templatesToken,
})

const mapDispatchToProps = dispatch => {
  return {
    saveNewPactLogisticConfig: (idParadigma, typeContract, configurationContractNumber, startDate, endDate, transportOriginDestination, conditionsIntegrityMaterials, useAssets, statusBlockchain, usernameInsert, dateInsert, usernameUpdate, dateUpdate, usernameDelete, dateDelete, idTypeBillOfLading, dateContract, shipper, consignee, notifyParty, carrier, placeOfAceptance, portOfLading, vessel, portOfDischarge, placeOfDelivery, finalDestination, amount, currency, signature, statusLifeCycle, contractPolicy ) => {
        dispatch(saveNewPactLogisticConfig(idParadigma, typeContract, configurationContractNumber, startDate, endDate, transportOriginDestination, conditionsIntegrityMaterials, useAssets, statusBlockchain, usernameInsert, dateInsert, usernameUpdate, dateUpdate, usernameDelete, dateDelete, idTypeBillOfLading, dateContract, shipper, consignee, notifyParty, carrier, placeOfAceptance, portOfLading, vessel, portOfDischarge, placeOfDelivery, finalDestination, amount, currency, signature, statusLifeCycle, contractPolicy));},
    saveNewPactLogisticRules: (idParadigma, typeContract, configurationContractNumber, idContainer, idTypeBillOfLading, temperature, humidity, gascontrol, impact, vibration, proximity, sealIntegrity, gps, temperatureLowerThreshold, temperatureUpperThreshold, temperatureFrecuency, temperatureUnitFrecuency, temperatureUnitMeasurement, temperatureErrorTime, temperatureErrorTimeUnit, temperatureErrorAction, temperatureActiveRule, humidityLowerThreshold, humidityUpperThreshold, humidityFrecuency, humidityUnitFrecuency, humidityUnitMeasurement, humidityErrorTime, humidityErrorTimeUnit, humidityErrorAction, humidityActiveRule, gascontrolLowerThreshold, gascontrolUpperThreshold, gascontrolFrecuency, gascontrolUnitFrecuency, gascontrolUnitMeasurement, gascontrolErrorTime, gascontrolErrorTimeUnit, gascontrolErrorAction, gascontrolActiveRule, gpsFrecuency, gpsUnitFrecuency, gpsUnitMeasurement, gpsErrorTime, gpsErrorTimeUnit, gpsErrorAction, gpsActiveRule ) => {
        dispatch(saveNewPactLogisticRules(idParadigma, typeContract, configurationContractNumber, idContainer, idTypeBillOfLading, temperature, humidity, gascontrol, impact, vibration, proximity, sealIntegrity, gps, temperatureLowerThreshold, temperatureUpperThreshold, temperatureFrecuency, temperatureUnitFrecuency, temperatureUnitMeasurement, temperatureErrorTime, temperatureErrorTimeUnit, temperatureErrorAction, temperatureActiveRule, humidityLowerThreshold, humidityUpperThreshold, humidityFrecuency, humidityUnitFrecuency, humidityUnitMeasurement, humidityErrorTime, humidityErrorTimeUnit, humidityErrorAction, humidityActiveRule, gascontrolLowerThreshold, gascontrolUpperThreshold, gascontrolFrecuency, gascontrolUnitFrecuency, gascontrolUnitMeasurement, gascontrolErrorTime, gascontrolErrorTimeUnit, gascontrolErrorAction, gascontrolActiveRule, gpsFrecuency, gpsUnitFrecuency, gpsUnitMeasurement, gpsErrorTime, gpsErrorTimeUnit, gpsErrorAction, gpsActiveRule));},
    saveNewPactMaintenanceConfig: (idParadigma, typeContract, configurationContractNumber, startDate, endDate, statusBlockchain, usernameInsert, dateInsert, usernameUpdate, dateUpdate, usernameDelete, dateDelete, idTypeBillOfLading, dateContract, yourNameCompany, yourAddress, clientNameCompany, clientAddress, amount, currency, signature, statusLifeCycle, contractPolicy ) => {
        dispatch(saveNewPactMaintenanceConfig(idParadigma, typeContract, configurationContractNumber, startDate, endDate, statusBlockchain, usernameInsert, dateInsert, usernameUpdate, dateUpdate, usernameDelete, dateDelete, idTypeBillOfLading, dateContract, yourNameCompany, yourAddress, clientNameCompany, clientAddress, amount, currency, signature, statusLifeCycle, contractPolicy));},
    saveNewPactMaintenanceRules: (idParadigma, typeContract, configurationContractNumber, idContainer, idTypeBillOfLading, fire, flood, sealintegrity, motion, smoke, fireErrorAction, fireActiveRule, floodErrorAction, floodActiveRule, sealintegrityErrorAction, sealintegrityActiveRule, motionErrorAction, motionActiveRule, smokeErrorAction, smokeActiveRule ) => {
        dispatch(saveNewPactMaintenanceRules(idParadigma, typeContract, configurationContractNumber, idContainer, idTypeBillOfLading, fire, flood, sealintegrity, motion, smoke, fireErrorAction, fireActiveRule, floodErrorAction, floodActiveRule, sealintegrityErrorAction, sealintegrityActiveRule, motionErrorAction, motionActiveRule, smokeErrorAction, smokeActiveRule));},
    saveNewPactProformaConfig: (idParadigma, typeContract, configurationContractNumber, startDate, endDate, statusBlockchain, usernameInsert, dateInsert, usernameUpdate, dateUpdate, usernameDelete, dateDelete, idTypeBillOfLading, dateContract, shippername, shippercompanyname, shippercontactperson, shipperstreetaddress, shippercitystzipcode, shipperphone, shipperemail, receivername, receivercompanyname, receivercontactperson, currency, receiverstreetaddress, receivercitystzipcode, receiverphone, receiveremail, reference, modeoftransport, totalnumberpackages, totalgrossweight, productid, description, quantity, unitprice, proformasubtotal, proformadiscount, proformataxrate, proformasalesrate, proformashipping, proformatotal, countryoforigin, portofembarcation, reasonforexport, portofdischarge, termsaleothercomments, gps, gpsFrecuency, gpsUnitFrecuency, gpsUnitMeasurement, gpsErrorTime, gpsErrorTimeUnit, gpsErrorAction, gpsActiveRule, signature, statusLifeCycle, contractPolicy ) => {
        dispatch(saveNewPactProformaConfig(idParadigma, typeContract, configurationContractNumber, startDate, endDate, statusBlockchain, usernameInsert, dateInsert, usernameUpdate, dateUpdate, usernameDelete, dateDelete, idTypeBillOfLading, dateContract, shippername, shippercompanyname, shippercontactperson, shipperstreetaddress, shippercitystzipcode, shipperphone, shipperemail, receivername, receivercompanyname, receivercontactperson, currency, receiverstreetaddress, receivercitystzipcode, receiverphone, receiveremail, reference, modeoftransport, totalnumberpackages, totalgrossweight, productid, description, quantity, unitprice, proformasubtotal, proformadiscount, proformataxrate, proformasalesrate, proformashipping, proformatotal, countryoforigin, portofembarcation, reasonforexport, portofdischarge, termsaleothercomments, gps, gpsFrecuency, gpsUnitFrecuency, gpsUnitMeasurement, gpsErrorTime, gpsErrorTimeUnit, gpsErrorAction, gpsActiveRule, signature, statusLifeCycle, contractPolicy));},
    saveNewPactProformaRules: (idParadigma, typeContract, configurationContractNumber, idContainer, idTypeBillOfLading, gps, gpsFrecuency, gpsUnitFrecuency, gpsUnitMeasurement, gpsErrorTime, gpsErrorTimeUnit, gpsErrorAction, gpsActiveRule ) => {
        dispatch(saveNewPactProformaRules(idParadigma, typeContract, configurationContractNumber, idContainer, idTypeBillOfLading, gps, gpsFrecuency, gpsUnitFrecuency, gpsUnitMeasurement, gpsErrorTime, gpsErrorTimeUnit, gpsErrorAction, gpsActiveRule));},
    removePactLogisticConfig: id => {dispatch(removePactLogisticConfig(id));},
    agregarContract: agregarContract,
    validarFormulario: validarFormulario,
    tokenTemplate: (usernameX) => {dispatch(tokenTemplate(usernameX));},
    mostrarTemplateAll: (usernameX) => {dispatch(mostrarTemplateAll(usernameX));},
    mostrarTemplate: (usernameX,idtemplate) => {dispatch(mostrarTemplate(usernameX,idtemplate));},
  };
};

export default withRouter(connect( mapStateToProps, mapDispatchToProps)(Contract));
